import _Modal from 'antd/lib/modal';
import _Spin from 'antd/lib/spin';
import _Button from 'antd/lib/button';
import React, { Component, forwardRef, useState, useMemo, useRef, useEffect, useImperativeHandle, memo } from 'react';
import PropTypes, { bool, func } from 'prop-types';
import _Pagination from 'antd/lib/pagination';
import _ConfigProvider from 'antd/lib/config-provider';
import ProTable from '@ant-design/pro-table';
import { sortableElement, sortableHandle, sortableContainer } from 'react-sortable-hoc';
import { ArrowDownOutlined, ArrowUpOutlined, MenuOutlined, SearchOutlined, MenuFoldOutlined, createFromIconfontCN, ArrowLeftOutlined, DownOutlined, LoadingOutlined, PlusOutlined, UserSwitchOutlined, BellOutlined, UserOutlined, DownloadOutlined, ImportOutlined, PhoneOutlined, LogoutOutlined, ExclamationCircleOutlined, LinkOutlined, EnvironmentOutlined, InfoCircleOutlined, WechatOutlined, AlipayCircleOutlined, CloseOutlined, CloudUploadOutlined, ExclamationCircleFilled } from '@ant-design/icons';
import zhCN from 'antd/lib/locale/zh_CN';
import className from 'classnames';
import { Resizable } from 'react-resizable';
import _Transfer from 'antd/lib/transfer';
import _Tree from 'antd/lib/tree';
import _Tooltip from 'antd/lib/tooltip';
import qs from 'qs';
import 'crypto-js';
import Cookies from 'js-cookie';
import 'antd/lib/notification';
import _message from 'antd/lib/message';
import 'react-loadable';
import axios from 'axios';
import { EventEmitter } from 'events';
import '@sentry/browser';
import '@sentry/tracing';
import _Popover from 'antd/lib/popover';
import _Input from 'antd/lib/input';
import _Tabs from 'antd/lib/tabs';
import _Tag from 'antd/lib/tag';
import E from 'wangeditor';
import { Link } from 'react-router-dom';
import ProLayout, { PageContainer } from '@ant-design/pro-layout';
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import _Card from 'antd/lib/card';
import _Table from 'antd/lib/table';
import _Alert from 'antd/lib/alert';
import _Space from 'antd/lib/space';
import _Dropdown from 'antd/lib/dropdown';
import _Menu from 'antd/lib/menu';
import _Checkbox from 'antd/lib/checkbox';
import 'react-window';
import ResizeObserver from 'rc-resize-observer';
import moment from 'moment';
import WaterMark from '@pansy/watermark';
import { createInstance } from '@datapunt/matomo-tracker-react';
import _Badge from 'antd/lib/badge';
import _Avatar from 'antd/lib/avatar';
import _Drawer from 'antd/lib/drawer';
import _Form from 'antd/lib/form';
import _Upload from 'antd/lib/upload';
import _Select from 'antd/lib/select';
import _Empty from 'antd/lib/empty';
import _Row from 'antd/lib/row';
import _Col from 'antd/lib/col';
import _DatePicker from 'antd/lib/date-picker';
import { Map, Marker, Base, Constants } from 'rc-bmap';
import { PhotoSlider } from 'react-photo-view';
import _Slider from 'antd/lib/slider';
import 'react-photo-view/dist/react-photo-view.css';
import QRCode from 'qrcode.react';
import _InputNumber from 'antd/lib/input-number';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

const noop$2 = () => {};
const propTypes$j = {
  open: PropTypes.oneOfType([PropTypes.bool, PropTypes.shape()]),
  loading: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  size: PropTypes.number,
  // 500
  showFooter: PropTypes.bool,
  footer: PropTypes.element,
  closable: PropTypes.bool,
  showCancelButton: PropTypes.bool,
  showSaveButton: PropTypes.bool,
  onClick: PropTypes.func,
  cancelButtonText: PropTypes.string,
  saveButtonText: PropTypes.string,
  oncancel: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.shape({})), PropTypes.shape({}), PropTypes.string])
};
const defaultProps$g = {
  loading: false,
  size: 550,
  open: true,
  showFooter: true,
  footer: null,
  title: 'modal 标题',
  closable: true,
  showCancelButton: true,
  showSaveButton: true,
  cancelButtonText: '取消',
  saveButtonText: '确定',
  onClick: noop$2,
  oncancel: null,
  children: []
};

/**
 * modal 对话框
 */
class ModalComponent extends Component {
  constructor(...args) {
    super(...args);
    this.handleClickFooterOkButton = flag => {
      const {
        onClick,
        oncancel
      } = this.props;
      if (onClick) onClick(flag);
      if (oncancel) oncancel(flag);
    };
    this.handleGetFooter = () => {
      const {
        footer,
        showCancelButton,
        showSaveButton,
        showFooter,
        cancelButtonText,
        saveButtonText,
        loading
      } = this.props;
      if (!showFooter) return null;
      if (footer) {
        return footer;
      }
      const footerArr = [];
      if (showCancelButton) {
        footerArr.push( /*#__PURE__*/React.createElement(_Button, {
          disabled: loading,
          key: "cancel",
          size: "default",
          onClick: () => this.handleClickFooterOkButton(false)
        }, cancelButtonText));
      }
      if (showSaveButton) {
        footerArr.push( /*#__PURE__*/React.createElement(_Button, {
          disabled: loading,
          key: "save",
          type: "primary",
          size: "default",
          onClick: () => {
            if (loading) return false;
            this.handleClickFooterOkButton.call(null, true);
            return true;
          }
        }, saveButtonText));
      }
      return footerArr;
    };
  }
  render() {
    const {
      loading,
      size,
      children,
      title,
      closable,
      open,
      ...otherProps
    } = this.props;
    return /*#__PURE__*/React.createElement(_Modal, _extends({}, otherProps, {
      width: size,
      title: title,
      open: open,
      closable: closable,
      maskClosable: false,
      onCancel: () => this.handleClickFooterOkButton(false),
      footer: this.handleGetFooter()
    }), /*#__PURE__*/React.createElement(_Spin, {
      spinning: loading
    }, /*#__PURE__*/React.createElement("div", {
      className: "modalContent"
    }, children)));
  }
}
ModalComponent.propTypes = propTypes$j;
ModalComponent.defaultProps = defaultProps$g;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z$h = ".styles-module_datePickerBox__1FPqQ {\n  width: 100%;\n}\n.styles-module_customizeBox__3F3Bz {\n  display: inline-block;\n  margin-left: 50px;\n}\n";
var styles$h = {"datePickerBox":"styles-module_datePickerBox__1FPqQ","customizeBox":"styles-module_customizeBox__3F3Bz"};
styleInject(css_248z$h);

const propTypes$i = {
  column: PropTypes.arrayOf(PropTypes.object).isRequired,
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired
};
const defaultProp = {
  open: false,
  column: [],
  onSuccess: () => {},
  onCancel: () => {}
};

/**
 * 自定义表头
 */
class CustomizeTableColumn extends Component {
  constructor(props) {
    super(props);
    /**
     * 处理 column 获得 初始化数据
     * @returns {{targetKeys: *, dataSource: *}}
     */
    this.getTransferColumn = () => {
      const {
        column
      } = this.props;
      const targetKeys = column.filter(item => !item.hide).map(item => item.dataIndex);
      const dataSource = column.map(item => ({
        ...item,
        key: item.dataIndex
      }));
      return {
        targetKeys,
        dataSource
      };
    };
    this.handleChange = nextTargetKeys => {
      this.setState({
        targetKeys: nextTargetKeys
      });
    };
    this.handleSelectedChange = (sourceSelectedKeys, targetSelectedKeys) => {
      this.setState({
        selectedKeys: [...sourceSelectedKeys, ...targetSelectedKeys]
      });
    };
    this.handleHideModal = flag => {
      const {
        targetKeys,
        dataSource
      } = this.state;
      const {
        onSuccess,
        onCancel
      } = this.props;
      const newColumns = dataSource.map(item => {
        const {
          dataIndex
        } = item;
        let hide = true;
        if (targetKeys.includes(dataIndex)) {
          hide = false;
        }
        return {
          ...item,
          hide
        };
      });
      if (flag) {
        if (onSuccess) onSuccess(newColumns);
      } else if (onCancel) onCancel();
    };
    const {
      dataSource: _dataSource,
      targetKeys: _targetKeys
    } = this.getTransferColumn();
    this.state = {
      targetKeys: _targetKeys,
      dataSource: _dataSource,
      selectedKeys: []
    };
  }
  render() {
    const {
      targetKeys,
      selectedKeys,
      dataSource
    } = this.state;
    return /*#__PURE__*/React.createElement(ModalComponent, {
      title: "\u81EA\u5B9A\u4E49\u8868\u5934",
      onClick: this.handleHideModal
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$h.customizeBox
    }, /*#__PURE__*/React.createElement(_Transfer, {
      rowKey: record => record.dataIndex,
      dataSource: dataSource,
      titles: ['未展示表头', '已选择表头'],
      targetKeys: targetKeys,
      selectedKeys: selectedKeys,
      onChange: this.handleChange,
      onSelectChange: this.handleSelectedChange,
      render: item => item.title,
      listStyle: {
        minHeight: 390
      }
    })));
  }
}
CustomizeTableColumn.propTypes = propTypes$i;
CustomizeTableColumn.defaultProp = defaultProp;

var css_248z$g = ".index-module_pagination__1z188 {\n  text-align: right;\n  margin-top: 15px;\n  margin-bottom: 12px;\n}\n.index-module_sortTitle__3fQu- {\n  cursor: pointer;\n}\n.index-module_activeSort__3ESTe i {\n  color: blue;\n}\n.index-module_ant-table-header-column__2kkbE {\n  display: inline-block;\n}\n.index-module_funcBox__2N4LJ {\n  text-align: right;\n  padding: 10px;\n}\n.ant-table-thead > tr > th {\n  background: #f8f8f9 !important;\n  color: rgba(0, 0, 0, 0.45) !important;\n}\n.ant-table.ant-table-middle .ant-table-thead .ant-table-column-sorters {\n  padding: 0 !important;\n}\n.ant-table-header-column {\n  width: 100% !important;\n  border-right: 1px solid rgba(26, 26, 26, 0.1) !important;\n}\n.ant-pagination-options {\n  margin-left: 10px !important;\n}\n.ant-table-fixed {\n  border-radius: 4px !important;\n}\n.ant-table-thead > tr > th:first-child {\n  border-radius: 4px 0px 0px 4px !important;\n}\n.ant-table-thead > tr > th:last-child {\n  border-radius: 0px 4px 4px 0px !important;\n}\n.ant-table-thead > tr > th {\n  padding: 5px 12px !important;\n  font-weight: normal !important;\n  border-bottom: 0px solid #e8e8e8 !important;\n}\n.ant-table-thead > tr > th:last-child > span {\n  border-right: 0 solid rgba(26, 26, 26, 0.1) !important;\n}\n.react-resizable {\n  position: relative;\n  background-clip: padding-box;\n}\n.react-resizable-handle {\n  position: absolute;\n  right: -6px;\n  bottom: 0;\n  z-index: 1;\n  width: 10px;\n  height: 100%;\n  cursor: col-resize;\n}\n.row-dragging {\n  background: #fafafa;\n  border: 1px solid #ccc;\n}\n.row-dragging td {\n  padding: 16px;\n  visibility: hidden;\n}\n.row-dragging .drag-open {\n  visibility: open;\n}\n.ant-pro-table .ant-card-body {\n  padding-bottom: 0px !important;\n  padding-right: 10px !important;\n  padding-left: 10px !important;\n}\n.ant-pro-table .ant-pro-card-body {\n  padding-bottom: 0px !important;\n  padding-left: 10px !important;\n  padding-right: 10px !important;\n}\n";
var styles$g = {"pagination":"index-module_pagination__1z188","sortTitle":"index-module_sortTitle__3fQu-","activeSort":"index-module_activeSort__3ESTe","ant-table-header-column":"index-module_ant-table-header-column__2kkbE","funcBox":"index-module_funcBox__2N4LJ"};
styleInject(css_248z$g);

/**
 * 排序
 * @type {{ASC: string, DESC: string}}
 */
const SORT = {
  ASC: 'ASC',
  DESC: 'DESC'
};
const noop$1 = () => {};
const propTypesRT = {
  onResize: PropTypes.func,
  width: PropTypes.number
};
const defaultPropsRT = {
  onResize: null,
  width: 0
};
const ResizableTitle = props => {
  const {
    onResize,
    width,
    ...restProps
  } = props;
  if (!width) {
    return /*#__PURE__*/React.createElement("th", restProps);
  }
  return /*#__PURE__*/React.createElement(Resizable, {
    width: width,
    height: 0,
    handle: /*#__PURE__*/React.createElement("span", {
      role: "button",
      "aria-label": "Resize",
      tabIndex: "0",
      onKeyPress: () => {},
      className: "react-resizable-handle",
      onClick: e => {
        e.stopPropagation();
      }
    }),
    onResize: onResize,
    draggableOpts: {
      enableUserSelectHack: false
    }
  }, /*#__PURE__*/React.createElement("th", restProps));
};
ResizableTitle.propTypes = propTypesRT;
ResizableTitle.defaultProps = defaultPropsRT;
const propTypes$h = {
  /**
   * 主键
   */
  rowKey: PropTypes.oneOfType([PropTypes.string, PropTypes.func]).isRequired,
  columns: PropTypes.arrayOf(PropTypes.object),
  // 表头: [title:"姓名"，dataIndex:"name",width:100,className:className,render:()=>{},hide:true]
  /**
   * 表格数据源
   */
  dataSource: PropTypes.arrayOf(PropTypes.object),
  /**
   * 是否展示表格选择
   */
  checked: PropTypes.bool,
  /**
   * 是否展示表格顶部自带的搜索框
   */
  search: PropTypes.bool,
  /**
   * 多选key []
   */
  selectedRowKeys: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.number, PropTypes.string])),
  /**
   * 多选row,这里需要注意，要想获取跨页正确的row必须得把这个必须得有
   */
  selectedRows: PropTypes.arrayOf(PropTypes.shape()),
  onSelectChange: PropTypes.func,
  /**
   * 是否展示序号
   */
  showNumber: PropTypes.bool,
  /**
   * 列宽是否可变
   */
  resizable: PropTypes.bool,
  /**
   * 是否在第一列增加拖拽排序手柄
   */
  dragsortable: PropTypes.bool,
  /**
   * 拖拽排序结束后的动作
   */
  onSortEnd: PropTypes.func,
  /**
   * 表格顶部右侧工具栏，缺省为空
   */
  toolBarRender: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  /**
   * 表格顶部右侧工具栏最右侧的几个小操作按钮
   */
  options: PropTypes.oneOfType([PropTypes.shape(), PropTypes.bool]),
  loading: PropTypes.bool,
  sortInfo: PropTypes.shape({
    sortField: PropTypes.string,
    // 排序字段
    sortOrder: PropTypes.string // 排序内容
  }),
  /**
   * 嵌套表格
   */
  expandedRow: PropTypes.func,
  /**
   * 是否全部展开
   */
  defaultExpandAllRows: PropTypes.bool,
  /**
   * 是否展示分页
   */
  showPagination: PropTypes.bool,
  pageIndex: PropTypes.number,
  pageSize: PropTypes.number,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  total: PropTypes.number,
  /**
   * 分页改变回调
   */
  onChange: PropTypes.func,
  /**
   * 自定义表头
   */
  showCustomizeTableHeader: PropTypes.bool,
  /**
   * 改变表头回调
   */
  onSaveCustomizeTableHeader: PropTypes.func,
  /**
   * 改变表头回调
   */
  bordered: PropTypes.bool,
  /**
   * 是否在表格底部显示选择了多少条数据
   */
  showSelected: PropTypes.bool,
  /**
   * 表格滚动控制
   */
  scroll: PropTypes.shape({}),
  selections: PropTypes.arrayOf(PropTypes.object),
  /**
   * 表格可选
   */
  type: PropTypes.string,
  /**
   * 表格可选
   */
  disabledId: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number]))
};
const defaultProps$f = {
  checked: false,
  search: false,
  selectedRowKeys: [],
  columns: [],
  dataSource: [],
  showNumber: true,
  onSelectChange: noop$1,
  resizable: false,
  dragsortable: false,
  onSortEnd: noop$1,
  toolBarRender: false,
  options: {
    fullScreen: false,
    reload: true,
    setting: true,
    density: false
  },
  loading: false,
  sortInfo: {},
  expandedRow: null,
  showPagination: true,
  pageSizeOptions: [10, 20, 50],
  pageIndex: 1,
  pageSize: 20,
  total: 0,
  onChange: noop$1,
  showCustomizeTableHeader: false,
  onSaveCustomizeTableHeader: noop$1,
  bordered: false,
  showSelected: false,
  defaultExpandAllRows: false,
  scroll: {},
  selections: [],
  type: 'checkbox',
  selectedRows: [],
  disabledId: []
};

/**
 * 通用表格组件
 */
class CommonTableComponent extends Component {
  constructor(_props) {
    super(_props);
    this.DraggableBodyRow = ({
      style,
      ...restProps
    }) => {
      const {
        rowKey,
        dataSource
      } = this.props;
      const SortableItem = sortableElement(props => /*#__PURE__*/React.createElement("tr", props));
      const index = dataSource.findIndex(x => x[rowKey] === restProps['data-row-key']);
      return /*#__PURE__*/React.createElement(SortableItem, _extends({
        index: index
      }, restProps));
    };
    /**
     * 拖拽结束后的动作
     * @param {*} param0
     */
    this.onSortEnd = ({
      oldIndex,
      newIndex
    }) => {
      const {
        onSortEnd
      } = this.props;
      if (oldIndex !== newIndex) {
        onSortEnd(oldIndex, newIndex);
      }
    };
    /**
     * 分页 改变回调
     */
    this.handleChange = (pageIndex, pageSize, sorter) => {
      const {
        onChange
      } = this.props;
      if (onChange) onChange(pageIndex, pageSize, sorter);
    };
    /**
     * 改变每页展示条数
     * @param pageIndex
     * @param pageSize
     */
    this.handleChangePageSize = (pageIndex, pageSize) => {
      const {
        onChange
      } = this.props;
      if (onChange) onChange(1, pageSize);
    };
    this.onSelectChange = (_selectedRowKeys, _selectedRows) => {
      const {
        selectedRowKeys,
        selectedRows,
        onSelectChange,
        dataSource,
        rowKey
      } = this.props;
      const oldSelectedRowKeys = selectedRowKeys.filter(item => !dataSource.find(item1 => item1[rowKey] === item));
      // 从oldSelectedRowKeys中删掉本页已选中，只保留其它页数据
      const oldSelectedRows = selectedRows.filter(item => !dataSource.find(item1 => item1[rowKey] === item[rowKey]));
      const newSelectedRowKeys = [..._selectedRowKeys, ...oldSelectedRowKeys];
      const newSelectedRow = [..._selectedRows, ...oldSelectedRows];
      this.setState({
        selectedRows: newSelectedRowKeys.length
      });
      if (onSelectChange) onSelectChange(newSelectedRowKeys, newSelectedRow);
    };
    /**
     * 表头选择
     * @returns {undefined}
     */
    this.getRowSelection = () => {
      const {
        checked,
        selectedRowKeys,
        selections,
        type,
        rowKey,
        disabledId
      } = this.props;
      let rowSelection;
      if (checked) {
        rowSelection = {
          type,
          selectedRowKeys,
          onChange: this.onSelectChange,
          hideDefaultSelections: true,
          getCheckboxProps: record => ({
            disabled: disabledId.includes(record[rowKey]) // Column configuration not to be checked
          })
        };

        // 增加自定义选择下拉选择
        if (selections.length > 0) {
          rowSelection.selections = [...selections];
        }
      }
      return rowSelection;
    };
    /**
     * 触发排序
     */
    this.handleSortChange = _ => {
      const {
        pageIndex,
        pageSize,
        onChange
      } = this.props;
      const sortInfo = _;
      sortInfo.sortOrder = sortInfo.sortOrder === SORT.DESC ? SORT.ASC : SORT.DESC;
      if (onChange) onChange(pageIndex, pageSize, sortInfo);
    };
    /**
     * 触发修改列宽
     * @param {*} index
     */
    this.handleResize = index => (e, {
      size
    }) => {
      const {
        columns
      } = this.props;
      columns[index].width = size.width;
      // 强制刷新
      this.forceUpdate();
    };
    /**
     * 产生所有列
     */
    this.getTableColumns = () => {
      const {
        showNumber,
        checked,
        pageSize,
        pageIndex,
        sortInfo,
        columns,
        resizable,
        dragsortable
      } = this.props;
      const {
        sortField,
        sortOrder
      } = sortInfo;
      if (!(columns instanceof Array)) return [];
      if (columns.length) {
        // 强行把第一列增加这个属性，以使表格显示正常
        columns[0].ellipsis = true;
      }
      const tableColumns = columns.filter(item => !item.hidden).map(item => {
        const {
          title,
          dataIndex,
          render,
          width,
          sort,
          hide,
          fixed,
          sorter,
          ...otherProps
        } = item;
        const renderServe = (value, record, index) => render ? render(value, record, index) : value || '-';
        let columnsTitle = title;
        if (sort) {
          if (!sortField || !sortOrder) {
            console.error('请正确传入 sortInfo props => {sortField:"sortFieldName",sortOrder:"DESC"}');
          }
          const activeSort = sortField === dataIndex ? styles$g.activeSort : '';
          columnsTitle = /*#__PURE__*/React.createElement("div", {
            role: "button",
            tabIndex: "0",
            className: className(styles$g.sortTitle, activeSort),
            onClick: this.handleSortChange.bind(null, sortInfo),
            onKeyPress: () => {}
          }, /*#__PURE__*/React.createElement("span", null, title), sortOrder === SORT.DESC ? /*#__PURE__*/React.createElement(ArrowDownOutlined, null) : /*#__PURE__*/React.createElement(ArrowUpOutlined, null));
        }
        return {
          title: columnsTitle,
          dataIndex,
          key: dataIndex,
          width,
          sorter: !!sorter,
          fixed,
          render: renderServe,
          ...otherProps
        };
      });
      if (!checked && showNumber) {
        tableColumns.unshift({
          title: '序号',
          dataIndex: '_sortNumber',
          key: '_sortNumber',
          width: 80,
          render: (value, record, index) => (pageIndex - 1) * pageSize + index + 1
        });
      }
      if (dragsortable) {
        const DragHandle = sortableHandle(() => /*#__PURE__*/React.createElement(MenuOutlined, {
          style: {
            cursor: 'pointer',
            color: '#999'
          }
        }));
        tableColumns.unshift({
          title: '',
          dataIndex: 'sort',
          width: 30,
          className: 'drag-open',
          hideInSearch: true,
          render: () => /*#__PURE__*/React.createElement(DragHandle, null)
        });
      }
      if (resizable) {
        return tableColumns.map((col, index) => ({
          ...col,
          onHeaderCell: column => ({
            width: column.width,
            onResize: this.handleResize(index)
          })
        }));
      }
      return tableColumns;
    };
    this.changeCustomizeHeaderShow = () => {
      const {
        showHeaderModal
      } = this.state;
      this.setState({
        showHeaderModal: !showHeaderModal
      });
    };
    this.handleSetColumns = newColumn => {
      const {
        onSaveCustomizeTableHeader
      } = this.props;
      if (onSaveCustomizeTableHeader) onSaveCustomizeTableHeader(newColumn);
      this.setState({
        showHeaderModal: false
      });
    };
    /**
     * 返回表格
     */
    this.renderTable = () => {
      const {
        rowKey,
        showPagination,
        bordered,
        scroll,
        toolBarRender,
        options,
        expandedRow,
        defaultExpandAllRows,
        search,
        pageSize,
        ...otherProps
      } = this.props;
      return /*#__PURE__*/React.createElement(_ConfigProvider, {
        locale: zhCN
      }, /*#__PURE__*/React.createElement(ProTable, _extends({}, otherProps, {
        components: this.components,
        rowKey: rowKey,
        bordered: bordered,
        rowSelection: this.getRowSelection(),
        columns: this.getTableColumns()
        // 这里禁用了表格自身的loading，将来可以放开
        ,
        loading: false,
        search: search
        // 这里用于显示选择了多少条记录，目前暂时禁用
        ,
        tableAlertRender: false,
        toolBarRender: toolBarRender || (() => /*#__PURE__*/React.createElement(React.Fragment, null)),
        options: toolBarRender ? options : false,
        onChange: this.handleChange,
        pagination: showPagination && (search ? {
          pageSize
        } : !showPagination),
        size: "middle",
        expandedRowRender: expandedRow || null,
        defaultExpandAllRows: defaultExpandAllRows,
        scroll: scroll
      })));
    };
    /**
     * 返回分页
     */
    this.renderPagination = () => {
      const {
        showPagination,
        pageSizeOptions,
        pageIndex,
        pageSize,
        total,
        search,
        showSelected
      } = this.props;
      const {
        selectedRows
      } = this.state;
      if (search || !showPagination) return null;
      return /*#__PURE__*/React.createElement(_ConfigProvider, {
        locale: zhCN
      }, /*#__PURE__*/React.createElement(_Pagination, {
        current: pageIndex,
        pageSize: pageSize,
        total: total,
        onChange: this.handleChange
        // onShowSizeChange={this.handleChangePageSize}
        ,
        showTotal: total1 => {
          if (showSelected && selectedRows > 0) {
            return `已选择${selectedRows}条，共 ${total1} 条记录`;
          }
          return `共 ${total1} 条记录`;
        },
        pageSizeOptions: pageSizeOptions.map(value => String(value)),
        showQuickJumper: true,
        showSizeChanger: true,
        style: {
          paddingRight: 24
        }
      }));
    };
    this.state = {
      showHeaderModal: false,
      selectedRows: _props.selectedRowKeys ? _props.selectedRowKeys.length : 0
    };
    this.components = {};
    if (_props.resizable) {
      this.components.header = {
        cell: ResizableTitle
      };
    }
    if (_props.dragsortable) {
      const SortableContainer = sortableContainer(props1 => /*#__PURE__*/React.createElement("tbody", props1));
      const DraggableContainer = props1 => /*#__PURE__*/React.createElement(SortableContainer, _extends({
        useDragHandle: true,
        helperClass: "row-dragging",
        onSortEnd: this.onSortEnd
      }, props1));
      this.components.body = {
        wrapper: DraggableContainer,
        row: this.DraggableBodyRow
      };
    }
  }
  componentDidUpdate(prevProps) {
    const {
      selectedRowKeys
    } = this.props;
    if (prevProps.selectedRowKeys && selectedRowKeys) {
      if (prevProps.selectedRowKeys.length !== selectedRowKeys.length) {
        // eslint-disable-next-line
        this.setState({
          selectedRows: selectedRowKeys ? selectedRowKeys.length : 0
        });
      }
    }
  }
  render() {
    const {
      loading,
      showCustomizeTableHeader,
      columns
    } = this.props;
    const {
      showHeaderModal
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$g.tableComponentBox
    }, /*#__PURE__*/React.createElement(_Spin, {
      spinning: loading,
      size: "large"
    }, showCustomizeTableHeader && /*#__PURE__*/React.createElement("div", {
      className: styles$g.funcBox
    }, /*#__PURE__*/React.createElement(_Button, {
      type: "primary",
      onClick: this.changeCustomizeHeaderShow
    }, "\u81EA\u5B9A\u4E49\u8868\u5934")), /*#__PURE__*/React.createElement("div", {
      className: styles$g.table
    }, this.renderTable()), /*#__PURE__*/React.createElement("div", {
      className: styles$g.pagination
    }, this.renderPagination()), showHeaderModal && /*#__PURE__*/React.createElement(CustomizeTableColumn, {
      column: columns,
      onCancel: this.changeCustomizeHeaderShow,
      onSuccess: this.handleSetColumns
    })));
  }
}
CommonTableComponent.propTypes = propTypes$h;
CommonTableComponent.defaultProps = defaultProps$f;

/*
 * RSA, a suite of routines for performing RSA public-key computations in JavaScript.
 * Copyright 1998-2005 David Shapiro.
 * Dave Shapiro
 * dave@ohdave.com
 * changed by Fuchun, 2010-05-06
 * fcrpg2005@gmail.com
 */
/*
 * RSA, a suite of routines for performing RSA public-key computations in JavaScript.
 * Copyright 1998-2005 David Shapiro.
 * Dave Shapiro
 * dave@ohdave.com
 * changed by Fuchun, 2010-05-06
 * fcrpg2005@gmail.com
 */

(function ($w) {
  let RSAUtils;
  if (typeof $w.RSAUtils === 'undefined') {
    $w.RSAUtils = {};
  }
  RSAUtils = $w.RSAUtils;

  // const biRadixBase = 2
  const biRadixBits = 16;
  const bitsPerDigit = biRadixBits;
  const biRadix = 1 << 16; // = 2^16 = 65536
  const biHalfRadix = biRadix >>> 1;
  const biRadixSquared = biRadix * biRadix;
  const maxDigitVal = biRadix - 1;
  // const maxInteger = 9999999999999998

  // maxDigits:
  // Change this to accommodate your largest number size. Use setMaxDigits()
  // to change it!
  //
  // In general, if you're working with numbers of size N bits, you'll need 2*N
  // bits of storage. Each digit holds 16 bits. So, a 1024-bit key will need
  //
  // 1024 * 2 / 16 = 128 digits of storage.
  //
  let maxDigits;
  let ZERO_ARRAY;
  let bigZero;
  let bigOne;
  $w.SbigInt = function (flag) {
    if (typeof flag === 'boolean' && flag === true) {
      this.digits = null;
    } else {
      this.digits = ZERO_ARRAY.slice(0);
    }
    this.isNeg = false;
  };
  const BigInt = $w.SbigInt;
  RSAUtils.setMaxDigits = function (value) {
    maxDigits = value;
    ZERO_ARRAY = new Array(maxDigits);
    for (let iza = 0; iza < ZERO_ARRAY.length; iza += 1) ZERO_ARRAY[iza] = 0;
    bigZero = new BigInt();
    bigOne = new BigInt();
    bigOne.digits[0] = 1;
  };
  RSAUtils.setMaxDigits(20);

  // The maximum number of digits in base 10 you can convert to an
  // integer without JavaScript throwing up on you.
  const dpl10 = 15;
  RSAUtils.biFromNumber = function (i) {
    const result = new BigInt();
    result.isNeg = i < 0;
    i = Math.abs(i);
    let j = 0;
    while (i > 0) {
      result.digits[j] = i & maxDigitVal;
      j += 1;
      i = Math.floor(i / biRadix);
    }
    return result;
  };

  // lr10 = 10 ^ dpl10
  const lr10 = RSAUtils.biFromNumber(1000000000000000);
  RSAUtils.biFromDecimal = function (s) {
    const isNeg = s.charAt(0) === '-';
    let i = isNeg ? 1 : 0;
    let result;
    // Skip leading zeros.
    while (i < s.length && s.charAt(i) === '0') i += 1;
    if (i === s.length) {
      result = new BigInt();
    } else {
      const digitCount = s.length - i;
      let fgl = digitCount % dpl10;
      if (fgl === 0) fgl = dpl10;
      result = RSAUtils.biFromNumber(Number(s.substr(i, fgl)));
      i += fgl;
      while (i < s.length) {
        result = RSAUtils.biAdd(RSAUtils.biMultiply(result, lr10), RSAUtils.biFromNumber(Number(s.substr(i, dpl10))));
        i += dpl10;
      }
      result.isNeg = isNeg;
    }
    return result;
  };
  RSAUtils.biCopy = function (bi) {
    const result = new BigInt(true);
    result.digits = bi.digits.slice(0);
    result.isNeg = bi.isNeg;
    return result;
  };
  RSAUtils.reverseStr = function (s) {
    let result = '';
    for (let i = s.length - 1; i > -1; i -= 1) {
      result += s.charAt(i);
    }
    return result;
  };
  const hexatrigesimalToChar = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z'];
  RSAUtils.biToString = function (x, radix) {
    // 2 <= radix <= 36
    const b = new BigInt();
    b.digits[0] = radix;
    let qr = RSAUtils.biDivideModulo(x, b);
    let result = hexatrigesimalToChar[qr[1].digits[0]];
    while (RSAUtils.biCompare(qr[0], bigZero) === 1) {
      qr = RSAUtils.biDivideModulo(qr[0], b);
      // digit = qr[1].digits[0]
      result += hexatrigesimalToChar[qr[1].digits[0]];
    }
    return (x.isNeg ? '-' : '') + RSAUtils.reverseStr(result);
  };
  RSAUtils.biToDecimal = function (x) {
    const b = new BigInt();
    b.digits[0] = 10;
    let qr = RSAUtils.biDivideModulo(x, b);
    let result = String(qr[1].digits[0]);
    while (RSAUtils.biCompare(qr[0], bigZero) === 1) {
      qr = RSAUtils.biDivideModulo(qr[0], b);
      result += String(qr[1].digits[0]);
    }
    return (x.isNeg ? '-' : '') + RSAUtils.reverseStr(result);
  };
  const hexToChar = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f'];
  RSAUtils.digitToHex = function (n) {
    const mask = 0xf;
    let result = '';
    for (let i = 0; i < 4; i += 1) {
      result += hexToChar[n & mask];
      n >>>= 4;
    }
    return RSAUtils.reverseStr(result);
  };
  RSAUtils.biToHex = function (x) {
    let result = '';
    // const n = RSAUtils.biHighIndex(x)
    for (let i = RSAUtils.biHighIndex(x); i > -1; i -= 1) {
      result += RSAUtils.digitToHex(x.digits[i]);
    }
    return result;
  };
  RSAUtils.charToHex = function (c) {
    const ZERO = 48;
    const NINE = ZERO + 9;
    const littleA = 97;
    const littleZ = littleA + 25;
    const bigA = 65;
    const bigZ = 65 + 25;
    let result;
    if (c >= ZERO && c <= NINE) {
      result = c - ZERO;
    } else if (c >= bigA && c <= bigZ) {
      result = 10 + c - bigA;
    } else if (c >= littleA && c <= littleZ) {
      result = 10 + c - littleA;
    } else {
      result = 0;
    }
    return result;
  };
  RSAUtils.hexToDigit = function (s) {
    let result = 0;
    const sl = Math.min(s.length, 4);
    for (let i = 0; i < sl; i += 1) {
      result <<= 4;
      result |= RSAUtils.charToHex(s.charCodeAt(i));
    }
    return result;
  };
  RSAUtils.biFromHex = function (s) {
    const result = new BigInt();
    const sl = s.length;
    for (let i = sl, j = 0; i > 0; i -= 4, j += 1) {
      result.digits[j] = RSAUtils.hexToDigit(s.substr(Math.max(i - 4, 0), Math.min(i, 4)));
    }
    return result;
  };
  RSAUtils.biFromString = function (s, radix) {
    const isNeg = s.charAt(0) === '-';
    const istop = isNeg ? 1 : 0;
    let result = new BigInt();
    let place = new BigInt();
    place.digits[0] = 1; // radix^0
    for (let i = s.length - 1; i >= istop; i -= 1) {
      const c = s.charCodeAt(i);
      const digit = RSAUtils.charToHex(c);
      const biDigit = RSAUtils.biMultiplyDigit(place, digit);
      result = RSAUtils.biAdd(result, biDigit);
      place = RSAUtils.biMultiplyDigit(place, radix);
    }
    result.isNeg = isNeg;
    return result;
  };
  RSAUtils.biDump = function (b) {
    return (b.isNeg ? '-' : '') + b.digits.join(' ');
  };
  RSAUtils.biAdd = function (x, y) {
    let result;
    if (x.isNeg !== y.isNeg) {
      y.isNeg = !y.isNeg;
      result = RSAUtils.biSubtract(x, y);
      y.isNeg = !y.isNeg;
    } else {
      result = new BigInt();
      let c = 0;
      let n;
      for (let i = 0; i < x.digits.length; i += 1) {
        n = x.digits[i] + y.digits[i] + c;
        result.digits[i] = n % biRadix;
        c = Number(n >= biRadix);
      }
      result.isNeg = x.isNeg;
    }
    return result;
  };
  RSAUtils.biSubtract = function (x, y) {
    let result;
    if (x.isNeg !== y.isNeg) {
      y.isNeg = !y.isNeg;
      result = RSAUtils.biAdd(x, y);
      y.isNeg = !y.isNeg;
    } else {
      result = new BigInt();
      let n;
      let c;
      c = 0;
      for (let i = 0; i < x.digits.length; i += 1) {
        n = x.digits[i] - y.digits[i] + c;
        result.digits[i] = n % biRadix;
        // Stupid non-conforming modulus operation.
        if (result.digits[i] < 0) result.digits[i] += biRadix;
        c = 0 - Number(n < 0);
      }
      // Fix up the negative sign, if any.
      if (c === -1) {
        c = 0;
        for (let i = 0; i < x.digits.length; i += 1) {
          n = 0 - result.digits[i] + c;
          result.digits[i] = n % biRadix;
          // Stupid non-conforming modulus operation.
          if (result.digits[i] < 0) result.digits[i] += biRadix;
          c = 0 - Number(n < 0);
        }
        // Result is opposite sign of arguments.
        result.isNeg = !x.isNeg;
      } else {
        // Result is same sign.
        result.isNeg = x.isNeg;
      }
    }
    return result;
  };
  RSAUtils.biHighIndex = function (x) {
    let result = x.digits.length - 1;
    while (result > 0 && x.digits[result] === 0) result -= 1;
    return result;
  };
  RSAUtils.biNumBits = function (x) {
    const n = RSAUtils.biHighIndex(x);
    let d = x.digits[n];
    const m = (n + 1) * bitsPerDigit;
    let result;
    for (result = m; result > m - bitsPerDigit; result -= 1) {
      if ((d & 0x8000) !== 0) break;
      d <<= 1;
    }
    return result;
  };
  RSAUtils.biMultiply = function (x, y) {
    const result = new BigInt();
    let c;
    const n = RSAUtils.biHighIndex(x);
    const t = RSAUtils.biHighIndex(y);
    // let u
    let uv;
    let k;
    for (let i = 0; i <= t; i += 1) {
      c = 0;
      k = i;
      for (let j = 0; j <= n; j += 1, k += 1) {
        uv = result.digits[k] + x.digits[j] * y.digits[i] + c;
        result.digits[k] = uv & maxDigitVal;
        c = uv >>> biRadixBits;
        // c = Math.floor(uv / biRadix);
      }
      result.digits[i + n + 1] = c;
    }
    // Someone give me a logical xor, please.
    result.isNeg = x.isNeg !== y.isNeg;
    return result;
  };
  RSAUtils.biMultiplyDigit = function (x, y) {
    // let n
    let c;
    let uv;
    const result = new BigInt();
    const n = RSAUtils.biHighIndex(x);
    c = 0;
    for (let j = 0; j <= n; j += 1) {
      uv = result.digits[j] + x.digits[j] * y + c;
      result.digits[j] = uv & maxDigitVal;
      c = uv >>> biRadixBits;
      // c = Math.floor(uv / biRadix);
    }
    result.digits[1 + n] = c;
    return result;
  };
  RSAUtils.arrayCopy = function (src, srcStart, dest, destStart, n) {
    const m = Math.min(srcStart + n, src.length);
    for (let i = srcStart, j = destStart; i < m; i += 1, j += 1) {
      dest[j] = src[i];
    }
  };
  const highBitMasks = [0x0000, 0x8000, 0xc000, 0xe000, 0xf000, 0xf800, 0xfc00, 0xfe00, 0xff00, 0xff80, 0xffc0, 0xffe0, 0xfff0, 0xfff8, 0xfffc, 0xfffe, 0xffff];
  RSAUtils.biShiftLeft = function (x, n) {
    const digitCount = Math.floor(n / bitsPerDigit);
    const result = new BigInt();
    RSAUtils.arrayCopy(x.digits, 0, result.digits, digitCount, result.digits.length - digitCount);
    const bits = n % bitsPerDigit;
    const rightBits = bitsPerDigit - bits;
    let i;
    let i1;
    for (i = result.digits.length - 1, i1 = i - 1; i > 0; i -= 1, i1 -= 1) {
      result.digits[i] = result.digits[i] << bits & maxDigitVal | (result.digits[i1] & highBitMasks[bits]) >>> rightBits;
    }
    result.digits[0] = result.digits[i] << bits & maxDigitVal;
    result.isNeg = x.isNeg;
    return result;
  };
  const lowBitMasks = [0x0000, 0x0001, 0x0003, 0x0007, 0x000f, 0x001f, 0x003f, 0x007f, 0x00ff, 0x01ff, 0x03ff, 0x07ff, 0x0fff, 0x1fff, 0x3fff, 0x7fff, 0xffff];
  RSAUtils.biShiftRight = function (x, n) {
    const digitCount = Math.floor(n / bitsPerDigit);
    const result = new BigInt();
    RSAUtils.arrayCopy(x.digits, digitCount, result.digits, 0, x.digits.length - digitCount);
    const bits = n % bitsPerDigit;
    const leftBits = bitsPerDigit - bits;
    for (let i = 0, i1 = i + 1; i < result.digits.length - 1; i += 1, i1 += 1) {
      result.digits[i] = result.digits[i] >>> bits | (result.digits[i1] & lowBitMasks[bits]) << leftBits;
    }
    result.digits[result.digits.length - 1] >>>= bits;
    result.isNeg = x.isNeg;
    return result;
  };
  RSAUtils.biMultiplyByRadixPower = function (x, n) {
    const result = new BigInt();
    RSAUtils.arrayCopy(x.digits, 0, result.digits, n, result.digits.length - n);
    return result;
  };
  RSAUtils.biDivideByRadixPower = function (x, n) {
    const result = new BigInt();
    RSAUtils.arrayCopy(x.digits, n, result.digits, 0, result.digits.length - n);
    return result;
  };
  RSAUtils.biModuloByRadixPower = function (x, n) {
    const result = new BigInt();
    RSAUtils.arrayCopy(x.digits, 0, result.digits, 0, n);
    return result;
  };
  RSAUtils.biCompare = function (x, y) {
    if (x.isNeg !== y.isNeg) {
      return 1 - 2 * Number(x.isNeg);
    }
    for (let i = x.digits.length - 1; i >= 0; i -= 1) {
      if (x.digits[i] !== y.digits[i]) {
        if (x.isNeg) {
          return 1 - 2 * Number(x.digits[i] > y.digits[i]);
        }
        return 1 - 2 * Number(x.digits[i] < y.digits[i]);
      }
    }
    return 0;
  };
  RSAUtils.biDivideModulo = function (x, y) {
    let nb = RSAUtils.biNumBits(x);
    let tb = RSAUtils.biNumBits(y);
    const origYIsNeg = y.isNeg;
    let q;
    let r;
    if (nb < tb) {
      // |x| < |y|
      if (x.isNeg) {
        q = RSAUtils.biCopy(bigOne);
        q.isNeg = !y.isNeg;
        x.isNeg = false;
        y.isNeg = false;
        r = RSAUtils.biSubtract(y, x);
        // Restore signs, 'cause they're references.
        x.isNeg = true;
        y.isNeg = origYIsNeg;
      } else {
        q = new BigInt();
        r = RSAUtils.biCopy(x);
      }
      return [q, r];
    }
    q = new BigInt();
    r = x;

    // Normalize Y.
    let t = Math.ceil(tb / bitsPerDigit) - 1;
    let lambda = 0;
    while (y.digits[t] < biHalfRadix) {
      y = RSAUtils.biShiftLeft(y, 1);
      lambda += 1;
      tb += 1;
      t = Math.ceil(tb / bitsPerDigit) - 1;
    }
    // Shift r over to keep the quotient constant. We'll shift the
    // remainder back at the end.
    r = RSAUtils.biShiftLeft(r, lambda);
    nb += lambda; // Update the bit count for x.
    const n = Math.ceil(nb / bitsPerDigit) - 1;
    let b = RSAUtils.biMultiplyByRadixPower(y, n - t);
    while (RSAUtils.biCompare(r, b) !== -1) {
      q.digits[n - t] += 1;
      r = RSAUtils.biSubtract(r, b);
    }
    for (let i = n; i > t; i -= 1) {
      const ri = i >= r.digits.length ? 0 : r.digits[i];
      const ri1 = i - 1 >= r.digits.length ? 0 : r.digits[i - 1];
      const ri2 = i - 2 >= r.digits.length ? 0 : r.digits[i - 2];
      const yt = t >= y.digits.length ? 0 : y.digits[t];
      const yt1 = t - 1 >= y.digits.length ? 0 : y.digits[t - 1];
      if (ri === yt) {
        q.digits[i - t - 1] = maxDigitVal;
      } else {
        q.digits[i - t - 1] = Math.floor((ri * biRadix + ri1) / yt);
      }
      let c1 = q.digits[i - t - 1] * (yt * biRadix + yt1);
      let c2 = ri * biRadixSquared + (ri1 * biRadix + ri2);
      while (c1 > c2) {
        q.digits[i - t - 1] -= 1;
        c1 = q.digits[i - t - 1] * (yt * biRadix | yt1);
        c2 = ri * biRadix * biRadix + (ri1 * biRadix + ri2);
      }
      b = RSAUtils.biMultiplyByRadixPower(y, i - t - 1);
      r = RSAUtils.biSubtract(r, RSAUtils.biMultiplyDigit(b, q.digits[i - t - 1]));
      if (r.isNeg) {
        r = RSAUtils.biAdd(r, b);
        q.digits[i - t - 1] -= 1;
      }
    }
    r = RSAUtils.biShiftRight(r, lambda);
    // Fiddle with the signs and stuff to make sure that 0 <= r < y.
    q.isNeg = x.isNeg !== origYIsNeg;
    if (x.isNeg) {
      if (origYIsNeg) {
        q = RSAUtils.biAdd(q, bigOne);
      } else {
        q = RSAUtils.biSubtract(q, bigOne);
      }
      y = RSAUtils.biShiftRight(y, lambda);
      r = RSAUtils.biSubtract(y, r);
    }
    // Check for the unbelievably stupid degenerate case of r == -0.
    if (r.digits[0] === 0 && RSAUtils.biHighIndex(r) === 0) r.isNeg = false;
    return [q, r];
  };
  RSAUtils.biDivide = function (x, y) {
    return RSAUtils.biDivideModulo(x, y)[0];
  };
  RSAUtils.biModulo = function (x, y) {
    return RSAUtils.biDivideModulo(x, y)[1];
  };
  RSAUtils.biMultiplyMod = function (x, y, m) {
    return RSAUtils.biModulo(RSAUtils.biMultiply(x, y), m);
  };
  RSAUtils.biPow = function (x, y) {
    let result = bigOne;
    let a = x;
    while (true) {
      if ((y & 1) !== 0) result = RSAUtils.biMultiply(result, a);
      y >>= 1;
      if (y === 0) break;
      a = RSAUtils.biMultiply(a, a);
    }
    return result;
  };
  RSAUtils.biPowMod = function (x, y, m) {
    let result = bigOne;
    let a = x;
    let k = y;
    while (true) {
      if ((k.digits[0] & 1) !== 0) {
        result = RSAUtils.biMultiplyMod(result, a, m);
      }
      k = RSAUtils.biShiftRight(k, 1);
      if (k.digits[0] === 0 && RSAUtils.biHighIndex(k) === 0) break;
      a = RSAUtils.biMultiplyMod(a, a, m);
    }
    return result;
  };
  function BarrettMuModulo(x) {
    const $dmath = RSAUtils;
    const q1 = $dmath.biDivideByRadixPower(x, this.k - 1);
    const q2 = $dmath.biMultiply(q1, this.mu);
    const q3 = $dmath.biDivideByRadixPower(q2, this.k + 1);
    const r1 = $dmath.biModuloByRadixPower(x, this.k + 1);
    const r2term = $dmath.biMultiply(q3, this.modulus);
    const r2 = $dmath.biModuloByRadixPower(r2term, this.k + 1);
    let r = $dmath.biSubtract(r1, r2);
    if (r.isNeg) {
      r = $dmath.biAdd(r, this.bkplus1);
    }
    let rgtem = $dmath.biCompare(r, this.modulus) >= 0;
    while (rgtem) {
      r = $dmath.biSubtract(r, this.modulus);
      rgtem = $dmath.biCompare(r, this.modulus) >= 0;
    }
    return r;
  }
  function BarrettMuMultiplyMod(x, y) {
    /*
        x = this.modulo(x);
        y = this.modulo(y);
        */
    const xy = RSAUtils.biMultiply(x, y);
    return this.modulo(xy);
  }
  function BarrettMuPowMod(x, y) {
    let result = new BigInt();
    result.digits[0] = 1;
    let a = x;
    let k = y;
    while (true) {
      if ((k.digits[0] & 1) !== 0) result = this.multiplyMod(result, a);
      k = RSAUtils.biShiftRight(k, 1);
      if (k.digits[0] === 0 && RSAUtils.biHighIndex(k) === 0) break;
      a = this.multiplyMod(a, a);
    }
    return result;
  }
  $w.BarrettMu = function (m) {
    this.modulus = RSAUtils.biCopy(m);
    this.k = RSAUtils.biHighIndex(this.modulus) + 1;
    const b2k = new BigInt();
    b2k.digits[2 * this.k] = 1; // b2k = b^(2k)
    this.mu = RSAUtils.biDivide(b2k, this.modulus);
    this.bkplus1 = new BigInt();
    this.bkplus1.digits[this.k + 1] = 1; // bkplus1 = b^(k+1)
    this.modulo = BarrettMuModulo;
    this.multiplyMod = BarrettMuMultiplyMod;
    this.powMod = BarrettMuPowMod;
  };
  const RSAKeyPair = function (encryptionExponent, decryptionExponent, modulus) {
    const $dmath = RSAUtils;
    this.e = $dmath.biFromHex(encryptionExponent);
    this.d = $dmath.biFromHex(decryptionExponent);
    this.m = $dmath.biFromHex(modulus);
    // We can do two bytes per digit, so
    // chunkSize = 2 * (number of digits in modulus - 1).
    // Since biHighIndex returns the high index, not the number of digits, 1 has
    // already been subtracted.
    this.chunkSize = 2 * $dmath.biHighIndex(this.m);
    this.radix = 16;
    this.barrett = new $w.BarrettMu(this.m);
  };
  RSAUtils.getKeyPair = function (encryptionExponent, decryptionExponent, modulus) {
    return new RSAKeyPair(encryptionExponent, decryptionExponent, modulus);
  };
  if (typeof $w.twoDigit === 'undefined') {
    $w.twoDigit = function (n) {
      return (n < 10 ? '0' : '') + String(n);
    };
  }

  // Altered by Rob Saunders (rob@robsaunders.net). New routine pads the
  // string after it has been converted to an array. This fixes an
  // incompatibility with Flash MX's ActionScript.
  RSAUtils.encryptedString = function (key, s) {
    const a = [];
    const sl = s.length;
    let i = 0;
    while (i < sl) {
      a[i] = s.charCodeAt(i);
      i += 1;
    }
    while (a.length % key.chunkSize !== 0) {
      a[i] = 0;
      i += 1;
    }
    const al = a.length;
    let result = '';
    let j;
    let k;
    let block;
    for (i = 0; i < al; i += key.chunkSize) {
      block = new BigInt();
      j = 0;
      for (k = i; k < i + key.chunkSize; j += 1) {
        block.digits[j] = a[k];
        k += 1;
        block.digits[j] += a[k] << 8;
        k += 1;
      }
      const crypt = key.barrett.powMod(block, key.e);
      const text = key.radix === 16 ? RSAUtils.biToHex(crypt) : RSAUtils.biToString(crypt, key.radix);
      result += `${text} `;
    }
    return result.substring(0, result.length - 1); // Remove last space.
  };
  RSAUtils.decryptedString = function (key, s) {
    const blocks = s.split(' ');
    let result = '';
    let i;
    let j;
    let block;
    for (i = 0; i < blocks.length; i += 1) {
      let bi;
      if (key.radix === 16) {
        bi = RSAUtils.biFromHex(blocks[i]);
      } else {
        bi = RSAUtils.biFromString(blocks[i], key.radix);
      }
      block = key.barrett.powMod(bi, key.d);
      for (j = 0; j <= RSAUtils.biHighIndex(block); j += 1) {
        result += String.fromCharCode(block.digits[j] & 255, block.digits[j] >> 8);
      }
    }
    // Remove trailing null, if any.
    if (result.charCodeAt(result.length - 1) === 0) {
      result = result.substring(0, result.length - 1);
    }
    return result;
  };
  RSAUtils.setMaxDigits(130);
})(window);

/**
 * 简单函数防抖
 * @param action
 * @param delay
 * @returns {Function}
 */
const debounce = function debounce(action, delay = 300, ...args) {
  let timer = null;
  return function funcDebounce(...args1) {
    clearTimeout(timer);
    timer = setTimeout(() => {
      action.apply(this, args1, args);
    }, delay);
  };
};

/**
 * 将秒转换为 分:秒
 * second  秒数
 */
const formatMS = second => {
  // 计算分钟
  let m = Math.floor(second / 60);
  // 计算秒
  let s = second % 60;
  // 将变量转换为字符串
  m += '';
  s += '';
  // 如果只有一位数，前面增加一个0
  s = s.length === 1 ? `0${s}` : s;
  return `${m}:${s}`;
};

/**
 * 获取URL指定参数
 * @param pathName 参数名
 * @returns {string|null}
 */
const getRequest = pathName => {
  const reg = new RegExp(`(^|&)${pathName}=([^&]*)(&|$)`); // 构造一个含有目标参数的正则表达式对象
  const r = window.location.search.substr(1).match(reg); // 匹配目标参数
  if (r != null) {
    return decodeURI(r[2]);
  }
  return null; // 返回参数值
};

/**
 * 将http链接转化为https链接
 * @param {string} value url链接
 */
const forceHttps = value => {
  if (value) {
    return window.location.protocol === 'https:' ? value.replace(/^http:\/\//i, 'https://') : value;
  }
  return '';
};

/**
 * 清理前端缓存LocalStorage
 */
const clearLocalStorage = () => {
  const reportDowload = localStorage.getItem('report-dowload'); // 特殊情况 报表需要退出的时候保留缓存,这里不想一个一个清理localStorage了
  const p = localStorage.getItem('p');
  const customerMessageHeader = localStorage.getItem('customer-message-header');
  localStorage.clear();
  if (reportDowload) localStorage.setItem('report-dowload', reportDowload);
  if (p) localStorage.setItem('p', p);
  if (customerMessageHeader) localStorage.setItem('customer-message-header', customerMessageHeader);
};

/**
 * 退出登录清理cookie+localStorage
 * @param {*} url
 */

const logout = async (url, type) => {
  Cookies.remove('userid');
  Cookies.remove('company');
  // 部分电脑之前登录过 导致还有这个，程序先清理下，后续这个代码可以删除（dialTimes）
  Cookies.remove('dialTimes');
  Cookies.remove('user', {
    path: '/',
    domain: 'yunkecn.com'
  });
  Cookies.remove('userToken', {
    path: '/',
    domain: 'yunkecn.com'
  });
  clearLocalStorage();
  if (url) {
    window.location.href = url;
  }
  if (type === 1) {
    window.localStorage.setItem('ischatworkbench', '1');
  }
};

// import message from 'antd/es/message';
// import { message } from 'antd';
// 这么写会导致vite build后按cjs进行加载,这里强制使用es
const captureError = params => {
  window.capture?.error(params);
};
const isInIframe = () => {
  return window.self !== window.top;
};
class Request {
  constructor() {
    this.Instance = axios.create({
      timeout: 60000 * 2,
      // 10s超时
      responseType: 'json',
      withCredentials: true
    });
    this.InstancePhone = axios.create({
      responseType: 'json',
      withCredentials: true
    });
    this.setBaseURL = baseURL => {
      this.Instance.interceptors.request.use(_ => {
        const config = _;
        config.baseURL = baseURL;
        return config;
      });
    };
    /** z
     * get 方式发送请求
     * @param url 地址
     * @param params 参数
     * @timeout 超时时间
     */
    this.get = (url, params = {}, headers = {}, timeout = 60000) => this.Instance({
      method: 'get',
      url,
      params,
      headers,
      timeout
    });
    /**
     * delete 方式发送请求
     * @param {*} url
     * @param {*} data 需要删除的ID
     */
    this.deleteJson = (url, data) => this.Instance({
      method: 'DELETE',
      url,
      data
    });
    /**
     * 以json的形式发送请求
     * @param url 地址
     * @param data 数据
     */
    this.postJson = (url, data, headers = {
      channel: 4,
      source: 'yunkepc',
      'content-type': 'application/json'
    }, timeout = 60000) => this.Instance.post(url, data, {
      headers,
      timeout
    });
    /**
     * 上传手机号5000条。容易超时。用这个
     */
    this.postJsonPhone = (url, data) => this.InstancePhone.post(url, data);
    /**
     * form表单提交
     * @param url
     * @param data
     * @returns {1}
     */
    this.postForm = (url, data, headers, timeout) => this.Instance.post(url, data, {
      headers: {
        'content-type': 'application/x-www-form-urlencoded',
        userId: '',
        ...headers
      },
      timeout
    });
    const searchParams = new URLSearchParams(window.location.search);
    const user = searchParams.get('user');
    if (user && user !== 'null') {
      sessionStorage.setItem('user', user);
    }
    const search = new URLSearchParams(encodeURI(window.location.search));
    const str = decodeURIComponent(search.get('cookie'));
    if (str) {
      if (isInIframe) {
        str.split(';').forEach(item => {
          document.cookie = `${item}; path=/; samesite=none; secure`;
        });
      } else {
        str.split(';').forEach(item => {
          document.cookie = `${item}; path=/`;
        });
      }
    }
    this.Instance.interceptors.response.use(response => {
      // // 接口发送成功，无返回数据
      // if (!response) {
      //   message.error('当前网络环境不佳，请检查网络');
      //   return Promise.reject(new Error('error'));
      // }
      const {
        data
      } = response;
      // 未有效登录信息-接口失败
      if (data === undefined || data === null) {
        // message.error('接口发生错误');
        captureError({
          error: '接口错误 -> data is null',
          tags: {
            EVENTTYPE: 'fetch_no_data'
          },
          extra: response
        });
        return {};
      }
      if (data.code === 302) {
        if (localStorage.getItem('color') === 'ec') {
          window.location.href = '/cms/wechat/noAuthPage';
          return;
        }
        if (data.data === '/pc/personalFrame/frame') {
          // 这个地址不跳转了，因为后台么有改没办法前端处理这个，这个是错误的废弃地址
          return data;
        }
        if (data.data === '/pc/accountCheck/index') {
          window.location.href = data.data;
        } else {
          if (!['/cms/auth/forgotpass'].includes(window.location.pathname)) {
            /**
             *  阿维塔 反馈 302 后会提示很多信息， 用此方法解决
             *  为什么不用 message key 来实现 因为 new Request 每次都会 生成一个实例 message key 会存在多个实例中
             *  所以 不用message key 来实现
             */
            document.querySelectorAll('.ant-message-notice')?.forEach(e => e?.remove());
            // message.error({
            //   content: data.message || '登录失败',
            //   key: 'messge_error',
            // });
          }
          window.location.href = data.data;
        }
      }
      return data;
    }, error => {
      const errInfo = error?.response;
      captureError({
        error: `接口错误 -> ${error}`,
        tags: {
          EVENTTYPE: 'fetch_error'
        },
        extra: errInfo
      });
      return Promise.reject(error);
    });
    this.Instance.interceptors.request.use(config => {
      // 网络不好 接口未发送
      if (!navigator.onLine) {
        // message.error('当前网络环境不佳，请检查网络');
        return config;
      }
      const newConfig = {
        ...config
      };
      const {
        userId
      } = JSON.parse(localStorage.getItem('userData')) || {};
      if (!newConfig.headers.userId) {
        newConfig.headers.userId = userId || '';
      }
      if (sessionStorage.getItem('user')) {
        newConfig.headers.user = sessionStorage.getItem('user');
      }
      if (sessionStorage.getItem('token')) {
        newConfig.headers.token = sessionStorage.getItem('token');
      }
      if (sessionStorage.getItem('userId')) {
        newConfig.headers.userId = sessionStorage.getItem('userId');
      }
      if (sessionStorage.getItem('source')) {
        newConfig.headers.source = sessionStorage.getItem('source');
      }
      if (localStorage.getItem('company')) {
        newConfig.headers.company = localStorage.getItem('company');
      }
      if ((newConfig?.url?.startsWith('/wxz') || newConfig?.url?.startsWith('/cashier') || newConfig?.url?.startsWith('/wll') || newConfig?.url?.startsWith('/yxz') || newConfig?.url?.startsWith('/wll-rpa') || newConfig?.url?.startsWith('/vcard-api')) && window.location.host?.startsWith('crm') && window.location.host?.includes('.yunkecn.com')) {
        if (localStorage.getItem('isTest')) {
          newConfig.baseURL = 'https://test.yunkecn.com';
        } else {
          newConfig.baseURL = 'https://crm.yunkecn.com';
        }
      }
      // if (!newConfig.url.includes('http')) {
      //   const baseURL = !window.location.host.includes('localhost')
      //  && localStorage.getItem('domain') !== 'undefined' ? localStorage.getItem('domain') : '';
      //   newConfig.baseURL = baseURL;
      // }
      const searchUrl = config.url?.split('?')[1] ? `?${config.url?.split('?')[1]}` : '';
      // 这里暂时写死域名调试微小助用，这些域名的后台没有返回privateValue
      const channelInfo = JSON.parse(localStorage.getItem('channelInfo')); // 判断是否是私有部署环境
      if (channelInfo?.privateValue === 'ENV-private' && channelInfo?.useLocalNewWxz !== 1 && config.url.startsWith('/wxz')) {
        newConfig.url = `/usercenter/redirect/post${searchUrl}`;
        newConfig.method = 'post';
        newConfig.data = {
          url: `${window.location.protocol}//crm.yunkecn.com${config.url}`,
          method: config.method,
          contentType: config.headers['content-type'],
          params: JSON.stringify(config.data) || qs.stringify(config.params),
          header: JSON.stringify({
            cookie: document.cookie,
            source: config.headers.source
          })
        };
      }
      return newConfig;
    });
  }
  /**
   * form-data 方式提交
   * @param {*} url
   * @param {*} data
   */
  formData(url, data = {}, headers, timeout) {
    const form = new FormData();
    if (JSON.stringify(data) !== '{}') {
      Object.entries(data).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item, index) => {
            if (typeof item === 'object') {
              Object.entries(item).forEach(([itemKey, itemValue]) => {
                form.set(`${key}[${index}].${itemKey}`, itemValue);
              });
            } else {
              form.set(`${key}[${index}]`, item);
            }
          });
        } else {
          form.set(key, value);
        }
      });
    }
    return this.Instance.post(url, form, {
      headers: {
        'content-type': 'multipart/form-data',
        userId: '',
        ...headers
      },
      timeout
    });
  }

  // eslint-disable-next-line class-methods-use-this
  async download(url, data, {
    responseType = 'arraybuffer',
    method = 'post',
    fileType = '.xlsx',
    name,
    headers = {
      'content-type': 'application/json'
    }
  } = {}) {
    try {
      const stringData = JSON.stringify(data);
      axios.defaults.withCredentials = true;
      const res = await axios({
        method,
        url,
        data: stringData === '{}' ? undefined : data,
        responseType,
        headers: {
          ...headers,
          user: sessionStorage.getItem('user') ? sessionStorage.getItem('user') : '',
          userId: sessionStorage.getItem('userId'),
          token: sessionStorage.getItem('token'),
          source: sessionStorage.getItem('source')
        }
      });
      const blob = new Blob([res.data]);
      const blobUrl = window.URL.createObjectURL(blob);
      const {
        headers: herder
      } = res;
      const fileName = herder['content-disposition'];
      const urlName = name || fileName?.split('=')[1] || new Date().getTime() + fileType;
      const aElement = document.createElement('a');
      document.body.appendChild(aElement);
      aElement.style.display = 'none';
      aElement.href = blobUrl;
      aElement.download = urlName;
      aElement.click();
      document.body.removeChild(aElement);
      return Promise.resolve(urlName);
    } catch (error) {
      return Promise.reject(error);
    }
  }

  // eslint-disable-next-line class-methods-use-this
  async downloadWithoutCredentials(url, data, {
    responseType = 'arraybuffer',
    method = 'post',
    fileType = '.xlsx',
    name,
    headers = {
      'content-type': 'application/json'
    }
  } = {}) {
    try {
      const stringData = JSON.stringify(data);
      const res = await axios({
        method,
        url,
        data: stringData === '{}' ? undefined : data,
        responseType,
        headers
      });
      const blob = new Blob([res.data]);
      const blobUrl = window.URL.createObjectURL(blob);
      const {
        headers: herder
      } = res;
      const fileName = herder['content-disposition'];
      const urlName = name || fileName?.split('=')[1] || new Date().getTime() + fileType;
      const aElement = document.createElement('a');
      document.body.appendChild(aElement);
      aElement.style.display = 'none';
      aElement.href = blobUrl;
      aElement.download = urlName;
      aElement.click();
      document.body.removeChild(aElement);
      return Promise.resolve(urlName);
    } catch (error) {
      return Promise.reject(error);
    }
  }
}
var request = new Request();

const Emitter = function () {
  let instance = null;
  return class {
    constructor() {
      if (!instance) {
        instance = new EventEmitter();
      }
      return instance;
    }
  };
}();
var Emitter$1 = new Emitter();

var img$I = "data:image/png;base64,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";

var img$H = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAOZlWElmTU0AKgAAAAgABgESAAMAAAABAAEAAAEaAAUAAAABAAAAVgEbAAUAAAABAAAAXgExAAIAAAAiAAAAZgEyAAIAAAAUAAAAiIdpAAQAAAABAAAAnAAAAAAAAABIAAAAAQAAAEgAAAABQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpADIwMjA6MDk6MjkgMTk6NTk6NTcAAASQBAACAAAAFAAAANKgAQADAAAAAQABAACgAgAEAAAAAQAAABigAwAEAAAAAQAAABgAAAAAMjAyMDowOToyOSAxOTo1OTo1NwBNlXJmAAAACXBIWXMAAAsTAAALEwEAmpwYAAAJmWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIKICAgICAgICAgICAgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIKICAgICAgICAgICAgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIgogICAgICAgICAgICB4bWxuczpwaG90b3Nob3A9Imh0dHA6Ly9ucy5hZG9iZS5jb20vcGhvdG9zaG9wLzEuMC8iCiAgICAgICAgICAgIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8eG1wTU06SW5zdGFuY2VJRD54bXAuaWlkOjcxM2JhNzY0LTM4ZGEtODE0Ny04MjNkLTY5Y2U2ZDUxMGJmNjwveG1wTU06SW5zdGFuY2VJRD4KICAgICAgICAgPHhtcE1NOkRvY3VtZW50SUQ+YWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOjY5NDY0MTNhLTM0ZDgtYjc0Yi05NjFmLWU4M2NjOTRkNzJhMTwveG1wTU06RG9jdW1lbnRJRD4KICAgICAgICAgPHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD54bXAuZGlkOjQ1NDRhY2JlLTA0ZmQtMWM0NC05NjljLWY1M2RjNDAzN2ExZDwveG1wTU06T3JpZ2luYWxEb2N1bWVudElEPgogICAgICAgICA8eG1wTU06SGlzdG9yeT4KICAgICAgICAgICAgPHJkZjpTZXE+CiAgICAgICAgICAgICAgIDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVzb3VyY2UiPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6c29mdHdhcmVBZ2VudD5BZG9iZSBQaG90b3Nob3AgQ0MgMjAxOCAoV2luZG93cyk8L3N0RXZ0OnNvZnR3YXJlQWdlbnQ+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDp3aGVuPjIwMjAtMDktMjlUMTk6NTk6NTcrMDg6MDA8L3N0RXZ0OndoZW4+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDppbnN0YW5jZUlEPnhtcC5paWQ6NDU0NGFjYmUtMDRmZC0xYzQ0LTk2OWMtZjUzZGM0MDM3YTFkPC9zdEV2dDppbnN0YW5jZUlEPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6YWN0aW9uPmNyZWF0ZWQ8L3N0RXZ0OmFjdGlvbj4KICAgICAgICAgICAgICAgPC9yZGY6bGk+CiAgICAgICAgICAgICAgIDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVzb3VyY2UiPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6c29mdHdhcmVBZ2VudD5BZG9iZSBQaG90b3Nob3AgQ0MgMjAxOCAoV2luZG93cyk8L3N0RXZ0OnNvZnR3YXJlQWdlbnQ+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDpjaGFuZ2VkPi88L3N0RXZ0OmNoYW5nZWQ+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDp3aGVuPjIwMjAtMDktMjlUMTk6NTk6NTcrMDg6MDA8L3N0RXZ0OndoZW4+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDppbnN0YW5jZUlEPnhtcC5paWQ6NzEzYmE3NjQtMzhkYS04MTQ3LTgyM2QtNjljZTZkNTEwYmY2PC9zdEV2dDppbnN0YW5jZUlEPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6YWN0aW9uPnNhdmVkPC9zdEV2dDphY3Rpb24+CiAgICAgICAgICAgICAgIDwvcmRmOmxpPgogICAgICAgICAgICA8L3JkZjpTZXE+CiAgICAgICAgIDwveG1wTU06SGlzdG9yeT4KICAgICAgICAgPHhtcDpNb2RpZnlEYXRlPjIwMjAtMDktMjlUMTk6NTk6NTcrMDg6MDA8L3htcDpNb2RpZnlEYXRlPgogICAgICAgICA8eG1wOkNyZWF0b3JUb29sPkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE4IChXaW5kb3dzKTwveG1wOkNyZWF0b3JUb29sPgogICAgICAgICA8eG1wOk1ldGFkYXRhRGF0ZT4yMDIwLTA5LTI5VDE5OjU5OjU3KzA4OjAwPC94bXA6TWV0YWRhdGFEYXRlPgogICAgICAgICA8eG1wOkNyZWF0ZURhdGU+MjAyMC0wOS0yOVQxOTo1OTo1NyswODowMDwveG1wOkNyZWF0ZURhdGU+CiAgICAgICAgIDxwaG90b3Nob3A6Q29sb3JNb2RlPjM8L3Bob3Rvc2hvcDpDb2xvck1vZGU+CiAgICAgICAgIDxwaG90b3Nob3A6RG9jdW1lbnRBbmNlc3RvcnM+CiAgICAgICAgICAgIDxyZGY6QmFnPgogICAgICAgICAgICAgICA8cmRmOmxpPjE0RDQzNTg5NzQ4RjlBQ0Y0RkQ3NTVGNzg4MTM5OUI4PC9yZGY6bGk+CiAgICAgICAgICAgIDwvcmRmOkJhZz4KICAgICAgICAgPC9waG90b3Nob3A6RG9jdW1lbnRBbmNlc3RvcnM+CiAgICAgICAgIDxkYzpmb3JtYXQ+aW1hZ2UvcG5nPC9kYzpmb3JtYXQ+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgp7Rf5BAAAHOUlEQVRIDW1Va2wU1xk9d+bOzL7X+/DaXuM19oKxjZPgAsGQR50UFdJISUoLalSqFqkiUqKoaaKmTylLlB9Vqv7oQzQ0zY82Uis5SksDioJKYzvEhpQYKI6ha2Mva7zeXbzeh/fh3Z3H7R23RDTlSiPNnPvN9zj3fucDPrMYiwifgRAdP9V9bfzEE9Gz7zxyY+L03tv3h4YgDg0NiYwxcjseiUAwsf8BhyMR+lAkopmGx44xaUfLy8/bbdGdFqdrp88bDNRrIphuxXIifZwSW9nnD/3Ouf3QyC3Hkydf22ejQl947+GXb2GfBmBD+0Vy4C09FhtuWJ06/XMbLT7iaXe3uDa1AHoIjEkagUp0NUdEsSQYKwksTsSy8zn/4V1PfO+jf4y/t62Nzv7F41BxJU1nqqvNP7zvq8+9vRZgiDs/wJ3nzrxxT6Jw/u32cCXsCG4FbH0GqJdXJFNA5NSJDGwVIAUdrGygdE1OzI1iNdXNWnx3k0zhAoIdK7pErOLNpAszN5RnRRaJCH3PHDWKo3/uqaRP/L1zo9QmhQfUqr2Z8KyJoFUpQ5EwVMCMGgGrE2h1QVPrYt0mMq/TB5adJLXsEuzOXraQSAh+Z7JqtxI6HysZlEQihslXNvH+m6GN5QBC3XUiCrIFizBIFTDcPGOZP9yICDAMDYRokKwyJGYQyBp83R1sceoM2BIhHlBo5YJIaQkKDRR46cD5d3/wiqVyth++u4xMsiRlVy5CctbR2toIUeGUaIz7d0NHCaJcgq45cX3agFpegs1WQ7PbToLcdvHGGVAigTILMUoUxKATYmrsVKCeHhvqaFOliWhFn451iFR+EKlkAFOXJtHotcDmykI3MmunUC6KGD4dRz7Xzqvrw2xUQXzuDEJeP9y8ukLiAmyKbDDdLsylvH+kyX+Obt/QpFquzs7oBfsR8eFHB3nWDkiKC5nkDpwZOYq9e1ZgcS5BrXXiwxED6zq+jp7uz4GpnJAHdVw834dzH/0GD4RLsOsE5YUSBF8AEKy6oNCVB621JJLVx43Nux4mdYWiqFfxr2gcNmcQG3ofQ3w6xolsQGJ+FrJjAO1dAyipFlTVLK7OTqNzUz8M1wPI5M9BtrUaxVSO3kgqmqWhKSrUjZXNan4Ubu9GCLLHjIrpmSh67lqPJw8+iWzO5LITWL3JOV+Fr3EdNEIhSiI+GD+J3k2b8VLkR+AdiGrufhC2ZNRVK3Il//y9X/vxZaGSz2gW3QUxMwlVS0BWJFyZum6ePd559yTOf/w3uOx1oD4Lu6SjkElCIgbXAQUfjP3H7he/PIZU9CKnxwqhmkUVLujM+iYhpE6hSiqqAXiLI7hxsR+N9+/DF3fvw9Ff1ZBLT+Du9hxczpu8AjtanC7ErnG76T6s7+3Dt759EF5PDUgtoduShZUtoVjmBcvr0N7bM2omKR76wpZw0+rCbosiGulkRkzGM7CKIpobLVjvT2NLVwkORx7FxVaeOQ8SMhCbvoCb8xk4mIGAR0OIzqKlOg9aua7VqERzrsHZnm9896UjR35Wp2XqH1/IN6BNuCht8iisXHqdaDOv8jPpgmJvxdS5ONZ3+HHq5Cfo7WuCN+gALRK0W4+jGC2gxTClIwfbug5WzgZpPEUNsrH3BUIai6YECeh/bOKm2LwAuYEzd01vcTCEPJsQtDvgk8tw2yR8cimDvY974XCuIna1gJC/DL9rBeE2bmtjsIsueAa2av5dO5BeVt8a2Pedvw7tx5q+CXv27CmXG1r/tIggVKowIvLmVqv8sMoQtCJ6NsjYPehDE1eMns4Af29Gk59rXSUPvZRAPHUBNd8GroeMFJGFFOwbN7lvfHpwTUjXpKJv4L6j0bPZZ8XKnMVnE1Vq5CRqKCA1B/S6DCLJvKkU1KslVLUFVNQKiOqEoLdjJdCEjvVNQC3Hu30F67bszJsBbi0a4Te/5aFD18d//+r+2Fz+BFXOS14YqlAzJE22Y9koo14rQqAiiGKFxd0Eh9UO2d4ASXQjYEnxRFKMZXJ1qrZRqxK0ms6d0128ghEIPICxn9+mXd988aQR3Pbly/kdhUzOJy0niTY3l0OVifCEPAiEm9HY2QJXswNOtwAFy0ysXDG0pbhWTl8lesFqW04G1Wa5d9IMsNWze02l13gygcggaGQE2ok//DRkSUwdtyxN9geb01rnPUHOLx8HuiQYosjnbFWHWjF0ndPIVVPT+xFfceSrpPXXvq5t77Vu/8qYOaMPHDigm34/DWB+DEcG+Uwe0fiwlj58/SevBI3LLzZJ78PubYSmJ3inq7pi6ecD3oV0sY681BWz2O69Jje4X2j7/MG1zBl3Tv7r/P8CmMCxY4elp576rWq+D7/2/Pet9dQzojC9KFnCYa+nzZ9Ox0/A2V6we1tHe7/03Bt8+jDTlg0PUiw9zW53buJ3XOYY5Rtr1WWil1pNo5mxsXDy47FH7/ADMbO+A74G/RuzTS9vaTg1gwAAAABJRU5ErkJggg==";

var img$G = "data:image/png;base64,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";

var img$F = "data:image/png;base64,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";

var img$E = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAABkUlEQVRIS2NkoDFghJoPov/3uAvlO3wXNSPFzgOcr0+V7Hw3kYGBAWwGul6QIFziib3BRVExeV1SLHj96uFlmYMX9JEdiqwfwwIuDlEdUiz49uP1lVELGP4pPAMnBqYHUiiRyM3HxUh2HIA0f/307f9nr7+MYh4sYAte7fjzn3cb83+YHEiM5Di4+/6bJkijEDsHC4OECINCFzfj/0cPwC5nlFNgfFD29T/DizcM737++AMSUxbkuk5SJL//9g8lmcpMk2AQYHrB+O0/9/9f/3kZnmS9QElkglxMpCVTdAtAvhDM+QkOovdT2MGuRwaUW8DAAA8OcLChAapYgC/jkWTBbhXBMxKCskYgA0GRCHIxIfrF+8fnXO+8NyGqqABZwMYlqkdKUfHr2+tLg8uCn/84DWA+4OXh+ff5yxcmEB8Xm53p+wWSfIBsATFBRYwF4EwKqiw2aCt2CTKzFhBjMEzN+7+/JwRcvV+Gr8KBWwBi6CmLi5FiwaW7L1/hSkEwg0kxj2S1sDqZZI3Eahj6FgAABYIPKMSs5dgAAAAASUVORK5CYII=";

var img$D = "data:image/png;base64,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";

var img$C = "data:image/png;base64,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";

var img$B = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAOZlWElmTU0AKgAAAAgABgESAAMAAAABAAEAAAEaAAUAAAABAAAAVgEbAAUAAAABAAAAXgExAAIAAAAiAAAAZgEyAAIAAAAUAAAAiIdpAAQAAAABAAAAnAAAAAAAAABIAAAAAQAAAEgAAAABQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpADIwMjA6MDk6MjkgMTk6NTc6NTIAAASQBAACAAAAFAAAANKgAQADAAAAAQABAACgAgAEAAAAAQAAABigAwAEAAAAAQAAABgAAAAAMjAyMDowOToyOSAxOTo1Nzo1MgAEN8KrAAAACXBIWXMAAAsTAAALEwEAmpwYAAAJmWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIKICAgICAgICAgICAgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIKICAgICAgICAgICAgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIgogICAgICAgICAgICB4bWxuczpwaG90b3Nob3A9Imh0dHA6Ly9ucy5hZG9iZS5jb20vcGhvdG9zaG9wLzEuMC8iCiAgICAgICAgICAgIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8eG1wTU06SW5zdGFuY2VJRD54bXAuaWlkOjdmYjczMzRiLTkwZjYtN2I0ZS05ZGM4LWJmZTg4NTlkOTQyMTwveG1wTU06SW5zdGFuY2VJRD4KICAgICAgICAgPHhtcE1NOkRvY3VtZW50SUQ+YWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOmZlOWRhYzIyLTJhOGEtODU0My1iNDIzLTQwYjg0N2JmOTk2NzwveG1wTU06RG9jdW1lbnRJRD4KICAgICAgICAgPHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD54bXAuZGlkOjhmN2M2MzQyLTYwOGUtOTk0OS1iZjE0LTQ3MTQyYjA1NmJlNTwveG1wTU06T3JpZ2luYWxEb2N1bWVudElEPgogICAgICAgICA8eG1wTU06SGlzdG9yeT4KICAgICAgICAgICAgPHJkZjpTZXE+CiAgICAgICAgICAgICAgIDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVzb3VyY2UiPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6c29mdHdhcmVBZ2VudD5BZG9iZSBQaG90b3Nob3AgQ0MgMjAxOCAoV2luZG93cyk8L3N0RXZ0OnNvZnR3YXJlQWdlbnQ+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDp3aGVuPjIwMjAtMDktMjlUMTk6NTc6NTIrMDg6MDA8L3N0RXZ0OndoZW4+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDppbnN0YW5jZUlEPnhtcC5paWQ6OGY3YzYzNDItNjA4ZS05OTQ5LWJmMTQtNDcxNDJiMDU2YmU1PC9zdEV2dDppbnN0YW5jZUlEPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6YWN0aW9uPmNyZWF0ZWQ8L3N0RXZ0OmFjdGlvbj4KICAgICAgICAgICAgICAgPC9yZGY6bGk+CiAgICAgICAgICAgICAgIDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVzb3VyY2UiPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6c29mdHdhcmVBZ2VudD5BZG9iZSBQaG90b3Nob3AgQ0MgMjAxOCAoV2luZG93cyk8L3N0RXZ0OnNvZnR3YXJlQWdlbnQ+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDpjaGFuZ2VkPi88L3N0RXZ0OmNoYW5nZWQ+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDp3aGVuPjIwMjAtMDktMjlUMTk6NTc6NTIrMDg6MDA8L3N0RXZ0OndoZW4+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDppbnN0YW5jZUlEPnhtcC5paWQ6N2ZiNzMzNGItOTBmNi03YjRlLTlkYzgtYmZlODg1OWQ5NDIxPC9zdEV2dDppbnN0YW5jZUlEPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6YWN0aW9uPnNhdmVkPC9zdEV2dDphY3Rpb24+CiAgICAgICAgICAgICAgIDwvcmRmOmxpPgogICAgICAgICAgICA8L3JkZjpTZXE+CiAgICAgICAgIDwveG1wTU06SGlzdG9yeT4KICAgICAgICAgPHhtcDpNb2RpZnlEYXRlPjIwMjAtMDktMjlUMTk6NTc6NTIrMDg6MDA8L3htcDpNb2RpZnlEYXRlPgogICAgICAgICA8eG1wOkNyZWF0b3JUb29sPkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE4IChXaW5kb3dzKTwveG1wOkNyZWF0b3JUb29sPgogICAgICAgICA8eG1wOk1ldGFkYXRhRGF0ZT4yMDIwLTA5LTI5VDE5OjU3OjUyKzA4OjAwPC94bXA6TWV0YWRhdGFEYXRlPgogICAgICAgICA8eG1wOkNyZWF0ZURhdGU+MjAyMC0wOS0yOVQxOTo1Nzo1MiswODowMDwveG1wOkNyZWF0ZURhdGU+CiAgICAgICAgIDxwaG90b3Nob3A6Q29sb3JNb2RlPjM8L3Bob3Rvc2hvcDpDb2xvck1vZGU+CiAgICAgICAgIDxwaG90b3Nob3A6RG9jdW1lbnRBbmNlc3RvcnM+CiAgICAgICAgICAgIDxyZGY6QmFnPgogICAgICAgICAgICAgICA8cmRmOmxpPjE0RDQzNTg5NzQ4RjlBQ0Y0RkQ3NTVGNzg4MTM5OUI4PC9yZGY6bGk+CiAgICAgICAgICAgIDwvcmRmOkJhZz4KICAgICAgICAgPC9waG90b3Nob3A6RG9jdW1lbnRBbmNlc3RvcnM+CiAgICAgICAgIDxkYzpmb3JtYXQ+aW1hZ2UvcG5nPC9kYzpmb3JtYXQ+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo3R6rqAAAG60lEQVRIDYVWe2wcRxn/zezjnvbZ58fZPr9jJ45JcO06StxaKaYPKAiQKvkoUigi4qEIlVf/cCGATBRFShBShcQfROGfFFp0FrRIRoKWNknViCa1nTSu3cZOnPhtn5+3t7t3u7ezw+y1piJE4rsbze3M7O97/eb7DriPcM4JHwS9z5a3pN5vPZnsl7z37t37n4VkMiklEgm2c/DyX48fjvjNY0V+ncpypEYGaSQkO6/Zxrxulmym16NnHnnm53d2zntKhPCd5/9SwPkgJWTQ9TZnh08ccdnaL/zVNF61tyGIUA1A6sSO58A2wBfhbixheXI5bW/QcYRajzc98b3LApwNDg5SMQo4sgfmiWc5IQnG196qnn73zZMI3j5av6cWtLRLYDbmOQkKYzjPIy/mGigkzml0G/Geu5HM6kivMz196fbwrwcE1JlHMOiFt6CgEGfhj3gp4enB7JU/n2mMTR6NP7DPplVdDL4Az7makmerMmeLisoWZdVZlLm9qjiOobg06BbVHnRK2yKQ7Ounxl/95Vf7BuEk+yF5eIUQ8QuDMukbdMZePtldKb1xJX5wPzTagPfHb9KyWBV272sCJ56zEgjxDHOFL2LmDFnNwPrSBorK/W7UWKFzY6tIlXQePPD5gatcREX+OClOciIZLrr2+3Px/SGq6YxNvHdBqmlW4A+lwR0ThIYFYJkAl8GpLhTqQh3H5vw8VqZmcVeRaH1Vpd3UWKxqH37wM3Hwy5hMcHkoQbwwscaxK1+pKjc6IAcZcWel7oeKoVRUAtQSw4Tr5oTVm8IDFS63wJABcxnqWgKoa/4UHEPHxsqGAtvi1ar+pbfPD/SSZ06/TRNDYJ4X5dn1AVUWL/IYCRS1wPWFYWwZMDIuDNNB3iMu1QDnBqT8Xfi4DMqisCwqwpRGzmEIlYQIUy2nLJpGBV/2Ei78FbL8t3Ntana+VZICuD4lkYsjK6hr8KMmXg9HBIIR4YFlojquYE+LX4Q+jJF/UVwdWURTcxwlpUVgFhFeqchbW7Q9T6E6Ts/NkZfKP1KQulXfGHD8uqa6Z18aI2eTN3Dk6QTO/vbH4JKIoGSD6QyX3/ojykqXYNlFePhzrwvTZnDi1Gk899QxESKGAFWwnN3AreHzKE+P8oiZUQo01ayUYtoGWM5Hdtc3ek6hq6MVes7Alr6NjJ6GoZvCFxuKTeHLOTj2tHfpgNa6GPLbJjQ9i6y+BltPCa9t8ckohrWsFGj6jxd+cLjJHrtUV+PwlL8Zq1uUBMNhZBWGHCWgsgOS11BRFcauqjSQdzC3GcP8qoGgGoWr2yI3tuBUVhiZZbuzprS+zVdGO57cXwhRSayM8yU/nPTrKPenEY2Xwi+7oEEFLBQCFL/42njn6iwCglTx2nIUuys41CzukrsksP2Q0gSbawZmfYQHtClkyR6y3tZuFxTsbW9L3Vx414puwVeCNe6qFkhxGNw1BQvCcGW/AMqiuaIJ10fXkd5wsba6iJ4Ho1DFfcstrWNhUsbERhav5HX+jdg2WGnp9Pdbv6DRpEhhcUfipu5G/2CzVhDdceScDpLjYgjrc6qgoyrcl6BxBzU1PjTUAg8+HAOTRJHJOMjMGnDGb6DIymKZqnTNbAexS37n5Yiiv9+bEajb95s72SonndlSXK6Kq0Rg2yJEaQprwcbGmA5fah2tpQQhU8R8xoA+msH2eyb0mS0EeAQsS91RZ1XiVvXKo92P/93DLSTZ80KUOvbOr757tnLzzW/LylJ+vbhOWbYU1OoSAqkcyJqNsGpDbimBI+iYn9PANyXkBQlyUg4+V8YbyLC1riLpsbKe9w89++Knvb5QoGl/UqgQcvCpr5+cr37UNCqblbua7Z4Yv43Lczr0W64oAyY2FwRPLqZh/jOFzEwOaUHN1MoW2DrFhLkE2hAjP+w9gMpqq4R0/ijiYRYUENHBviO4Qnb1zqkVVeeaOzrx2OF9+f5du/GX4G13OkbcYEZUazMLZ9MA1yxwI4/t7Qx3ihV3NeSwrYYK3vfkfhauDEDPCopdf0F0Ja/+fiwDyX4yNDTJDaV9oqXeeraxoViNh0L27HxGvuhziFweE2wKMkOmTFf9bjoUdOdiJfRafTEdKpqiBzo/S7q7D0mbmqzPLDjfenH42h2vTxdysKPkgugLfaIvXPrTT0+2tfiei4RU//BrH9z5yeQNJ6QEWttcBbJiQdR4UNeHNJNxxdTm+x7osY60t7/aVeZ/edYmZvdD3/xQHBEpEFV9B3xn3unLU5fO72XEORoklafqe7+ofe34kc8saJkn1syUP+fmnbpIrT8eiV3sDJa+9vzzp8X1/kR2MD5ZuefXRy30nsX//0g4T4q/LoV+/J/T/wYVE09ZpvWgmgAAAABJRU5ErkJggg==";

var img$A = "data:image/png;base64,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";

var img$z = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAOZlWElmTU0AKgAAAAgABgESAAMAAAABAAEAAAEaAAUAAAABAAAAVgEbAAUAAAABAAAAXgExAAIAAAAiAAAAZgEyAAIAAAAUAAAAiIdpAAQAAAABAAAAnAAAAAAAAABIAAAAAQAAAEgAAAABQWRvYmUgUGhvdG9zaG9wIENDIDIwMTggKFdpbmRvd3MpADIwMjA6MDk6MjkgMTk6NTc6MDgAAASQBAACAAAAFAAAANKgAQADAAAAAQABAACgAgAEAAAAAQAAABigAwAEAAAAAQAAABgAAAAAMjAyMDowOToyOSAxOTo1NzowOADmZD9xAAAACXBIWXMAAAsTAAALEwEAmpwYAAAJmWlUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iWE1QIENvcmUgNS40LjAiPgogICA8cmRmOlJERiB4bWxuczpyZGY9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkvMDIvMjItcmRmLXN5bnRheC1ucyMiPgogICAgICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIgogICAgICAgICAgICB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIKICAgICAgICAgICAgeG1sbnM6c3RFdnQ9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZUV2ZW50IyIKICAgICAgICAgICAgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIgogICAgICAgICAgICB4bWxuczpwaG90b3Nob3A9Imh0dHA6Ly9ucy5hZG9iZS5jb20vcGhvdG9zaG9wLzEuMC8iCiAgICAgICAgICAgIHhtbG5zOmRjPSJodHRwOi8vcHVybC5vcmcvZGMvZWxlbWVudHMvMS4xLyIKICAgICAgICAgICAgeG1sbnM6dGlmZj0iaHR0cDovL25zLmFkb2JlLmNvbS90aWZmLzEuMC8iPgogICAgICAgICA8eG1wTU06SW5zdGFuY2VJRD54bXAuaWlkOmIyYzljNjVlLWI1NzUtYTU0Yi04Y2FiLWM0ZGI2MzAxZDYzNTwveG1wTU06SW5zdGFuY2VJRD4KICAgICAgICAgPHhtcE1NOkRvY3VtZW50SUQ+YWRvYmU6ZG9jaWQ6cGhvdG9zaG9wOjdmMGRjZjllLWI1NTMtOTA0My1iZTkwLWFlZTI4MmEwM2U2ZTwveG1wTU06RG9jdW1lbnRJRD4KICAgICAgICAgPHhtcE1NOk9yaWdpbmFsRG9jdW1lbnRJRD54bXAuZGlkOjk2YmY4NjNmLWZjOTQtMjI0NC04N2FlLTJkYmQ3ODZjNjZhNzwveG1wTU06T3JpZ2luYWxEb2N1bWVudElEPgogICAgICAgICA8eG1wTU06SGlzdG9yeT4KICAgICAgICAgICAgPHJkZjpTZXE+CiAgICAgICAgICAgICAgIDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVzb3VyY2UiPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6c29mdHdhcmVBZ2VudD5BZG9iZSBQaG90b3Nob3AgQ0MgMjAxOCAoV2luZG93cyk8L3N0RXZ0OnNvZnR3YXJlQWdlbnQ+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDp3aGVuPjIwMjAtMDktMjlUMTk6NTc6MDgrMDg6MDA8L3N0RXZ0OndoZW4+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDppbnN0YW5jZUlEPnhtcC5paWQ6OTZiZjg2M2YtZmM5NC0yMjQ0LTg3YWUtMmRiZDc4NmM2NmE3PC9zdEV2dDppbnN0YW5jZUlEPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6YWN0aW9uPmNyZWF0ZWQ8L3N0RXZ0OmFjdGlvbj4KICAgICAgICAgICAgICAgPC9yZGY6bGk+CiAgICAgICAgICAgICAgIDxyZGY6bGkgcmRmOnBhcnNlVHlwZT0iUmVzb3VyY2UiPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6c29mdHdhcmVBZ2VudD5BZG9iZSBQaG90b3Nob3AgQ0MgMjAxOCAoV2luZG93cyk8L3N0RXZ0OnNvZnR3YXJlQWdlbnQ+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDpjaGFuZ2VkPi88L3N0RXZ0OmNoYW5nZWQ+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDp3aGVuPjIwMjAtMDktMjlUMTk6NTc6MDgrMDg6MDA8L3N0RXZ0OndoZW4+CiAgICAgICAgICAgICAgICAgIDxzdEV2dDppbnN0YW5jZUlEPnhtcC5paWQ6YjJjOWM2NWUtYjU3NS1hNTRiLThjYWItYzRkYjYzMDFkNjM1PC9zdEV2dDppbnN0YW5jZUlEPgogICAgICAgICAgICAgICAgICA8c3RFdnQ6YWN0aW9uPnNhdmVkPC9zdEV2dDphY3Rpb24+CiAgICAgICAgICAgICAgIDwvcmRmOmxpPgogICAgICAgICAgICA8L3JkZjpTZXE+CiAgICAgICAgIDwveG1wTU06SGlzdG9yeT4KICAgICAgICAgPHhtcDpNb2RpZnlEYXRlPjIwMjAtMDktMjlUMTk6NTc6MDgrMDg6MDA8L3htcDpNb2RpZnlEYXRlPgogICAgICAgICA8eG1wOkNyZWF0b3JUb29sPkFkb2JlIFBob3Rvc2hvcCBDQyAyMDE4IChXaW5kb3dzKTwveG1wOkNyZWF0b3JUb29sPgogICAgICAgICA8eG1wOk1ldGFkYXRhRGF0ZT4yMDIwLTA5LTI5VDE5OjU3OjA4KzA4OjAwPC94bXA6TWV0YWRhdGFEYXRlPgogICAgICAgICA8eG1wOkNyZWF0ZURhdGU+MjAyMC0wOS0yOVQxOTo1NzowOCswODowMDwveG1wOkNyZWF0ZURhdGU+CiAgICAgICAgIDxwaG90b3Nob3A6Q29sb3JNb2RlPjM8L3Bob3Rvc2hvcDpDb2xvck1vZGU+CiAgICAgICAgIDxwaG90b3Nob3A6RG9jdW1lbnRBbmNlc3RvcnM+CiAgICAgICAgICAgIDxyZGY6QmFnPgogICAgICAgICAgICAgICA8cmRmOmxpPjE0RDQzNTg5NzQ4RjlBQ0Y0RkQ3NTVGNzg4MTM5OUI4PC9yZGY6bGk+CiAgICAgICAgICAgIDwvcmRmOkJhZz4KICAgICAgICAgPC9waG90b3Nob3A6RG9jdW1lbnRBbmNlc3RvcnM+CiAgICAgICAgIDxkYzpmb3JtYXQ+aW1hZ2UvcG5nPC9kYzpmb3JtYXQ+CiAgICAgICAgIDx0aWZmOk9yaWVudGF0aW9uPjE8L3RpZmY6T3JpZW50YXRpb24+CiAgICAgIDwvcmRmOkRlc2NyaXB0aW9uPgogICA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgpZUcoCAAAG7ElEQVRIDXVWa2wcVxk9987Mvl/2eut1/IgfsU0fTqFgSmIjYqlAK1Epaql5CClVhYSgFPEjCm2R0EZIJZQ/fahC/EBUUB51JaqIVCWkquOU4ISEuI2bB7Gzduy1d7229zU7uzuzM3P5ZkqjINqR5nXv3PPdc77z3TvAxxxCpPh0ap/8Md0f1ez9qMb/AxBCsJOHJyTGUiYNsMWS8P3r1Se9kXu7n+BodsksLFkmPzpw32PHMmfPxtdn335UqZTGIj7lM1rDmtMC/nVIbON42XomlUoZ7NaoDjgdwmlbmX95ILv0z31hn+fJcNTji7VFuoIBLxiTkVvXDLlgLTVLm0E9q3f1jowBLb2wLRtWbhlqfhuBnYNP+Sf2H7nJQKRSnMBtB/zKG0e+o2XOPTMyEmv1JDohBfsBkbTAvNRfF8mE6kFzZdjMZ7F5MWeVrDU7GOxjQknCE40Zdm0+kF29vo+gjrgMiAqn0wVf+uNTz7d36j9QBndATvSY4HEOhCDg57aQIIQBiTcFWEMwaEC5zIvX3oC6GULPrq/D9HcJFLfF4sxfeHq9/IAbgDRh9CCu/PngL3rj6YO+4RHTbBviwmRcgh+QZdjuFxJkJqFWruDKpTQqVS/8EscdfdcgbZ1BaeML2DH2qDBUTeRmjvNwrPPLXEynZAf8+msvPdQWWD8odYZNEY1IMta4opTAlQKEvQRmL0CSFlGspHHi7ffgC43iEyNfRaLjS3jnpIymtAv+wAVsp09aXM/zgsZyrfsfOy2zCdctQGXmx607bfBAJ8r5AlvIZ8AbUbQkPejtiQDkB8ZMXL20iOGhQxi4czeqahNtHW3gvq9h7tyLmLijB6ULv0feGkdDi52hnGqkL/D+H3728G3ha/dwb9EqZNLyzIk6jOa3EWx9CIvpHvzj1Cox0GBpBVjVIbQne1ApFSCZmyhpeSjhfvisIeh61o5R6hSWX9xz6OlvOdiuixR785DHKwF60D5/ySt9euJxdO7oRUOqon94HBdm3kQ6/QI9RwFJwGyWEQwkIGocAUVBuVoGt9agWBvUH4ZVy7PM7KxrGn7j4rEWu7req3COytY6C7WOId6WhFotoFj2oEJG6RvoBVmeMmVioPcGLs8fg1YvwFYs1NUNZBeOoj1+mYzVYGK7AgvGwPL8m7tdBvPlMrrqmxZrGBBhSndzA8zUYPiIEd39ngjWSmWE/XG8e6oA0wpgsPs8/n2WnCMnYFc20e/NoIOGWtkaZGOb7OtnZbsWcwLwXLbOYOjUO4+o14Oo+Q7Sl04hYEsIyUHoWxso5M6hLd7Ee+dz+OmDr5Jxvdg7uIC7Wl7HaPdFJD1ZiGIWUp1SSsxEw4Za0gmUcjDc4RfmjZBs6CF4NB19yRiu536Di/kbUKK3AdWrlI9zaPHHEPUzbJGy78+t4vP3CgQVKrz6GoRVJzZUL00KYLbCajDI3DbcAOPj3yydnn19sVlPJjxqDF6Rxe2tMWjW39CU0wjvbIPsoXVPCyJJARUatbq6ANzdQ4ASyRkA5363EAW3YNumsHiIdXQmSWOSyFncNCl5umLL0GvLgpeK4NkMomoDrWYIitYAL9Ps7Ay6+4qIdQD5XJ6Kr0qyUgArRDAUwEPg3oaoEOYWD2V3f3HvZTeAczG673xuNcfXGhpXoDKbq4RX3gJK9LlGBUZFZtcNtLcEcODxcXS1J8CERdLU6EOymVDB5SpMu2BVbXKc0vpSpOu+7ekUKTW9D/KDk99dE/bgtFaJoKkxU9TKEE2ym+HoSvKYW6S1QoUmMDEaw6d2JbC50qDANDtyGgwqwpptVUtMWVUT+fDIA790Jj6DlM03v/eIu/4n7vnKrxbMIXO9tKJYwrDtpkb0KWmOGXSDPK7SuUKMFuA3thC0iVm9RgQqaNRtUSysmNlqP0TX557de/9kIUUTd1Zoci/gvpyEOffK4QNSfvblYPWvJEePqfiFxAOMcQ9pTaums6LSCy3ZHNwmiRolWLqwt9SGWWe3ewpi4LejT7xyYIrqeZLEI2iqCef6352M7nzuT89+v3L17M87lb/74lEVciDU9HrIKZJPFrQLgJP0NJSbmmVUM0KtQck090Bv2/Pr8W8ceJqF786LqSmJTU5aDrYb4JYg7uPGW7/bv7pw5sVa9ni4N2pGQ7Sdm41lyhjlkZMypL0lDUlqM4qKvLMc7Rt94a6Hf/QTd/At4M77zQBuJzE5TL5NET1i45l+/od9XlY8pBfXdvgjifsjAdopyZqyvwW5snoi3r3r3U9+duw51jO+7mBNTT3CJydfc2fu4DnH/wT4oOlmu5v8D9uWzx+dsHU9bsJbj4XjIjEy9hbNxa1WB4cmRPvFBz8MH45x7v8BEVBOtASbW8kAAAAASUVORK5CYII=";

var img$y = "data:image/png;base64,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";

var img$x = "data:image/png;base64,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";

var img$w = "data:image/png;base64,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";

var img$v = "data:image/png;base64,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";

var img$u = "data:image/png;base64,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";

var img$t = "data:image/png;base64,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";

var img$s = "data:image/png;base64,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";

const TextLength = val => {
  const data = val.replace(/\[微笑\]/g, '').replace(/\[撇嘴\]/g, '').replace(/\[色\]/g, '').replace(/\[发呆\]/g, '').replace(/\[得意\]/g, '').replace(/\[流泪\]/g, '').replace(/\[害羞\]/g, '').replace(/\[闭嘴\]/g, '').replace(/\[睡\]/g, '').replace(/\[大哭\]/g, '').replace(/\[尴尬\]/g, '').replace(/\[发怒\]/g, '').replace(/\[调皮\]/g, '').replace(/\[呲牙\]/g, '').replace(/\[惊讶\]/g, '').replace(/\[难过\]/g, '').replace(/\[酷\]/g, '').replace(/\[冷汗\]/g, '').replace(/\[抓狂\]/g, '').replace(/\[吐\]/g, '').replace(/\[偷笑\]/g, '').replace(/\[愉快\]/g, '').replace(/\[白眼\]/g, '').replace(/\[傲慢\]/g, '').replace(/\[饥饿\]/g, '').replace(/\[困\]/g, '').replace(/\[惊恐\]/g, '').replace(/\[流汗\]/g, '').replace(/\[憨笑\]/g, '').replace(/\[悠闲\]/g, '').replace(/\[奋斗\]/g, '').replace(/\[咒骂\]/g, '').replace(/\[疑问\]/g, '').replace(/\[嘘\]/g, '').replace(/\[晕\]/g, '').replace(/\[疯了\]/g, '').replace(/\[衰\]/g, '').replace(/\[骷髅\]/g, '').replace(/\[敲打\]/g, '').replace(/\[再见\]/g, '').replace(/\[擦汗\]/g, '').replace(/\[抠鼻\]/g, '').replace(/\[鼓掌\]/g, '').replace(/\[糗大了\]/g, '').replace(/\[坏笑\]/g, '').replace(/\[左哼哼\]/g, '').replace(/\[右哼哼\]/g, '').replace(/\[哈欠\]/g, '').replace(/\[鄙视\]/g, '').replace(/\[委屈\]/g, '').replace(/\[快哭了\]/g, '').replace(/\[阴险\]/g, '').replace(/\[亲亲\]/g, '').replace(/\[吓\]/g, '').replace(/\[可怜\]/g, '').replace(/\[菜刀\]/g, '').replace(/\[西瓜\]/g, '').replace(/\[啤酒\]/g, '').replace(/\[篮球\]/g, '').replace(/\[乒乓\]/g, '').replace(/\[咖啡\]/g, '').replace(/\[饭\]/g, '').replace(/\[猪头\]/g, '').replace(/\[玫瑰\]/g, '').replace(/\[凋谢\]/g, '').replace(/\[嘴唇\]/g, '').replace(/\[爱心\]/g, '').replace(/\[心碎\]/g, '').replace(/\[蛋糕\]/g, '').replace(/\[闪电\]/g, '').replace(/\[炸弹\]/g, '').replace(/\[刀\]/g, '').replace(/\[足球\]/g, '').replace(/\[瓢虫\]/g, '').replace(/\[便便\]/g, '').replace(/\[月亮\]/g, '').replace(/\[太阳\]/g, '').replace(/\[礼物\]/g, '').replace(/\[拥抱\]/g, '').replace(/\[强\]/g, '').replace(/\[弱\]/g, '').replace(/\[握手\]/g, '').replace(/\[胜利\]/g, '').replace(/\[抱拳\]/g, '').replace(/\[勾引\]/g, '').replace(/\[拳头\]/g, '').replace(/\[差劲\]/g, '').replace(/\[爱你\]/g, '').replace(/\[NO\]/g, '').replace(/\[OK\]/g, '').replace(/\[爱情\]/g, '').replace(/\[飞吻\]/g, '').replace(/\[跳跳\]/g, '').replace(/\[发抖\]/g, '').replace(/\[怄火\]/g, '').replace(/\[转圈\]/g, '').replace(/\[磕头\]/g, '').replace(/\[回头\]/g, '').replace(/\[跳绳\]/g, '').replace(/\[投降\]/g, '').replace(/\[激动\]/g, '').replace(/\[乱舞\]/g, '').replace(/\[献吻\]/g, '').replace(/\[左太极\]/g, '').replace(/\[右太极\]/g, '').replace(/<span>/g, '').replace(/<\/span>/g, '');
  return data;
};
const TextEmoji = val => {
  let data;
  if (val) {
    data = val.replace(/\[微笑\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/0.gif" alt="[微笑]" />').replace(/\[撇嘴\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/1.gif" alt="[撇嘴]" />').replace(/\[色\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/2.gif" alt="[色]" />').replace(/\[发呆\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/3.gif" alt="[发呆]" />').replace(/\[得意\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/4.gif" alt="[得意]" />').replace(/\[流泪\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/5.gif" alt="[流泪]" />').replace(/\[害羞\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/6.gif" alt="[害羞]" />').replace(/\[闭嘴\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/7.gif" alt="[闭嘴]" />').replace(/\[睡\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/8.gif" alt="[睡]" />').replace(/\[大哭\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/9.gif" alt="[大哭]" />').replace(/\[尴尬\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/10.gif" alt="[尴尬]" />').replace(/\[发怒\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/11.gif" alt="[发怒]" />').replace(/\[调皮\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/12.gif" alt="[调皮]" />').replace(/\[呲牙\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/13.gif" alt="[呲牙]" />').replace(/\[惊讶\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/14.gif" alt="[惊讶]" />').replace(/\[难过\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/15.gif" alt="[难过]" />').replace(/\[酷\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/16.gif" alt="[酷]" />').replace(/\[冷汗\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/17.gif" alt="[冷汗]" />').replace(/\[抓狂\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/18.gif" alt="[抓狂]" />').replace(/\[吐\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/19.gif" alt="[吐]" />').replace(/\[偷笑\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/20.gif" alt="[偷笑]" />').replace(/\[愉快\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/21.gif" alt="[愉快]" />').replace(/\[白眼\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/22.gif" alt="[白眼]" />').replace(/\[傲慢\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/23.gif" alt="[傲慢]" />').replace(/\[饥饿\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/24.gif" alt="[饥饿]" />').replace(/\[困\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/25.gif" alt="[困]" />').replace(/\[惊恐\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/26.gif" alt="[惊恐]" />').replace(/\[流汗\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/27.gif" alt="[流汗]" />').replace(/\[憨笑\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/28.gif" alt="[憨笑]" />').replace(/\[悠闲\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/29.gif" alt="[悠闲]" />').replace(/\[奋斗\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/30.gif" alt="[奋斗]" />').replace(/\[咒骂\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/31.gif" alt="[咒骂]" />').replace(/\[疑问\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/32.gif" alt="[疑问]" />').replace(/\[嘘\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/33.gif" alt="[嘘]" />').replace(/\[晕\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/34.gif" alt="[晕]" />').replace(/\[疯了\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/35.gif" alt="[疯了]" />').replace(/\[衰\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/36.gif" alt="[衰]" />').replace(/\[骷髅\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/37.gif" alt="[骷髅]" />').replace(/\[敲打\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/38.gif" alt="[敲打]" />').replace(/\[再见\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/39.gif" alt="[再见]" />').replace(/\[擦汗\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/40.gif" alt="[擦汗]" />').replace(/\[抠鼻\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/41.gif" alt="[抠鼻]" />').replace(/\[鼓掌\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/42.gif" alt="[鼓掌]" />').replace(/\[糗大了\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/43.gif" alt="[糗大了]" />').replace(/\[坏笑\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/44.gif" alt="[坏笑]" />').replace(/\[左哼哼\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/45.gif" alt="[左哼哼]" />').replace(/\[右哼哼\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/46.gif" alt="[右哼哼]" />').replace(/\[哈欠\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/47.gif" alt="[哈欠]" />').replace(/\[鄙视\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/48.gif" alt="[鄙视]" />').replace(/\[委屈\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/49.gif" alt="[委屈]" />').replace(/\[快哭了\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/50.gif" alt="[快哭了]" />').replace(/\[阴险\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/51.gif" alt="[阴险]" />').replace(/\[亲亲\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/52.gif" alt="[亲亲]" />').replace(/\[吓\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/53.gif" alt="[吓]" />').replace(/\[可怜\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/54.gif" alt="[可怜]" />').replace(/\[菜刀\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/55.gif" alt="[菜刀]" />').replace(/\[西瓜\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/56.gif" alt="[西瓜]" />').replace(/\[啤酒\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/57.gif" alt="[啤酒]" />').replace(/\[篮球\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/58.gif" alt="[篮球]" />').replace(/\[乒乓\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/59.gif" alt="[乒乓]" />').replace(/\[咖啡\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/60.gif" alt="[咖啡]" />').replace(/\[饭\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/61.gif" alt="[饭]" />').replace(/\[猪头\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/62.gif" alt="[猪头]" />').replace(/\[玫瑰\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/63.gif" alt="[玫瑰]" />').replace(/\[凋谢\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/64.gif" alt="[凋谢]" />').replace(/\[嘴唇\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/65.gif" alt="[嘴唇]" />').replace(/\[爱心\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/66.gif" alt="[爱心]" />').replace(/\[心碎\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/67.gif" alt="[心碎]" />').replace(/\[蛋糕\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/68.gif" alt="[蛋糕]" />').replace(/\[闪电\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/69.gif" alt="[闪电]" />').replace(/\[炸弹\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/70.gif" alt="[炸弹]" />').replace(/\[刀\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/71.gif" alt="[刀]" />').replace(/\[足球\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/72.gif" alt="[足球]" />').replace(/\[瓢虫\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/73.gif" alt="[瓢虫]" />').replace(/\[便便\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/74.gif" alt="[便便]" />').replace(/\[月亮\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/75.gif" alt="[月亮]" />').replace(/\[太阳\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/76.gif" alt="[太阳]" />').replace(/\[礼物\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/77.gif" alt="[礼物]" />').replace(/\[拥抱\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/78.gif" alt="[拥抱]" />').replace(/\[强\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/79.gif" alt="[强]" />').replace(/\[弱\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/80.gif" alt="[弱]" />').replace(/\[握手\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/81.gif" alt="[握手]" />').replace(/\[胜利\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/82.gif" alt="[胜利]" />').replace(/\[抱拳\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/83.gif" alt="[抱拳]" />').replace(/\[勾引\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/84.gif" alt="[勾引]" />').replace(/\[拳头\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/85.gif" alt="[拳头]" />').replace(/\[差劲\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/86.gif" alt="[差劲]" />').replace(/\[爱你\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/87.gif" alt="[爱你]" />').replace(/\[NO\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/88.gif" alt="[NO]" />').replace(/\[OK\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/89.gif" alt="[OK]" />').replace(/\[爱情\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/90.gif" alt="[爱情]" />').replace(/\[飞吻\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/91.gif" alt="[飞吻]" />').replace(/\[跳跳\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/92.gif" alt="[跳跳]" />').replace(/\[发抖\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/93.gif" alt="[发抖]" />').replace(/\[怄火\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/94.gif" alt="[怄火]" />').replace(/\[转圈\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/95.gif" alt="[转圈]" />').replace(/\[磕头\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/96.gif" alt="[磕头]" />').replace(/\[回头\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/97.gif" alt="[回头]" />').replace(/\[跳绳\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/98.gif" alt="[跳绳]" />').replace(/\[投降\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/99.gif" alt="[投降]" />').replace(/\[激动\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/100.gif" alt="[激动]" />').replace(/\[乱舞\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/101.gif" alt="[乱舞]" />').replace(/\[献吻\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/102.gif" alt="[献吻]" />').replace(/\[左太极\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/103.gif" alt="[左太极]" />').replace(/\[右太极\]/g, '<img src="https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/104.gif" alt="[右太极]" />').replace(/\[奸笑\]/g, `<img src="${img$I}" alt="[奸笑]" />`).replace(/\[嘿哈\]/g, `<img src="${img$H}" alt="[嘿哈]" />`).replace(/\[捂脸\]/g, `<img src="${img$G}" alt="[捂脸]" />`).replace(/\[机智\]/g, `<img src="${img$F}" alt="[机智]" />`).replace(/\[红包\]/g, `<img src="${img$E}" alt="[红包]" />`).replace(/\[耶\]/g, `<img src="${img$D}" alt="[耶]" />`).replace(/\[皱眉\]/g, `<img src="${img$C}" alt="[皱眉]" />`).replace(/\[吃瓜\]/g, `<img src="${img$B}" alt="[吃瓜]" />`).replace(/\[汗\]/g, `<img src="${img$A}" alt="[汗]" />`).replace(/\[天啊\]/g, `<img src="${img$z}" alt="[天啊]" />`).replace(/\[Emm\]/g, `<img src="${img$y}" alt="[Emm]" />`).replace(/\[社会社会\]/g, `<img src="${img$x}" alt="[社会社会]" />`).replace(/\[旺柴\]/g, `<img src="${img$w}" alt="[旺柴]" />`).replace(/\[好的\]/g, `<img src="${img$v}" alt="[好的]" />`).replace(/\[打脸\]/g, `<img src="${img$u}" alt="[打脸]" />`).replace(/\[加油\]/g, `<img src="${img$t}" alt="[加油]" />`).replace(/\[哇\]/g, `<img src="${img$s}" alt="[哇]" />`);
  }
  return data;
};
const list = ['微笑', '撇嘴', '色', '发呆', '得意', '流泪', '害羞', '闭嘴', '睡', '大哭', '尴尬', '发怒', '调皮', '呲牙', '惊讶', '难过', '酷', '冷汗', '抓狂', '吐', '偷笑', '愉快', '白眼', '傲慢', '饥饿', '困', '惊恐', '流汗', '憨笑', '悠闲', '奋斗', '咒骂', '疑问', '嘘', '晕', '疯了', '衰', '骷髅', '敲打', '再见', '擦汗', '抠鼻', '鼓掌', '糗大了', '坏笑', '左哼哼', '右哼哼', '哈欠', '鄙视', '委屈', '快哭了', '阴险', '亲亲', '吓', '可怜', '菜刀', '西瓜', '啤酒', '篮球', '乒乓', '咖啡', '饭', '猪头', '玫瑰', '凋谢', '嘴唇', '爱心', '心碎', '蛋糕', '闪电', '炸弹', '刀', '足球', '瓢虫', '便便', '月亮', '太阳', '礼物', '拥抱', '强', '弱', '握手', '胜利', '抱拳', '勾引', '拳头', '差劲', '爱你', 'NO', 'OK', '爱情', '飞吻', '跳跳', '发抖', '怄火', '转圈', '磕头', '回头', '跳绳', '投降', '激动', '乱舞', '献吻', '左太极', '右太极', '奸笑', '嘿哈', '捂脸', '机智', '红包', '耶', '皱眉', '吃瓜', '汗', '天啊', 'Emm', '社会社会', '旺柴', '好的', '打脸', '加油', '哇'];
const emoji = {
  图形类: ['➕', '➖', '✖️', '➗', '💡', '💢', '💣', '💤', '💦', '💨', '💩', '💪', '💫', '💬', '✨', '⭐', '💮', '💯', '↩↪', '🔃', '🔊', '🔋', '🔌', '🔍', '🔎', '🔒', '🔓', '🔏', '🔐', '🔑', '🔔', '☑️'],
  手势类: ['✊', '✋', '✌️', '👊', '👍', '☝️', '👆', '👇', '👈', '👉', '👋', '👏', '👌', '👎', '👐'],
  天气类: ['☀️', '☁️', '☔', '⛄', '⚡', '🌀', '🌂', '🌃', '🌄', '🌅', '🌆', '🌇', '🌈', '❄️', '⛅ ', '🌊'],
  时间类: ['🌔', '🌓', '🌙', '🌕', '🌛', '🌟', '🌠', '🌠', '🕐', '🕑', '🕒', '🕓', '🕔', '🕕', '🕖', '🕗', '🕘', '🕙', '🕚', '🕛', '⌚', '⌛', '⏰', '⏳'],
  星座类: ['♈', '♉', '♊', '♋', '♌', '♍', '♎', '♏', '♐', '♑', '♒', '♓', '⛎'],
  花草类: ['🍀', '🌷', '🌱', '🍁', '🌸', '🌹', '🍂', '🍃', '🌺', '🌻', '🌴', '🌵', '🌾', '🌽', '🍄', '🌰', '🌼', '🌿'],
  水果类: ['🍒', '🍌', '🍎', '🍊', '🍓', '🍉', '🍅', '🍆', '🍈', '🍈', '🍍', '🍇', '🍑'],
  人物类: ['👀', '👂', '👃', '👄', '👅', '💄', '💅', '💆', '💇', '💈', '👤', '👦', '👧', '👨', '👩', '👪', '👫', '👮', '👯', '👰', '👱', '👲', '👳', '👴', '👵', '👶', '👷', '👸', '👹', '👹', '👻', '👼', '👽', '👾', '👿', '💀', '💁', '💂', '💃'],
  动物类: ['🐌', '🐍', '🐎', '🐔', '🐗', '🐫', '🐘', '🐨', '🐒', '🐑', '🐙', '🐚', '🐛', '🐜', '🐝', '🐞', '🐠', '🐡', '🐢', '🐤', '🐥', '🐥', '🐦', '🐣', '🐧', '🐩', '🐟', '🐬', '🐭', '🐯', '🐱', '🐳', '🐴', '🐵', '🐶', '🐷', '🐻', '🐹', '🐺', '🐮', '🐰', '🐸', '🐾', '🐲', '🐼', '🐽'],
  生活类: ['⚓', '🏮', '🗻', '🗼', '🗽', '🗾', '🗿', '👞', '👟', '👠', '👡', '👢', '👓', '👕', '👖', '👑', '👔', '👒', '👗', '👘', '👙', '👚', '👛', '👜', '👝', '💰', '💹', '💲', '💳', '💴', '💵', '💸', '🔥', '🔦', '🔧', '🔨', '🔩', '🔪', '🔫', '🔮', '🔯', '🔰', '🔱', '💉', '💊', '🅰', '🅱', '🆎', '🅾', '🎀', '🎁', '🎂', '🎄', '🎅', '🎌', '🎆', '🎈', '🎉', '🎍', '🎎', '🎓', '🎒', '🎏', '🎇', '🎐', '🎃', '🎊', '🎋', '🎑', '📟'],
  通讯类: ['☎', '📞', '📱', '📲', '📝', '📠', '✉', '📨', '📩', '📪', '📫', '📮', '📰', '📢', '📣', '📡', '📤', '📥', '📦', '📧'],
  学习类: ['🔠', '🔡', '🔢', '🔤', '✒', '💺', '💻', '✏', '📎', '💼', '💽', '💾', '💿', '📀', '✂', '📍', '📅', '📖', '📗', '📜', '📇'],
  运动类: ['🎽', '⚾', '⛳', '🎾', '⚽', '🎿', '🏀', '🏁', '🏂', '🏃', '🏄', '🏆', '🏈', '🏊'],
  交通类: ['🚃', '🚇', 'Ⓜ', '🚄', '🚅', '🚗', '🚙', '🚌', '🚏', '🚢', '✈', '⛵', '🚉', '🚀', '🚤', '🚕', '🚚', '🚒', '🚑', '🚓', '⛽', '🅿', '🚥', '🚧', '🚨', '♨'],
  娱乐类: ['⛺', '🎠', '🎡', '🎢', '🎣', '🎤', '🎥', '🎦', '🎧', '🎨', '🎩', '🎪', '🎫', '🎬', '🎯', '🀄', '🎰', '🎱', '🎲', '🎴', '🎵', '🎶', '🎷', '🎸', '〽', '📷', '📹', '📺', '📻', '📼', '💋', '💌', '💍', '💎', '💏', '💐', '💑', '💒', '🔞', '©', '®', '™'],
  美食类: ['🍔', '🍙', '🍰', '🍜', '🍞', '🍳', '🍦', '🍟', '🍡', '🍘', '🍚', '🍝', '🍛', '🍢', '🍣', '🍱', '🍲', '☕', '🍺', '🍵', '🍶', '🍻'],
  爱心类: ['💓', '💔', '💘', '💙', '💚', '💛', '💜', '💝', '💟', '♣', '♦', '♠', '♥'],
  交通标志类: ['🚬', '🚭', '♿', '⚠️', '⛔', '♻', '🚲', '🚶', '🚹', '🚺', '🛀', '🚻', '🚽', '🚾', '🚼', '✔'],
  其他: ['👻', '🙏', '💪', '🎉', '🎁', '😄', '😃', '😀', '😊', '😉', '😍', '😘', '😚', '😗', '😜', '😝', '😛', '😳', '😁', '😔', '😌', '😒', '😣', '😢', '😂', '😭', '😪', '😥', '😅', '😩', '😫', '😨', '😱', '😠', '😡', '😤', '😖', '😆', '😋', '😷', '😎', '😴', '😵', '😲', '😟', '😦', '😧', '😈', '👿', '😮', '😬', '😐', '😕', '😯', '😶', '😇', '😏', '😑', '👲', '👳', '👮', '👷', '💂', '👶', '👦', '👧', '👨', '👩', '👴', '👵', '👱', '👼', '👸', '😺', '😸', '😻', '😽', '😼', '🙀', '😿', '😹', '😾', '👹', '👺', '🙈', '🙉', '🙊', '💀', '👽', '💩', '🔥', '✨', '🌟', '💫', '💥', '💢', '💦', '💧', '💤', '💨', '👂', '👀', '👃', '👅', '👄', '👍', '👎', '👌', '👊', '✊', '✌️', '👋', '✋', '👐', '👆', '👇', '👉', '👈', '🙌', '🙏', '☝️', '👏', '💪', '🚶', '🏃', '💃', '👫', '👪', '👬', '👭', '💏', '💑', '👯', '🙆', '🙅', '💁', '🙋', '💆', '💇', '💅', '👰', '🙎', '🙍', '🙇', '🎩', '👑', '👒', '👟', '👞', '👡', '👠', '👢', '👕', '👔', '👚', '👗', '🎽', '👖', '👘', '👙', '💼', '👜', '👝', '👛', '👓', '🎀', '🌂', '💄', '💛', '💙', '💜', '💚', '❤️', '💔', '💗', '💓', '💕', '💖', '💞', '💘', '💌', '💋', '💍', '💎', '👤', '👥', '💬', '👣', '💭']
};
const emojiImgs = {
  奸笑: img$I,
  嘿哈: img$H,
  捂脸: img$G,
  机智: img$F,
  红包: img$E,
  耶: img$D,
  皱眉: img$C,
  吃瓜: img$B,
  汗: img$A,
  天啊: img$z,
  Emm: img$y,
  社会社会: img$x,
  旺柴: img$w,
  好的: img$v,
  打脸: img$u,
  加油: img$t,
  哇: img$s
};

/**
 * 请求组织架构树
 * @param id  请求的id
 * @param showUser 是否显示用户
 * @returns {*}
 */
const getDeptTree = (id, showUser = true, showUserStatus, queryQywxStatus) => request.postJson('/usercenter/dept/tree', {
  id,
  showUser,
  showUserStatus,
  queryQywxStatus
});

/**
 * 查询组织结构
 * @param keyword 关键字
 * @param type 1部门 2用户 3全部（全部查询时 phoneOnly 与 limit无效）
 * @param limit
 * @param phoneOnly
 */
const searchUserDept = (keyword, type = 3, showUserStatus, queryQywxStatus, limit = 20, phoneOnly = false) => request.postJson('/usercenter/dept/search', {
  keyword,
  type,
  limit,
  phoneOnly,
  showUserStatus,
  queryQywxStatus
}).then(res => res.data);

/**
 * 组织架构排序

 */
const sortDepts = data => request.postJson('/pc/crm_t_department/sortDepts', data);

/**
 * 获取渠道信息
 */
const getChannelInfo = () => request.postJson('/usercenter/company/getChannelInfo', {}).then(res => res.data);

/**
 * 修改用户公司信息
 * @param {*} data
 * @returns
 */
const changeCompanyinfo = data => request.formData('/pc/home/companyinfo', data).then(res => res);

/**
 * 获取用户信息
 * @returns
 */
const getUserInfo = () => request.postJson('/pc/home/userInfo').then(res => res.data);

/**
 * 获取用户公司信息
 * @returns
 */
const getCompanyInfo = () => request.postJson('/pc/home/getcompanyInfo').then(res => res.data);

/**
 * 获取用户菜单
 * @returns
 */
const getMenu = () => request.get('/pc/authority/permissions').then(res => res.data);

// 用户登录
const listUserByPhone = data => request.postJson('/usercenter/login/listUserByPhone', data).then(res => res);

// 用户登录
const login = data => request.postJson('/usercenter/login/pcLogin', data).then(res => res);

/**
 * 充值
 */
const addRechargeCode = data => request.postJson('/cashier/web/pay/manager/addRechargeCode', data);

/**
 *获取员工是否在线
 */
const getDevice = data => request.postForm('/pc/setup/getDeviceForOther', qs.stringify(data));

/**
 * 是否开启水印
 */
const getWatermark = () => {
  const url = '/pc/safe/watermark';
  return request.postJson(url);
};

/**
 * 查询员工信息
 */
const getfindByUser = data => request.postForm('/pc/crm_t_portaluser/findByUser', qs.stringify(data));

/**
 * 获取app版本信息
 * @param {*} data
 * @returns
 */
const getAllLastAppByPlatform = data => request.postJson('/yunkeCellPhone/initial/getAllLastAppByPlatform', data, {
  imei: 'imei'
});

/**
 * 退出登录
 * pc/home/logout
 */

const homeLogout = () => request.postJson('/pc/home/logout', {
  type: 1
});

var css_248z$f = ".ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {\n  background-color: #bae7ff;\n}\n.ant-tree-node-content-wrapper[draggable=\"true\"] .draggable-img,\n.ant-tree .ant-tree-node-content-wrapper .draggable-img {\n  width: 13px;\n  display: none;\n}\n.ant-tree-node-content-wrapper[draggable=\"true\"] .ant-tooltip,\n.ant-tree .ant-tree-node-content-wrapper .ant-tooltip {\n  background-color: #fff;\n}\n.ant-tree-node-content-wrapper[draggable=\"true\"] .ant-tree-title,\n.ant-tree .ant-tree-node-content-wrapper .ant-tree-title {\n  display: flex;\n  align-items: center;\n}\n.ant-tree-node-content-wrapper[draggable=\"true\"] .ant-tree-title .draggable,\n.ant-tree .ant-tree-node-content-wrapper .ant-tree-title .draggable {\n  cursor: move;\n  width: auto !important;\n  display: block;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.ant-tree-node-content-wrapper[draggable=\"true\"] .ant-tree-title:hover .draggable-img,\n.ant-tree .ant-tree-node-content-wrapper .ant-tree-title:hover .draggable-img {\n  margin-left: 10px;\n  display: inline-block;\n}\n.styles-module_treeContent__3-FtS {\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: #f7f8fa !important;\n  white-space: nowrap;\n}\n";
var styles$f = {"treeContent":"styles-module_treeContent__3-FtS"};
styleInject(css_248z$f);

const propTypes$g = {
  mode: PropTypes.oneOf(['lazy', 'data']),
  // data:[{id:"ID",name:"NAME",isDept:true}] -- 直接加载数据
  /**
   * 选中的选项
   */
  selectedValue: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape()])),
  onChange: PropTypes.func,
  // 参数 所选key:String[] 所选数据源：String:[]
  /**
   * 是否自动选择顶级结点
   */
  autoSelectTopNode: PropTypes.bool,
  /**
   * 多选框
   */
  checkable: PropTypes.bool,
  /**
   * 线
   */
  showLine: PropTypes.bool,
  treeData: PropTypes.arrayOf(PropTypes.shape()),
  loadDataServe: PropTypes.func,
  /**
   * 添加是否部门可选
   */
  department: PropTypes.bool,
  /**
   * 添加是否显示用户
   */
  showUser: PropTypes.bool,
  /**
   * lazy-select-tree传递过来的
   * tab值
   * 是否在职参数 1在职 2 离职
   */
  showUserStatus: PropTypes.string,
  /**
   * 是否开启选项卡
   */
  quitShow: PropTypes.bool,
  /**
   *是否查询企业微信绑定状态 默认不查询
   */
  queryQywxStatus: PropTypes.bool,
  /**
   * 获取构造出来的树的所有结点数据
   */
  getTreeData: PropTypes.func,
  /**
   * 是否可以拖拽
   */

  draggable: PropTypes.bool,
  /**
  *更改父级组件的treeData
  */
  handleChangeTreeData: PropTypes.func,
  searchInput: PropTypes.bool
};
const defaultProps$e = {
  onChange: null,
  autoSelectTopNode: false,
  mode: 'lazy',
  selectedValue: [],
  checkable: false,
  showLine: false,
  treeData: [],
  loadDataServe: null,
  department: true,
  showUser: true,
  showUserStatus: '1',
  quitShow: false,
  queryQywxStatus: false,
  getTreeData: null,
  draggable: false,
  handleChangeTreeData: null,
  searchInput: false
};
function updateTreeData(list, key, children) {
  return list.map(node => {
    if (node.id === key) {
      return {
        ...node,
        children
      };
    }
    if (node.children) {
      return {
        ...node,
        children: updateTreeData(node.children, key, children)
      };
    }
    return node;
  });
}
function loopDepName(treeData, id, joinStr) {
  let str = '';
  const string = joinStr || ',';
  for (let i = 0; i < treeData.length; i += 1) {
    const item = treeData[i];
    if (item.id === id) {
      return item.name;
    }
    if (item.children) {
      str = item.name + string + loopDepName(item.children, id, string);
      if (str === item.name + string) {
        str = '';
      } else {
        return str;
      }
    }
  }
  return str;
}
function changeItem$2(treeData, department, queryQywxStatus, index, searchInput) {
  treeData.forEach((_, index1) => {
    const element = _;
    element.key = searchInput ? element.id : `${index || 0 + index1}-${element.id}`;
    element.title = element.name;
    element.isLeaf = element.isDept === undefined ? true : !element.isDept;
    element.originData = {
      ...element
    };
    delete element.originData.originData;
    if (!department) {
      if (element.isDept) element.disabled = true;
    }
    if (queryQywxStatus) {
      if (!element.isDept && !element.bindQywx) element.disabled = true; // 禁用组织架构未绑定企业微信的
    }
    if (element.children) {
      changeItem$2(element.children, department, queryQywxStatus, index, searchInput);
    }
  });
}

/**
 * 组织架构树
 * 平铺展示
 * 懒加载
 */
class LazyOrganizationTree extends Component {
  constructor(props) {
    super(props);
    this.reloadTreeData = () => {
      // 如果切换是否显示部门重新加载
      this.setState({
        defaultExpandedKeys: null
      }, () => {
        this.loadTreeData();
      });
    };
    /**
     * 首次加载组织树的数据
     * @param {*} optId
     */
    this.loadTreeData = async optId => {
      const {
        loadDataServe,
        showUser,
        department,
        autoSelectTopNode,
        onChange,
        showUserStatus,
        quitShow,
        queryQywxStatus,
        searchInput
      } = this.props;
      let treeData;
      const serveString = loadDataServe?.toString() || '';
      const isDeptTree = serveString.indexOf('/usercenter/dept/tree') > -1;
      if (loadDataServe && !isDeptTree) {
        const response = await loadDataServe(optId, showUser, showUserStatus, queryQywxStatus);
        if (Array.isArray(response)) {
          treeData = response;
        } else {
          treeData = response.data;
        }
      } else {
        treeData = localStorage.getItem(`tree1${showUser}`);
        if (treeData && !quitShow && treeData !== 'undefined') {
          // 如果本地缓存已经有了，则直接取
          treeData = JSON.parse(treeData);
        } else {
          const {
            data
          } = await getDeptTree(optId, showUser, showUserStatus, queryQywxStatus);
          treeData = data;
          localStorage.setItem(`tree1${showUser}`, JSON.stringify(treeData));
        }
      }
      if (treeData && Array.isArray(treeData)) {
        changeItem$2(treeData, department, queryQywxStatus, 0, searchInput);
        if (treeData[0]) {
          setTimeout(() => {
            const deptlist = treeData.filter(item => item.isDept);
            const userList = treeData.filter(item => !item.isDept).sort((str1, str2) => str1.name.localeCompare(str2.name));
            const newTreeData = deptlist.concat(userList);
            const defaultExpandedKeys = newTreeData[0].key; // 展开树id
            // 自动选择最顶部节点
            if (autoSelectTopNode && onChange) {
              onChange([defaultExpandedKeys], [newTreeData[0]]);
            }
            this.setState({
              treeData: newTreeData,
              defaultExpandedKeys
            });
          }, 1);
        }
      }
    };
    /**
     * 加载部门下的组织树数据
     * @param {*} param0
     */
    this.lazyLoadData = async ({
      key,
      id
    }) => {
      const {
        treeData,
        defaultExpandedKeys
      } = this.state;
      const {
        handleChangeTreeData
      } = this.props;
      const {
        loadDataServe,
        showUser,
        department,
        showUserStatus,
        quitShow,
        queryQywxStatus,
        searchInput
      } = this.props;
      let treeData1;
      const serveString = loadDataServe?.toString() || '';
      const isDeptTree = serveString.indexOf('/usercenter/dept/tree') > -1;
      if (loadDataServe && !isDeptTree) {
        const response = await loadDataServe(id, showUser, showUserStatus, queryQywxStatus);
        if (Array.isArray(response)) {
          treeData1 = response;
        } else {
          treeData1 = response.data;
        }
      } else if (key === defaultExpandedKeys) {
        // 如果是第一级，则检查缓存中有没有
        treeData1 = localStorage.getItem(`tree2${showUser}`);
        if (treeData1 && !quitShow) {
          // 如果本地缓存已经有了，则直接取
          treeData1 = JSON.parse(treeData1);
        } else {
          const {
            data
          } = await getDeptTree(id, showUser, showUserStatus, queryQywxStatus);
          treeData1 = data;
          localStorage.setItem(`tree2${showUser}`, JSON.stringify(treeData1));
        }
      } else {
        // 不是第一级，还是要从服务端获取
        const {
          data
        } = await getDeptTree(id, showUser, showUserStatus, queryQywxStatus);
        treeData1 = data;
      }
      if (treeData1) {
        changeItem$2(treeData1, department, queryQywxStatus, 0, searchInput);
        const deptlist = treeData1.filter(item => item.isDept);
        const userList = treeData1.filter(item => !item.isDept).sort((str1, str2) => str1.name.localeCompare(str2.name));
        const storTreeData = deptlist.concat(userList);
        const newTreeData = updateTreeData(treeData, id, storTreeData);
        this.setState({
          treeData: newTreeData
        }, () => {
          if (handleChangeTreeData) {
            handleChangeTreeData(newTreeData);
          }
        });
      }
    };
    /**
     * 点击选中事件 -- 单选
     * @param selectedKeys
     * @param selectedNodes
     */
    this.onSelect = (selectedKeys, info) => {
      const {
        treeData
      } = this.state;
      const {
        onChange
      } = this.props;
      const temp = loopDepName(treeData, info.selectedNodes[0]?.pid || '', ',');
      const routes = temp ? temp?.split(',') : [];
      if (onChange) onChange(selectedKeys, info.selectedNodes, routes);
    };
    /**
     * 多选选择事件 -- 多选
     * @param checkedKeys
     * @param checkedNodes 选择 node obj
     */
    this.onCheck = (checkedKeys, {
      checkedNodes
    }) => {
      const {
        onChange
      } = this.props;
      if (onChange) onChange(checkedKeys, checkedNodes);
    };
    this.onDrop = info => {
      const dropKey = info.node.key;
      const dragKey = info.dragNode.key;
      const dropPos = info.node.pos.split('-');
      const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
      let chil = [];
      if (dropPosition === -1) return; // 不可拖到顶级部门外
      const isSameLevel = (a, b) => {
        const aLevel = a.pos.split('-').length;
        const bLevel = b.pos.split('-').length;
        return aLevel === bLevel;
      };
      const isSameParent = (a, b) => {
        const aLevel = a.pos.split('-');
        const bLevel = b.pos.split('-');
        aLevel.pop();
        bLevel.pop();
        return aLevel.join('') === bLevel.join('');
      };
      const canDrop = isSameParent(info.dragNode, info.node) && isSameLevel(info.dragNode, info.node) && info.dropToGap;
      if (!canDrop && info.dragNode.pid !== info.node.id) {
        return;
      }
      const loop = (data, key, callback) => {
        for (let i = 0; i < data.length; i += 1) {
          if (data[i].key === key) {
            return callback(data[i], i, data);
          }
          if (data[i].children) {
            loop(data[i].children, key, callback);
          }
        }
        return null;
      };
      const {
        treeData
      } = this.state;
      const data = [...treeData];
      // Find dragObject
      let dragObj;
      loop(data, dragKey, (item, index, arr) => {
        arr.splice(index, 1);
        dragObj = item;
      });
      if (!info.dropToGap) {
        loop(data, dropKey, item => {
          // eslint-disable-next-line no-param-reassign
          item.children = item.children || [];
          item.children.unshift(dragObj);
          chil = item.children;
        });
      } else if ((info.node.props.children || []).length > 0 // Has children
      && info.node.props.expanded // Is expanded
      && dropPosition === 1 // On the bottom gap
      ) {
        loop(data, dropKey, item => {
          // eslint-disable-next-line no-param-reassign
          item.children = item.children || [];
          // where to insert 示例添加到头部，可以是随意位置
          item.children.unshift(dragObj);
          chil = item.children;
        });
      } else if (canDrop) {
        let ar;
        let i;
        loop(data, dropKey, (item, index, arr) => {
          ar = arr;
          i = index;
        });
        if (dropPosition === -1) {
          ar.splice(i, 0, dragObj);
        } else {
          ar.splice(i + 1, 0, dragObj);
        }
        chil = ar;
      }
      sortDepts(chil.map(item => item.id)).then(() => {
        localStorage.removeItem('tree2true');
        localStorage.removeItem('tree2false');
      });
      this.setState({
        treeData: data
      });
    };
    /**
     * tree渲染
     */
    this.renderTree = () => {
      const {
        treeData
      } = this.state;
      if (treeData.length === 0) return null;
      const {
        checkable,
        selectedValue,
        showLine,
        // mode,
        getTreeData,
        draggable
      } = this.props;
      const {
        defaultExpandedKeys
      } = this.state;
      if (getTreeData) {
        getTreeData(treeData);
      }
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Tree, {
        checkable: checkable,
        showLine: showLine,
        onSelect: checkable ? undefined : this.onSelect,
        onCheck: checkable ? this.onCheck : undefined,
        placeholder: "\u59D4\u5C48\u7FC1",
        draggable: draggable,
        onDrop: draggable ? this.onDrop : undefined,
        defaultExpandedKeys: [defaultExpandedKeys],
        loadData: this.lazyLoadData,
        selectedKeys: checkable ? undefined : selectedValue,
        checkedKeys: checkable ? selectedValue : [],
        treeData: treeData,
        style: {
          fontSize: 13
        },
        titleRender: nodeData => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
          className: draggable ? 'draggable' : ''
        }, nodeData.name), draggable && /*#__PURE__*/React.createElement(_Tooltip, {
          title: /*#__PURE__*/React.createElement("span", {
            style: {
              color: '#555555',
              fontSize: 10
            }
          }, "\u4E0A\u4E0B\u62D6\u62FD\u79FB\u52A8", /*#__PURE__*/React.createElement("br", null), "\u7EC4\u7EC7\u67B6\u6784\u6392\u5E8F"),
          color: "#fff"
        }, /*#__PURE__*/React.createElement("img", {
          className: "draggable-img",
          src: "//yunke-pcfile.oss-cn-beijing.aliyuncs.com/POrV/2021-09-24/d5e1c7cb77.png",
          alt: ""
        })))
      }));
    };
    const {
      treeData: _treeData
    } = props;
    this.state = {
      treeData: _treeData,
      defaultExpandedKeys: null
    };
  }
  componentDidMount() {
    const {
      mode
    } = this.props;
    if (mode === 'lazy') this.loadTreeData();
  }

  // showUserStatus 离职切换tab时
  componentDidUpdate(prevProps) {
    const {
      showUser,
      showUserStatus
    } = this.props;
    if (prevProps.showUser !== showUser || prevProps.showUserStatus !== showUserStatus) {
      this.reloadTreeData();
    }
  }
  render() {
    const {
      mode
    } = this.props;
    const {
      defaultExpandedKeys
    } = this.state;
    if (!defaultExpandedKeys && mode === 'lazy') return false; // 懒加载模式 默认展开一层
    return /*#__PURE__*/React.createElement("div", {
      className: styles$f.treeContent
    }, this.renderTree());
  }
}
LazyOrganizationTree.getDerivedStateFromProps = props => props.mode === 'data' ? {
  treeData: props.treeData
} : null;
LazyOrganizationTree.propTypes = propTypes$g;
LazyOrganizationTree.defaultProps = defaultProps$e;

var css_248z$e = ".ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {\n  background-color: #bae7ff;\n}\n.styles-module_treeContent__1ygyl {\n  width: 100%;\n  max-height: 500px;\n  overflow: auto;\n}\n.styles-module_treeModeModal__3lQyd {\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  background-color: #f7f8fa !important;\n  padding: 3px 0 !important;\n}\n.styles-module_selectTreeNode__S4oL0 {\n  box-sizing: border-box;\n  margin: 0;\n  font-variant: tabular-nums;\n  list-style: none;\n  -webkit-font-feature-settings: \"tnum\";\n  font-feature-settings: \"tnum\";\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  min-height: 32px;\n  padding: 4px 11px;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  line-height: 1.5;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #e6e6e6;\n  border-radius: 4px;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n.styles-module_searchBox__22C3a {\n  padding: 6px 10px;\n  background-color: #f7f8fa !important;\n}\n.styles-module_hide__3Z8jd {\n  display: none;\n}\n.styles-module_mySelf__3jdTo {\n  display: inline-block;\n  line-height: 24px;\n  cursor: pointer;\n  border-radius: 4px;\n  margin-left: 5px;\n  padding: 0 5px;\n}\n.styles-module_mySelf__3jdTo:hover {\n  background: rgba(186, 231, 255, 0.49);\n}\n.styles-module_active__2Z38W {\n  display: inline-block;\n  line-height: 24px;\n  cursor: pointer;\n  border-radius: 4px;\n  margin-left: 5px;\n  padding: 0px 5px;\n  background: #bae7ff;\n}\n.styles-module_active__2Z38W:hover {\n  background: rgba(186, 231, 255, 0.49);\n}\n";
var styles$e = {"treeContent":"styles-module_treeContent__1ygyl","treeModeModal":"styles-module_treeModeModal__3lQyd","selectTreeNode":"styles-module_selectTreeNode__S4oL0","searchBox":"styles-module_searchBox__22C3a","hide":"styles-module_hide__3Z8jd","mySelf":"styles-module_mySelf__3jdTo","active":"styles-module_active__2Z38W"};
styleInject(css_248z$e);

const propTypes$f = {
  /**
   * 模式有两种：缺省是input，在输入框里选择，另一种是tree，直接展开组织树，用于展示
   */
  mode: PropTypes.oneOf(['tree', 'input']),
  type: PropTypes.oneOf([1, 2, 3]),
  selectedValue: PropTypes.arrayOf(PropTypes.shape()),
  // [{id:'ID',name:"部门一"}]
  onChange: PropTypes.func,
  // 参数 所选数据源：String:[{}]
  /**
   * 是否自动选中顶级结点
   */
  autoSelectTopNode: PropTypes.bool,
  /**
   * 搜索
   */
  showSearch: PropTypes.bool,
  /**
   * 是否通过多选框进行多选
   */
  checkable: PropTypes.bool,
  /**
   * 线
   */
  showLine: PropTypes.bool,
  /**
   * 触发方式，点击或划过，缺省为点击
   */
  trigger: PropTypes.oneOf(['hove', 'click']),
  loadDataServe: PropTypes.func,
  /**
   * 添加是否部门可选
   */
  department: PropTypes.bool,
  /**
   * 是否展示用户
   */
  showUser: PropTypes.bool,
  borderStyle: PropTypes.shape({}),
  placeholder: PropTypes.string,
  /**
   * 是否显示自己，传用户信息
   */
  showMySelf: PropTypes.shape({
    userId: PropTypes.string,
    realName: PropTypes.string,
    departmentId: PropTypes.string
  }),
  searchTree: PropTypes.func,
  loadSearchServe: PropTypes.func,
  // 是否展示离职人员组织架构
  quitShow: PropTypes.bool,
  status: PropTypes.string,
  // 是否查询企业微信绑定状态 默认不查询
  queryQywxStatus: PropTypes.bool,
  draggable: PropTypes.bool,
  // 是否可以拖拽,
  topLevelDepartment: PropTypes.element
};
const defaultProps$d = {
  onChange: null,
  autoSelectTopNode: false,
  showSearch: false,
  checkable: false,
  trigger: 'click',
  mode: 'input',
  type: 2,
  showLine: true,
  loadDataServe: null,
  department: true,
  showUser: true,
  borderStyle: {},
  placeholder: '',
  selectedValue: [],
  showMySelf: {},
  searchTree: null,
  loadSearchServe: null,
  quitShow: false,
  status: '1',
  queryQywxStatus: false,
  draggable: false,
  topLevelDepartment: null
};
function changeItem$1(treeData, department, queryQywxStatus, index, mode) {
  return treeData.forEach((_, index1) => {
    const element = _;
    element.key = mode === 'input' ? element.id : `${index || 0 + index1}-${element.id}`;
    element.title = element.name;
    element.isLeaf = !element.isDept;
    element.originData = {
      ...element
    };
    if (queryQywxStatus) {
      if (!element.isDept && !element.bindQywx) element.disabled = true; // 禁用组织架构未绑定企业微信的
    }
    if (element.children) {
      changeItem$1(element.children, department, queryQywxStatus, index, mode);
    }
    if (!department) {
      if (element.isDept) element.disabled = true;
    }
    delete element.originData.originData;
  });
}

/**
 * 下拉框搜索树
 * 1.懒加载
 * 2.加搜索
 * 3.可控
 */
class LazySelectTree$1 extends React.PureComponent {
  constructor(props) {
    super(props);
    this.showRefBox = /*#__PURE__*/React.createRef();
    this.searchTree = debounce(async searchKey => {
      const {
        loadDataServe,
        type,
        searchTree,
        loadSearchServe,
        status,
        mode,
        queryQywxStatus,
        department
      } = this.props;
      const {
        showUserStatus
      } = this.state;
      let service = loadSearchServe || loadDataServe || searchUserDept;
      if (searchTree && !loadSearchServe) {
        service = searchTree;
      }
      const params = await service(searchKey, type, mode === 'input' ? showUserStatus : status, queryQywxStatus);
      let searchTreeData = [];
      if (params) {
        searchTreeData = params.userList ? params.userList : params || []; // 客户列表个人版 返回的数据结构不一致处理数据
      }
      changeItem$1(searchTreeData, department, queryQywxStatus, 0, mode);
      this.setState({
        searchTreeData
      });
    });
    this.changeShowUser = () => {
      const {
        showUser
      } = this.props;
      this.setState({
        searchSelectNodes: [],
        showUser
      });
    };
    this.setPopoverBoxWidth = () => {
      const {
        mode
      } = this.props;
      if (mode !== 'input') return;
      const boxWidth = this.showRefBox.current.offsetWidth;
      this.setState({
        boxWidth
      });
    };
    /**
     * 组织架构树 改变事件
     * @param key
     * @param checkNodes
     */
    this.handleOriginChange = (key, checkNodes, temp) => {
      const {
        onChange,
        checkable,
        selectedValue
      } = this.props;
      const {
        searchSelectNodes
      } = this.state;
      const data = [];
      // 在新生成的树中查找已选中的值
      selectedValue.forEach(item => {
        // 如果没有找到，则保留已选中的项
        if (!this.treeData.find(item1 => item1.id === item.id)) {
          data.push(item);
        }
      });
      if (checkable) {
        // 多选
        // 首先在搜索结点中查找，如果不存在，并且在可见树中也不存在，则增加
        searchSelectNodes.forEach(item => {
          if (!data.find(item1 => item1.id === item.id) && !this.treeData.find(item1 => item1.id === item.id)) {
            data.push(item);
          }
        });
        checkNodes.forEach(item => {
          const {
            pid,
            originData
          } = item;
          // 如果选中的项目的父结点没有被选中，则增加，如果父结点已选中，则不必增加
          if (!key.includes(pid)) data.push({
            ...originData
          });
        });
        // this.setState({ treeSelectNodes: data });
        if (onChange) onChange(data);
      } else {
        // 单选
        // 将输入框下面的组织树隐藏
        this.setState({
          open: false
        });
        if (key.length) {
          if (onChange) {
            onChange(checkNodes[0] ? [{
              ...checkNodes[0].originData,
              routes: temp
            }] : [],
            // routers为 当前节点的所有父节点
            checkNodes[0] ? checkNodes[0].pid : undefined);
          }
        }
      }
    };
    /**
     * 搜索树 改变事件
     * @param key
     * @param checkNodes
     */
    this.handleSearchChange = (key, checkNodes) => {
      const {
        onChange,
        checkable,
        selectedValue
      } = this.props;
      const {
        searchTreeData
      } = this.state;
      if (checkable) {
        // 多选
        const data = [];
        // 在新生成的树中查找已选中的值
        selectedValue.forEach(item => {
          // 如果没有找到，则保留已选中的项
          if (!searchTreeData.find(item1 => item1.id === item.id)) {
            data.push(item);
          }
        });
        checkNodes.forEach(({
          pid,
          originData
        }) => {
          // 如果选中的项目的父结点没有被选中，则增加，如果父结点已选中，则不必增加
          if (!key.includes(pid)) data.push({
            ...originData
          });
        });
        this.setState({
          searchSelectNodes: data
        });
        // data.concat(treeSelectNodes);
        onChange(data);
      } else if (key.length) {
        const data = checkNodes[0] ? [checkNodes[0].originData] : []; // 搜索的时返回的routers没有带自己本身
        const pid = checkNodes[0] ? checkNodes[0].pid : undefined;
        onChange(data, pid);
      }
    };
    /**
     * 删除tag
     * @param id
     * @returns {Function}
     */
    this.handleDeleteSelect = id => () => {
      const {
        selectedValue,
        onChange
      } = this.props;
      const newData = selectedValue.filter(item => item.id !== id);
      if (onChange) onChange(newData);
    };
    /**
     * 树选择改变事件
     * @param searchKey
     */
    this.handleChangeSearchKey = async searchKey => {
      const {
        flag
      } = this.state;
      const searchValue = searchKey ? searchKey.trim() : searchKey;
      this.setState({
        searchKey: searchValue
      });
      // 取消搜索
      if (flag) return false;
      if (!searchValue) return false;
      this.searchTree(searchValue);
      return true;
    };
    this.handleComposition = e => {
      if (e.type === 'compositionend') {
        this.setState({
          flag: false
        }, () => {
          this.handleChangeSearchKey(e.target.value);
        });
      } else {
        this.setState({
          flag: true
        });
      }
    };
    /**
     * 展示所选key
     */
    this.renderSelectKeys = () => {
      const {
        selectedValue,
        placeholder
      } = this.props;
      if (!selectedValue.length) {
        return /*#__PURE__*/React.createElement("span", {
          style: {
            color: '#ccc',
            fontSize: '14'
          }
        }, placeholder || '请选择组织架构');
      }
      if (Array.isArray(selectedValue) && selectedValue.length) {
        return selectedValue.map(item => {
          const {
            id,
            name
          } = item;
          return /*#__PURE__*/React.createElement(_Tag, {
            key: id,
            closable: true,
            onClose: this.handleDeleteSelect(id)
          }, name);
        });
      }
      return /*#__PURE__*/React.createElement("span", {
        style: {
          color: '#bfbfbf'
        }
      }, placeholder || '请选择组织架构');
    };
    this.selectMySelf = flag => {
      const {
        selectedValue,
        onChange,
        checkable,
        showMySelf
      } = this.props;
      let value = [...selectedValue];
      const data = {
        id: showMySelf.userId,
        isDept: false,
        name: showMySelf.realName,
        pid: showMySelf.departmentId
      };
      if (!flag) {
        if (checkable) value.push(data);else value = [data];
      } else {
        const index = selectedValue.findIndex(item => item.id === showMySelf.userId);
        value.splice(index, 1);
      }
      this.setState({
        open: false
      });
      if (onChange) onChange(value);
    };
    this.handleChangeTabValue = value => {
      this.setState({
        showUserStatus: value
      });
    };
    /**
     * 返回组织架构树
     * @returns {*}
     */
    this.renderTree = () => {
      const {
        checkable,
        selectedValue,
        mode,
        loadDataServe,
        showLine,
        department,
        showMySelf,
        autoSelectTopNode,
        quitShow,
        status,
        queryQywxStatus,
        showSearch,
        draggable
      } = this.props;
      const {
        boxWidth,
        showUser,
        showUserStatus
      } = this.state;
      const value = mode === 'input' ? selectedValue.map(item => item.id) : selectedValue.map(item => item.key);
      return /*#__PURE__*/React.createElement("div", {
        className: mode === 'input' ? styles$e.treeContent : styles$e.treeModeModal,
        style: {
          minWidth: `${boxWidth}px`,
          height: showSearch ? 'calc(100% - 44px)' : '100%'
        }
      }, mode === 'input' && quitShow && /*#__PURE__*/React.createElement(_Tabs, {
        onChange: this.handleChangeTabValue
      }, /*#__PURE__*/React.createElement(_Tabs.TabPane, {
        tab: "\u5728\u804C\u5458\u5DE5",
        key: "1"
      }), /*#__PURE__*/React.createElement(_Tabs.TabPane, {
        tab: "\u79BB\u804C\u5458\u5DE5",
        key: "2"
      })), showMySelf.userId && showUserStatus !== '2' && /*#__PURE__*/React.createElement("div", {
        role: "button",
        tabIndex: "0",
        className: selectedValue.find(item => item.id === showMySelf.userId) ? styles$e.active : styles$e.mySelf,
        onClick: this.selectMySelf.bind(null, selectedValue.find(item => item.id === showMySelf.userId)),
        onKeyPress: () => {}
      }, "\u6211\u81EA\u5DF1"), /*#__PURE__*/React.createElement(LazyOrganizationTree, {
        loadDataServe: loadDataServe,
        checkable: checkable,
        showLine: showLine,
        showUser: showUser,
        searchInput: mode === 'input',
        department: department,
        showUserStatus: mode === 'input' ? showUserStatus : status,
        onChange: this.handleOriginChange,
        autoSelectTopNode: autoSelectTopNode,
        selectedValue: value,
        quitShow: quitShow,
        draggable: draggable,
        queryQywxStatus: queryQywxStatus,
        getTreeData: e => {
          this.treeData = [];
          const flatTree = x => {
            x.forEach(item => {
              if (item.children) {
                flatTree(item.children);
              }
              this.treeData.push(item);
            });
          };
          flatTree(e);
        }
      }));
    };
    this.renderContent = () => {
      const {
        showSearch
      } = this.props;
      const {
        searchKey
      } = this.state;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: !searchKey ? styles$e.hide : undefined
      }, this.renderSearchTree()), /*#__PURE__*/React.createElement("div", {
        className: searchKey ? styles$e.hide : undefined,
        style: {
          height: showSearch ? 'calc(100% - 44px)' : '100%',
          overflow: 'auto'
        }
      }, this.renderTree()));
    };
    /**
     * 返回搜索框
     * @returns {*}
     */
    this.renderSearch = () => {
      const {
        searchKey
      } = this.state;
      return /*#__PURE__*/React.createElement("div", {
        className: styles$e.searchBox
      }, /*#__PURE__*/React.createElement(_Input, {
        placeholder: "\u8BF7\u8F93\u5165\u641C\u7D22\u5173\u952E\u5B57",
        allowClear: true,
        prefix: /*#__PURE__*/React.createElement(SearchOutlined, {
          style: {
            color: 'rgba(0,0,0,.25)'
          }
        }),
        value: searchKey,
        onChange: event => this.handleChangeSearchKey(event.target.value),
        onCompositionStart: this.handleComposition,
        onCompositionUpdate: this.handleComposition,
        onCompositionEnd: this.handleComposition
      }));
    };
    /**
     * 返回搜索树
     * @returns {*}
     */
    this.renderSearchTree = () => {
      const {
        checkable,
        selectedValue,
        mode,
        loadDataServe,
        showLine,
        department,
        showUser,
        status,
        showSearch
      } = this.props;
      const {
        searchTreeData,
        boxWidth,
        showUserStatus
      } = this.state;
      // eslint-disable-next-line no-nested-ternary
      const selectValue = Array.isArray(selectedValue) && selectedValue.length ? mode === 'input' ? selectedValue.map(item => item.id) : selectedValue.map(item => item.key) : undefined;
      return /*#__PURE__*/React.createElement("div", {
        className: mode === 'input' ? styles$e.treeContent : styles$e.treeModeModal,
        style: {
          minWidth: `${boxWidth}px`,
          height: showSearch ? 'calc(100% - 44px)' : '100%'
        }
      }, /*#__PURE__*/React.createElement(LazyOrganizationTree, {
        mode: "data",
        loadDataServe: loadDataServe,
        checkable: checkable,
        searchInput: mode === 'input',
        onChange: this.handleSearchChange,
        selectedValue: selectValue,
        lazy: false,
        showUser: showUser,
        showUserStatus: mode === 'input' ? showUserStatus : status,
        showLine: showLine,
        department: department,
        treeData: searchTreeData,
        handleChangeTreeData: value => {
          this.setState({
            searchTreeData: value
          });
        }
        // getTreeData={(e) => {
        //   console.log(e);
        //   this.searchData = e
        //   // this.treeData = [];
        //   // const flatTree = (x) => {
        //   //   x.forEach((item) => {
        //   //     if (item.children) {
        //   //       flatTree(item.children);
        //   //     }
        //   //     this.treeData.push(item);
        //   //   });
        //   // };
        //   // flatTree(e);
        // }}
      }));
    };
    /**
     * 渲染在输入框下面的组织树
     */
    this.renderModeInput = () => {
      const {
        trigger,
        showSearch,
        borderStyle
      } = this.props;
      const {
        open
      } = this.state;
      return /*#__PURE__*/React.createElement("div", {
        className: styles$e.treeContent
      }, /*#__PURE__*/React.createElement(_Popover, {
        className: styles$e.treeContent,
        content: this.renderContent(),
        title: showSearch ? this.renderSearch() : false,
        trigger: trigger,
        onOpenChange: e => {
          this.setState({
            open: e
          });
        },
        open: open,
        placement: "bottom"
      }, /*#__PURE__*/React.createElement("div", {
        ref: this.showRefBox,
        className: styles$e.selectTreeNode,
        style: borderStyle
      }, this.renderSelectKeys())));
    };
    /**
     * 渲染直接展开的组织树
     */
    this.renderModeTree = () => {
      const {
        showSearch,
        topLevelDepartment
      } = this.props;
      return /*#__PURE__*/React.createElement("div", {
        className: styles$e.treeModeModal
      }, showSearch && this.renderSearch(), topLevelDepartment, this.renderContent());
    };
    const {
      showUser: _showUser
    } = this.props;
    this.state = {
      boxWidth: 0,
      searchTreeData: [],
      // 搜索数据树
      searchKey: null,
      showUser: _showUser,
      // treeSelectNodes: [],
      searchSelectNodes: [],
      open: false,
      showUserStatus: '1',
      flag: false
    };
    this.treeData = [];
    // this.searchData = [];
  }
  componentDidMount() {
    this.setPopoverBoxWidth();
  }
  componentDidUpdate(prevProps) {
    const {
      showUser
    } = this.props;
    if (prevProps.showUser !== showUser) {
      this.changeShowUser();
    }
  }
  render() {
    const {
      mode
    } = this.props;
    if (mode === 'input') return this.renderModeInput();
    if (mode === 'tree') return this.renderModeTree();
    return /*#__PURE__*/React.createElement("div", null);
  }
}
LazySelectTree$1.propTypes = propTypes$f;
LazySelectTree$1.defaultProps = defaultProps$d;

var css_248z$d = ".index-module_leftTree__1vMJl {\n  position: relative;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n  transition: all 0.2s;\n  background: #fff;\n}\n.index-module_leftTree__1vMJl.index-module_close__ilvJU {\n  padding: 0;\n  color: rgba(26, 26, 26, 0.4);\n}\n.index-module_leftTree__1vMJl.index-module_close__ilvJU .index-module_arrow__1Bsfa {\n  transition: all 0.2s;\n  transform: rotate(180deg);\n}\n.index-module_collapsedButton__JBS0L {\n  cursor: pointer;\n  position: absolute;\n  display: inline-block;\n  text-align: center;\n  background-color: #ffffff;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  overflow: hidden;\n  width: 18px;\n  height: 40px;\n  right: -10px;\n  bottom: 28px;\n  display: flex;\n  align-items: center;\n  justify-items: center;\n  justify-content: center;\n  color: #505050;\n  z-index: 999;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-left: none;\n}\n";
var styles$d = {"leftTree":"index-module_leftTree__1vMJl","close":"index-module_close__ilvJU","arrow":"index-module_arrow__1Bsfa","collapsedButton":"index-module_collapsedButton__JBS0L"};
styleInject(css_248z$d);

const propTypes$e = {
  onChange: PropTypes.func,
  selectedValue: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape()])),
  showUser: PropTypes.bool,
  loadDataServe: PropTypes.func,
  loadSearchServe: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.object]),
  topChildren: PropTypes.oneOfType([PropTypes.object]),
  width: PropTypes.number,
  autoSelectTopNode: PropTypes.bool,
  quitShow: PropTypes.bool,
  status: PropTypes.string,
  department: PropTypes.bool,
  draggable: PropTypes.bool,
  // 是否可以拖拽
  topLevelDepartment: PropTypes.element
};
const defaultProps$c = {
  onChange: null,
  selectedValue: [],
  showUser: false,
  loadDataServe: null,
  loadSearchServe: null,
  children: null,
  topChildren: null,
  width: 200,
  autoSelectTopNode: true,
  quitShow: false,
  status: '',
  department: true,
  draggable: false,
  topLevelDepartment: null
};
class CollapseTree extends Component {
  constructor(props) {
    super(props);
    this.toogleCollapse = () => {
      const {
        open
      } = this.state;
      this.setState({
        open: !open
      });
    };
    this.state = {
      open: true
    };
  }
  render() {
    const {
      onChange,
      selectedValue,
      showUser,
      loadDataServe,
      loadSearchServe,
      children,
      topChildren,
      autoSelectTopNode,
      quitShow,
      status,
      department,
      draggable,
      width,
      topLevelDepartment
    } = this.props;
    const {
      open
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: `${styles$d.leftTree} ${open ? '' : styles$d.close}`,
      style: {
        width: open ? width : 10
      }
    }, /*#__PURE__*/React.createElement("div", {
      role: "button",
      tabIndex: "0",
      onKeyPress: () => {},
      onClick: this.toogleCollapse,
      className: styles$d.collapsedButton
    }, /*#__PURE__*/React.createElement(MenuFoldOutlined, {
      className: styles$d.arrow
    })), open && topChildren, /*#__PURE__*/React.createElement(LazySelectTree$1, {
      checkable: false,
      mode: "tree",
      style: {
        width: '100px'
      },
      showLine: false,
      searchTree: searchUserDept,
      type: showUser ? 3 : 1,
      loadDataServe: loadDataServe || getDeptTree,
      loadSearchServe: loadSearchServe,
      showSearch: true,
      showUser: showUser || false,
      selectedValue: selectedValue,
      quitShow: quitShow,
      onChange: onChange,
      status: status,
      topLevelDepartment: topLevelDepartment,
      department: department,
      autoSelectTopNode: autoSelectTopNode,
      draggable: draggable
    }), open && children);
  }
}
CollapseTree.propTypes = propTypes$e;
CollapseTree.defaultProps = defaultProps$c;

var css_248z$c = ".style-module_editorElemBox__sPypg {\n  width: 100%;\n  z-index: 10 !important;\n  position: relative;\n}\n.style-module_editorElemBox__sPypg div {\n  z-index: 10 !important;\n}\n.style-module_editorElemBox__sPypg > div > div:nth-child(1) {\n  border-radius: 5px 5px 0px 0px !important;\n  border: 1px solid #e6e6e6 !important;\n}\n.style-module_editorElemBox__sPypg > div > div:nth-child(2) {\n  border-radius: 0px 0px 5px 5px !important;\n  border: 1px solid #e6e6e6 !important;\n}\n.style-module_editorElemBox__sPypg > div > div:nth-child(2) {\n  height: 200px !important;\n  white-space: pre-wrap;\n}\n.style-module_editorElemBox__sPypg > div > div:nth-child(2) > div:nth-child(2) {\n  height: 190px !important;\n  overflow: hidden !important;\n  width: 95% !important;\n  margin-left: -50% !important;\n  top: 10px !important;\n}\n.style-module_editorElemBox__sPypg > div > div:nth-child(2) > div:nth-child(2) > div {\n  height: 120px !important;\n}\n.style-module_editorElemBox__sPypg > div > div:nth-child(2) > div:nth-child(2) > i {\n  display: none;\n}\n.style-module_editorElemBox__sPypg > div > div:nth-child(2) > div:nth-child(2) > ul {\n  flex-wrap: wrap;\n}\n.style-module_spanTop__csa7K {\n  position: absolute;\n  top: 5px;\n  right: 10px;\n}\n.w-e-text-container {\n  height: 250px !important;\n}\n.w-e-text img {\n  display: inline;\n}\n";
var styles$c = {"editorElemBox":"style-module_editorElemBox__sPypg","spanTop":"style-module_spanTop__csa7K"};
styleInject(css_248z$c);

const propTypes$d = {
  types: PropTypes.number,
  // 类型
  textVal: PropTypes.string,
  // 文本类型
  onChange: PropTypes.func,
  change: PropTypes.bool
};
const defaultProps$b = {
  textVal: '',
  types: 0,
  onChange: () => {},
  change: false
};
class EmojiReplace extends Component {
  constructor() {
    super();
    this.editor = null;
    this.getText = arg => {
      let txt = '';
      arg.forEach((item, key) => {
        if (key > 0) {
          txt += '\n';
        }
        if (item.children) {
          item.children.forEach(val => {
            if (typeof val === 'string') {
              txt += val;
            }
            if (val.tag === 'img') {
              txt += val.attrs[1].value;
            }
            if (val.tag === 'span') {
              txt += val.children[0];
            }
          });
        }
      });
      return txt.replace(/<br\/>/g, '\n');
    };
    this.cartView = _textVal => {
      const {
        onChange,
        types,
        textVal
      } = this.props;
      const arr = list.map((item, index) => ({
        // 针对这个表情单独处理下
        alt: `[${[item === 'Yeah' ? `${item}!` : item]}]`,
        style: {
          width: '10px',
          height: '10px'
        },
        src: index <= 104 ? `https://res.wx.qq.com/mpres/htmledition/images/icon/emotion/${index}.gif` : emojiImgs[item]
      }));
      const elem = this.editorElem.current;
      this.editor = new E(elem);
      this.editor.customConfig.menus = ['emoticon'];
      const otherEmoji = Object.keys(emoji).map(v => ({
        title: v,
        type: 'emoji',
        content: emoji[v]
      }));
      this.editor.customConfig.emotions = [{
        // tab 的标题
        title: '默认',
        // type -> 'emoji' / 'image'
        type: 'image',
        // content -> 数组
        content: arr
      }, ...otherEmoji];
      this.editor.customConfig.pasteTextHandle = content => {
        if (content === '' && !content) return '';
        let str = content.replace(/<br\/>/g, '\n');
        str = TextEmoji(str.replace(/<\/?[^>]*>/g, ''));
        str = str.replace(/<xml>[\s\S]*?<\/xml>/gi, '');
        str = str.replace(/<style>[\s\S]*?<\/style>/gi, '');
        str = str.replace(/[ | ]*\n/g, '\n');
        str = str.replace(/&nbsp;/gi, '');
        return str;
      };
      // 使用 onchange 函数监听内容的变化，并实时更新到 state 中
      this.editor.customConfig.onchange = () => {
        // t 是处理后的内容（测试的数据[得意][微笑]哈哈）
        const t = this.getText(this.editor.txt.getJSON());
        const txt = TextLength(t);
        this.setState({
          num: txt.length
        });
        if (types === 2) {
          if (txt.length > 120) {
            _message.warning('描述文本已达上限!');
          }
        } else if (types === 1) {
          if (txt.length > 1000) {
            _message.warning('描述文本已达上限!');
          }
        }
        console.log(t);
        if (onChange) onChange(t); // 这里预览的第一个换行去掉
      };
      this.editor.create();
      if (textVal || _textVal) {
        // 回显数据
        const vaList = TextEmoji(textVal || _textVal);
        let html = '';
        if (typeof vaList === 'string') {
          html = `<p>${vaList}</p>`;
        } else {
          vaList.forEach(item => {
            html += `<p>${item}</p>`;
          });
        }
        this.editor.txt.html(html);
      }
    };
    this.remderNum = () => {
      const {
        types
      } = this.props;
      const {
        num
      } = this.state;
      if (types === 1) {
        return /*#__PURE__*/React.createElement("span", {
          className: styles$c.spanTop
        }, num, "/1000");
      }
      if (types === 2) {
        return /*#__PURE__*/React.createElement("span", {
          className: styles$c.spanTop
        }, num, "/120");
      }
      return '';
    };
    this.editorElem = /*#__PURE__*/React.createRef();
    this.state = {
      num: 0
    };
  }
  componentDidMount() {
    setTimeout(() => {
      const {
        textVal
      } = this.props;
      // 这里异步读一下，不想让他每次监听到变化后就初始化
      if (textVal) {
        this.cartView(textVal);
      }
    }, 500);
    this.cartView();
  }
  componentDidUpdate(preProps) {
    const {
      change,
      textVal
    } = this.props;
    if (change !== preProps.change) {
      if (textVal) {
        this.cartView(textVal);
      }
    }
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$c.editorElemBox
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        width: '100%'
      },
      ref: this.editorElem
    }), this.remderNum());
  }
}
EmojiReplace.propTypes = propTypes$d;
EmojiReplace.defaultProps = defaultProps$b;

var css_248z$b = ".preview-module_previewPhone__2qhoE {\n  width: 100% !important;\n  background: rgba(0, 0, 0, 0.04);\n  height: 100%;\n  position: relative;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: contain;\n}\n.preview-module_previwTit__AzOhj {\n  padding: 20px;\n  font-size: 16px;\n}\n.preview-module_previewBox__1jLXl {\n  width: 100%;\n  height: 100%;\n  overflow: scroll;\n}\n.preview-module_previewCon__jEWA2 {\n  width: 99%;\n  height: auto;\n  display: flex;\n  margin-bottom: 20px;\n}\n.preview-module_previewLeft__3C943 {\n  width: auto;\n  height: 100%;\n}\n.preview-module_previewLeft__3C943 img {\n  width: 40px;\n  height: 40px;\n  margin-left: 20px;\n  margin-right: 8px;\n  border-radius: 5px;\n}\n.preview-module_previewRight__GgEjj {\n  width: 83%;\n  padding-right: 20px;\n}\n.preview-module_previewRight__GgEjj .preview-module_previewName__2tFt6 {\n  color: #2e448f;\n  line-height: 24px;\n}\n.preview-module_textCon__WT_9g {\n  width: 100%;\n  max-height: 100px;\n  font-size: 14px;\n  overflow: hidden;\n  line-height: 20px;\n}\n.preview-module_textCon2__3TZj6 {\n  width: 100%;\n  font-size: 14px;\n  overflow: hidden;\n  line-height: 20px;\n}\n.preview-module_textShow__3LibY {\n  width: 100%;\n  overflow-wrap: wrap;\n}\n.preview-module_btn__2zgzW {\n  padding: 0;\n}\n.preview-module_btn2__2owEo {\n  display: none;\n}\n.preview-module_linkBox__3n6R7 {\n  padding: 5px;\n  height: 110px;\n  margin: 10px 0;\n  width: 100%;\n  background: #ffffff;\n  display: block;\n  border-radius: 4px;\n}\n.preview-module_linkBox__3n6R7 .preview-module_dls__Wqkz3 {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.preview-module_linkBox__3n6R7 .preview-module_dlstit__2gLAY {\n  width: 100%;\n  height: 40px;\n  line-height: 40px;\n  padding: 0 5px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.preview-module_linkBox__3n6R7 .preview-module_dlscon__YsOdn {\n  flex: 1;\n  display: flex;\n  overflow: hidden;\n  padding: 0 5px;\n}\n.preview-module_linkBox__3n6R7 .preview-module_dlsimg__3YyMe {\n  width: 50px;\n  line-height: 60px;\n}\n.preview-module_linkBox__3n6R7 .preview-module_dlsimg__3YyMe img {\n  width: 50px;\n  height: 50px;\n}\n.preview-module_linkBox__3n6R7 .preview-module_dlsconent__2MuSC {\n  flex: 1;\n  text-overflow: -o-ellipsis-lastline;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 3;\n  -webkit-box-orient: vertical;\n}\n.preview-module_video__lS8Mv {\n  width: 100%;\n  margin-top: 10px;\n}\n.preview-module_video__lS8Mv video {\n  width: 100%;\n}\n.preview-module_noeimg__1wXc3 {\n  width: 100%;\n  height: 220px;\n  margin-top: 10px;\n}\n.preview-module_noeimg__1wXc3 img {\n  width: 140px;\n  height: auto;\n}\n.preview-module_moreimg__TZm3t {\n  width: 100%;\n  height: auto;\n  margin-top: 5px;\n}\n.preview-module_moreimg__TZm3t img {\n  width: 70px;\n  height: 70px;\n  margin-top: 8px;\n  margin-left: 8px;\n}\n.preview-module_wenjian__JYpyx {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n}\n";
var styles$b = {"previewPhone":"preview-module_previewPhone__2qhoE","previwTit":"preview-module_previwTit__AzOhj","previewBox":"preview-module_previewBox__1jLXl","previewCon":"preview-module_previewCon__jEWA2","previewLeft":"preview-module_previewLeft__3C943","previewRight":"preview-module_previewRight__GgEjj","previewName":"preview-module_previewName__2tFt6","textCon":"preview-module_textCon__WT_9g","textCon2":"preview-module_textCon2__3TZj6","textShow":"preview-module_textShow__3LibY","btn":"preview-module_btn__2zgzW","btn2":"preview-module_btn2__2owEo","linkBox":"preview-module_linkBox__3n6R7","dls":"preview-module_dls__Wqkz3","dlstit":"preview-module_dlstit__2gLAY","dlscon":"preview-module_dlscon__YsOdn","dlsimg":"preview-module_dlsimg__3YyMe","dlsconent":"preview-module_dlsconent__2MuSC","video":"preview-module_video__lS8Mv","noeimg":"preview-module_noeimg__1wXc3","moreimg":"preview-module_moreimg__TZm3t","wenjian":"preview-module_wenjian__JYpyx"};
styleInject(css_248z$b);

var img$r = "data:image/jpeg;base64,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";

// 手机预览效果
const propTypes$c = {
  page: PropTypes.number,
  // 1快捷回复，2营销素材
  types: PropTypes.number,
  // 显示类型1文本、2图片、3视频、4链接、5文件
  content: PropTypes.string,
  // 文本内容
  // links: PropTypes.string.isRequired, // 链接
  videoUlr: PropTypes.string,
  // 视频链接
  image: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.shape(), PropTypes.string])),
  // 图片-=-[{img:www.baidu.com},{img:www.jd.com}]
  imagePath: PropTypes.string,
  // 链接路径
  title: PropTypes.string,
  // 链接标题
  remark: PropTypes.string,
  // 链接描述
  inside: PropTypes.bool,
  messages: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({})))
};
const defaultProps$a = {
  inside: false,
  page: 1,
  types: 1,
  content: '',
  videoUlr: '',
  image: [],
  imagePath: '',
  title: '',
  remark: '',
  messages: []
};
class preview extends Component {
  constructor(props) {
    super(props);
    this.ButtonType = ({
      content,
      remark,
      types
    }) => {
      const {
        link
      } = this.state;
      if (types === 1) {
        return /*#__PURE__*/React.createElement(_Button, {
          className: content.length >= 80 ? styles$b.btn : styles$b.btn2,
          type: "link",
          onClick: () => {
            this.setState({
              link: link === '全文' ? '收起' : '全文'
            });
          }
        }, link);
      }
      return /*#__PURE__*/React.createElement(_Button, {
        className: remark.length >= 80 ? styles$b.btn : styles$b.btn2,
        type: "link",
        onClick: () => {
          this.setState({
            link: link === '全文' ? '收起' : '全文'
          });
        }
      }, link);
    };
    // 文本内容
    this.textWen = ({
      content,
      remark,
      types
    }) => {
      const {
        link
      } = this.state;
      return /*#__PURE__*/React.createElement("div", {
        className: link === '全文' ? styles$b.textCon : styles$b.textCon2
      }, /*#__PURE__*/React.createElement("div", {
        className: "textShow",
        dangerouslySetInnerHTML: {
          __html: TextEmoji(types === 1 ? content : remark)
        }
      }));
    };
    // 图片
    this.imageLen = ({
      image
    }) => {
      if (image.length <= 0) {
        return (
          /*#__PURE__*/
          // 没有
          React.createElement("div", null)
        );
      }
      if (image.length < 2) {
        return (
          /*#__PURE__*/
          // 单张
          React.createElement("div", {
            className: styles$b.noeimg
          }, image.map(person => /*#__PURE__*/React.createElement("img", {
            key: person.img || person,
            src: person.img || person,
            alt: ""
          })))
        );
      }
      return (
        /*#__PURE__*/
        // 多张
        React.createElement("div", {
          className: styles$b.moreimg
        }, image.map(person => /*#__PURE__*/React.createElement("img", {
          key: person.img || person,
          src: person.img || person,
          alt: ""
        })))
      );
    };
    // 展示文本
    this.wenbenTYPE = ({
      content,
      remark,
      types
    }) => /*#__PURE__*/React.createElement("div", null, this.textWen({
      content,
      remark,
      types
    }), this.ButtonType({
      content,
      remark,
      types
    }));
    // 所有内容展示
    this.ContentArea = ({
      types,
      title,
      remark,
      imagePath,
      videoUlr,
      page,
      inside,
      content,
      image
    }) => {
      if (types === 2) {
        return /*#__PURE__*/React.createElement("div", null, page === 1 ? '' : this.wenbenTYPE({
          content,
          remark,
          types
        }), /*#__PURE__*/React.createElement("div", {
          className: styles$b.previewImg
        }, this.imageLen({
          image
        })));
      }
      if (types === 3) {
        return /*#__PURE__*/React.createElement("div", null, page === 1 ? '' : this.wenbenTYPE({
          content,
          remark,
          types
        }), /*#__PURE__*/React.createElement("div", {
          className: styles$b.video
        }, /*#__PURE__*/React.createElement("a", {
          href: videoUlr,
          target: "yunke_video"
        }, /*#__PURE__*/React.createElement("video", {
          src: videoUlr
        }, /*#__PURE__*/React.createElement("track", {
          kind: "captions"
        })))));
      }
      if (types === 4 && inside) {
        return /*#__PURE__*/React.createElement("div", null, page === 1 ? '' : this.wenbenTYPE({
          content,
          remark,
          types
        }), /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: styles$b.linkBox,
          href: "#",
          style: {
            height: 'auto'
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$b.dls
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$b.dlscon
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$b.dlsimg
        }, /*#__PURE__*/React.createElement("img", {
          src: imagePath,
          alt: ""
        })), /*#__PURE__*/React.createElement("div", {
          className: styles$b.dlsconent
        }, title)))));
      }
      if (types === 4 && !inside) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: styles$b.linkBox,
          href: "#"
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$b.dls
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$b.dlstit
        }, title), /*#__PURE__*/React.createElement("div", {
          className: styles$b.dlscon
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$b.dlsconent
        }, remark), /*#__PURE__*/React.createElement("div", {
          className: styles$b.dlsimg
        }, /*#__PURE__*/React.createElement("img", {
          src: imagePath,
          alt: ""
        }))))));
      }
      if (types === 1) {
        return /*#__PURE__*/React.createElement("div", null, this.wenbenTYPE({
          content,
          remark,
          types
        }));
      }
      if (types === 5) {
        return /*#__PURE__*/React.createElement("div", null);
      }
      return /*#__PURE__*/React.createElement("div", null);
    };
    this.state = {
      link: '全文'
    };
  }
  render() {
    const {
      types,
      title,
      remark,
      imagePath,
      videoUlr,
      page,
      inside,
      content,
      image,
      messages
    } = this.props;
    // 这里为了展示多条消息、多条微信，且兼容了旧代码
    let wechats = [[{
      types,
      title,
      remark,
      imagePath,
      videoUlr,
      page,
      inside,
      content,
      image
    }]];
    if (messages.length > 0) {
      wechats = messages;
    }
    return /*#__PURE__*/React.createElement("div", {
      className: styles$b.previewPhone
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$b.previewBox
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$b.previwTit
    }, "\u6548\u679C\u9884\u89C8"), wechats.map(item => item.map(item1 => /*#__PURE__*/React.createElement("div", {
      className: styles$b.previewCon,
      key: Math.random()
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$b.previewLeft
    }, /*#__PURE__*/React.createElement("img", {
      src: img$r,
      alt: ""
    })), /*#__PURE__*/React.createElement("div", {
      className: styles$b.previewRight
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: styles$b.previewName
    }, item1.nickName || '微信昵称'), /*#__PURE__*/React.createElement("div", {
      key: Math.random()
    }, this.ContentArea(item1)))))))));
  }
}
preview.propTypes = propTypes$c;
preview.defaultProps = defaultProps$a;

const propTypes$b = {
  value: PropTypes.string.isRequired
};
class HeaderNav extends Component {
  constructor(props) {
    super(props);
    this.TagLength = text => {
      if (text) {
        if (text.split('，').length < 3) {
          return /*#__PURE__*/React.createElement("div", null, text);
        }
        return /*#__PURE__*/React.createElement(_Tooltip, {
          title: text
        }, /*#__PURE__*/React.createElement("div", null, text.split('，').splice(0, 3).join('，'), "\xA0\u5171", text.split('，').length, "\u4E2A"));
      }
      return /*#__PURE__*/React.createElement("div", null, "-");
    };
    this.state = {};
  }
  render() {
    const {
      value
    } = this.props;
    return /*#__PURE__*/React.createElement("div", null, this.TagLength(value));
  }
}
HeaderNav.propTypes = propTypes$b;

var css_248z$a = ".index-module_leftTree__1F4KS {\n  position: relative;\n  width: 235px;\n  height: 100%;\n  flex-shrink: 0;\n  padding-right: 10px;\n  transition: all 0.2s;\n  border-right: 1px solid rgba(0, 0, 0, 0.06);\n}\n.index-module_leftTree__1F4KS.index-module_close__1DwzQ {\n  width: 15px;\n  padding: 0;\n  color: rgba(26, 26, 26, 0.4);\n  border: 0px;\n  margin-right: 5px !important;\n}\n.index-module_leftTree__1F4KS.index-module_close__1DwzQ .index-module_arrow__2TVSN {\n  transition: all 0.2s;\n  transform: rotate(180deg);\n}\n.index-module_leftTree__1F4KS > div:nth-child(2) > div:nth-child(1) {\n  padding-left: 5px;\n}\n.index-module_collapsedButton__4Lpc- {\n  cursor: pointer;\n  position: absolute;\n  display: inline-block;\n  text-align: center;\n  background-color: #ffffff;\n  border-top-left-radius: 4px;\n  border-bottom-left-radius: 4px;\n  overflow: hidden;\n  width: 16px;\n  height: 33px;\n  right: -1px;\n  top: 20px;\n  display: flex;\n  align-items: center;\n  justify-items: center;\n  justify-content: center;\n  color: #505050;\n  z-index: 999;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-right: none;\n}\n.index-module_collapsedButton2__U9t0V {\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  border-top-left-radius: 0px;\n  border-bottom-left-radius: 0px;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-left: none;\n}\n";
var styles$a = {"leftTree":"index-module_leftTree__1F4KS","close":"index-module_close__1DwzQ","arrow":"index-module_arrow__2TVSN","collapsedButton":"index-module_collapsedButton__4Lpc-","collapsedButton2":"index-module_collapsedButton2__U9t0V"};
styleInject(css_248z$a);

const IconFonts$1 = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1781333_opezf6b0hyn.js'
});
const propTypes$a = {
  onChange: PropTypes.func,
  selectedValue: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.shape()])),
  showUser: PropTypes.bool,
  loadDataServe: PropTypes.func,
  draggable: PropTypes.bool
};
const defaultProps$9 = {
  onChange: null,
  selectedValue: [],
  showUser: false,
  loadDataServe: null,
  draggable: false
};
class insideTree extends Component {
  constructor(props) {
    super(props);
    this.toogleCollapse = () => {
      const {
        open
      } = this.state;
      this.setState({
        open: !open
      });
    };
    this.state = {
      open: true
    };
  }
  render() {
    const {
      onChange,
      selectedValue,
      showUser,
      loadDataServe,
      draggable
    } = this.props;
    const {
      open
    } = this.state;
    const service = loadDataServe || getDeptTree;
    // showUser 是否显示员工，或搜索员工，true&false
    return /*#__PURE__*/React.createElement("div", {
      className: `${styles$a.leftTree} ${open === true ? '' : styles$a.close}`
    }, /*#__PURE__*/React.createElement("div", {
      role: "button",
      tabIndex: "0",
      onKeyPress: () => {},
      onClick: this.toogleCollapse,
      className: `${styles$a.collapsedButton} ${open === true ? '' : styles$a.collapsedButton2}`
    }, /*#__PURE__*/React.createElement(IconFonts$1, {
      className: styles$a.arrow,
      style: {
        fontSize: 12
      },
      type: "icon0shouqi"
    })), /*#__PURE__*/React.createElement(LazySelectTree$1, {
      checkable: false,
      mode: "tree",
      style: {
        width: '100px'
      },
      showLine: false,
      searchTree: searchUserDept,
      type: showUser ? 3 : 1,
      loadDataServe: service,
      showSearch: true,
      draggable: draggable,
      showUser: showUser || false,
      selectedValue: selectedValue,
      onChange: onChange
    }));
  }
}
insideTree.propTypes = propTypes$a;
insideTree.defaultProps = defaultProps$9;

var css_248z$9 = ".ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {\n  background-color: #bae7ff;\n}\n.styles-module_treeContent__2vaYS {\n  width: 100%;\n  max-height: 1000px;\n  overflow: auto;\n}\n.styles-module_treeContent__2vaYS::-webkit-scrollbar {\n  display: none;\n}\n.styles-module_selectTreeNode__3TM8A {\n  box-sizing: border-box;\n  margin: 0;\n  font-variant: tabular-nums;\n  list-style: none;\n  -webkit-font-feature-settings: \"tnum\";\n  font-feature-settings: \"tnum\";\n  position: relative;\n  display: inline-block;\n  width: 100%;\n  min-height: 32px;\n  padding: 4px 11px;\n  color: rgba(0, 0, 0, 0.65);\n  font-size: 14px;\n  line-height: 1.5;\n  background-color: #fff;\n  background-image: none;\n  border: 1px solid #d9d9d9;\n  border-radius: 4px;\n  -webkit-transition: all 0.3s;\n  transition: all 0.3s;\n}\n.styles-module_searchBox__29sL0 {\n  padding: 10px;\n  background-color: #f7f8fa;\n}\n.styles-module_hide__1Q1SV {\n  display: none;\n}\n";
var styles$9 = {"treeContent":"styles-module_treeContent__2vaYS","selectTreeNode":"styles-module_selectTreeNode__3TM8A","searchBox":"styles-module_searchBox__29sL0","hide":"styles-module_hide__1Q1SV"};
styleInject(css_248z$9);

const noop = () => {};
function changeItem(treeData) {
  treeData.forEach(_ => {
    const element = _;
    element.key = element.id;
    element.title = element.name;
    element.isLeaf = element.isDept === undefined ? true : !element.isDept;
    element.originData = {
      ...element
    };
    delete element.originData.originData;
    if (element.children) {
      changeItem(element.children);
    }
  });
}
const propTypes$9 = {
  selectedValue: PropTypes.arrayOf(PropTypes.shape({})),
  // [{id:'ID',name:"部门一"}]
  onChange: PropTypes.func,
  // 参数 所选数据源：String:[{}]
  checkable: PropTypes.bool,
  // 多选
  loadDataServe: PropTypes.func
};
const defaultProps$8 = {
  selectedValue: [],
  onChange: noop,
  checkable: false,
  loadDataServe: null
};

/**
 * 下拉框搜索树
 * 1.懒加载
 * 2.加搜索
 * 3.可控
 */
class LazySelectTree extends Component {
  constructor(props) {
    super(props);
    this.searchTree = debounce(async searchKey => {
      const {
        loadDataServe
      } = this.props;
      const service = loadDataServe || searchUserDept;
      try {
        const searchTreeData = await service(searchKey);
        changeItem(searchTreeData);
        this.setState({
          searchTreeData
        });
      } catch (e) {
        console.log(e);
      }
    });
    /**
     * 组织架构树 改变事件
     * @param key
     * @param checkNodes
     */
    this.handleOriginChange = (key, checkNodes) => {
      const {
        onChange,
        checkable
      } = this.props;
      const {
        searchSelectNodes
      } = this.state;
      const data = [];
      if (checkable) {
        checkNodes.forEach(({
          pid,
          originData
        }) => {
          if (!key.includes(pid)) data.push({
            ...originData
          });
        });
        this.setState({
          treeSelectNodes: data
        });
        if (onChange) onChange(data.concat(searchSelectNodes));
      } else {
        const data1 = checkNodes[0] ? [checkNodes[0].originData] : [];
        onChange(data1);
      }
    };
    /**
     * 搜索树 改变事件
     * @param key
     * @param checkNodes
     */
    this.handleSearchChange = (key, checkNodes) => {
      const {
        onChange,
        checkable
      } = this.props;
      const {
        treeSelectNodes
      } = this.state;
      if (checkable) {
        const data = [];
        checkNodes.forEach(({
          pid,
          originData
        }) => {
          if (!key.includes(pid)) data.push({
            ...originData
          });
        });
        this.setState({
          searchSelectNodes: data
        });
        onChange(data.concat(treeSelectNodes));
      } else {
        const data = checkNodes[0] ? [checkNodes[0].originData] : [];
        onChange(data);
      }
    };
    /**
     * 树选择改变事件
     * @param searchKey
     */
    this.handleChangeSearchKey = async searchKey => {
      const searchValue = searchKey ? searchKey.trim() : searchKey;
      this.setState({
        searchKey: searchValue
      });
      // 取消搜索
      if (!searchValue) return;
      this.searchTree(searchValue);
    };
    /**
     * 返回组织架构树
     * @returns {*}
     */
    this.renderTree = () => {
      const {
        checkable,
        selectedValue,
        loadDataServe
      } = this.props;
      const {
        boxWidth
      } = this.state;
      const value = selectedValue.map(item => item.id);
      return /*#__PURE__*/React.createElement("div", {
        className: styles$9.treeContent,
        style: {
          minWidth: `${boxWidth}px`
        }
      }, /*#__PURE__*/React.createElement(LazyOrganizationTree, {
        checkable: checkable,
        onChange: this.handleOriginChange,
        selectedValue: value,
        loadDataServe: loadDataServe
      }));
    };
    this.renderContent = () => {
      const {
        searchKey
      } = this.state;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: !searchKey ? styles$9.hide : undefined
      }, this.renderSearchTree()), /*#__PURE__*/React.createElement("div", {
        className: searchKey ? styles$9.hide : undefined
      }, !searchKey && this.renderTree()));
    };
    /**
     * 返回搜索框
     * @returns {*}
     */
    this.renderSearch = () => {
      const {
        searchKey
      } = this.state;
      return /*#__PURE__*/React.createElement("div", {
        className: styles$9.searchBox
      }, /*#__PURE__*/React.createElement(_Input, {
        placeholder: "\u8BF7\u8F93\u5165\u641C\u7D22\u5173\u952E\u5B57",
        value: searchKey,
        onChange: event => this.handleChangeSearchKey(event.target.value)
      }));
    };
    /**
     * 返回搜索树
     * @returns {*}
     */
    this.renderSearchTree = () => {
      const {
        checkable,
        selectedValue
      } = this.props;
      const {
        searchTreeData,
        boxWidth
      } = this.state;
      const selectValue = selectedValue.map(item => item.id);
      return /*#__PURE__*/React.createElement("div", {
        className: styles$9.treeContent,
        style: {
          minWidth: `${boxWidth}px`
        }
      }, /*#__PURE__*/React.createElement(LazyOrganizationTree, {
        mode: "data",
        checkable: checkable,
        onChange: this.handleSearchChange,
        onSelect: this.onSelect,
        selectedValue: selectValue,
        lazy: false,
        treeData: searchTreeData
      }));
    };
    this.state = {
      boxWidth: 0,
      searchTreeData: [],
      // 搜索数据树
      searchKey: null,
      treeSelectNodes: [],
      searchSelectNodes: []
    };
  }
  render() {
    return /*#__PURE__*/React.createElement("div", {
      className: styles$9.treeContent
    }, /*#__PURE__*/React.createElement("div", null, this.renderSearch()), /*#__PURE__*/React.createElement("div", null, this.renderContent()));
  }
}
LazySelectTree.propTypes = propTypes$9;
LazySelectTree.defaultProps = defaultProps$8;

var css_248z$8 = ".index-module_pageview__2cq9h {\n  width: 100%;\n  height: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  background-color: transparent;\n  overflow: hidden;\n}\n.index-module_pageview__2cq9h .index-module_lefttree__PzqWC {\n  position: relative;\n  flex-shrink: 0;\n  transition: all 0.2s;\n  background: #fff;\n  box-shadow: 0 0 10px 0 #ccc;\n  z-index: 999;\n}\n.index-module_pageview__2cq9h .index-module_lefttree__PzqWC.index-module_close__2rHG0 {\n  width: 10px;\n  padding: 0;\n  color: rgba(26, 26, 26, 0.4);\n}\n.index-module_pageview__2cq9h .index-module_lefttree__PzqWC.index-module_close__2rHG0 .index-module_arrow__3cC9p {\n  transition: all 0.2s;\n  transform: rotate(180deg);\n}\n.index-module_pageview__2cq9h .index-module_yunke-collapsed-button__30pSB {\n  cursor: pointer;\n  position: absolute;\n  display: inline-block;\n  text-align: center;\n  background-color: #ffffff;\n  border-top-right-radius: 4px;\n  border-bottom-right-radius: 4px;\n  overflow: hidden;\n  width: 18px;\n  height: 40px;\n  right: -10px;\n  top: 28px;\n  display: flex;\n  align-items: center;\n  justify-items: center;\n  justify-content: center;\n  color: #505050;\n  z-index: 999;\n  border: 1px solid rgba(0, 0, 0, 0.06);\n  border-left: none;\n}\n.index-module_pageview__2cq9h .index-module_rightcontent__rEuD6 {\n  width: 100%;\n  display: flex;\n  overflow: hidden;\n  flex-direction: column;\n}\n.index-module_pageview__2cq9h .index-module_rightcontent__rEuD6 .index-module_pagehead__2cRT9 {\n  padding: 10px 20px;\n}\n.index-module_pageview__2cq9h .index-module_rightcontent__rEuD6 .index-module_pagehead__2cRT9 .index-module_pagetitle__11jgC {\n  position: relative;\n  font-size: 16px;\n  line-height: 24px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.85);\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.index-module_pageview__2cq9h .index-module_rightcontent__rEuD6 .index-module_pagecontent__2iJE1 {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n}\n.index-module_pageview__2cq9h .index-module_rightcontent__rEuD6 .index-module_pagecontent__2iJE1 .index-module_yunke-btn-group__2-aoc {\n  padding: 16px 0;\n}\n.index-module_pageview__2cq9h .index-module_rightcontent__rEuD6 .index-module_pagecontent__2iJE1 .index-module_yunke-search-part__3jl9x {\n  padding: 16px 0;\n}\n.index-module_pageview__2cq9h .index-module_rightcontent__rEuD6 .index-module_pagecontent__2iJE1 .index-module_yunke-page-main-content__3cu8X {\n  padding: 0 0 0 0;\n}\n.index-module_pageview__2cq9h .index-module_rightcontent__rEuD6 .index-module_pagecontent__2iJE1 .index-module_yunke-tabs-content__3PFvq {\n  position: relative;\n  padding: 10px 0;\n}\n.index-module_pageview__2cq9h .index-module_rightcontent__rEuD6 .index-module_pagecontent__2iJE1 .index-module_searchform__357Me {\n  background-color: #fff;\n  margin-bottom: 10px;\n  display: flex;\n  padding: 10px;\n  justify-content: space-between;\n  align-items: center;\n  border-radius: 4px;\n}\n.index-module_pageview__2cq9h .index-module_rightcontent__rEuD6 .index-module_pagecontent__2iJE1 .index-module_searchform__357Me .ant-tabs-nav {\n  margin: 0;\n}\n.index-module_pageview__2cq9h .index-module_rightcontent__rEuD6 .index-module_pagecontent__2iJE1 .index-module_bottomtable__3CDgZ {\n  flex: 1;\n  overflow: hidden;\n}\n.ant-pro-basicLayout {\n  flex: 1;\n  overflow: auto;\n}\n.ant-page-header {\n  padding: 6px 12px;\n}\n.ant-page-header-footer {\n  margin-top: 0;\n}\n.ant-pro-page-container-children-content {\n  margin: 12px 12px 0;\n}\n.ant-pro-table-search {\n  padding: 12px 24px 0;\n}\n.ant-form-item {\n  margin-bottom: 12px;\n}\n";
var styles$8 = {"pageview":"index-module_pageview__2cq9h","lefttree":"index-module_lefttree__PzqWC","close":"index-module_close__2rHG0","arrow":"index-module_arrow__3cC9p","yunke-collapsed-button":"index-module_yunke-collapsed-button__30pSB","rightcontent":"index-module_rightcontent__rEuD6","pagehead":"index-module_pagehead__2cRT9","pagetitle":"index-module_pagetitle__11jgC","pagecontent":"index-module_pagecontent__2iJE1","yunke-btn-group":"index-module_yunke-btn-group__2-aoc","yunke-search-part":"index-module_yunke-search-part__3jl9x","yunke-page-main-content":"index-module_yunke-page-main-content__3cu8X","yunke-tabs-content":"index-module_yunke-tabs-content__3PFvq","searchform":"index-module_searchform__357Me","bottomtable":"index-module_bottomtable__3CDgZ"};
styleInject(css_248z$8);

const propTypes$8 = {
  /**
   * 这是左侧内容，通常用来显示组织架构树
   */
  lefttree: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * 这是右侧最顶端的面包屑
   */
  // breadcrumb: PropTypes.arrayOf(PropTypes.shape()),
  /**
   * 这是右侧最顶部标题栏的内容
   */
  title: PropTypes.string,
  /**
   * 这是右侧最顶部二级标题栏的内容
   */
  subTitle: PropTypes.oneOfType([PropTypes.shape(), PropTypes.string]),
  /**
   * 顶部右侧操作区内容
   */
  extra: PropTypes.arrayOf(PropTypes.shape()),
  /**
   * 顶部内容
   */
  headerContent: PropTypes.oneOfType([PropTypes.shape(), PropTypes.string]),
  /**
   * 顶部的标签栏
   */
  tabList: PropTypes.arrayOf(PropTypes.shape()),
  /**
   * 缺省选中的标签
   */
  tabActiveKey: PropTypes.string,
  /**
   * 点击标签栏的动作
   */
  onTabChange: PropTypes.func,
  /**
   * 标签栏右侧额外的内容
   */
  tabBarExtraContent: PropTypes.shape(),
  /**
   * 顶部返回按钮的动作
   */
  onBack: PropTypes.func,
  /**
   * 顶部返回按钮的图标，缺省为空
   */
  backIcon: PropTypes.bool,
  /**
   * 这是右侧中间搜索框部分的内容
   */
  search: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  /**
   * 这是右侧底部放表格的部分
   */
  table: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};
const defaultProps$7 = {
  lefttree: '',
  // breadcrumb: null,
  extra: [],
  headerContent: null,
  tabList: [],
  tabActiveKey: '',
  onTabChange: null,
  tabBarExtraContent: null,
  onBack: () => {
    window.history.back();
  },
  backIcon: false,
  title: '',
  subTitle: '',
  search: '',
  table: ''
};

/**
 * 这是右侧总框架组件，用它来定义统一的右侧结构
 */
class RightContent extends Component {
  constructor(props) {
    super(props);
    /**
     * 生成面包屑内容
     * @param {*} route
     */
    this.breadcrumbItemRender = route => route.path ? /*#__PURE__*/React.createElement(Link, {
      to: route.path
    }, route.breadcrumbName) : /*#__PURE__*/React.createElement("span", null, route.breadcrumbName);
    this.state = {
      tableBackground: 'transparent'
      //   tablePadding: 0,
    };
    this.viewRef = /*#__PURE__*/React.createRef();
    this.tableRef = /*#__PURE__*/React.createRef();
  }
  componentDidMount() {
    let {
      table
    } = this.props;
    if (typeof table === 'object' && table.type !== CommonTableComponent) {
      if (table.props.children?.type === CommonTableComponent) {
        table = table.props.children;
      }
    }
    if (typeof table === 'object' && (table.props?.name === 'VirtualTable' || table.type === CommonTableComponent)) {
      this.setState({
        tableBackground: '#fff'
      });
      if (table.props.search) {
        table.props.scroll.y = this.viewRef.current.offsetHeight - this.tableRef.current.offsetTop - 260;
        this.setState({
          tableBackground: 'transparent'
        });
      } else {
        table.props.scroll.y = this.viewRef.current.offsetHeight - this.tableRef.current.offsetTop - 190;
      }
      if (!table.props.toolBarRender) {
        table.props.scroll.y += 32;
      }
    }
  }
  render() {
    const {
      lefttree,
      title,
      subTitle,
      headerContent,
      search,
      table,
      extra,
      onBack,
      backIcon,
      tabList,
      tabActiveKey,
      onTabChange,
      tabBarExtraContent
      // breadcrumb,
    } = this.props;
    const {
      tableBackground
    } = this.state;
    return /*#__PURE__*/React.createElement("div", {
      className: styles$8.pageview,
      ref: this.viewRef
    }, lefttree && /*#__PURE__*/React.createElement("div", {
      className: styles$8.lefttree
    }, lefttree), /*#__PURE__*/React.createElement(ProLayout, {
      title: title || '后台管理系统',
      navTheme: "light",
      menuRender: false,
      headerRender: false
    }, /*#__PURE__*/React.createElement(PageContainer
    // fixedHeader
    , {
      header: {
        title,
        subTitle,
        // breadcrumb: { // 需求去掉所有的面包屑
        //   itemRender: this.breadcrumbItemRender,
        //   routes: breadcrumb,
        // },
        children: headerContent,
        backIcon: backIcon ? /*#__PURE__*/React.createElement(ArrowLeftOutlined, null) : false,
        onBack
      },
      extra: extra,
      tabList: tabList,
      tabActiveKey: tabActiveKey,
      onTabChange: onTabChange,
      tabBarExtraContent: tabBarExtraContent
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$8.rightcontent,
      id: "content"
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$8.pagecontent
    }, search && /*#__PURE__*/React.createElement("div", {
      className: styles$8.searchform
    }, search), /*#__PURE__*/React.createElement("div", {
      ref: this.tableRef,
      style: {
        backgroundColor: tableBackground,
        borderRadius: '4px'
        //   padding: tablePadding,
      }
    }, table))))));
  }
}
RightContent.propTypes = propTypes$8;
RightContent.defaultProps = defaultProps$7;

const propTypes$7 = {
  title: PropTypes.string,
  /**
   * 文件地址
   */
  url: PropTypes.string.isRequired,
  /**
   * 文件名称
   */
  fileName: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  /**
   * 0-1之间的数值，定义自动剪裁区域的大小，默认1
   */
  autoCropArea: PropTypes.number
};
const defaultProps$6 = {
  title: '图片裁剪',
  onChange: () => {},
  autoCropArea: 1
};

/**
 * 图片裁剪
 */
class ImageClipping extends Component {
  constructor(props) {
    super(props);
    this.onCrop = () => {};
    /**
     * 确认
     */
    this.handleOk = bool => {
      const {
        onChange,
        fileName
      } = this.props;
      const suffixName = fileName.toLowerCase();
      const name = suffixName.replace(new RegExp('jpg', 'g'), 'jpeg');
      const type = name.substr(name.lastIndexOf('.') + 1);
      const canvas = this.cropperRef.current.cropper.getCroppedCanvas();
      if (canvas) {
        const dataurl = canvas.toDataURL(`image/${type}`);
        if (onChange) {
          if (bool) {
            onChange(this.dataURLtoFile(dataurl, name));
          } else {
            onChange();
          }
        }
      }
    };
    /**
     * 转file
     * @param {*} dataurl
     * @param {*} filename
     */
    this.dataURLtoFile = (dataurl, filename) => {
      const arr = dataurl.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      // eslint-disable-next-line
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new File([u8arr], filename, {
        type: mime
      });
    };
    this.cropperRef = /*#__PURE__*/React.createRef();
  }
  render() {
    const {
      url,
      title,
      autoCropArea
    } = this.props;
    return /*#__PURE__*/React.createElement(_ConfigProvider, {
      locale: zhCN
    }, /*#__PURE__*/React.createElement(_Modal, {
      title: title,
      open: url,
      onOk: () => this.handleOk(true),
      onCancel: () => this.handleOk(false)
    }, /*#__PURE__*/React.createElement(Cropper, _extends({
      src: url,
      guides: true,
      crop: this.onCrop,
      ref: this.cropperRef,
      style: {
        maxHeight: '70vh',
        width: '100%'
      },
      autoCropArea: autoCropArea
    }, this.props))));
  }
}
ImageClipping.propTypes = propTypes$7;
ImageClipping.defaultProps = defaultProps$6;

var css_248z$7 = ".style-module_virtualAlert__1KlJs {\n  padding: 4px 24px !important;\n  white-space: nowrap;\n  overflow: auto;\n  justify-content: space-between;\n}\n.style-module_virtualAlert__1KlJs .ant-alert-content {\n  flex: 0 0 100px;\n}\n";
var styles$7 = {"virtualAlert":"style-module_virtualAlert__1KlJs"};
styleInject(css_248z$7);

({
  onResize: PropTypes.func,
  width: PropTypes.number
});
const VirtualTable = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    columns,
    total,
    scroll,
    dataSource,
    checked,
    rowKey,
    loading,
    headerTitle,
    toolBarRender,
    actionBarRender,
    onSelectChange,
    onChange,
    selectAll,
    resizable,
    actionOnClose
  } = props;
  const [tableWidth, setTableWidth] = useState(0);
  const [isAll, setIsAll] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState({
    keys: [],
    rows: []
  });
  const [ignored, forceUpdate] = useState(1);
  const widthColumnCount = columns.filter(({
    width
  }) => !width).length;
  const cancelSelect = () => {
    if (isAll) {
      setIsAll(false);
    }
    setSelectedRowKeys({
      keys: [],
      rows: []
    });
  };
  const mergedColumns = useMemo(() => {
    const c = [...columns];
    if (checked) {
      const allKeys = dataSource.map(item => item[rowKey]);
      const allRows = dataSource.map(item => item);
      const oldSelectedRowKeys = selectedRowKeys.keys.filter(item => !dataSource.find(item1 => item1[rowKey] === item));
      const oldSelectedRows = selectedRowKeys.rows.filter(item => !dataSource.find(item1 => item1[rowKey] === item[rowKey]));
      const newSelectedRowKeys = [...oldSelectedRowKeys, ...allKeys];
      const newSelectedRow = [...oldSelectedRows, ...allRows];
      const renderTitle = () => /*#__PURE__*/React.createElement(_Space, null, /*#__PURE__*/React.createElement(_Checkbox, {
        checked: isAll || (selectedRowKeys.keys.length ? selectedRowKeys.keys.join() === newSelectedRowKeys.join() : false),
        indeterminate: selectedRowKeys.keys.length ? selectedRowKeys.keys.join() !== newSelectedRowKeys.join() : false,
        onChange: e => {
          if (e.target.checked) {
            setSelectedRowKeys({
              keys: newSelectedRowKeys,
              rows: newSelectedRow
            });
          } else {
            if (actionOnClose) {
              actionOnClose();
            }
            setIsAll(false);
            setSelectedRowKeys({
              keys: oldSelectedRowKeys,
              rows: oldSelectedRows
            });
          }
        }
      }), selectAll && /*#__PURE__*/React.createElement(_Dropdown, {
        menu: /*#__PURE__*/React.createElement(_Menu, null, /*#__PURE__*/React.createElement(_Menu.Item, {
          onClick: () => {
            setIsAll(!isAll);
            cancelSelect();
            if (actionOnClose && isAll) {
              actionOnClose();
            }
          },
          key: "all"
        }, isAll ? '取消选择全部' : '选择全部'), /*#__PURE__*/React.createElement(_Menu.Item, {
          key: "current_all",
          onClick: () => {
            setIsAll(false);
            if (selectedRowKeys.keys.length) {
              if (actionOnClose) {
                actionOnClose();
              }
              setSelectedRowKeys(selectedRowKeys.keys.join() === newSelectedRowKeys.join() ? {
                keys: oldSelectedRowKeys,
                rows: oldSelectedRows
              } : {
                keys: newSelectedRowKeys,
                rows: newSelectedRow
              });
            } else {
              setSelectedRowKeys({
                keys: newSelectedRowKeys,
                rows: newSelectedRow
              });
            }
          }
        }, selectedRowKeys.keys.length && selectedRowKeys.keys.join() === allKeys.join() ? '取消选择' : '选择当前页'))
      }, /*#__PURE__*/React.createElement(DownOutlined, {
        style: {
          fontSize: 10
        }
      })));
      c.unshift({
        title: renderTitle(),
        width: 50,
        dataIndex: rowKey,
        render(row, record, rowIndex) {
          return /*#__PURE__*/React.createElement("div", {
            style: {
              padding: '5px 12px'
            }
          }, /*#__PURE__*/React.createElement(_Checkbox, {
            disabled: isAll,
            checked: isAll || selectedRowKeys.keys.includes(row),
            onChange: e => {
              const selectedRow = JSON.parse(JSON.stringify(selectedRowKeys));
              if (e.target.checked) {
                selectedRow.keys.splice(rowIndex, 0, row);
                selectedRow.rows.splice(rowIndex, 0, record);
              } else {
                const sRowIndex = selectedRow.keys.findIndex(item => item === row);
                selectedRow.keys.splice(sRowIndex, 1);
                selectedRow.rows.splice(sRowIndex, 1);
              }
              setSelectedRowKeys(selectedRow);
            }
          }));
        }
      });
    }
    if (resizable) {
      const handleResize = index => (e, {
        size
      }) => {
        c[index].width = size.width;
        let text = JSON.parse(JSON.stringify(ignored));
        forceUpdate(text += 1);
      };
      return c.map((col, index) => ({
        ...col,
        onHeaderCell: column => ({
          width: column.width,
          onResize: handleResize(index)
        })
      }));
    }
    return c.map(column => {
      if (column.width) {
        return {
          ...column,
          width: c.length <= 9 ? Math.floor(tableWidth / c.length) : column.width
        };
      }
      return {
        ...column,
        width: Math.floor(tableWidth / widthColumnCount)
      };
    });
  }, [ignored, columns, checked, dataSource, selectedRowKeys, isAll, tableWidth, widthColumnCount]);
  const gridRef = useRef();
  useState(() => {
    const obj = {};
    Object.defineProperty(obj, 'scrollLeft', {
      get: () => null,
      set: scrollLeft => {
        if (gridRef.current) {
          gridRef.current.scrollTo({
            scrollLeft
          });
        }
      }
    });
    return obj;
  });
  const resetVirtualGrid = () => {
    gridRef.current?.resetAfterIndices({
      columnIndex: 0,
      shouldForceUpdate: true
    });
  };
  const someScroll = useMemo(() => {
    if (selectedRowKeys.keys.length || isAll) {
      return {
        y: scroll.y
      };
    }
    return scroll;
  }, [scroll, selectedRowKeys, isAll]);
  useEffect(() => resetVirtualGrid, [tableWidth, columns, dataSource, ignored]);
  useEffect(() => {
    onSelectChange(selectedRowKeys.keys, selectedRowKeys.rows, isAll);
  }, [selectedRowKeys, isAll]);
  /**
   * 返回分页
   */
  const renderPagination = () => {
    const {
      pageSizeOptions,
      pageIndex,
      pageSize
    } = props;
    return /*#__PURE__*/React.createElement(_ConfigProvider, {
      locale: zhCN
    }, /*#__PURE__*/React.createElement(_Pagination, {
      current: pageIndex,
      pageSize: pageSize,
      total: total,
      onChange: (pIndex, pSize, sorter) => onChange?.(pIndex, pSize, sorter),
      onShowSizeChange: (pIndex, pSize) => onChange?.(1, pSize),
      showTotal: total1 => `共 ${total1} 条记录`,
      pageSizeOptions: pageSizeOptions.map(value => String(value)),
      showQuickJumper: true,
      showSizeChanger: true,
      style: {
        paddingRight: 24,
        textAlign: 'right',
        marginTop: 15,
        marginBottom: 12
      }
    }));
  };
  useImperativeHandle(ref, () => ({
    cancelSelect
  }), []);
  return /*#__PURE__*/React.createElement(_Spin, {
    spinning: loading,
    size: "large"
  }, /*#__PURE__*/React.createElement(_Card, {
    bordered: false,
    bodyStyle: {
      paddingTop: 0,
      paddingBottom: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "ant-pro-table-list-toolbar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ant-pro-table-list-toolbar-container"
  }, /*#__PURE__*/React.createElement("div", {
    className: "ant-pro-table-list-toolbar-title"
  }, headerTitle), toolBarRender())), selectedRowKeys.keys.length || isAll ? /*#__PURE__*/React.createElement("div", {
    className: "ant-pro-table-alert"
  }, /*#__PURE__*/React.createElement(_Alert, {
    className: styles$7.virtualAlert,
    message: /*#__PURE__*/React.createElement("span", null, "\u5DF2\u9009\u62E9", /*#__PURE__*/React.createElement(_Button, {
      type: "link",
      size: "small"
    }, selectedRowKeys.keys.length || total), "\u9879"),
    type: "info",
    action: /*#__PURE__*/React.createElement(React.Fragment, null, actionBarRender(), /*#__PURE__*/React.createElement(_Button, {
      type: "link",
      size: "small",
      onClick: () => {
        cancelSelect();
        if (actionOnClose) {
          actionOnClose();
        }
      }
    }, "\u53D6\u6D88\u9009\u62E9"))
  })) : null, /*#__PURE__*/React.createElement(ResizeObserver, {
    onResize: ({
      width
    }) => {
      setTableWidth(width);
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "resizeObserverContainer"
  }, /*#__PURE__*/React.createElement(_Table, {
    dataSource: dataSource,
    scroll: someScroll,
    locale: {
      cancelSort: '点击取消排序',
      triggerDesc: '点击降序',
      triggerAsc: '点击升序'
    },
    virtual: true,
    className: "virtual-table",
    columns: mergedColumns,
    pagination: false,
    onChange: (pageIndex, pageSize, sort) => {
      onChange?.(pageIndex, pageSize, sort);
    }
  }))), renderPagination()));
});
VirtualTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  dataSource: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  /**
   * 是否展示表格选择
   */
  checked: PropTypes.bool,
  rowKey: PropTypes.string,
  pageSizeOptions: PropTypes.arrayOf(PropTypes.number),
  pageIndex: PropTypes.number,
  pageSize: PropTypes.number,
  total: PropTypes.number,
  /**
   * 分页改变回调
   */
  onChange: PropTypes.func,
  loading: PropTypes.bool,
  onSelectChange: PropTypes.func,
  // eslint-disable-next-line react/no-unused-prop-types
  name: PropTypes.string,
  /**
  * 表格滚动控制
  */
  scroll: PropTypes.shape({
    y: PropTypes.number
  }),
  headerTitle: PropTypes.string,
  /**
   * 表格顶部右侧工具栏，缺省为空
   */
  toolBarRender: PropTypes.func,
  /**
   * 表格底部选择工具栏，缺省为空
   */
  actionBarRender: PropTypes.func,
  /**
   * 是否开启选择全部
   */
  selectAll: PropTypes.bool,
  /**
   *列宽是否可变
   */
  resizable: PropTypes.bool,
  /**
   * 点击取消选择之后的回掉
   */
  actionOnClose: PropTypes.func
};
VirtualTable.defaultProps = {
  checked: false,
  rowKey: '',
  pageSizeOptions: [10, 20, 50],
  pageIndex: 1,
  pageSize: 20,
  total: 0,
  loading: false,
  selectAll: false,
  name: 'VirtualTable',
  headerTitle: '',
  scroll: {
    y: 300
  },
  toolBarRender: () => /*#__PURE__*/React.createElement(React.Fragment, null),
  actionBarRender: () => /*#__PURE__*/React.createElement(React.Fragment, null),
  onChange: () => null,
  onSelectChange: () => null,
  resizable: false,
  actionOnClose: null
};

/**
 * 退出登录
 * @param {*} url
 * @returns
 */
const useLogout = () => {
  /**
   * 清除storage
   */
  const clearLocalStorage = () => {
    const reportDowload = localStorage.getItem('report-dowload'); // 特殊情况 报表需要退出的时候保留缓存,这里不想一个一个清理localStorage了
    const customerIsShow = localStorage.getItem('customerIsShow');
    const wechatVisible = localStorage.getItem('wechatVisible');
    const contactListWidth = localStorage.getItem('contactListWidth');
    const p = localStorage.getItem('p');
    const customerMessageHeader = localStorage.getItem('customer-message-header');
    localStorage.clear();
    if (reportDowload) localStorage.setItem('report-dowload', reportDowload);
    if (p) localStorage.setItem('p', p);
    if (customerMessageHeader) localStorage.setItem('customer-message-header', customerMessageHeader);
    if (customerIsShow) localStorage.setItem('customerIsShow', customerIsShow);
    if (wechatVisible) localStorage.setItem('wechatVisible', wechatVisible);
    if (contactListWidth) localStorage.setItem('contactListWidth', contactListWidth);
  };
  /**
   * 退出登录
   */
  const logout = url => {
    Cookies.remove('userid');
    Cookies.remove('company');
    // 部分电脑之前登录过 导致还有这个，程序先清理下，后续这个代码可以删除（dialTimes）
    Cookies.remove('dialTimes');
    Cookies.remove('user', {
      path: '/',
      domain: 'yunkecn.com'
    });
    Cookies.remove('userToken', {
      path: '/',
      domain: 'yunkecn.com'
    });
    clearLocalStorage();
    if (url) {
      window.location.href = url;
    }
  };
  return {
    logout,
    clearLocalStorage
  };
};

/**
 * 获取渠道信息、个人信息
 * @returns
 */
const useSiteInfo = () => {
  const {
    logout
  } = useLogout();
  const [siteInfo, setSiteInfo] = useState({
    navigationLogo: undefined,
    allowCharge: 0
  });
  const [userInfo, setUserinfo] = useState(JSON.parse(localStorage.getItem('userData')) || undefined);
  const [companyInfo, setCompanyInfo] = useState(JSON.parse(localStorage.getItem('companyInfo')) || undefined);
  /**
   * 获取渠道信息
   */
  const loadChannel = async () => {
    let channelInfo = localStorage.getItem('channelInfo');
    if (!channelInfo || JSON.parse(channelInfo)?.privateValue === undefined) {
      channelInfo = await getChannelInfo();
      if (channelInfo) {
        // 接口异常处理
        localStorage.setItem('channelInfo', JSON.stringify(channelInfo));
      }
    } else {
      channelInfo = JSON.parse(channelInfo);
    }
    if (channelInfo.urlLogo) {
      let link = document.querySelector('link[rel="shortcut icon"]') || document.querySelector('link[rel="icon"]');
      if (!link) {
        link = document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      link.href = channelInfo.urlLogo;
    }
    setSiteInfo(channelInfo);
  };
  /**
   * 获取个人信息
   */
  const loadUserInfo = async () => {
    if (!userInfo) {
      const response = await getUserInfo().catch(e => {
        if (e.code === 302) {
          logout(e.data);
        }
      });
      if (response) {
        setUserinfo(response);
        localStorage.setItem('userData', JSON.stringify(response));
      }
    }
  };
  /**
   * 获取公司信息
   */
  const loadCompanyInfo = async update => {
    if (!companyInfo || update) {
      const response = getCompanyInfo();
      setCompanyInfo(response);
      localStorage.setItem('companyInfo', JSON.stringify(response));
    }
  };
  useEffect(() => {
    loadUserInfo();
    loadChannel();
    loadCompanyInfo();
  }, []);
  return {
    siteInfo,
    userInfo,
    companyInfo,
    refetchCompany: () => loadCompanyInfo('update')
  };
};

const IconFont = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1502858_a2vkj7wfaq9.js'
});
const IconFonts = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/font_1781333_4s05zjng6g9.js'
});
const IconFontss = createFromIconfontCN({
  scriptUrl: '//at.alicdn.com/t/c/font_2951654_rep1ogqu7so.js'
});
const icons = {
  100101: 'icon-shujutongji',
  100102: 'icon-shoujitongji',
  100103: 'icon-dakatongji',
  100501: 'icon-weixinkanban',
  100502: 'icon-weixinhaoguanli1',
  100105: 'iconweixinhaoguanli',
  100104: 'icon-shujubaobiao',
  100503: 'icon-weixinfengkong',
  10050303: 'iconweixinfengkong',
  100301: 'iconweixinfengkong',
  100504: 'iconfuzhuyingxiao',
  100506: 'icon-kefuxitong1',
  100507: 'iconweixiaoquan',
  100509: 'icon-douyin',
  100508: 'iconyunmingpian',
  100505: 'icon-weixinshezhi1',
  101601: 'iconweixinhaoguanli',
  101602: 'iconweixinfengkong',
  101401: 'icon-weixinkehuliebiao',
  101403: 'icon17fuzhuyingxiao',
  100303: 'icon17fuzhuyingxiao',
  100302: 'icon18qiyeweixinyingxiao',
  101405: 'icon-weixiaozhushezhi',
  101603: 'iconshezhi',
  101604: 'iconweixinkanban',
  101703: 'iconshezhi',
  101704: 'iconweixinkanban',
  101701: 'iconweixinhaoguanli',
  100201: 'icon12kehuliebiao',
  100202: 'icon13tonghualishi',
  100203: 'icon14duanxinlishi',
  100204: 'iconweixinfengkong',
  100205: 'icon15qiyegonghai',
  100206: 'icon16xiaoshouluyin',
  100207: 'icon13tonghualishi',
  100801: 'icon12kehuliebiao',
  100802: 'icon13tonghualishi',
  101406: 'iconyingxiaogongju-shoujihaibao',
  102001: 'iconshezhi',
  102002: 'icon12kehuliebiao',
  102003: 'icon20yingxiaorenwu',
  102004: 'icon18qiyeweixinyingxiao',
  102005: 'iconweixinhaoguanli',
  102006: 'iconweixinfengkong',
  104202: 'icon-huiyuanguanli',
  104201: 'icon-jifenguanli',
  userDetail: 'icon-gerenxinxi2',
  import: 'icon-daoru',
  myaccount: 'icon-gerenxinxi1',
  dowload: 'icon-tianchongxing-',
  100209: 'icon-zhuangshishuazi-2',
  100210: 'icon-yunwei-xitongjiance',
  100221: 'icon-kehuguanli',
  100222: 'icon-goutongjilu',
  100220: 'icon-waihuxitong',
  100223: 'icon-gongju',
  100510: 'icon-QQ1',
  100511: 'icon-whatsappguanli',
  1016: 'icon-qiweiguanfangguanli',
  100513: 'icon-qiyeweixinguanli',
  100514: 'icon-weishujuliucun1',
  105006: 'icon-shuju',
  105002: 'icon-weixin',
  105003: 'icon-qiwei',
  105007: 'icon-guankong',
  105005: 'icon-peizhi',
  105009: 'icon-duihua',
  100751: 'icon-a-yonghuquanxianshezhi',
  100752: 'icon-zidingyiyewubiaoqian',
  100753: 'icon-yewushuxingshezhi',
  100754: 'icon-xitongshezhi',
  102201: 'icon-shebeitongji',
  102202: 'icon-shebeiguanli',
  102203: 'icon-dingweiguankong',
  102204: 'icon-yingyongguankong',
  102205: 'icon-waihuguankong',
  102207: 'icon-shoujifengkong',
  102206: 'icon-shebeizhuangtaiguanli',
  102209: 'icon-guankongzhushouAPPduan',
  101407: 'icon-shujukanban',
  101402: 'icon-weixinyingxiaorenwu',
  101404: 'icon-qiyeweixinrenwu',
  101412: 'icon-liaotianjilu',
  101413: 'icon-kehubiaoqian',
  101409: 'icon-douyinyingxiao',
  105301: 'icon-weixin',
  105302: 'icon-peizhi',
  105201: 'icon-yunxiaozhi',
  105202: 'icon-jichushezhi',
  105203: 'icon-gongju1',
  103605: 'icon-fuzhuyingxiao',
  103602: 'icon-shouyinzhushou',
  103603: 'icon-haibaoguangchang',
  103604: 'icon-wailiangongju',
  103607: 'icon-tuoke',
  103609: 'icon-tuoke',
  103611: 'icon-liaotiangongju',
  103612: 'icon-neibudingdan',
  103613: 'icon-liaotiangongju',
  105101: 'icon-jichushezhi1',
  105102: 'icon-rexianfuwu',
  105103: 'icon-rexianguanli',
  105104: 'icon-jiankongyutongji',
  105105: 'icon-zhishiku',
  103406: 'icon-zhibo',
  103408: 'icon-yingxiaohuodong',
  103401: 'icon-shuju1',
  104203: 'icon-xitongshezhi1',
  103501: 'icon-shuju4',
  103502: 'icon-qudao',
  103503: 'icon-yongjinshezhi',
  103504: 'icon-yingxiaojiangli',
  103505: 'icon-shezhi',
  103506: 'icon-tuikeguanli',
  103402: 'icon-shangcheng',
  103403: 'icon-dingdan',
  103404: 'icon-xuexi',
  103405: 'icon-sucai',
  106004: 'icon-AIyuangongfenxi',
  106003: 'icon-kehudongcha',
  106002: 'icon-AIfenxishezhi',
  106001: 'icon-AIdianhuazhijian'
};
const useRoutes = ({
  module,
  search,
  pathname
}) => {
  const [menus, setMenus] = useState(JSON.parse(localStorage.getItem('permissions')) || []);
  const fromUrl = new URLSearchParams(window.location.search).get('from') || '';
  const r = useMemo(() => {
    const windowPath = (window.location.pathname + window.location.hash).replace('sub-', 'cms/');
    const menu = menus.find(item => {
      const first = item.children?.find(second => {
        if (second.url?.startsWith('/pc/cms')) {
          // TODO 这里后端接口有错误
          // eslint-disable-next-line
          second.url = second.url.substring(3);
        }
        if (second.children) {
          return second.children.find(third => windowPath.includes(third.url) || fromUrl?.includes(third.url));
        }
        return windowPath.includes(second.url) || fromUrl?.includes(second.url);
      });
      if (first) {
        return first;
      }
      if (windowPath.includes(item.url)) {
        return item;
      }
      return null;
    });
    if (menu?.id === '1007' && menu?.children?.length > 10) {
      // 初始的时候设置菜单需要改造一下，改造完成之后就不用再次改造了
      const newMenu = [{
        name: '常用设置',
        pId: '1007',
        id: 102001,
        url: '/cms/settings/index'
      }, {
        name: '用户&权限设置',
        pId: '1007',
        id: 102002,
        children: []
      }, {
        name: '自定义业务标签',
        pId: '1007',
        id: 102003,
        children: []
      }, {
        name: '业务属性设置',
        pId: '1007',
        id: 102004,
        children: []
      }, {
        name: '手机管理',
        pId: '1007',
        id: 102005,
        children: []
      }, {
        name: '系统设置',
        pId: '1007',
        id: 102006,
        children: []
      }];
      menu.children.forEach(item => {
        newMenu[item.groupSort]?.children?.push(item);
      });
      menu.children = newMenu.filter(item => item?.children?.length !== 0);
    }
    const routes = menu?.children?.map(item => {
      let firstPath = item.url || item.name;
      if (!item.children) {
        if (item.url.includes(module) && item.url.startsWith('/cms')) {
          firstPath = item.url.replace(`/cms/${module}`, '');
        } else {
          firstPath = item.url;
        }
      }
      if (!item.children) {
        if (item.url.includes(module) && item.url.startsWith('/cms')) {
          item.url.replace(`/cms/${module}`, '');
        } else {
          item.url;
        }
      }
      return {
        path: firstPath,
        key: firstPath.includes('#') ? `${firstPath?.split('#')[0]}${item.id}` : `${firstPath}${item.id}`,
        name: item.children ? item.name : /*#__PURE__*/React.createElement(React.Fragment, null, item.url === "/cms/chatworkbench/index" || item.url === 'http://qia.novoai.com.cn' ? /*#__PURE__*/React.createElement("a", {
          href: item.url,
          target: "_blank"
        }, item.name) : /*#__PURE__*/React.createElement("a", {
          href: item.url
        }, item.name)),
        icon: icons[item.id] ? /*#__PURE__*/React.createElement(IconFonts, {
          type: icons[item.id]
        }) || /*#__PURE__*/React.createElement(IconFontss, {
          type: icons[item.id]
        }) : /*#__PURE__*/React.createElement(IconFont, {
          type: "iconshezhi"
        }),
        routes: item.children?.map(second => {
          const path = second.url.replace(`/cms/${module}`, '');
          const name = second.url.includes(`/${module}/`) && !second.url?.includes('#') && !second.url?.includes('?') ? /*#__PURE__*/React.createElement(React.Fragment, null, second.url === "/cms/chatworkbench/index" ? /*#__PURE__*/React.createElement("a", {
            href: second.url,
            target: "_blank"
          }, second.name) : /*#__PURE__*/React.createElement(Link, {
            to: {
              pathname: path
            }
          }, second.name)) : /*#__PURE__*/React.createElement("a", {
            href: second.url
          }, second.name);
          return {
            path: second.url.replace(/#/, '1'),
            key: second.url.includes('#') ? `${second.url?.split('#')[0]}${item.id}` : second.url,
            name
          };
        })
      };
    });
    return {
      topMenu: menus?.filter(_ => _.pId === '0')?.filter(item => item.children)?.map(item => ({
        // filter  处理接口数据二级导航 放到一级导航上
        path: item.id === menu?.id ? windowPath : item.url,
        name: item.id === menu?.id ? item.name : /*#__PURE__*/React.createElement("a", {
          href: item.url
        }, item.name)
      })),
      routes
    };
  }, [menus, pathname]);
  /**
   * 获取菜单
   */
  const loadMenu = async () => {
    if (Array.isArray(menus) && menus.length) return;
    const response = await getMenu();
    if (Array.isArray(response)) {
      setMenus(response);
      localStorage.setItem('permissions', JSON.stringify(response));
    } else {
      setMenus([]);
    }
  };
  useEffect(() => {
    loadMenu();
  }, []);
  return {
    ...r
  };
};

const getChromeVersion = () => {
  const arr = navigator.userAgent.split(' ');
  let chromeVersion = '';
  for (let i = 0; i < arr.length; i += 1) {
    if (/chrome/i.test(arr[i])) chromeVersion = arr[i];
  }
  if (chromeVersion) {
    return Number(chromeVersion.split('/')[1].split('.')[0]);
  }
  return false;
};
/**
 * 检查低版本浏览器
 */
const useCheckVersion = () => {
  useEffect(() => {
    // eslint-disable-next-line
    if (String.prototype.hasOwnProperty('matchAll')) {
      const edgeVersion = [...navigator.userAgent.matchAll(/edge\/(\d+)\./gmi)];
      if (edgeVersion.length > 0) {
        if (Number(edgeVersion[0][1]) < 37) {
          _message.warning('您的浏览器版本太低，使用网站时可能会有问题，建议尽快升级至最新版本的浏览器');
        }
      }
    } else if (getChromeVersion()) {
      // 针对chrome<73版本单独处理下
      const version = getChromeVersion();
      if (version < 65) {
        _message.warning('您的浏览器版本太低，使用网站时可能会有问题，建议尽快升级至最新版本的浏览器');
      }
    }
  }, []);
};

const {
  Option
} = _Select;
const industry = ['IT/通讯/电子/互联网', '金融业', '房地产/建筑业', '商业服务', '贸易/批发/零售', '文教传媒/体育娱乐', '生产/加工/制造', '仓储物流', '能源/矿产/环保', '政府/非盈利机构', '农林牧渔'];

/**
 * 图片转base64
 * @param {*} img
 * @param {*} callback
 */
const getBase64 = (img, callback) => {
  if (!img) return;
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
};
/**
 * 修改企业信息
 * @returns
 */
const CompanyDrawer = ({
  open = false,
  onClose,
  companyInfo
}) => {
  const [commingle, setCommingle] = useState('');
  const [loading, setLoading] = useState(false);
  /**
   * 上传图片组件
   * @type {unknown}
   */
  const uploadButton = useMemo(() => /*#__PURE__*/React.createElement("div", null, loading ? /*#__PURE__*/React.createElement(LoadingOutlined, null) : /*#__PURE__*/React.createElement(PlusOutlined, null), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 8,
      fontSize: 12
    }
  }, "\u70B9\u51FB\u53EF\u66F4\u6362\u5934\u50CF")), [loading]);
  /**
   * 选择图片
   * @param info
   */
  const handleChange = info => {
    if (info.file.status === 'uploading') {
      setLoading(true);
    }
    getBase64(info.file.originFileObj, imageUrl => {
      setLoading(false);
      setCommingle(imageUrl);
    });
  };
  const beforeUpload = file => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp';
    if (!isJpgOrPng) {
      _message.error('不支持此类文件');
    }
    const isLt2M = file.size / 1024 / 1024 < 2;
    if (!isLt2M) {
      _message.error('不能超过2MB!');
    }
    return isJpgOrPng && isLt2M;
  };
  /**
   * 修改企业信息
   * @param {*} values
   */
  const onFinish = async values => {
    const data = {
      comimgurl: values?.imgUrl?.file?.originFileObj || new File([], 'file', {}),
      ...values
    };
    delete data.imgUrl;
    const response = await changeCompanyinfo(data);
    if (response.success) {
      onClose(true);
    } else {
      _message.error(response.message);
    }
  };
  return /*#__PURE__*/React.createElement(_Drawer, {
    title: "\u4F01\u4E1A\u4FE1\u606F",
    placement: "right",
    open: open,
    width: 440,
    onClose: onClose,
    className: "yunke-drawer",
    zIndex: 1033
  }, /*#__PURE__*/React.createElement(_Form, {
    onFinish: onFinish,
    initialValues: {
      comname: companyInfo?.name || '',
      comimgurl: companyInfo?.imgUrl || '',
      comaddress: companyInfo?.companyAddress || '',
      comsummary: companyInfo?.summary || '',
      comdescremark: companyInfo?.descRemark || ''
    }
  }, /*#__PURE__*/React.createElement(_Tooltip, {
    title: "\u70B9\u51FB\u53EF\u66F4\u6362\u5934\u50CF,\u652F\u6301JEPG\u3001PNG\u3001BMP\u683C\u5F0F\u5927\u5C0F\u4E0D\u8D85\u8FC72M"
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    label: "\u4F01\u4E1A\u5934\u50CF",
    name: "imgUrl"
  }, /*#__PURE__*/React.createElement(_Upload, {
    name: "avatar",
    listType: "picture-card",
    className: "avatar-uploader",
    showUploadList: false,
    beforeUpload: beforeUpload,
    onChange: handleChange,
    customRequest: () => {},
    fileList: []
  }, (commingle || companyInfo?.imgUrl) && !loading ? /*#__PURE__*/React.createElement("img", {
    src: commingle || companyInfo?.imgUrl,
    alt: "avatar",
    style: {
      width: '100%'
    }
  }) : uploadButton))), /*#__PURE__*/React.createElement(_Form.Item, {
    label: "\u4F01\u4E1A\u540D\u79F0",
    name: "comname",
    rules: [{
      required: true,
      message: '该项为必填'
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    placeholder: "\u8BF7\u8F93\u5165\u4F01\u4E1A\u540D\u79F0",
    maxLength: 20
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    label: "\u4F01\u4E1A\u5730\u5740",
    name: "comaddress"
  }, /*#__PURE__*/React.createElement(_Input, {
    placeholder: "\u8BF7\u8F93\u5165\u4F01\u4E1A\u5730\u5740",
    maxLength: 50
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    label: "\u4F01\u4E1A\u7B80\u4ECB",
    name: "comsummary"
  }, /*#__PURE__*/React.createElement(_Input, {
    placeholder: "\u8BF7\u8F93\u5165\u4F01\u4E1A\u7B80\u4ECB"
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    label: "\u6240\u5C5E\u884C\u4E1A",
    name: "comdescremark"
  }, /*#__PURE__*/React.createElement(_Select, {
    placeholder: "\u8BF7\u9009\u62E9\u6240\u5C5E\u884C\u4E1A"
  }, industry.map(item => /*#__PURE__*/React.createElement(Option, {
    key: item,
    value: item
  }, item)))), /*#__PURE__*/React.createElement(_Form.Item, {
    wrapperCol: {
      span: 12,
      offset: 6
    }
  }, /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    htmlType: "submit"
  }, "\u4FDD\u5B58"), /*#__PURE__*/React.createElement(_Button, {
    style: {
      marginLeft: 10
    },
    onClick: onClose
  }, "\u53D6\u6D88"))));
};
CompanyDrawer.propTypes = {
  open: PropTypes.bool,
  companyInfo: PropTypes.shape({
    imgUrl: PropTypes.string,
    name: PropTypes.string,
    companyAddress: PropTypes.string,
    descRemark: PropTypes.string,
    summary: PropTypes.string,
    code: PropTypes.string
  }),
  onClose: PropTypes.func
};
CompanyDrawer.defaultProps = {
  open: false,
  companyInfo: {},
  onClose: () => null
};

var css_248z$6 = ".style-module_upright__10VZR {\n  display: flex;\n  align-items: center;\n}\n.style-module_upright__10VZR .style-module_icon__1jQu_ {\n  margin-right: 1rem;\n  cursor: pointer;\n}\n.style-module_upright__10VZR .style-module_icon__1jQu_ > span {\n  vertical-align: middle;\n}\n.upright-name {\n  font-weight: 500;\n  font-size: 1.25rem;\n}\n.upright-icon {\n  width: 0.75rem;\n  height: 0.75rem;\n  margin-left: 1rem;\n  margin-top: 0.75rem;\n}\n";
var styles$6 = {"upright":"style-module_upright__10VZR","icon":"style-module_icon__1jQu_"};
styleInject(css_248z$6);

var img$q = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAcCAYAAAB/E6/TAAABh0lEQVRIS+3WvU7DMBAH8P91aCckpIo8Rccy9CImGHgCHgCBBAwwMbAimJlAtE/AQ8CCElsd2LKVlamoUCEkCpEOuYUKRaSxk9AJrzn75/PHORQEwVGlUjkAUIV9+wBwzszHs7pEUVRtNBrvJobCMHwDULM3JpFENGDmelo/pdQmgDMAmpnXDSRfwc8AoiyQiEhEzCw7vu9f/Ravtd4WkbaIEIAXz/OWphAR3TDzWhaU9f0nMpmT7Pi+3ykVSiJEtNdqtS6/92i8dEUzmoWUBmUhpUA2SGHIFikEuSC5IVckF5REAOwyczvl4m6IyIUpV073yAUxsFLqWkRWATxZQ66IgcIwvAWwQkSvVlAexBnSWm+JSMcUSFO7Zu1Jcp+sM+p2u/U4jh/MM+KKOGXU6/Vq/X7/HoAHYD/tdKVVdOuMzAAGGw6HC81m8zHrici9dK4D/0NFV2zaP+0wDETkrjRlMtAygMVxZVBKjUTE5Z8uz1wGpgSdENHhH2IjIjo1/11zaXODPgH0HZXhGdfJywAAAABJRU5ErkJggg==";

var img$p = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAkCAYAAACe0YppAAADJklEQVRYR+2XW0hUURSGvzUzGUUWShEF9VBQURQVQUS9WdRDBRWVQSmFdNExKHpQKMywe3RjmlKKIq0wfbB86fIiBkV080YUCUFX6E5mFx3PitMoOuM5M2fG8a39eM5a/7f22nuvvZcQz8jVoSgHgQAG+fjlR6wyEpPDVXVTSwbKfpSRnb7vcZNHKmUUiuFUzxm4WAdQzyqEnSiTLMWFpyhFjKCCQglECyAyOEcnAOkom4FR0cQ6/79FOIObck7KCzufIFhV8JKKi7HAVDqYibDQdnYOIyCYhdu4eUwHDQiv8fEFERVytB3F41QrQXY/hWzVBIk5lxHa/oOdp6svltFSPXccjB4WSnj5GR6+sqYumgzJA0P/PXkDzR972bdHXOMr62HpNBic1O14/h5sKOsNProctqWFfq9uhJVn4U/vchIZbMpkzoYLGfZgl0DxGsiaGwotfwTrLkC7dRHtG9jjgtJMSJ8VCjWzknUJDPuDGj94oAcqsmDJ1FCorwa2VkCU4hAfOPcqXNsEaWHXxYGbkH/d0XaPHVxVDyOTYc64UMCuaii64QhqGsUODpc2C+62SjhR4xjad7BhwKYrcPZuTFAQAubt9Aelx0kNFQk/Tl1/Ax2QeREuP4wRapoLrSa4CWWKnbsVuC0Aq89BVUMc0KBLnQmuRFnhFPyzDZYVw61ncUPBRbkJ3oLidwJu+Q2LT0Ntcx+gpqubjcJuHcwH3gApVnJdqf7SCot88MDmgnAcivCZJMYE31w5ug8l3w58aBksOAkN7xzLRzLci192BsHZOgShDmV8uMf8ifD6Kzz/kACo0MwgpnNEWruftzk6B+XOvxXojyGYl+M8Tsn94InqOby6A4PD/cEFtuOXY13avR/0Xt2Dwa4Ew3fjl8KemtadhFf3Y5CXIPi/zRSuZd/CeHUtSgnKoLgCEH4hZOGTy1b+kXunXJ2BQWmkkmoZlNCIkoFf6uyCjt4tFqiHj+QC5holR5y98B0oYDi+aB1jdHAXKU9TaGEdsNEiA024KMFDKcflm5OlcQ7uqVagSXzqnP1wWiiUNiew6Ls6VpU47P8CvtcljsVT6hkAAAAASUVORK5CYII=";

var css_248z$5 = ".style_SearchMenu__3pyyA .ant-modal-close {\n  display: none;\n}\n.style_SearchMenu__3pyyA .DocSearch-Modal {\n  background: #f5f6f7;\n  border-radius: 20px;\n  flex-direction: column;\n  max-width: 600px;\n  position: relative;\n}\n.style_SearchMenu__3pyyA .DocSearch-SearchBar {\n  padding: 30px 30px 0;\n}\n.style_SearchMenu__3pyyA .DocSearch-Container--Stalled .DocSearch-LoadingIndicator,\n.style_SearchMenu__3pyyA .DocSearch-MagnifierLabel,\n.style_SearchMenu__3pyyA .DocSearch-Reset {\n  align-items: center;\n  color: #3578e5;\n  display: flex;\n  justify-content: center;\n}\n.style_SearchMenu__3pyyA .DocSearch-LoadingIndicator svg,\n.style_SearchMenu__3pyyA .DocSearch-MagnifierLabel svg {\n  height: 24px;\n  width: 24px;\n}\n.style_SearchMenu__3pyyA .DocSearch-Search-Icon {\n  stroke-width: 1.6;\n}\n.style_SearchMenu__3pyyA .DocSearch-Input {\n  appearance: none;\n  background: 0 0;\n  border: 0;\n  color: #1c1e21;\n  flex: 1;\n  font-size: 1.2em;\n  height: 100%;\n  outline: 0;\n  padding: 0 0 0 8px;\n  width: 80%;\n}\n.style_SearchMenu__3pyyA .DocSearch-Reset {\n  -webkit-animation: 0.1s ease-in forwards b;\n  animation: 0.1s ease-in forwards b;\n  appearance: none;\n  background: none;\n  border-radius: 50%;\n  color: #1c1e21;\n  padding: 2px;\n  right: 0;\n}\n.style_SearchMenu__3pyyA .DocSearch-Cancel,\n.style_SearchMenu__3pyyA .DocSearch-Container--Stalled .DocSearch-MagnifierLabel,\n.style_SearchMenu__3pyyA .DocSearch-LoadingIndicator,\n.style_SearchMenu__3pyyA .DocSearch-Reset[hidden] {\n  display: none;\n}\n.style_SearchMenu__3pyyA .DocSearch-Form {\n  align-items: center;\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: inset 0 0 0 2px #3578e5;\n  display: flex;\n  height: 56px;\n  margin: 0;\n  padding: 0 12px;\n  position: relative;\n  width: 100%;\n}\n.style_SearchMenu__3pyyA .DocSearch-Dropdown {\n  max-height: 488px;\n  min-height: 12;\n  overflow-y: auto;\n  overflow-y: overlay;\n  padding: 0 30px;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hits:last-of-type {\n  margin-bottom: 24px;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hit-source {\n  background: #f5f6f7;\n  color: #3578e5;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 32px;\n  margin: 0 -4px;\n  padding: 8px 4px 0;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n.style_SearchMenu__3pyyA .DocSearch-Dropdown ul {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hit {\n  border-radius: 4px;\n  display: flex;\n  padding-bottom: 4px;\n  position: relative;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hit.active .DocSearch-Hit-action {\n  display: flex;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hit.active mark {\n  color: #fff;\n  text-decoration: underline;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hit.active .DocSearch-Hit-Container,\n.style_SearchMenu__3pyyA .DocSearch-Hit.active .DocSearch-Hit-icon,\n.style_SearchMenu__3pyyA .DocSearch-Hit.active .DocSearch-Hit-action,\n.style_SearchMenu__3pyyA .DocSearch-Hit.active .DocSearch-Hit-path {\n  color: #fff;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hit.active a {\n  background-color: #3578e5;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hit a {\n  background: #fff;\n  border-radius: 4px;\n  box-shadow: 0 1px 3px 0 #d4d9e1;\n  display: block;\n  padding-left: 12px;\n  width: 100%;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hit-Container {\n  align-items: center;\n  color: #444950;\n  display: flex;\n  flex-direction: row;\n  height: 56px;\n  padding: 0 12px 0 0;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hit-icon {\n  height: 20px;\n  width: 20px;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hit-action,\n.style_SearchMenu__3pyyA .DocSearch-Hit-icon {\n  color: #969faf;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hit-content-wrapper {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  font-weight: 500;\n  justify-content: center;\n  line-height: 1.2em;\n  margin: 0 8px;\n  position: relative;\n  width: 80%;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hit-action {\n  align-items: center;\n  display: none;\n  height: 22px;\n  width: 22px;\n}\n.style_SearchMenu__3pyyA .DocSearch-Footer {\n  align-items: center;\n  background: #fff;\n  border-radius: 0 0 20px 20px;\n  box-shadow: 0 -1px 0 0 #e0e3e8, 0 -3px 6px 0 rgb(69 98 12.91666667%);\n  display: flex;\n  flex-shrink: 0;\n  height: 44px;\n  justify-content: space-betwe;\n  padding: 30px;\n  position: relative;\n  -webkit-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  width: 100%;\n  z-index: 5;\n}\n.style_SearchMenu__3pyyA .DocSearch-Commands {\n  color: #969faf;\n  display: flex;\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n.style_SearchMenu__3pyyA .DocSearch-Commands li:not(:last-of-type) {\n  margin-right: 0.8em;\n}\n.style_SearchMenu__3pyyA .DocSearch-Commands-Key {\n  align-items: center;\n  background: linear-gradient(-225deg, #d5dbe4, #f8f8f8);\n  border-radius: 2px;\n  box-shadow: inset 0 -2px 0 0 #cdcde6, inset 0 0 1px 1px #fff, 0 1px 2px 1px rgba(30, 35, 90, 0.4);\n  display: flex;\n  height: 18px;\n  justify-content: center;\n  margin-right: 0.4em;\n  padding-bottom: 1px;\n  width: 20px;\n}\n.style_SearchMenu__3pyyA .DocSearch-Label {\n  font-size: 0.75em;\n  line-height: 1.6em;\n}\n.style_SearchMenu__3pyyA .DocSearch-Commands li,\n.style_SearchMenu__3pyyA .buttonContainer_K7p6 {\n  align-items: center;\n  display: flex;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hit-path {\n  color: #969faf;\n  font-size: 0.75em;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hit-Tree,\n.style_SearchMenu__3pyyA .DocSearch-Hit-action,\n.style_SearchMenu__3pyyA .DocSearch-Hit-icon,\n.style_SearchMenu__3pyyA .DocSearch-Reset {\n  stroke-width: 1.4;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hit-Tree {\n  color: #fff;\n  height: 56px;\n  opacity: 0.5;\n  width: 24px;\n}\n.style_SearchMenu__3pyyA .DocSearch-Hits mark {\n  background: none;\n  color: #3578e5;\n  padding: 0;\n}\n";
var styles$5 = {"SearchMenu":"style_SearchMenu__3pyyA"};
styleInject(css_248z$5);

/**
 * 搜索菜单
 * @returns
 */
const propTypes$6 = {
  searchTrue: bool.isRequired,
  handleKeyDown: func.isRequired
};
const SearchMenu = props => {
  const {
    searchTrue
  } = props;
  const isLock = useRef(false);
  const [search, setSearch] = useState('');
  const [open, setOpen] = useState(searchTrue);
  useEffect(() => {
    setOpen(searchTrue);
  }, [searchTrue]);
  const menus = useMemo(() => open ? JSON.parse(localStorage.getItem('permissions')) : [], [open]);

  /**
   * 重置css
   */
  const resetClass = () => {
    const list = document.querySelectorAll('.DocSearch-Hit');
    list.forEach((el, index) => {
      list[index].className = 'DocSearch-Hit';
    });
  };
  /**
   * 监听鼠标
   * @param {number} keyCode
   * @returns
   */
  const handleKeyDown = ({
    keyCode
  }) => {
    const list = document.querySelectorAll('.DocSearch-Hit');
    if (keyCode === 13) {
      document.querySelector('.DocSearch-Hit.active')?.querySelector('a')?.click();
    }
    if (keyCode === 40) {
      const selectId = [...list].indexOf(document.querySelector('.DocSearch-Hit.active'));
      resetClass();
      let current = selectId === -1 ? 0 : selectId + 1;
      if (current > list.length - 1) {
        current = 0;
      }
      list[current].className += ' active';
      isLock.current = true;
      list[current]?.scrollIntoView({
        block: 'nearest'
      });
    }
    if (keyCode === 38) {
      const selectId = [...list].indexOf(document.querySelector('.DocSearch-Hit.active'));
      resetClass();
      let current = selectId === -1 ? 0 : selectId - 1;
      if (current < 0) {
        current = list.length - 1;
      }
      list[current].className += ' active';
      isLock.current = true;
      list[current]?.scrollIntoView({
        block: 'nearest'
      });
    }
  };
  useEffect(() => {
    if (document.querySelector('.DocSearch-Hit.active')) {
      resetClass();
    }
  }, [search]);
  useEffect(() => {
    const dropdown = document.querySelector('.DocSearch-Dropdown');
    if (open) {
      document.addEventListener('keydown', handleKeyDown, false);
      dropdown.addEventListener('wheel', () => {
        isLock.current = true;
      }, false);
      document.addEventListener('mouseover', () => {
        isLock.current = false;
      }, false);
    }
    return () => {
      document.removeEventListener('keydown', handleKeyDown, false);
      dropdown?.removeEventListener('wheel', () => {}, false);
      document.removeEventListener('mouseover', () => {}, false);
    };
  }, [open, handleKeyDown]);
  const openState = () => {
    setOpen(false);
    props.handleKeyDown(false);
  };
  const renderMenu = ({
    name,
    url,
    id
  }) => {
    if (name.includes(search) || url.includes(search)) {
      return /*#__PURE__*/React.createElement("li", {
        key: id,
        className: "DocSearch-Hit",
        onMouseEnter: e => {
          if (isLock.current) return;
          resetClass();
          e.currentTarget.className += ' active';
        }
      }, /*#__PURE__*/React.createElement("a", {
        href: url
      }, /*#__PURE__*/React.createElement("div", {
        className: "DocSearch-Hit-Container"
      }, /*#__PURE__*/React.createElement("div", {
        className: "DocSearch-Hit-icon"
      }, /*#__PURE__*/React.createElement("svg", {
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M17 5H3h14zm0 5H3h14zm0 5H3h14z",
        stroke: "currentColor",
        fill: "none",
        fillRule: "evenodd",
        strokeLinejoin: "round"
      }))), /*#__PURE__*/React.createElement("div", {
        className: "DocSearch-Hit-content-wrapper"
      }, /*#__PURE__*/React.createElement("span", {
        className: "DocSearch-Hit-title"
      }, search ? name.split(search).reduce((prev, c, i) => {
        if (!i) {
          return [c];
        }
        return prev.concat( /*#__PURE__*/React.createElement("mark", {
          key: search + c
        }, search), c);
      }, []) : name)), /*#__PURE__*/React.createElement("div", {
        className: "DocSearch-Hit-action"
      }, /*#__PURE__*/React.createElement("svg", {
        className: "DocSearch-Hit-Select-Icon",
        width: "20",
        height: "20",
        viewBox: "0 0 20 20"
      }, /*#__PURE__*/React.createElement("g", {
        stroke: "currentColor",
        fill: "none",
        fillRule: "evenodd",
        strokeLinecap: "round",
        strokeLinejoin: "round"
      }, /*#__PURE__*/React.createElement("path", {
        d: "M18 3v4c0 2-2 4-4 4H2"
      }), /*#__PURE__*/React.createElement("path", {
        d: "M8 17l-6-6 6-6"
      })))))));
    }
    return null;
  };
  const renderTitle = menu => {
    if (menu.url.includes(search) || menu.name.includes(search) || menu?.children?.filter(f => f?.children ? f?.children?.filter(c => c?.url?.includes(search) || c.name?.includes(search)).length !== 0 : f?.url?.includes(search) || f?.name?.includes(search)).length !== 0) {
      return /*#__PURE__*/React.createElement("div", {
        key: menu.id,
        className: "DocSearch-Hit-source"
      }, menu.name);
    }
    return null;
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SearchOutlined, {
    onClick: () => setOpen(true),
    style: {
      color: '#ccc',
      fontSize: 24
    }
  }), /*#__PURE__*/React.createElement(_Modal, {
    className: styles$5.SearchMenu,
    open: open,
    footer: null,
    onCancel: openState
    // bodyStyle={{
    //   padding: 0,
    // }}
    ,
    styles: {
      body: {
        padding: 0
      }
    },
    style: {
      top: 70
    },
    closeIcon: /*#__PURE__*/React.createElement("div", null),
    getContainer: () => document.getElementById('root')
  }, /*#__PURE__*/React.createElement("div", {
    className: "DocSearch-Modal"
  }, /*#__PURE__*/React.createElement("header", {
    className: "DocSearch-SearchBar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "DocSearch-Form"
  }, /*#__PURE__*/React.createElement("div", {
    className: "DocSearch-MagnifierLabel",
    htmlFor: "docsearch-input",
    id: "docsearch-label"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    className: "DocSearch-Search-Icon",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z",
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), /*#__PURE__*/React.createElement("div", {
    className: "DocSearch-LoadingIndicator"
  }, /*#__PURE__*/React.createElement("svg", {
    viewBox: "0 0 38 38",
    stroke: "currentColor",
    strokeOpacity: ".5"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 1)",
    strokeWidth: "2"
  }, /*#__PURE__*/React.createElement("circle", {
    strokeOpacity: ".3",
    cx: "18",
    cy: "18",
    r: "18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36 18c0-9.94-8.06-18-18-18"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 18 18",
    to: "360 18 18",
    dur: "1s",
    repeatCount: "indefinite"
  })))))), /*#__PURE__*/React.createElement("input", {
    ref: input => {
      if (input != null) {
        input.focus();
      }
    },
    className: "DocSearch-Input",
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
    enterKeyHint: "go",
    spellCheck: "false",
    placeholder: "\u8BF7\u8F93\u5165\u529F\u80FD\u540D\u79F0",
    maxLength: "64",
    type: "text",
    value: search,
    onChange: e => {
      setSearch(e.target.value);
    }
  }), search ?
  /*#__PURE__*/
  // eslint-disable-next-line jsx-a11y/control-has-associated-label
  React.createElement("button", {
    type: "button",
    className: "DocSearch-Reset",
    onClick: () => {
      setSearch('');
    }
  }, /*#__PURE__*/React.createElement("svg", {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 10l5.09-5.09L10 10l5.09 5.09L10 10zm0 0L4.91 4.91 10 10l-5.09 5.09L10 10z",
    stroke: "currentColor",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))) : null)), /*#__PURE__*/React.createElement("div", {
    className: "DocSearch-Dropdown"
  }, /*#__PURE__*/React.createElement("div", {
    className: "DocSearch-Dropdown-Container"
  }, /*#__PURE__*/React.createElement("section", {
    className: "DocSearch-Hits"
  }, menus?.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.id
  }, renderTitle(item), /*#__PURE__*/React.createElement("ul", {
    className: "docsearch-list"
  }, item.children?.map(subitem => {
    if (subitem?.children?.length) {
      return subitem?.children?.map(citem => renderMenu({
        name: citem.name,
        url: citem.url,
        id: citem.id
      }));
    }
    return renderMenu({
      name: subitem.name,
      url: subitem.url,
      id: subitem.id
    });
  }))))))), /*#__PURE__*/React.createElement("footer", {
    className: "DocSearch-Footer"
  }, /*#__PURE__*/React.createElement("ul", {
    className: "DocSearch-Commands"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "DocSearch-Commands-Key"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "15",
    height: "15"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 3.53088v3c0 1-1 2-2 2H4M7 11.53088l-3-3 3-3"
  })))), /*#__PURE__*/React.createElement("span", {
    className: "DocSearch-Label"
  }, "\u9009\u4E2D\u8DF3\u8F6C")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "DocSearch-Commands-Key"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "15",
    height: "15"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 3.5v8M10.5 8.5l-3 3-3-3"
  })))), /*#__PURE__*/React.createElement("span", {
    className: "DocSearch-Commands-Key"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "15",
    height: "15"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11.5v-8M10.5 6.5l-3-3-3 3"
  })))), /*#__PURE__*/React.createElement("span", {
    className: "DocSearch-Label"
  }, "\u4E0A\u4E0B\u9009\u62E9")), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("span", {
    className: "DocSearch-Commands-Key"
  }, /*#__PURE__*/React.createElement("svg", {
    width: "15",
    height: "15"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.6167 8.936c-.1065.3583-.6883.962-1.4875.962-.7993 0-1.653-.9165-1.653-2.1258v-.5678c0-1.2548.7896-2.1016 1.653-2.1016.8634 0 1.3601.4778 1.4875 1.0724M9 6c-.1352-.4735-.7506-.9219-1.46-.8972-.7092.0246-1.344.57-1.344 1.2166s.4198.8812 1.3445.9805C8.465 7.3992 8.968 7.9337 9 8.5c.032.5663-.454 1.398-1.4595 1.398C6.6593 9.898 6 9 5.963 8.4851m-1.4748.5368c-.2635.5941-.8099.876-1.5443.876s-1.7073-.6248-1.7073-2.204v-.4603c0-1.0416.721-2.131 1.7073-2.131.9864 0 1.6425 1.031 1.5443 2.2492h-2.956"
  })))), /*#__PURE__*/React.createElement("span", {
    className: "DocSearch-Label"
  }, "\u5173\u95ED")))))));
};
SearchMenu.propTypes = propTypes$6;
var SearchMenu$1 = /*#__PURE__*/memo(SearchMenu);

const TopRight = ({
  userInfo,
  companyInfo,
  siteInfo,
  refetchCompany,
  deploy
}) => {
  const {
    logout,
    clearLocalStorage
  } = useLogout();
  const [open, setopen] = useState(false);
  const [searchTrue, setSearchTrue] = useState(false);
  const [userList, setUserList] = useState(JSON.parse(localStorage.getItem('userList')) || []);
  const loadUser = async phone => {
    if (userList.length) return;
    const response = await listUserByPhone({
      phone,
      queryScope: 'company'
    });
    if (response.success) {
      setUserList(response.data);
      localStorage.setItem('userList', JSON.stringify(response.data));
    }
  };
  const switchUser = async companyCode => {
    const {
      cellphone
    } = JSON.parse(localStorage.getItem('userData')) || {};
    const {
      channelCode
    } = JSON.parse(localStorage.getItem('channelInfo'));
    const response = await login({
      phone: cellphone,
      password: localStorage.getItem('p'),
      channelCode,
      companyCode
    });
    if (response.success) {
      clearLocalStorage();
      localStorage.setItem('userid', response.data.id);
      localStorage.setItem('company', response.data.companyCode);
      localStorage.setItem('phoneNumber', cellphone); // 快鲸多账户选择需要手机号
      if (response?.data?.thirdToken) {
        localStorage.setItem('thirdToken', response?.data?.thirdToken);
      }
      setUserList([]);
      loadUser(response.data.phone);
      const menuRes = await getMenu();
      const res = await getUserInfo().catch(e => {
        if (e.code === 302) {
          logout(e.data);
        }
      });
      if (res) {
        localStorage.setItem('userData', JSON.stringify(res));
      }
      if (Array.isArray(menuRes.data)) {
        localStorage.setItem('permissions', JSON.stringify(menuRes.data));
        if (menuRes.data?.length > 0) {
          window.location.href = menuRes.data?.[0].url;
        }
      }
    } else {
      _message.error(response.message);
    }
  };
  const handleKeyDown = e => {
    if (e.ctrlKey && e.keyCode === 70) {
      e.preventDefault();
      setSearchTrue(true);
    }
  };
  useEffect(() => {
    const {
      cellphone
    } = JSON.parse(localStorage.getItem('userData')) || {};
    document.addEventListener('keydown', handleKeyDown);
    loadUser(cellphone);
  }, []);
  const renderAvatarList = () => {
    const userData = JSON.parse(localStorage.getItem('userData')) || {};
    const {
      global
    } = deploy;
    return /*#__PURE__*/React.createElement(_Menu, null, /*#__PURE__*/React.createElement(_Menu.Item, {
      key: "user",
      onClick: () => {
        window.location.href = '/cms/home/userDetail';
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex'
      }
    }, /*#__PURE__*/React.createElement("span", {
      className: "upright-name"
    }, userInfo.realName), /*#__PURE__*/React.createElement("img", {
      className: "upright-icon",
      src: img$q,
      alt: ""
    }))), /*#__PURE__*/React.createElement(_Menu.Item, {
      key: "company",
      onClick: () => {
        setopen(true);
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'flex',
        alignItems: 'center'
      }
    }, /*#__PURE__*/React.createElement("img", {
      style: {
        width: 12,
        height: 16,
        marginRight: 12,
        marginTop: 4
      },
      src: img$p,
      alt: ""
    }), /*#__PURE__*/React.createElement("span", {
      style: {
        textOverflow: 'ellipsis'
      }
    }, companyInfo?.name), /*#__PURE__*/React.createElement("img", {
      className: "upright-icon",
      src: img$q,
      style: {
        marginTop: 4
      },
      alt: ""
    }))), /*#__PURE__*/React.createElement(_Menu.Divider, null), /*#__PURE__*/React.createElement(_Menu.Item, {
      icon: /*#__PURE__*/React.createElement(UserOutlined, null),
      key: "userDetail"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/cms/home/userDetail"
    }, "\u4E2A\u4EBA\u4E2D\u5FC3")), (userInfo.userType === 1 || userInfo.userType === 2) && siteInfo?.allowCharge === 1 && global?.my_account && /*#__PURE__*/React.createElement(_Menu.Item, {
      icon: /*#__PURE__*/React.createElement(UserOutlined, null),
      key: "account"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/cms/home/myaccount"
    }, "\u6211\u7684\u8D26\u6237")), /*#__PURE__*/React.createElement(_Menu.Item, {
      icon: /*#__PURE__*/React.createElement(DownloadOutlined, null),
      key: "download"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/cms/dowload"
    }, "\u4E0B\u8F7D\u4E2D\u5FC3")), global?.import_list && /*#__PURE__*/React.createElement(_Menu.Item, {
      icon: /*#__PURE__*/React.createElement(ImportOutlined, null),
      key: "import"
    }, /*#__PURE__*/React.createElement("a", {
      href: "/cms/import"
    }, "\u5BFC\u5165\u8BB0\u5F55")), siteInfo.channelCode === 'yunke' ? /*#__PURE__*/React.createElement(_Menu.Item, {
      icon: /*#__PURE__*/React.createElement(PhoneOutlined, null),
      key: "soft_phone"
    }, /*#__PURE__*/React.createElement("a", {
      href: "https://yunke-pcfile.oss-cn-beijing.aliyuncs.com/d/telsoft.rar",
      target: "_blank",
      rel: "noreferrer"
    }, "\u4E0B\u8F7D\u8F6F\u7535\u8BDD")) : null, /*#__PURE__*/React.createElement(_Menu.Divider, null), !userData?.isCspSync && /*#__PURE__*/React.createElement(_Menu.Item, {
      key: "exit",
      icon: /*#__PURE__*/React.createElement(LogoutOutlined, null),
      onClick: () => {
        _Modal.confirm({
          title: '您确定要退出登录吗？',
          icon: /*#__PURE__*/React.createElement(ExclamationCircleOutlined, null),
          content: '您确定要退出登录吗？',
          okText: '确定',
          cancelText: '取消',
          onOk: async () => {
            await homeLogout();
            logout('/cms/auth/login');
          }
        });
      }
    }, "\u9000\u51FA\u767B\u5F55"));
  };
  const items = () => userList.map(item => ({
    key: item.companyCode,
    label: /*#__PURE__*/React.createElement("div", {
      key: item.companyCode,
      tabIndex: 0,
      role: "button",
      onKeyDown: () => null,
      onClick: () => {
        if (item.companyCode === companyInfo.code) return;
        switchUser(item.companyCode);
      }
    }, /*#__PURE__*/React.createElement(_Avatar, {
      style: {
        verticalAlign: 'middle',
        position: 'relative',
        background: '#227ffc'
      },
      size: "small"
    }, item.company.substring(0, 1)), item.company)
  }));
  return /*#__PURE__*/React.createElement("div", {
    className: styles$6.upright
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$6.icon
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$6.icon
  }, /*#__PURE__*/React.createElement(SearchMenu$1, {
    searchTrue: searchTrue,
    handleKeyDown: () => setSearchTrue(false)
  })), userList.length > 1 && localStorage.getItem('p') ? /*#__PURE__*/React.createElement("div", {
    className: styles$6.icon
  }, /*#__PURE__*/React.createElement(_Dropdown, {
    menu: {
      items: items()
    }
  }, /*#__PURE__*/React.createElement(UserSwitchOutlined, {
    style: {
      color: '#ccc',
      fontSize: 24
    }
  }))) : null, /*#__PURE__*/React.createElement("div", {
    className: styles$6.icon
  }, /*#__PURE__*/React.createElement(_Badge, {
    count: 0,
    style: {
      boxShadow: 'none'
    }
  }, /*#__PURE__*/React.createElement(BellOutlined, {
    style: {
      color: '#ccc',
      fontSize: 24
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: styles$6.icon
  }, /*#__PURE__*/React.createElement(_Dropdown, {
    overlay: renderAvatarList()
  }, /*#__PURE__*/React.createElement(_Avatar, {
    icon: /*#__PURE__*/React.createElement(UserOutlined, null),
    src: userInfo.headImg,
    alt: "\u7528\u6237\u5934\u50CF"
  }))), open && /*#__PURE__*/React.createElement(CompanyDrawer, {
    companyInfo: companyInfo,
    open: open,
    onClose: update => {
      if (update) {
        refetchCompany();
      }
      setopen(false);
    }
  }));
};
TopRight.propTypes = {
  companyInfo: PropTypes.shape({
    imgUrl: PropTypes.string,
    name: PropTypes.string,
    companyAddress: PropTypes.string,
    descRemark: PropTypes.string,
    summary: PropTypes.string,
    code: PropTypes.string
  }),
  userInfo: PropTypes.shape({
    id: PropTypes.string,
    headImg: PropTypes.string,
    realName: PropTypes.string,
    userType: PropTypes.number,
    userSex: PropTypes.number,
    cellphone: PropTypes.string,
    major: PropTypes.string,
    manageDepartments: PropTypes.arrayOf(PropTypes.string)
  }),
  siteInfo: PropTypes.shape({
    allowCharge: PropTypes.number,
    channelCode: PropTypes.string
  }),
  refetchCompany: PropTypes.func,
  deploy: PropTypes.shape()
};
TopRight.defaultProps = {
  companyInfo: {},
  userInfo: {},
  siteInfo: {},
  refetchCompany: () => null,
  deploy: {}
};
var TopRight$1 = /*#__PURE__*/memo(TopRight);

var css_248z$4 = ".style-module_container__1dZ36 {\n  display: flex;\n  flex: 1 1 0;\n  overflow: hidden;\n  flex-direction: column;\n}\n*:focus {\n  outline: none;\n}\n#subapp-viewport {\n  flex-direction: column;\n  flex: 1 1 0;\n  height: 100%;\n}\n#subapp-viewport > div {\n  height: 100%;\n  flex: 1;\n}\n.ant-table-row-clickable {\n  cursor: pointer;\n}\n.ant-pro-basicLayout-content .ant-pro-page-container {\n  margin: -24px -24px 0 !important;\n}\n.ant-pro-basicLayout {\n  height: 100%;\n}\n.ant-pro-top-nav-header-logo img {\n  height: auto !important;\n}\n.ant-menu-horizontal > .ant-menu-item,\n.ant-menu-horizontal > .ant-menu-submenu {\n  font-weight: 600;\n  font-size: 15px;\n}\n.ant-menu.ant-menu-dark.ant-menu-horizontal .ant-pro-menu-item-title a {\n  color: #fff;\n}\n.ant-menu.ant-menu-dark.ant-pro-sider-menu .ant-pro-menu-item-title a {\n  color: #ccc;\n}\n.ant-menu-dark.ant-menu-dark:not(.ant-menu-horizontal) .ant-menu-item-selected {\n  margin: 0 5px;\n}\n.ant-menu.ant-menu-dark a,\n.ant-menu-dark .ant-menu-sub a,\n.ant-menu.ant-menu-dark .ant-menu-sub .ant-menu-item a {\n  color: #fff !important;\n}\n.ant-pro-menu-item .anticon,\n.ant-picker .anticon,\n.ant-pagination .anticon,\n.ant-drawer .anticon,\n.ant-modal .anticon,\n.ant-btn .anticon {\n  vertical-align: -0.125em !important;\n}\n.ant-dropdown-menu .ant-dropdown-menu-item > .anticon:first-child {\n  vertical-align: 0.1em;\n}\n.ant-image-preview-img-wrapper {\n  display: flex;\n  justify-content: center;\n}\nbody ::-webkit-scrollbar-track {\n  background: rgba(0, 0, 0, 0.06);\n  border-radius: 3px;\n  box-shadow: inset 0 0 5px rgb(0 21 8.2%);\n  -webkit-box-shadow: inset 0 0 5px rgb(0 21 8.2%);\n}\nbody ::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.12);\n  border-radius: 3px;\n  box-shadow: inset 0 0 5px rgb(0 21 8.2%);\n  -webkit-box-shadow: inset 0 0 5px rgb(0 21 8.2%);\n}\n.ant-menu-dark {\n  background-color: red;\n}\n.ant-menu-vertical .ant-menu-item::after,\n.ant-menu-vertical-left .ant-menu-item::after,\n.ant-menu-vertical-right .ant-menu-item::after,\n.ant-menu-inline .ant-menu-item::after {\n  border: 0 !important;\n}\n.ant-menu-horizontal > .ant-menu-item a::before {\n  height: 38px;\n  margin-top: 5px !important;\n}\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-item,\n.ant-menu-dark.ant-menu-horizontal > .ant-menu-submenu {\n  height: 32px !important;\n  border-radius: 6px;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  margin-top: 8px !important;\n}\n.ant-menu-sub.ant-menu-inline > .ant-menu-item,\n.ant-menu-sub.ant-menu-inline > .ant-menu-submenu > .ant-menu-submenu-title {\n  width: 109px !important;\n  margin: 0 !important;\n  display: inline-block !important;\n  font-size: 13px !important;\n  border-radius: 5px;\n}\n.ant-pro-sider-light {\n  width: 230px !important;\n  max-width: 230px !important;\n  min-width: 230px !important;\n  z-index: 1000;\n}\n.ant-menu-sub.ant-menu-inline {\n  margin-left: 5px !important;\n}\n.ant-layout-sider-collapsed {\n  flex: 0 0 48px !important;\n  max-width: 48px !important;\n  min-width: 48px !important;\n  width: 48px !important;\n}\n.ant-tree,\n.scrm-tree {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n  color: #000000d9;\n  font-size: 14px;\n  font-variant: tabular-nums;\n  line-height: 1.5715;\n  list-style: none;\n  font-feature-settings: \"tnum\";\n  background-color: #f7f8fa !important;\n  transition: background-color 0.3s;\n}\n.ant-menu-submenu-expand-icon,\n.ant-menu-submenu-arrow {\n  position: absolute !important;\n  top: 50% !important;\n  right: 16px !important;\n  width: 10px !important;\n  color: #111 !important;\n  transform: translateY(-50%) !important;\n  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n}\n.ant-menu-inline .ant-menu-submenu,\n.ant-menu-vertical-left .ant-menu-submenu,\n.ant-menu-vertical-right .ant-menu-submenu,\n.ant-menu-vertical .ant-menu-submenu {\n  padding-bottom: 6px !important;\n}\n.ant-menu-item .ant-menu-item-icon + span,\n.ant-menu-submenu-title .ant-menu-item-icon + span,\n.ant-menu-item .anticon + span,\n.ant-menu-submenu-title .anticon + span {\n  margin-left: 18px !important;\n  font-weight: 600 !important;\n  opacity: 1 !important;\n  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), margin 0.3s, color 0.3s !important;\n}\n.ant-menu-inline.ant-menu-root .ant-menu-item,\n.ant-menu-inline.ant-menu-root .ant-menu-submenu-title {\n  margin: 0 3px;\n}\n.ant-menu-vertical .ant-menu-submenu,\n.ant-menu-vertical-left .ant-menu-submenu,\n.ant-menu-vertical-right .ant-menu-submenu,\n.ant-menu-inline .ant-menu-submenu {\n  padding-bottom: 6px !important;\n  width: calc(100% - 3px) !important;\n}\n.ant-menu-vertical .ant-menu-item,\n.ant-menu-vertical-left .ant-menu-item,\n.ant-menu-vertical-right .ant-menu-item,\n.ant-menu-inline .ant-menu-item,\n.ant-menu-vertical .ant-menu-submenu-title,\n.ant-menu-vertical-left .ant-menu-submenu-title,\n.ant-menu-vertical-right .ant-menu-submenu-title,\n.ant-menu-inline .ant-menu-submenu-title {\n  height: 40px !important;\n  margin-top: 4px !important;\n  margin-bottom: 0 !important;\n  padding: 0 13px !important;\n  overflow: hidden !important;\n  line-height: 40px !important;\n  border-radius: 5px;\n}\n.yunke-form-layout .yunke-form-custom .yunke-form-item {\n  width: 50%;\n  padding-right: 20px;\n}\n.yunke-form-layout .yunke-form-custom {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n.ant-card {\n  border-radius: 5px !important;\n}\n.ant-modal-header {\n  border-radius: 8px !important;\n}\n.scrm-menu-vertical .scrm-menu-item::after,\n.scrm-menu-vertical-left .scrm-menu-item::after,\n.scrm-menu-vertical-right .scrm-menu-item::after,\n.scrm-menu-inline .scrm-menu-item::after {\n  border: 0 !important;\n}\n.scrm-menu-horizontal > .scrm-menu-item a::before {\n  height: 38px;\n  margin-top: 5px !important;\n}\n.scrm-menu-dark.scrm-menu-horizontal > .scrm-menu-item,\n.scrm-menu-dark.scrm-menu-horizontal > .scrm-menu-submenu {\n  height: 32px !important;\n  border-radius: 6px;\n  display: flex !important;\n  justify-content: center;\n  align-items: center;\n  margin-top: 8px !important;\n}\n.scrm-menu-sub.scrm-menu-inline > .scrm-menu-item,\n.scrm-menu-sub.scrm-menu-inline > .scrm-menu-submenu > .scrm-menu-submenu-title {\n  width: 109px !important;\n  margin: 0 !important;\n  display: inline-block !important;\n  font-size: 13px !important;\n  border-radius: 5px;\n}\n.scrm-pro-sider-light {\n  width: 230px !important;\n  max-width: 230px !important;\n  min-width: 230px !important;\n}\n.scrm-menu-sub.scrm-menu-inline {\n  margin-left: 5px !important;\n}\n.scrm-layout-sider-collapsed {\n  flex: 0 0 48px !important;\n  max-width: 48px !important;\n  min-width: 48px !important;\n  width: 48px !important;\n}\n.scrm-menu-submenu-expand-icon,\n.scrm-menu-submenu-arrow {\n  position: absolute !important;\n  top: 50% !important;\n  right: 16px !important;\n  width: 10px !important;\n  color: #111 !important;\n  transform: translateY(-50%) !important;\n  transition: transform 0.3s cubic-bezier(0.645, 0.045, 0.355, 1) !important;\n}\n.scrm-menu-inline .scrm-menu-submenu,\n.scrm-menu-vertical-left .scrm-menu-submenu,\n.scrm-menu-vertical-right .scrm-menu-submenu,\n.scrm-menu-vertical .scrm-menu-submenu {\n  padding-bottom: 6px !important;\n}\n.scrm-menu-item .scrm-menu-item-icon + span,\n.scrm-menu-submenu-title .scrm-menu-item-icon + span,\n.scrm-menu-item .scrmicon + span,\n.scrm-menu-submenu-title .scrmicon + span {\n  margin-left: 10px !important;\n  font-weight: 600 !important;\n  opacity: 1 !important;\n  transition: opacity 0.3s cubic-bezier(0.645, 0.045, 0.355, 1), margin 0.3s, color 0.3s !important;\n}\n.scrm-menu-inline.scrm-menu-root .scrm-menu-item,\n.scrm-menu-inline.scrm-menu-root .scrm-menu-submenu-title {\n  margin: 0 3px;\n}\n.scrm-menu-vertical .scrm-menu-submenu,\n.scrm-menu-vertical-left .scrm-menu-submenu,\n.scrm-menu-vertical-right .scrm-menu-submenu,\n.scrm-menu-inline .scrm-menu-submenu {\n  padding-bottom: 6px !important;\n  width: calc(100% - 3px) !important;\n}\n.scrm-menu-submenu {\n  color: #111;\n}\n.scrm-menu-vertical .scrm-menu-item,\n.scrm-menu-vertical-left .scrm-menu-item,\n.scrm-menu-vertical-right .scrm-menu-item,\n.scrm-menu-inline .scrm-menu-item,\n.scrm-menu-vertical .scrm-menu-submenu-title,\n.scrm-menu-vertical-left .scrm-menu-submenu-title,\n.scrm-menu-vertical-right .scrm-menu-submenu-title,\n.scrm-menu-inline .scrm-menu-submenu-title {\n  height: 40px !important;\n  margin-top: 4px !important;\n  margin-bottom: 0 !important;\n  padding: 0 13px !important;\n  overflow: hidden !important;\n  line-height: 40px !important;\n  text-overflow: ellipsis !important;\n  border-radius: 5px;\n  width: calc(100% - 3px) !important;\n}\n.scrm-modal-content {\n  position: relative !important;\n  background-color: #fff !important;\n  background-clip: padding-box !important;\n  border: 0 !important;\n  border-radius: 8px !important;\n  pointer-events: auto !important;\n}\n.scrm-card {\n  border-radius: 5px !important;\n}\n.scrm-modal-header {\n  border-radius: 8px !important;\n}\n.ant-pro-sider-collapsed-button .anticon {\n  float: right;\n}\n.style-module_formModal__V0CES {\n  display: flex;\n  justify-content: flex-start;\n  align-content: flex-start;\n  flex-wrap: wrap;\n  transition: all 0.5s;\n}\n.style-module_formModal__V0CES .style-module_yunke-form-item__3x7wf {\n  width: 50%;\n  padding-right: 20px;\n}\n.style-module_formModal__V0CES .style-module_yunke-form-item__3x7wf:nth-child(2n) {\n  padding-right: 0;\n}\n.style-module_formModal__V0CES > * {\n  width: 50%;\n  padding-right: 20px !important;\n}\n.style-module_formModal__V0CES > *:nth-child(2n) {\n  padding-right: 0;\n}\n.style-module_formModal__V0CES .ant-form-item-label {\n  line-height: 22px;\n}\n.style-module_formModal__V0CES .ant-form-item {\n  margin-bottom: 10px;\n}\n";
var styles$4 = {"container":"style-module_container__1dZ36","formModal":"style-module_formModal__V0CES","yunke-form-item":"style-module_yunke-form-item__3x7wf"};
styleInject(css_248z$4);

/**
  * 这些页面不需要左侧菜单栏
  * @returns
  */
const checkNotSidebarPage = () => {
  const {
    pathname
  } = window.location;
  return /remote|qualityTesting|scrm|\/douyin|douyinSuccess|init/.test(pathname);
};
const instance = createInstance({
  urlBase: 'https://mat.yunkecn.com',
  siteId: 1
});

/**
 * 总模版
 * @returns
 */
const Layout = ({
  children,
  module,
  pathname,
  onRoutes,
  deploy
}) => {
  const {
    siteInfo,
    userInfo,
    companyInfo,
    refetchCompany
  } = useSiteInfo();
  const {
    topMenu,
    routes
  } = useRoutes({
    module,
    pathname
  });
  const addRecord = () => {
    if (window.location.hostname === 'crm.yunkecn.com') {
      // 只有公版正式才统计
      const newUserInfo = localStorage.getItem('userData') && localStorage.getItem('userData') !== 'undefined' ? JSON.parse(localStorage.getItem('userData')) : {};
      const href = window.location.origin + window.location.pathname;
      instance.trackPageView({
        href: window.location.pathname.includes('/cms/wechat/salewechat/message/wechat-window') ? '/cms/wechat/salewechat/message/wechat-window' : href,
        customDimensions: [{
          id: 1,
          value: newUserInfo?.companyId
        }, {
          id: 2,
          value: newUserInfo?.userId
        }, {
          id: 3,
          value: newUserInfo?.cellphone
        }, {
          id: 4,
          value: newUserInfo?.realName
        }]
      });
    }
  };
  useCheckVersion();
  useEffect(() => {
    onRoutes(routes);
    addRecord();
    console.log('routesyunkecom', routes);
  }, [routes]);

  /**
   * 显示水印
   * @returns
   */
  const watermark = async () => {
    const loginUser = JSON.parse(localStorage.getItem('userData'));
    // 登录及注册页面不获取水印配置
    const noNeedWatermarkPages = ['/auth/login', 'auth/reg', '/auth/forgotpass', '/auth/accountcheck', '/auth/changephone'];
    if (noNeedWatermarkPages.includes(window.location.pathname)) return;
    const response = await getWatermark().catch(error => {
      if (error.code === 302) {
        logout('/cms/auth/login');
      }
    });
    if (response?.success) {
      if (response.data.show) {
        if (deploy?.waterMark) {
          const waterMark = new WaterMark();
          switch (response.data.rule) {
            case 1:
              waterMark.update({
                text: [`${loginUser.cellphone}`, loginUser.userId, moment(new Date()).format('YYYY-MM-DD HH:mm:ss')],
                rotate: -20,
                fontSize: 24,
                width: 450,
                height: 450,
                fontWeight: 500
              });
              break;
            case 2:
              waterMark.update({
                text: [loginUser.realName, `${loginUser.cellphone}`, moment(new Date()).format('YYYY-MM-DD HH:mm:ss')],
                rotate: -20,
                width: 250,
                height: 250
              });
              break;
            case 3:
              waterMark.update({
                text: [`${loginUser.cellphone}`, moment(new Date()).format('YYYY-MM-DD HH:mm:ss')],
                rotate: -20,
                width: 200,
                height: 200,
                fontWeight: 500
              });
              break;
            case 4:
              waterMark.update({
                text: (loginUser?.realName || '') + (loginUser?.cellphone?.slice(-4) || ''),
                rotate: -20
              });
              break;
          }
          waterMark.render();
        } else {
          const waterMark = new WaterMark();
          waterMark.update({
            text: (loginUser?.realName || '') + (loginUser?.cellphone?.slice(-4) || ''),
            rotate: -20
          });
          waterMark.render();
        }
      }
    }
  };
  useEffect(() => {
    watermark();
  }, []);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ProLayout, {
    layout: "top",
    disableContentMargin: true,
    logo: siteInfo.navigationLogo ? siteInfo.navigationLogo : false,
    title: false,
    onMenuHeaderClick: () => {
      window.location.href = '/cms/';
    },
    route: {
      routes: topMenu
    },
    navTheme: "dark" // 设置导航栏主题为暗色
    ,
    headerTheme: "dark" // 设置头部主题为暗色
    ,
    rightContentRender: () => userInfo ? /*#__PURE__*/React.createElement(TopRight$1, {
      siteInfo: siteInfo,
      deploy: deploy,
      userInfo: userInfo,
      companyInfo: companyInfo,
      refetchCompany: refetchCompany
    }) : null,
    menuProps: {
      style: {
        textAlign: 'center',
        justifyContent: 'center'
      }
    },
    contentStyle: {
      display: 'flex',
      flexDirection: 'column'
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.container
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$4.container
  }, routes?.length !== 0 ? /*#__PURE__*/React.createElement(ProLayout, {
    title: "\u9996\u9875",
    navTheme: "light",
    menuHeaderRender: false,
    menuRender: (props, defaultDom) => checkNotSidebarPage() || !routes ? null : defaultDom,
    route: {
      routes
    },
    contentStyle: {
      height: 1
    },
    headerRender: false,
    disableContentMargin: true,
    menu: {
      defaultOpenAll: true,
      autoClose: false
    }
  }, /*#__PURE__*/React.createElement("div", {
    id: "subapp-viewport",
    className: "subapp"
  }, /*#__PURE__*/React.createElement("div", null, children))) : /*#__PURE__*/React.createElement("div", {
    id: "subapp-viewport",
    className: "subapp"
  }, /*#__PURE__*/React.createElement("div", null, children))))));
};
Layout.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  module: PropTypes.string,
  pathname: PropTypes.string.isRequired,
  onRoutes: PropTypes.func,
  deploy: PropTypes.shape()
};
Layout.defaultProps = {
  module: '',
  onRoutes: () => null,
  deploy: {}
};
var index = /*#__PURE__*/memo(Layout);

var img$o = "data:image/png;base64,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";

var img$n = "data:image/png;base64,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";

var img$m = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMwAAADMCAMAAAAI/LzAAAAA/1BMVEUAAABVqv8AQP8zmf8zZv8XdP88h/8rcf8oef80ffozevo8gvo7e/o1gvo0e/o4gvo3e/o2gvs1e/s0gvs6fPs2ffw7gfw3ffw5ffw4gfw4ffw5ff04gf04ff03ff05gf04ff05f/s4fvs4fvw4f/w5fvw4f/w6fvw5fvw6fvw4f/w4fvw5f/w4fvw4f/w4fvw4f/w5fvw4f/w4fvw5f/w5fvw6f/w4fvw5f/w4f/w5fvw4f/w4fv06f/04fv05f/05fvs5f/w4fvw5f/w6f/w4fvw5fvw5f/w5fvw4f/w5fvw5f/w5f/w5fvw6f/w5f/w5fvw5fvw5f/w5fvw6gPwLfLMRAAAAVHRSTlMAAwQFCgsREhMxMjM0NTY3ODk6O0JaW1xeX2BsbXJ4eXqHiJKTlJWWmJqbnJ2ep6ipqrW2t7i5ur2/wMfMz9DR2t3e3+Hi6Onq6+zt9fb3+fr8/f4V1ZDZAAACs0lEQVR42u3dfVcSQRSA8Y0CgkJeTLGiwFLTXpSyzDKoSBRQk3bn+3+WzlkMQRf9Yy/t3DnP8w1+Z1mYnTtn8TzSUqrSaLZ7Z8biznqtZqOcupXyYOPEKGmwnr+RUt4zqvpUmknJvg2MsoLXmWhLoWMU1l2MsqwMjcqG1euWWmCUFtSuWpZ9o7bgybRlcWgUN5z6UrvfNao7zE5g3hnlbU38VgbaMf7CGPPZqG93vB4zDpS7wLxyAbM2stw9cQHTHz0RVIwTFUNMww1MPcQ03cBsh5i2G5hWiOm5gTkKMb/dwJyGGONIYMCAAQMGDBgwYMCAAQMGjCWYwXuRvluBOZA5DXJv3yGMqCZxjJf+6hBG8NpYgJHTxMSsfovR+GBF+osVmFjzg2fS18YOjJDGEoyMJnlMVe6+SR7zZ0Xs2iSPMXIaCzByGhswYhorMFIaOzBCGkswMhpbMCIaazASGnswAhqLMPE1yWN+XvbjUbx1mi2rZpFnTzsxXrrjEMY7AANGBrP/IqolnZjommDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMGDAgAEDBgwYMG5iYr0UNLrVxDBzCwwYMDZjhF7YPqvBf8XYGBgwYMCAAQMGDBgwYMCAATMHjFN/3N5zA3MUYtpuYFrz2stPou0Q03ADUw8xZTcwxRCTGrhg6adGO7sbLmBeXmxT513A5P5tuu/pt3wYTxBKvnaLX7ich7zRjtmcGO5kD3VbfmUmR1XloWbLeXF68Lak+LYJHl8dI9YCtZan14eiVaWftPPlqBHvw45GS7cSPbDObqm7cfzNzMz5+8JHXZbdwo3HCfLratbQ/bXcracjUqX6Tuv41Oq9i+PWzvPiHY+09BeIvZ8gRl6oxgAAAABJRU5ErkJggg==";

var img$l = "data:image/png;base64,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";

var img$k = "data:image/png;base64,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";

var img$j = "data:image/png;base64,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";

var img$i = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMwAAADMCAMAAAAI/LzAAAAC6FBMVEUAAAAAAP8AAP9Vqv8AQP8zmf8AVf9Jkv8gYP8cjv8zZv8XdP8qav87dv8kbf8ziP8wcP88h/8rcf8oef8zc/8xhv86dP8sev8qdf8zhf87dv8ve/8udv81hP8zd/8xhP8+fP88eP8zfP8yeP8wg/82ef87g/8zef84g/83ef81ffk6evk2ffo1evo0ffozevo8gvo7e/o1gvo0e/o4gvo3e/o2gvs1e/s0gvs3e/s2gvs1e/s1gvs4fPc7fvs6fPs1fvs1fPs3fvs3fPs2fvs1fPs4fvw3fPw2fPw4fvw7fPw3fvw2fPw2fvw4fPw3fvw3fPw5gfw4ffw4gfw6ffw2gfw2ffw7gfw3ffw3gfw5ffw4gfw4ffw6gfw3ffw5gfw4ffw4gfw3ff05gf07ff04gf03ff03gf05ff04gf06ff03gf05ff04gf04ff03gf03ff07gf06gf03ff05gf04ff04gf04ff03gf05ff04fvk3f/s7fvs4f/s6fvs4f/s3fvs5f/s4fvs4f/s3fvs5f/s4fvs6f/s4fvs7f/s4f/s4fvw4f/w5fvw4f/w6fvw4f/w5fvw5f/w6fvw4f/w4fvw5f/w4fvw4f/w4fvw5f/w5fvw6f/w4fvw5f/w5fvw4f/w4fvw4f/w5fvw5f/w6fvw4f/w5fvw5f/w6fvw4f/w4fvw5f/w5fvw4f/w4fvw5f/w5fvw6f/w4fvw5f/w5fvw5f/w4fvw4f/w5fvw5f/w6fvw4f/w5fvw5f/w6fvw4f/w4fvw5f/w5fvw6f/w4fv05f/05fv06f/04fv05f/05fv05f/05fv04f/s5fvs5f/s6fvs4f/s5f/w6fvw5f/w4fvw5f/w5fvw6f/w4fvw5f/w5fvw6f/w5fvw5f/w5fvw5f/w5fvw4f/w5fvw5f/w6fvw5f/w5fvw5f/w6fvw5f/w4fvw5f/w5fvw6f/w5fvw5f/w5fvw6f/w5fvw5f/w5fvw6gPyxCELpAAAA93RSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHyEiIyQlJicoKSorLC8wMTIzNDU2Nzg5Ojs8PT4/QEFCQ0RFRkdISUpMTU5PUFFSU1RVVldYWVpbXF1eX2BhYmNkZWZnaGlqa2xtbm9wcXJzdHV3eHl6e3x9foCBgoOEhYaHiImKi4yNjo+RkpOUlZaXmJmam5ydnp+goaKjpKWmp6ipqqusra6vsLGys7S1tre4ubq7vL2+v8DBwsPExcbHyMnKy8zNzs/Q0dLT1NXW19jZ29zd3t/g4eLj5OXm5+jp6uvs7e7v8PHy8/T19vf4+fr7/P3+VvPMlgAACidJREFUeNrtnXd8FEUUxy8hhCYCAQFBBRUxCIJASChR6UWqihTpRaQKSBDpICC9dxAkoYN0VBBEkZYgRUACBCENpCaQcjf/Si5n8t7u7O7M3u5d9j7z/rvd+e3sd8vbmTdv5mw2YVaxgLDRUTFJqSQPW2pSdNTo0ABNlHcW3CUWsTvza6iihO4nlrJ9dRRRglY4iMXMsawEnaVWLLGgxdWlsXyaTixp6V3kLIMcxKLmGCRl6WwnljVHd8xSN51Y2NKRUysZRyxtN4IAzEpicVsKvpUOq8PYa+fAHCCWtz057THiA1bdBbPQF2DmZbPkv+sLMMnZPYIw4hMW4oQZ7RswEU6YKN+A2eCEifENmGgnTJJvwCQ4YZ74BkyKE4b4iAkYASNgBIyAETACRsAIGAEjYASMgBEwAkbACBgBI2AEjK/BpC9BdpWringo3cujXIVqTTfqzlRG2Rx8g1OzoLQcxxj9dVRpZcMes2E4lYsLpjHSnmcXLkfCwYbBHETH9U/mYHlcEGlnsys7I+Fuw2DSiqIDb+KA2YkTjlqwK8tDXYHHxnmzNuiM+nLAfIZhCj9lFV5AuiYGuuYl6MgVOGBeleS1/cwqnIdkMw2EueWHDn2FmeUvaZJeBKuyHbfjYP5oVkOHZs9PmSmFqckotJeCqpcMbQFEoDNqywzTSArjzzi2fRqpehsKcwQdu3gGq2MuIEtsjWRTTuf3n8wwmUHo4L8zwuyQZ+n2YlM2h5p8dw2FIR+jM5rACNNfDsP0+JMM9GWrZ3CreQ06o/o6HXOWXWIR/ookEw2GSfJH01Ie6PjwuWwui3I8kpwwuj9TGx1+J5PmWxpMKxblu1BRym40zDicbM+kaUiDKcqQD/4ENU87Gd7TPIHO6E2djjnLjvA209cYDmMvgyqI43PMML99DOc32i/e+BhANwSzkkHRL7f4ZCAN0VaGwKpqmBDQiEQwnzAoKoDGMtcn8GGAnrYpD8z9/Jwe5jwoHl8c/NjM16M7bEaoqT6q4oxm+Rm5hQs6qgBpPy3lUF7vxw/zDYKZxuOYg1FcoyJXh6ONKUHAswimEY9j7kGGcHTu7qDWxiJzIpqvwDoKas2x3QYKLycrODp3UeiqXTUHph+qZD9H6YskhuPJ6c8Z/dMFsx3BjGR3zKUcxF4SSJ9Xf6crwWqGmATzCDVPqrE75tbPfreG2mNqypvomu0xCQaHWjVaGbDfu0AaOhqnplyNXs0Us2BQENy2XrXse6Dk389+X0EzKZnbTU2IWTCXEUx31RZJYG7BN5xbXoOdu/tsLxtb9E8fDHkd1lNereRWWQT/c6jdxnrFLpgHMxhVdFGlZB9ZBB81uAYoKxfxhz/0wexFMHPYPrCuCD7qqlVSVn4Eq+hjIszT52BNLZUL/kl5h6FLsCmuPeBAncDNJsKQlrCmIsrjE9Mo7zBqqC5hagEG3DMTZiF6zn5hiq78/w6jFk0HJvdfj5gJE4dgFHvzDwIp77CjHJCWyFSQtuKP/umFIW/ZWHrzW6jjbGgNgj8UgtqwS2o7aS7MSKaAdm9QaGvO1g0MF/24juifbphD6Dnbou2Ywcf+bj4gbUBXTkZrYRBzYTLQY9Bf2yOFK4R489PD1Wh0aq3JMKSDTbs3D53wFLB9LNT+QFOmFYbt8ttmw6xg6NOGK0RxjmnmXBzSE/3TDxOPBp4XUx0ziLCVhdkyaPyNGq7+Wn+Sjq4ULbR0VXtaic2gQDe050OovUGR1mX7JhsGgy5ecdq3rxco8D3ag5J7VlDCU4HskQJDYH6zaXz7HOUVR8pvwme0o1y6R98AvX4Ye2lY4yR5gRiVNkJVuHKP/JM4QvN9NBgG506Fy/dPVYlcDIfaU+rvY6wnYNbDGgMfyfY3UEkYOAC1U6XKe/l4B+fchkGtEtsuNccsaxs/LQKk76u1T21DPQJDwlQjjptU3/EW8K5KM+IGwgPv9QzMRFhnFenenmDnKpl2jlq0Mlhf9M8tmDPIOd9Udsx+t2TaS1A6DO+7DR13U+IZGAdKn1yNd0aDXW9TxDADpSretQ4edpaHYNAnXtrpmAJ2jaJo+yvf1V6sQTlDYWDjy1YGJ17Dkc9DFO025btaUWf0zz0YGK+QLMIDx6SLptGC0PmV7upVvRm67sHgeN4MuGejZuMqXOmuLmPpkJsAM0Nx1KGHZuNqitJd7cQ6TGAwzAWloVoUG4vVduzTgfRFHdl5RsDgFL8f6WcarODY4Uk3VrhAkzwJMwDW/CU9UjRMQduVflfnqjeoTYTZpRB4qAc271PQom9j7kKRbXVH/9yFSS1MTbz+F6QjFVLKekj2pw3A22GwowvxJAzOO97w/1aYW9FcUVuTNgB/Ch7wO8/CoCe8Jy00rjyuNoYW6IMjOn6JnoWJpY08Isd8WVF7FGrXuTY2g6vGE8/C4El1rsTr02x5WChe7QqspcMBxq88DfMFhJmXvW0S23gymhvjCnke5cyvNRYGZet+II9H7lDRoolS55ybxrsR/XMfBk2qy049hI458KGK9qa8Fwabn+2Ip2HwpLqjWVsi1SIvip19pwtPKcAyEm0ezFIIMzZrSzfmFM5h0gmCKJ523fMw/8DwQ2iWYy4LNpxV1e6D5/4TwSnmwcTzMCjHNfDZ5T0Hk4TUJzGnFpI44lB3on9GwKCE/eO4UdBTQ9sUv16pgQwNVFNhjkqm+LQHPzdqaGEeRtFMNPpXMNUbMJkwh7QrcZTmSPe/aEPv1wTwqxnxBgzpiDJ24SsTpqmF6X7LSBN9E9ONhFkLIxCZC7hmC/YFpYeTYm5F/wyBQZPqbg/gmvEGRy/aJIAfLxPvwKCMi5MNuXq9cBSn6jGeKRxmwcBJddvL8+W8gDBuodXUvCEPw8BJddP9+HJeYHeht3vRP2Ng4KQ60Ij2T2DQnqL/cVR94i0YyaQ6rl4vHoHPnWnnPZgo6gmNYdJ2pmpPew8GT6pDnRuur1SOvWD3Hgwa8+fs9eKp3zmtIi/CTKWcUAdGLe2f/dZ5E+Ys5YSW6elCuPxgojdh8PwQ5Twymh2WS2sSr8L0k51QVVZpRjGdftA0mO2yExqhL77D4QdNg5HP+T/IrF2k0w+aBiNZv0x16obUrklh2hMvw8zWs0SGyypLtEu9DXNZckLzObSDdfpB02Ak6xAuSeC5EFi6hngdJs+YgBEwAkbACBgBI2AEjIARMAJGwAgYASNgBIyAETACRsBYDMan/rg9yTdgEuTzLK1r2fOQo3wDZoOe5V3yqkXkZIv7gGUvJR5wxxdYkgNyV1O1vM3Vt8BT3rTqrEsvW8B25/4Fgd3qLPZacNlui9tikE0QdMPaLNdKwNyI0HQrs6SF4EyPThZ+bRyyjORBDsuyDJSnFHax6JOWRk2QrhlrRZa4MHoeftBSy7049sUlbEpWe6+1WPbUsqlZjfmWaUMnz6tu07KAOhGR0YkpeRkjJTE6clRIPpswq9h/Bl/qayIKozgAAAAASUVORK5CYII=";

var img$h = "data:image/png;base64,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";

var img$g = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMwAAADMCAMAAAAI/LzAAAAA0lBMVEUAAABVVQCAQABmMwCHSw+OVQ6GURuSUxqPUhmRVRmOUxmQUhiOVRiQUxySUhuPVRuRVBqPUhqPVByRVRqSVBmQUxyQVBuRUxuPVRuQVRqRVBqQVRyRVBuQVBuRVBySVRyRVByRVBuRVRuSVBuSVBqRVByRVRyRVByRVBuRVBuSVRuRVBuRVRuSVBuRVRySVRyRVByRVRuRVRuSVRuSVRyRVRuRVRuSVRuRVRuSVBuRVRuRVRuSVBuRVRySVBuRVRySVRyRVRySVRyRVRuSVBuSVRyRhK3+AAAARXRSTlMAAwQFERITMTIzNDU2Nzg5OjtAWltcXl9gbG14eXqSk5SVlpiam5ydnqeoqbW2t7i5us/Q3t/h4ujp6uvs7fX29/n6/f47ymi2AAACMElEQVR42u3d2U7CUBSFYawgKDIqDggKgiMOWFQUnGh73v+VTA6IZRCDmsje+dd1ufgSSjdn7aSRCJESJ1tutDqvZoHz2nEb5YzzLWW1+myE5KmSmEnJNI2oXKe/pMROAiMswVF0uiV5awSmnZtm2fKMyHiFSUsxMEITFMctm74Rm2Bn1JLzjOB4Iz9qK20jOvexEObUCE899KwMpGP89SHmxojP5XAeMwoSH2AONWAO+pblZw2Ybv8fQdaoSMpiyjowJYtp6MCcWUxLB8a1mI4OzIPFvOnAvFiMURIwYMCAAQMGDBgwYMCAAQMGDBgwUjFzbReFPpef52IwYMCAAQMGDBgwYMCAAQMGDBgwP8Xk/0AOBgwYMGDAgAHDbAYGDBgwYMCAAcNsBgYMGDBgwIDhdIZBEwwYMGDAgAEjfTYDAwYMGDBgwIARPpupOmoCAwYMGDBgwIABAwYMGDBgwIABAwYMGDBgwIAB82vMwgUMGDBgwIABAwYMGDBgwIABAwbMv2NUvbi9owPzYDEtHRjXYho6MGcWU9aBKVlMRgcmZTHOkwZL1+lXCFUNmP1BH5LQgIl/tDtN+ZaLYVWV9qVb/ORn8XYsHVMLtYixe9mWu2i4E814ki291GjDuyH4tgm2x/vqYiDWsjvZvheEftN6m9N2CdZuJVra2embEbG6uBvHr0W/XPRYv5JluUzO3FtJVMTM0N2D+LdrOE66dO4+viz02cWje76XWooQKXkH6sNIa2iyAG0AAAAASUVORK5CYII=";

var img$f = "data:image/png;base64,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";

var img$e = "data:image/png;base64,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";

var img$d = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAeCAYAAAA7MK6iAAACXklEQVRIS8WWTXLTQBCFXysZZ8OPWRMZs4CSV4EbKCfAN4g5QZITBE7gcALMDZwTxLmBdxJsELbZy6liQcZRUyNZ0Y8ljVxWkVn3zNfdr/tJhEc69EhcNAb+bu71mYyvALyDW3n82odfVVRjYKfT8gh4FcF4qoM3AnZMMSAiVW3qVMObAXdanwi4YOYbAKMkiXJ44+DeXNrZDhTDGwG7ZmsMwgfVZ2t2F76pg+8MdkyhWnsSihvwF2shz2Khq+A7gdNQZv7Wm8tBfoXycGsm36uYUvDPNtp/n4kTMPogspMH2QdjCpAPQj9cnhzUPRSXMOhUrRUYfnKfl9ZMtkvBUZYYAhQGVZ08NNP69HIBvxAEg95iNSkEux1xBtBwbQRLZowNBOOAKXIioi4Am1S1AUY5TRO9GVdMqjNhS7zeXI7SBWy0Opsxn1szeamrej3FD9AyvSvBobZPxQRER2v9PuazzSeSaLqpd1nShcNVB65iVk/2j94sVjduR/gAPQfjyprfhQOnO9VTXVF5bBocBMcgUl6tNmB3sMq4qnIn9mfgM4FVxUOAfWsmX+iqrdzj+HIZ3Dnct8mgMXEwUBNPhnGt7sSWqYNrnevHS/Eu2MN1eqeZOTNwURINgrNQXoLhFU172hZ3rjgPNe5hiz/SK1q1ePfV91h9FnVtLtW4CPr2twxdKK85wOcALiIp6hvOhsZV0LKBi+314FZ2dT958RsZcB2obtrrtDnT6m2gWXhrBOJJXU/fqDj5PeWlGqRY07oVbBv30GrXFFMQuv8DWsu5tq2kbrzWueo+tG3cPyzYmi4LwdwTAAAAAElFTkSuQmCC";

var img$c = "data:image/png;base64,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";

var img$b = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAAolBMVEUAAAD///9AgP8kkv8qgP8nif8ohv8jgP8hhf8qgP8ngP8kfP8nfP8mffohffshfvskfPshe/kiffkjevoje/ojfPoie/ohfPsje/sie/she/oievkievkie/kievkhe/kie/kge/kie/khe/khfPkie/sie/ohevkhevohe/ohevoge/oievkievkhevkhe/khe/khe/khe/ohevoievohevndu+FaAAAANXRSTlMAAQQHDA0TFhcYGiMnLz1FRlVaXl9tcHN0fpqrra6vsLS1tre5ucXGxsfIzNXb3eDm5+3u+GIS/gMAAACXSURBVBjTY2AgE4iKYhHkEFRVFeRAFxUzlldXlzcWY0QWZDYxYgcZwq6myYQkLCUNVcWoLIcQ5ddjgTFZ9PnhwjIiCCXCsnCmASeQ4NbV5QZSnIZQQSFTU1MhBgZxU1NxOAdDNa8OVrMFJBEu0WfBGhzySjDfsSILM2mpgX3JpcCDopwRGCYa2ppGEpghqKLIx0ZseFMCAP1nC1zorHU9AAAAAElFTkSuQmCC";

var img$a = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAWCAMAAADzapwJAAAA/FBMVEUAAAAAAAD///8AAICAgP8AAFUAVaoAAEAzmf8AKlUAIEAgYN8cceMAM2YVauoAJ04eePArgP8NKF4ohv8ac/IWevQhhf8qgP8ccfYme/8kgP8acvYje/8ad/cif/8hc/cogP8ILmQeePgcePgcdfgHLlwML2UcevQLMGUgdfQKMWccdvYfefYjffsed/cfePchefcke/ojevoifPoievogefgfevgje/oifPogevgfevghfPshefgje/sjevsie/sjevoie/oievogePghevgievoie/ohe/khefghe/kie/ohefghevkievoie/ohe/oievoie/ohevohevlyOT1BAAAAU3RSTlMAAQECAgMDBAUGCAgJCgwNERITExQXFxgbGxwdHR4eHyAhIiQlJysuMDA0Njk7PEJdXWBhYmdrbm9xc3N0dHV+jI2OkJulpqqrubvj5ejp7fDz9KSuV5gAAADUSURBVBgZncFrP4NQAMDhf8bkPrcz5n6/HpwKszQrCkdo9v2/i5p+qbd7HkYjlOcpQZXUSej7YaIlJdbAMUmZTnxPod0X5NZ/LHIyblEQA8kfbVPiaIZEYsLJzSzUL68XMBNBRkXAy8c+zD+/HUGoyLgBMLNlAI2VCfA9Mm5ARa9LRkVArU7KqBkQKTIiMaFxcbixtnN2MMXY+zJD2obV24fOY+fuapqC/GzC3N7p+fHSJCVWv0Vus8m/dmybpMafvhcpkTqJgl749bpNlVBuV+0ykl+jyhrcyJH7GQAAAABJRU5ErkJggg==";

var img$9 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoCAYAAACM/rhtAAABS2lUWHRYTUw6Y29tLmFkb2JlLnhtcAAAAAAAPD94cGFja2V0IGJlZ2luPSLvu78iIGlkPSJXNU0wTXBDZWhpSHpyZVN6TlRjemtjOWQiPz4KPHg6eG1wbWV0YSB4bWxuczp4PSJhZG9iZTpuczptZXRhLyIgeDp4bXB0az0iQWRvYmUgWE1QIENvcmUgNS42LWMxMzggNzkuMTU5ODI0LCAyMDE2LzA5LzE0LTAxOjA5OjAxICAgICAgICAiPgogPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4KICA8cmRmOkRlc2NyaXB0aW9uIHJkZjphYm91dD0iIi8+CiA8L3JkZjpSREY+CjwveDp4bXBtZXRhPgo8P3hwYWNrZXQgZW5kPSJyIj8+IEmuOgAAAjxJREFUWIXtmNuOgjAURReKmAB1FNFg/P9PMxLFFBUwxEvnwWjEC+iAjA/uJwLN6crpbjeghWGo+GA1/hugSF/AsvoCltUXsKz0uiYKw5DVasV2u6XZbGLbNo7j0Gjk90h790GtlML3feI4vnnWbrcZj8e5kG/t4CWcpmn0+31M0yRNU4IgIE1TpJT0+/2HNd7mwWs4z/PodrsYhoEQAtd1AViv17l13tJBpRTT6ZQkSc5wlmVlxhiGAcB+v8+t9ZYO+r6fCwew2WwAaLVa9QJGUZRZ1ntwcRyzWCwA6HQ69QOeJjYMg9lsRpqmGTjf91FKYVkW3W43t17lHjx5qtFoMJlM2O12AAyHwwycaZp4nldYr/IOnjwlpWS326HrOr1e7wZuNBqhaVr9gNeeE0IQhuGf4KDiJd5ut8zn88w9KeX52rIsPM97Gg5KAEZRRBRF7Pd7Wq0WpmkSBMF5WV3XJUmSTPbatv3yPC9ncV62Aui6zng8LjzfntVLHryOr5+fH3q9XmaM67qVwb0E+Chbr7M0SZLK4J4GPGXrdUJces5xHOC4UarUU5vkUbbato1SisFgwHK5BKDZbNYLGIbhw2wVQiCEII7jM+C97C2jwiVerVYAOI7zMPgvs1UIUS/gyVNFcM9ma+WAJ09dvpHcg3slvl5RoQeFEEgpCYIAOH7oJEnCYrF4Oxw8kSSHw4HJZHLTQfhbtlYOCEdIKSXr9fqcvZ1Op/BlszbA/9TH//r4ApbVF7CsPh7wFz/6WDrNMI7YAAAAAElFTkSuQmCC";

// 微信聊天记录查询图片原图
const getOriginalPic = data => request.postJson('/pc/wechat/OriPic', data).then(res => res.data);

// 获取好友聊天记录信息
const chatRecords = (data, headers = {}) => request.postForm('/pc/wechat/chatRecords-v2', qs.stringify(data), headers).then(res => res.data);
// 获取群列表信息
const groupTalkerList = data => request.formData('/pc/wechat/groupTalkerList', data).then(res => res);
// 搜索聊天记录信息
const searchContent = data => request.postJson('/pc/wechat/searchContent', data).then(res => res);
// 跟进用户信息
const groupFriendSaleList = data => request.formData('/pc/wechat/groupFriendSaleList', data).then(res => res);
// 语音转文字
const voiceToCharacter = data => request.formData('/pc/wechat/voiceToCharacterAl', data).then(res => res);
// 语音播放获取
const voiceToPlay = (data, header = {}) => request.formData('/pc/wechat/voice', data, header).then(res => res);
// 语音通话/视频通话播放获取
const videoToPlay = (data, header = {}) => request.postJson('/pc/wechat/queryCallFile', data, header).then(res => res);
// 删除聊天记录
const delRecords = data => request.formData('/pc/wechat/delRecords', data).then(res => res);

/**
 * 获取录音地址
 * @param {*} data
 * @returns
 */
const voice2ToPlay = (data, header = {}) => request.get('/yunkeCellPhone/timeline/voice', data, header).then(res => res);

var img$8 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAABRFBMVEUAAABVVVUgICAcHBwaGhouLi4gICAbGxsfHx8bGxsdHR0cHBwZGRkaGhoaGhoaGhocHBwbGxsbGxsaGhocHBwaGhoaGhoZGRkZGRkbGxsgICAkJCQpKSkrKystLS0xMTE1NTU5OTlDQ0NFRUVGRkZJSUlMTExOTk5RUVFYWFhdXV1fX19mZmZpaWlqamptbW1xcXF0dHR2dnaBgYGDg4OGhoaLi4uNjY2Pj4+RkZGTk5OVlZWZmZmnp6esrKyurq6urq6xsbGysrKzs7O5ubm7u7vDw8PJycnJycnLy8vNzc3R0dHT09PX19fY2Njb29ve3t7e3t7g4ODg4ODh4eHk5OTo6Ojt7e3u7u7u7u7v7+/w8PDz8/Pz8/P39/f4+Pj4+Pj5+fn6+vr7+/v7+/v8/Pz8/Pz9/f39/f3+/v7///////8sE84xAAAAa3RSTlMAAwgJCgsQEyEwNDY9RUZOUlRVWlxhYmVmZ2hpamtrbW5wc3N0dHZ2d3p8fICBgoOFhoaMjo+RkpSVlZeYoqWmp6mpqq+wtry9v8DExcvMztHT09TV2N7j5ebm6e3u8fLz9fj4+fr7+/z9/r6GADwAAAHrSURBVEjHzZfXV8IwFMYFZLSFskoaFTfuvfdExb33REVR7///bg89SAtJmp74wPeU5JzfaXNzv5ubhoZ6kzekqAktpae0uKqEvC5IvxTDdsUkPx8aiGCSIgFntDGsY7L0cCMb9cgI04VkD4P1RTFbUR+VDSaxk5JBChtC2FkoRGYxn0h0EHHCqPbPfUnMq2R11DxRzK9o1YnJ2I1ke14hVzCy5VoYu1PY6gXdJaxbXBLhIsY7LB6r+JeLzb4PW2Z//pZ42C3YtE6lMhzjYHdgz15byvXKGW3ehfO0fcnL64j0AdxmyP5QnNj2I3gZrV5UTFh1YDtPoThfs6qacILNdl8BbNQuJ0xYY7L911AVaFOaCdtNMbHSZJ0O3gBctJLMYcL2xJ7+Oe6tzEYeAO4yxPQmfRmvw8NMeTz5CJAfI24nRd5zDj63W0qjqWeA4gI5Fho52ulTgLMBYzD3CgBZSiDjlHPuMoL0tISX3wx2n3YKKi3Dho3f/T4pGOxlGw1WqLk9+wEl3fc41X6Sq9ZKLCXQVlcR/Zwz2K9FOhtjVZL0YSG/yshaiV3DhvpYKe93WT1tHco/1W2hG0PsrhK6JcXuZ6HOQKwnEeuGxPowsQ5QrPcU63rF+m3BTl/wjWF53SAdaQmXr5v61y8Xrf2HIHF9kAAAAABJRU5ErkJggg==";

var img$7 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADwAAAA8CAMAAAANIilAAAABMlBMVEUAAAAAAAAAAAAAAAAAAAAzMzMqKiokJCQgICAcHBwaGhoXFxcVFRUnJyckJCQiIiIgICAeHh4cHBwbGxsaGhokJCQjIyMhISEgICAfHx8dHR0cHBwbGxsaGhoZGRkYGBggICAfHx8eHh4cHBwcHBwbGxsaGhoaGhogICAfHx8eHh4eHh4dHR0cHBwcHBwbGxsbGxsaGhoZGRkZGRkdHR0cHBwcHBwbGxsaGhoaGhoeHh4dHR0dHR0cHBwcHBwbGxsbGxsbGxsaGhoaGhoaGhoZGRkZGRkcHBwcHBwcHBwbGxsbGxsaGhoaGhodHR0cHBwcHBwcHBwbGxsbGxsbGxsaGhoaGhoaGhoaGhoZGRkcHBwbGxsbGxsbGxsbGxsaGhoaGhoaGhocHBwcHBwbGxsbGxu1Ve5bAAAAZnRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB4fICAhIiQlJicoKCkqKywtLi8wMTIzNDY3ODo7PD0+P0BBQkNERUZHSEhJSktMTU5QUVJTVFVWV1hZWltcXV5fYGFiY2RlZmfizdp3AAACc0lEQVRIx92X7VvSUBjGB4NQkxeXs0VDI8xKNEUzoxViSsAoCyF5ETYXO///vxDb2NjOy3bOt67uTxvn/Hiu7dznPs847l9TUiietXqDfudjSUwxket7XwcGcDUbNQ+ytGi+PgWwHloveApUapoAq5tiLAJdU2aAqKYQyhbuQJimb0PY4xmIkJIgoPEqiNY3/LrFFUAj9REOPgd0amDWrAxoVUXYpw/UMCjBVv5Fz4L7dBA+BSy6DHgtozHB5nM/XAVsUuNLNq0xwmZ+CVegsfrJMHCvvTucQDM8lu8GR1ocl/vt3w95xAbTNRcWZ+jf5u4CLPeatNZHcGzszH/ccGtr1qt9MoTm1Fy4gYTOtkU7tTV5fi0M4Cn9hcMTaALoHm2zGwM01DILh2BsrRccRiewACx8IuESz6aFmwKJBWUH3sb6wKb55bPD+uTAu4BA2/YXCJnYcOA3BA8OV6xwUkn2Dq+8Y1cWR6GV8c9sO8XaPJt4Wlm8bSKb7chEukxeZ5vN9B1fY+nFOicw/ilabM/dFeIYnZEledvw2Dn9bH69NSZ5mzuG2ZdLFoCJZNH30JwLd1dtQfv5i5VMPe/Wpiuk/cz3kDBI3/pzek5/gJLksZdDJ8GRP+f7/eDUypkBJbcvtnXW9PQHt8IIf/flNpdjK23KgbPqPRN8FeyLUrcM7BRu6SSDHt5DTvdDalZB24oY7UnZTmIaGr5Gxf5YwfZSPM1qt1cJXVzs1Ixia0ly/1gchaL6QWjju34RUry9GdVvyx0C2t2NRXfrcfkadbqhlpKUHwqZcmPkS5eJeiQwfaOkxFeff471Sbe+L61y/5f+Ah9gSrNLhYDaAAAAAElFTkSuQmCC";

var img$6 = "data:image/png;base64,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";

var img$5 = "data:image/png;base64,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";

var img$4 = "data:image/png;base64,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";

var img$3 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAANwAAADcCAIAAACUOFjWAAAQJUlEQVR42u2de3BU1R3HI4pgq6WA1gfQdoDSjtgZrZ1KcZzxNa0ObWdE/2gr0op22pI0PINAaJIahZCooWaARiwwq0KNdKQMEhR5FAQHAYvYgEPKoyQ8ogtN2L3Z3ezuPf0msVRiILt7zzl77r3f73z/4LG7597f+cw5957zO+fkWBRlmHIYAopQUhShpAglRRFKilBSFKGkCCVFEUqKIpRpqTFobT/YumJndF5tbEpN2/jl8TEL46PKEyNKkoNmJa+ZYfebZvedZPfKbTf+gL/iH/Ff+AA+hg/jK/givo4fwU/hBylCmYaONllr90bKamOPLIvfMjf5pal2zkQh3fhZ/DiKQEEoDoVShPI81Z9sXbI1Om5ZfEhhUgWCqRhF4wJwGbgY1ohPoUTjFNgRfSzQNrw4ayBeyLgkXBguz7ctqL+g3LQ/kruybWQpQLRNY7E727hUXDAum1B6TXUNrYWrY0OLkm4AsXvj4nELuBFC6W6dOG1VbYyOrki4pF1Mqe3E7eCmcGuE0k0Kha1VuyNjq+N98j3DYlfj1nCDuE3cLKE0Ws0ha/GW6DA3d9PpGjeLW8aNE0rjdLrFem5DbPBsH+H4WePGcfsIAqE0Qk1nrKfXxa6dafsTx88aQUAoEBBCmTUdD1pzVsf6TyeO5xkBQViOBwmlXp0NW8++FVM0B+gNIzgI0dkwodSiLQciN89NErtUjBl2hItQKlTDJ9aEQNxDg46ahjYRNISOUEoWeqFFm6MDC4hjhr66wEYAw4RSlt6tb71tfoJgOfeo+QkEk1A6bSCL18SQPEueZBnBREjDhDIzHWmy7lnABlKJ712QONJEKNPU+g8j13E8XKWvn2kjyIQyJSHDAGO/7LL1dOUItYEpHWZBefiUdVclu2ytvrsygbATyu61bl+EU9hZMZ6UEHxC2VUvbotelkcis+beeTaqgFD+X1gTzXmarPuSiTYqglC2Cwv1CYQ5RnX4GsqWkPXw0jg5MM3YJaEl5Esog83WfVV80TbU91clUEH+ghL76XA62/yJ8mxte5STFSJvfJIJkS7wTaXJrHCZo7/XZhvprvZSfz+uFUo8PvM50o3Pl5rfe7RCyXdt976PexNKjkdy/NIsKDvmbFi1rp7vEdrme3RAiUlVziJ6Yx5Sz/y4ciiRfsJMCy/lbWjIJ1ILJRL1mI3mvTw31fmXCqFESjMzdr2aF6w0X10hlEi1Z/151ahc90FZuy/CdTYe9qW5dq2yh0slUGL5Jtci+mE9pKJ1uvKhxMMG12v7Z/142BVQFq3ho6SPjOo2HUpsVcNHSb89XErfnyhHbsfNtDR/preFjYVy4eYoa8if0+KoehOhxLac3D/St8b+lxL3ZZUG5aMB5kr62tgv2CwosbE284CYQyRrf3UJUOIIAu6MT+d07Psv5TwKCVDiaAzWB935xgMYsg8lDhHieTb0Ofebajs/V8oplIVMBaLPd6HjBCJHUOIYQJ5CR3fxgOm2w/MhHUGJ4ylZB/TnnywBRnagxEG+XOpAX2jJhJNznjOHEgdMM/r0hRpL4KEbyuaQ5dsT3+lUPGR2sjmkF8pFzL2ge2osF2+J6oMSK9mGFbGZpHvw8KJkZoseM4HytV0RRpxOpbFctTuiCcqx1UwIolPyg9VxHVCeOG31yedIEJ2S++bbAEY5lFUbdb/iXPuEePAFsWirqK0T2/7lBb9zSLy5X7zwjvjpn8X1s7LAytfmiLxX26/h/WOichOGFRX24ABGOZSjK/StwhlYIGa8Lo4EhYfV2Cwmv6YQi8/j+MRq0fif867hr3vFFyarKvH2ioRaKOsaWrUl895aJrYfEj7Rrn+LO55THtIHqsVHp7op3RZizCKFyb/ARiGU2nKCRpaKfzQIX6nupLixVFU8e+WKwjXijHXB0kveMChvKD0oh2oZnkRX8tYB4UOt/kD0ny4/nn3y2x8cE8mLFY0PqKtQjGqrgnLTfk3Dkw8tEfGkH6FEN/roS+KSXJnBvDxflNYK2+6h6AWb1Q5YAh4lUOau1LGT/lVTxeaDwrfaf1JcMUlaMHvniaotKZWrFEo4b2WbEihHlurou7/9lE+byU7FEmL0M7I2VBFlb4qkbQSUOLxMPpRHmyw9792Pvyz8LDCEESIJPWaumLqqh+dInVDiHfxok2woAzs0jZk/VSt8roq3JYSxeK2ItKVRqHooBRCSDOWEgKajmf642e9QLt7mNIb5NSIaT69Q1VC294GBNslQDi9OEkpXQDmpRoSiaReqAcpvFCdlQll/slXb1CKhdALl2OqLjZBnF0r04ABJGpRLtkYJpflQPrwsQyK1QQmQpEE5blmcUBoOJRKpms5mXqgGKHNSPg03JSiHFCYJpclQ3lnZNfHHTCi/WpiUA2XHCKUglMZC+YPnxbEzTgvVAyV68FRGK3uGcu3eCKE0FsrbnxH1H0soVBuUwEkClGV6j+omlKlDeeOT4p8n5BSqDcqyFA4N7xnKR5bFCaWBUI4oEX+vl1aoHijh8Sm86/QM5S16d+kllKlA+a0/iD3HZBaqDcrvzE1KgFLznqiEskcoB81qX30mV9qgxK6qTqFsDGp99SaUPUKJtZ01e+QXqg1KpC81Bp1Buf1gK6E0B8ovTRWvvKekUH1QThSAyhGUK3ZGCaU5UJasVVWoTigBlSMo59XGCKUhUF41RdoAUHahnNfTqFAPUE6uaSOUhkA5ukKcbHE9lDCgcgTl+OVxQmkIlA+9IFoiXoDyF8vjjqAcs5BQmgLlz5dmkr1rIJQ/WugMylHlCUJJKOX6++UJR1COKEkSSkIp198sSTqC8oZZhJJQSvagWc6gvGaGTSgJpVx/ZYbtCMp+0wgloZTsL09zBmXfSYSSUEr2FZOdQdkrl1ASSsm+NI9QEkqPQcnum1Aa133zRYdQGveiwyEhQmnckNAgDp4TStke7HDwnNOMhNK4aUYmZBBK4xIymLpGKI1LXWOSrzlQMsn3U03hcghjoBxVLk40ewHKKQ6XQ3DhmDlQfnGy2NvoeiglLBzjEltzoIRn/80LUDpdYsvNCIyC8srJYukO10PpdDMCbttiFJTwgOkisNPNUDrftoUbXJkGZcc0nXj7I7dCKWGDK24FaCCU8NDfi3cPuxJKOVsBctNUA6GEvz5H5qnoLts0ldtLmwklPLxIvH/MTVBK216aG/EbCyV86zxRd8JNUMrZiJ9HlpgMJXzHs+LQJ66BUs6RJTzcyXAo4dvKxeGgC6CUdrgTj8EzH0r4x4vE8WbToZR5DB4PDDUfSviBavFxyFwoJR8YyqOVXQFle6riIhEMmwulzKOVeQi9W6CEf7NCNLeaCKXkQ+ihxwJthNIVUMK/ellYMeOgfDzQJhnKwA5Nj5VPrvM7lPM3SAjjjNdFOGYQlOi7gZBkKDtGK3VkZvwy4Gsik7b4XY2cSP52pYjFzYHSTmWEMj0ooZGlOh4rcepgNO5fKGMJ8d0yOZHslSuK1opE0ggobypNpk5aGlDmrtTxWHnlFFFb518o9zaIvpOkBRNclm9ob32zDmXeyjYlUG7ar2kS/Cd/SqPf8ZIAz8+WSg7mZXntiyh6bC+VQokHSsCjBEpoaJGOHvzyfLH6Az9C+cqu9o5Cejx754mn14u2xMWKrtyksEKHFSXTwiw9KAtXa0pjG1okth/yF5HvN4jhxQoXIUx67YLzPWih8fSprjaBjUIo6xpa9byDwyNKxPr9fiFyS734XrnykP6wSnzQ2D2U+C91793ARiGU0OgKfbsLXTVV/HqF2HPMyzgiG3LCS6L/dE0hvWGWmPgX8dGp867hpfdkvl118e0ViXQZSxvKqo26V4IPKBB3VoqSN8TL74m1H3rEK3aJp2rFvc+LgQVCczzh62a2v1G9ukdsONDecQ8oUPiKA2CUQ3nitNUn39YfR9qN7ptvAxjlUEJjq+MMN52KH6yOZwBYJlCu2h1huOlU+m6gognKUNgaVpRk0OmeFlsmgYomKKHFW6IMOn3xZhKQZEZXhlA2h6zBs9lY0hf0kNlJQKIVSui5DTGGnr5QMwk8MkYrcyhPt1jXzuTYEN3tOKgNPLIAJfT0OjaWdDfNJMBwwpUjKJvOWP2ns7Gku+ygaQOMrEGpM2+IdovnrI45hMoplMeDundVpU029kQ9HrSyDCX07FtsLOlPnyYBg3OiJEB5NmzdPJdjlrTAps9nw5YRUEJbDkS0Jf/SpjaTNjCQgpMcKKEJAaYO+dqPBeKyWJIGZcMn1sACNpY+9dUFNgAwDkpo0WZmafj0/QZVLxEkmVDiGfe2+QlWkt88an4ibFmGQgm9W9/aK5eduI98aa6NSrdMhhIqXsNhSx8Z1S0dIflQoiW/ZwE7cV/43gWSO25VUEJHmqzrmNXmdV8/0z7SpAIfNVBC6z+M8OHS24+SqGJF8KiCEprDBCKmApkGJVay3VXJh0sP+u7KRChsuRJK6PApLpnw4FIHVKtSqYUSWrcvclkeufSIe+fZqFDVzCiHEnpxW5Q5RN7IA0JVagBGB5TQvFq+9Lh+gntebUwPLZqghKbUtLFq3WtUnzZU9EEJPbyUOZeu9LilcZ2caIWyJWTdV8VBIpf5/qpES8jyLJRQsJnpbS5LS0OVaZZuKKHGoKbDy2iHxjFhjUH9gGQDyk4u2V6a30ZmhcisQdnZj/P50uTnSP29dvah7Hzv4fu4me/amt9sDIKS45c+H480F8r/zfdwHjL7s4ja5mxcAGXn/DjzNrKbaaFnXttNUHbmEzHPLVvZaBpyf1wJZWf+JfOC9Wfsqs6PdDeUVke+OlLtub5HgxFkhFppDrlHoOxU7b4I10OqXotYa1KX7QIorY51ulw/rm69tqLVsR6H0urY16BoDbtyyV02Qhq2jFaOZbywVQ0nymVNZ0vf98enUHY2mQs3R7n/ZcbG/pEIYNhyh3Is9wjbcj7avl8w0UzLNoImcUdTQtmNsLE29/1P0dgZX9Y+5ISyB+EIAhyNwfN7LmIEByE6G3Zj9boTyk7hECGcd8Zz+LoYAUFYjgfdW7FuhrJTOAYQx1Ny0hxGEBAKh+ciEkppwkG+OGB68GyfPmvixnH7Tk4zJpSq1BxqP6FiWJGP0MTN4pabQ16qRm9B2SlkGKzaHRlbHe+T79k+HbeGG8RthsLeq0AvQnlOJ05bVRujoysSHhratHE7uCncmoflZSjPqa6hFS+kQ93crePicQu4ET/Uly+gPKdN+yO5K9s6tkJwRdtp41JxwbhsX1WTv6A8p6NNVmBHdEKgbXixcc0nLgkXhss72uTPyvErlJ9V/cnWJVuj45bFhxRmDVAUjQvAZeBiWCOEsmsLunZvpKw29siyOCaOFc1k4mfx4ygCBaE437aIhDJDYT+d7QdbV+yMYk305Jq28cvjYxbGR5UnRpQkb5iVvGaG3W+a3XeSjeRZGH/AX/GP+C98AB/Dh/EVfBFfx4/gpxqDDCqhpAglRRFKilBSFKGkCCVFEUqKIpQUoaQoQkm5XP8FFQcbZdE2768AAAAASUVORK5CYII=";

var img$2 = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHwAAAB8CAYAAACrHtS+AAAQtElEQVR4Xu1de3BcV3n/vnN3V17LwRLEBqe0rhPZtAOBe67WsZAxIENj4saxCaAOjR2ThILzMOQFTUlKlHSatgOBBgohLTgJBELcB3VK3DgJiGJbkazde7eTaafEaSBlEkU2EzsPZGutPV/nc++qeu/dve/VPTP+w6N7vtfv3rPn8X2/g5C0eRUBnFfeJs5CwwHe19f3+kwm0woAi4UQKxDxbABYhohnEdHrASANAAtt7EcAoISIx4joBQAYIqJny+XyswDw8qlTp453dna+1EjvSawB7+vry2qa9pvpdLoDEXVEbCOi5TbAS9wARURH+QUAgF8AwH8TUfHUqVP95XL5l52dnSfcyA6zb+wAHxgYWJFOp9uFEO8GgPcSURsiZoMIIhHxiPAMIv6bUuqniJiXUvILEZsWC8AHBwfP1jTtXYjYDQCSh+coRJiIngeA/0TEfxwdHX1szZo1P4+CXXPZEFnAe3t7F7S0tKwDgI8h4noAeFPEg/kiEfUqpb73yiuvPNHV1XUyivZGDvD9+/e3Njc3X4yIVwDAakRMRTFwc9ikiKgfAO4dGRl5eO3atUeiZH9kAO/v739jU1PTNkT8OAC8JUpBqtcWInqGiO5WSj2Yy+V4Ahh6Cx3wffv2NS9ZsuRyIcRVAPA7oUfEBwOI6DAA3HX8+PH7u7q6XvNBhWORoQJeLBbPJ6KbEZFn3A3fiOhJROzRdf2xsJwNBXDTNJcj4q2IeAkAZMJyPiS9o0T0kFLqz9rb258J2oagAUfTNLcKIW4DgBVBOxsxfb9USt1sGMYDAEBB2RYY4Pl8fpmmabch4h8F5VxM9OwCgM/rus5ret9bIIBbltWJiN8AgHN99yieCp4aGxu7KpfLHfDbfN8BN01zByLejoiu9rb9DkQE5L9kD/H8YfjWfAM8n8+nNU3jidnNvlnfmIL/8umnn761u7u75Id7vgBuWVYLAHwJES/zw+hGl0lE3y6Xy5/K5XIve+2r54AfPHhw6cKFC+9FxI1eGzuf5BHRv46Ojl7W0dEx7KXfngLOYDc3N98PAB/w0sj5KouIHh8ZGdnq5X68Z4DbX/Z3EPH8+QqQT37vU0ptMwyDEzJcN08A57SibDb7ACJe4NqiRMC0CBDR3hMnTmzzIt3KNeC7d+/OrFy58h5E/FiClX8RIKL7Dx8+/Am3s3dXgPf09IjNmzfzGjtZevmH9bhkIrpDSnmLm61YV4CbpnmlEOJvAEAE4O+8V0FEZSLaaRjG3fUGo27ALctaCwB7EPEN9SpP+tUeASL6FQBskVIerL031JeXbs/If4yIb61HadLHXQSI6D9GRkbW17Ncq/kL3717t7Zq1ap7AIBzzpIWUgSI6Jt79uz5ZE9Pj6rFhJoBLxaLWwGAN1eS3+1aIu39swz0dl3X+TzdcasJcM4PT6VSvYj4W441JA/6FgEiem5sbGz96tWruTTKUXMMuL0E24WI2x1JTh4KJAK8PpdS8iGVo6wZx4AXCoUNmqb9MwAsCMSTRInTCJxUSm0yDOMJJx0cAd7b27uotbX1cQDocCI0eSbYCBBR35EjR87fsGHDr6tpdgS4aZo7hRBfqSYsjL/zZgQicllPcxj6I6Rzp67rvAk2Z6sKuL3m7kPEc6oJC+Hv+4joq4h4lIjegYifAoC3hWBH6Cq52IGI1lY7VasKuGmaNwghvhi6R9MNMMfGxjbkcjneeTrd+OXMZrPXc10aIp4ZQZt9NYmIrpNS/vVcSuYEPJ/Pn6lpGn/dK321tA7hXLEipbxjpq6mafLX/hkA+IMYFiPWEY3xLj8bGRnpnOsYdU7ATdO8QgjxTTcW+Nh3h67rvOM3azNN8wIhxJ8AAJcdz4dGSqmPG4bBue4ztlkB5/rs1tbW3qjOzJVSVxqGUTWlt1KsiIh/jIi/0eioc/3a8ePH189Wnz4r4IVC4QOapj0S1S1Up4BXAM7n8+ekUqlPA8DlDT6jV+VyeWN7e/u+mV7u2QBHy7K+i4gfjeoXUSvgE4Bfk0qlOIngwqj65tYuIvqulJLPPKa1GQG3LOu3EZFZDN7oVrlf/esFnO3htKxVq1Zx5epnG7QmfVgptcYwjOemxn82wJlX5V6/wPJCrhvAK/oPHTr0pnQ6zaVQOwGAOdwapimlthuG8W2ngO+NegaqF4BXglEsFt9KRJ9FRB4GG+LYlzNdpZS/XxVw5kHLZDIHEXFZlF93LwFnP/k0cMuWLZuJ6CZEPC/KvjuxjYiYVfKdU4f1aUO6aZofEkLsjvqb7jXglSAeOHDgjEWLFjGx0PUA8GYnwY3oMzxb/0h7e/s/TbRvJsC/KoS4JqJOjJvlF+AVBTzSNTU1XU1EVyJihZs16mGZat9XdF3npeh4mwS4vdlyKA6F+34DPuH3vQsAOO/+fXFDm4j+fWhoaM3GjRtHK7ZPAnxwcPAtqVTKCoq71E0AgwKcbWQS32w2y2SBvH6PDbWYzQ2rSymZNux0mwS4ZVnb7eVY1VM0N2B50TdIwCv2MnngggULrgYA/heHZRzvrfPy7DuzAc5F/Nd5AYjfMsIAvOJTPp8/V9O0zwPABxFR89tXN/KJ6MtSSp6ATvvCsVgs7gGATW4UBNU3TMDZR17GXXTRRRfap3GRTf0iooellFsqSY7jQ7dd8sspyG8PCjQ3esIGvGI75/u1tLRwUcZnongaxxO31157rWvdunXHJv2G2znn/XFhW4oK4BOG+XM0TbsBES+N2GnckdHR0Y4Kl/v4F57P541UKjUY9Q2XSoCjBvgE4N/Fv++I+P6pk2I3I5qLvkzn3S6lLE76wk3T/LAQ4u9dCA60a1QB5yDwaVxbWxvvWPLELgrLuIt1Xf/BJMAty+LDg78KFDUXyqIMeMUtm+SIVz2cdLHUhbuuuiqlbjQM486pgH8ZEa91JTnAznEAvBKOwcHBt6XT6VuI6MMhLePu1HX9xkmAF4vF73OWZ4CYuVIVJ8ArjlqW9QlE5IKOJlfO19iZiB6UUv7hVMAfBYANNcoK7fE4As7BsixrNyJ+JODAParr+mmGrfFZumVZP0HE9wRsSN3q4gq4aZo3CSH+om7H6+hIRD+RUvIh0CTAB+J08B9XwC3L+joiXlkHbm66DOi6fno3cOIXngDuJqQO+tpESD8IYXNrRsCTId0BaPU80t/f/7qmpqZPcpZsGDVvMw7pxWIxmbTVg+YcfewDFj5R46qX1R6LdyyOmZmllKfZrceH9GRZ5jh+jh4sFApvF0L8KSJeHPZ29YzLMsuyYnMWzhGP6qTNznXfiYg7IpQkMX3jxbKsGxHxC45e3wg8FDXA7Ss/LkHEm6J2laZS6gbDML40aUi305P/IQJYOjIhSoAXCoV19vD9e46MD/6h6Ycng4ODMp1O58P+vXEaiygAzhWpmqbx4chlEU5lnvl4NEmAcPqqAXCxQnNzMy+zrovK5fVzWD9zAkSS4uQM8EKhsEnTNM5TX+OsR7hPzZrixEu0JIlxdnAsy9J5QkZEH4oTb8ysSYzsapyWZkH9hleYoYQQfGdqHHLRp76140uySbN0/o9pmpcKIe6LSC7WnGOh34DbpAHddplRFNKU6vltYP7VSycyLk+qMBkYGFiVyWS41CjyxXN+Am6a5nt4mQUA6+Pw8s/xJvy6XC7rE+8pnwT43r17m5YtW3YoDrnpfgBuWRbz0TG/29Y41NdV++SJqDg0NNQxazGhPazPu3JhLiZYvHjx5fYhx1nVAhmXvxPRXVLKSXmK85oQgE+zNm3atEUIwawPoZ1m+fQCOSMEYAYnrpBtdMoPe2eRM0k3h5RJ6hPO/yfWMeWHvTx7JOq3A9f7G26zQ19lMy+3+hr1cIX/UNf1aYWh84a2i9ktFi9e3G1Xe8Z1meX4FVJKXTqxLrzScUbATdNcLoQYaBRivkKhsF7TtM/FkbbDMcKTH3xRKdXhmJiP156WZfFtwaeT1yPaqrIp2/ORaxGRDzrmzV0tRPSAlHLbTLjFmVx3vF5qqmOWZbUAAFNvMdgNz6A8xX++z+wCXdcfqwnwqNNnA8CPjh07duFEmmi+NbGtre2D9u+0EdGRyVezmD57aGioa+Jmy0SF1QjyLxdCfMtXC10IJ6KvlUqlO8vl8ovZbFYCwDVRZoB24arTrrx3foWu67Py5M4J+MDAwBsymcyTUbwCoxIB+7Zdvr5pSRzOAJwiV+dz//Xqq692Vug9ahrSKw+bpnm9EOJ0bXHSoh0BIrpWSnnXXFZW5WMzTZO/HCbbjdxFN9EOf7DWeXaNFZttWdbViFj1ErRgXUy0TYwAEV0jpfxatahU/cJZAF8Us3Tp0n2IuLaawOTvoURg//Dw8AWeXUXJLpim+X4hxL/Mpw2MUKCrUSkRnSAivmz2R066OvrCWVBynbSTcAb/DBHdJ6Vk0iBvr5NmV+zc9R8j4vLgXUs0To0AEf2iVCqtr5DuOYmQ4y+8IsyyLK6f4stTGuJuECdBiugzvIW6fWKCohM7awbcHtrvQUTeq05aSBEgor/bs2fPjp6eHgbecasZcHsCt0QIwZOEcx1rSh70MgJPKaXeV+3q6JkU1gU4CyoUCh08aw+DwsLLyMVNFhEdVUpd1N7ezhcJ1tzqBpw1FYtFPmf+evJ7XnPc6+pARGUAuEpK+bd1CfAgyR5N07xdCMF3gSTN5wgQ0Z9LKblAwtESzNMhvSKMmQ9SqRRf68xrwaT5F4FdY2NjO3K53Ck3KlwN6RXF+/fvbz3jjDN4qdawN/a6CbIHfX9IRNuklMfdyvIEcDYin8+fmUqlHogTX6vb4AXU/1E7A/WoF/o8A5yNsXO+dyHitEtOvTB2vskgoseJ6JJ6ll+zxcpTwFmJfX5+bwK6u9eTiB4ZHR29oqOjY9idpMm9PQfcHt4Xp1IppolKJnJ1oEVE95fL5U/ncrmX6+g+ZxdfALdBT2uadisicgGAb3q8DkjI8oiI7jh8+PDt3d3dJT9s8R0Iy7J4z/2OEBiE/YiXnzJfAoDP6bp+j59KfAfc/l1/JyLejYjv8NOZuMrmwn2+z1RK2ee3D4EAzk4wB2kmk7kVAJiDNGn/H4FvlUqlW84777wXgwhKYIBXnCkWi1sB4HYAWBGEg1HVQUTPMWGQlPJ7brZKa/UvcMDtIZ6rU/kSt0uCvuGn1gD58PxJInqoVCrdVkumild2hAJ4xXhOjORL2ON0uY7LwB9QSt1mGMYTLuXU3T1UwO3l20JN0y7jSQsi/m7dnkS749NMsFMul+/L5XIjYZoaOuAV523Gw60242GjMDT8jIi+US6XH8rlckNhAl3RHRnAKwbxyduiRYs22/Xda+LEa2r7wHTVTxLRLqXUw7lc7ldRADqygFcMs0kC383UkUzVEXVWKWZNAoBepdSDw8PDj89Wnx02+JH7wmcKyMDAwIpMJsObNx8lIhkVVgcieh4RnyKi75dKpZ+GMeuu9QWKBeATnWLeFqWUIYTgr/+9ALAyqLpwIuIJ12H7S96PiIWZiHNqBSHI52MH+MTg9PX1ZbPZ7JuJiDNodSJqA4Dl9vC/xMWhDeeMHSWiFwDgfxDxGaVUkX+bR0dHn+/s7DwRJEhe6oo14DMFgm92SKfTLalU6nVKqbMRcYUQYhkRnYWIrUTEbE4VtugRROSNkGOI+IJSakgI8SwR/XxsbOyVkydPHpuLTcFLIIKS1XCABxW4uOpJAI8rcnXa/b/ScrTX69IGcwAAAABJRU5ErkJggg==";

var img$1 = "data:image/png;base64,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";

var img = "data:image/png;base64,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";

var css_248z$3 = ".voice-module_rightWrapper__10_6g {\n  flex: 1;\n  width: 100%;\n  overflow: auto;\n  background-color: #ffffff;\n}\n.voice-module_rightWrapper__10_6g .voice-module_searchForm__1jpPB {\n  padding: 25px 25px;\n}\n.voice-module_checkBox__3H7Rp {\n  padding-top: 12px;\n  margin-right: 10px;\n}\n.voice-module_emptyContent__w2rkw {\n  display: flex;\n  width: 100%;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.voice-module_wechatInfo__2w5PS {\n  display: flex;\n  align-items: center;\n}\n.voice-module_wechatInfo__2w5PS .voice-module_avatar__1NXSZ {\n  margin-right: 10px;\n}\n.voice-module_searchContentWrapper__1Ggt6 {\n  height: 400px;\n  overflow: auto;\n}\n.voice-module_searchContentWrapper__1Ggt6 .voice-module_itemInfo__2z7nH {\n  cursor: pointer;\n  line-height: 22px;\n  border-bottom: 1px solid #e8e8e8;\n  margin-bottom: 5px;\n}\n.voice-module_searchContentWrapper__1Ggt6 .voice-module_itemInfo__2z7nH .voice-module_name__2Ih9F {\n  font-size: 14px;\n  padding: 3px 0;\n}\n.voice-module_searchContentWrapper__1Ggt6 .voice-module_itemInfo__2z7nH .voice-module_content__2-BYa {\n  max-width: 300px;\n  word-break: break-all;\n  font-size: 12px;\n}\n.voice-module_chatWrapper__2_kx2 {\n  width: 100%;\n  height: 100vh;\n  overflow: hidden;\n  min-width: 960px;\n  display: flex;\n  background-color: #f3f3f3;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_sidebar__3y4v1 {\n  width: 160px;\n  height: 100vh;\n  flex-shrink: 0;\n  background-color: #3b3b3b;\n  color: #ffffff;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_sidebar__3y4v1 .voice-module_avatar__1NXSZ {\n  text-align: center;\n  padding-top: 50px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_sidebar__3y4v1 .voice-module_nickname__2XxD_ {\n  text-align: center;\n  font-size: 16px;\n  color: #ffffff;\n  padding: 16px 5px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_sidebar__3y4v1 .voice-module_chatMenu__2GeOH {\n  padding-top: 10px;\n  padding-left: 30px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_sidebar__3y4v1 .voice-module_chatMenu__2GeOH .voice-module_menuItem__3VsrR {\n  display: block;\n  cursor: pointer;\n  font-size: 14px;\n  margin-bottom: 30px;\n  line-height: 20px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_sidebar__3y4v1 .voice-module_chatMenu__2GeOH .voice-module_menuItem__3VsrR.voice-module_active__2JrBZ {\n  color: #217af9;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv {\n  position: relative;\n  width: 360px !important;\n  height: 100vh;\n  flex-shrink: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid #cfcfcf;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv .voice-module_searchPart__3QZ_9 {\n  padding: 18px 24px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv .voice-module_tabContent__2dkGu {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  height: 0;\n  overflow: hidden;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv .voice-module_searchWrapper__20k2r {\n  position: absolute;\n  top: 70px;\n  width: 100%;\n  bottom: 0;\n  overflow: auto;\n  z-index: 99;\n  background-color: #ffffff;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv .voice-module_searchWrapper__20k2r .voice-module_friendItem__16R0X {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  padding: 16px 16px;\n  align-items: center;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv .voice-module_searchWrapper__20k2r .voice-module_friendItem__16R0X .voice-module_friendImg__1VuRE {\n  margin-right: 10px;\n  width: 44px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv .voice-module_searchWrapper__20k2r .voice-module_friendItem__16R0X .voice-module_descContent__2NpE6 {\n  font-size: 16px;\n  font-weight: 400;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  color: #1a1a1a;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv .voice-module_searchWrapper__20k2r .voice-module_friendItem__16R0X::after {\n  content: \" \";\n  position: absolute;\n  height: 1px;\n  background: #e4e4e4;\n  left: 16px;\n  bottom: -1px;\n  right: 0;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q {\n  flex: 1;\n  overflow-y: auto;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q .voice-module_friendItem__16R0X {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  padding: 16px 16px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q .voice-module_friendItem__16R0X .voice-module_friendImg__1VuRE {\n  margin-right: 10px;\n  width: 44px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q .voice-module_friendItem__16R0X .voice-module_descContent__2NpE6 {\n  overflow: hidden;\n  flex: 1;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q .voice-module_friendItem__16R0X .voice-module_descContent__2NpE6 .voice-module_tit__2xVAc {\n  font-size: 16px;\n  font-weight: 400;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  color: #1a1a1a;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q .voice-module_friendItem__16R0X .voice-module_descContent__2NpE6 .voice-module_desc__1CEz7 {\n  font-size: 12px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-weight: 400;\n  color: rgba(26, 26, 26, 0.7);\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q .voice-module_friendItem__16R0X::after {\n  content: \" \";\n  position: absolute;\n  height: 1px;\n  background: #e4e4e4;\n  left: 16px;\n  bottom: -1px;\n  right: 0;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q .voice-module_friendItem__16R0X.voice-module_active__2JrBZ {\n  background-color: #d6d6d6;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF {\n  width: 100%;\n  height: 100vh;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: auto;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_headerChat__3Itte {\n  padding: 20px 30px;\n  height: 120px;\n  overflow: hidden;\n  border-bottom: solid 1px #e8e8e8;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_headerChat__3Itte .voice-module_uname__3uW5D {\n  font-size: 18px;\n  font-weight: 500;\n  color: #1a1a1a;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_headerChat__3Itte .voice-module_subHead__CdyJo {\n  display: flex;\n  padding-top: 2px;\n  margin-bottom: 10px;\n  justify-content: space-between;\n  align-items: center;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_headerChat__3Itte .voice-module_subHead__CdyJo .voice-module_searchTool___OPug {\n  white-space: nowrap;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_headerChat__3Itte .voice-module_subHead__CdyJo .voice-module_btnUsers__2mh42 {\n  cursor: pointer;\n  font-size: 18px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- {\n  flex: 1;\n  position: relative;\n  padding: 20px 20px;\n  overflow: hidden;\n  overflow-y: auto;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_ant-drawer-content-wrapper__yKrPi {\n  box-shadow: none !important;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_linkMore__2noT3 {\n  text-align: center;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 8px 5px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_tips__2w3GY {\n  text-align: center;\n  padding: 10px 10px;\n  font-size: 12px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz {\n  display: flex;\n  flex-direction: row;\n  max-width: 100%;\n  padding: 10px 0;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz .voice-module_tipmsg__10LC1 {\n  font-size: 12px;\n  text-align: center;\n  width: 100%;\n  color: #b2b2b2;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz.voice-module_right__flf7V {\n  flex-direction: row-reverse;\n  text-align: right;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz.voice-module_right__flf7V .voice-module_mAvatar__3FbWx {\n  margin-right: 0;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz.voice-module_right__flf7V .voice-module_checkBox__3H7Rp {\n  margin-left: 10px;\n  margin-right: 0;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz.voice-module_right__flf7V .voice-module_corner__30d4N {\n  color: #ffffff;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz.voice-module_right__flf7V .voice-module_corner__30d4N::after {\n  border: 5px solid transparent;\n  border-left-color: inherit;\n  width: 0;\n  height: 0;\n  position: absolute;\n  content: \" \";\n  right: -10px;\n  left: auto;\n  top: 10px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz.voice-module_right__flf7V .voice-module_mContent__3n2Hy {\n  margin-right: 10px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz.voice-module_right__flf7V .voice-module_mContent__3n2Hy .voice-module_messBox__3vKtu {\n  position: relative;\n  background-color: rgba(33, 122, 249, 0.4);\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz.voice-module_right__flf7V .voice-module_mContent__3n2Hy .voice-module_messBox__3vKtu:after {\n  border: 5px solid transparent;\n  border-left-color: rgba(33, 122, 249, 0.4);\n  width: 0;\n  height: 0;\n  position: absolute;\n  content: \" \";\n  right: -10px;\n  left: auto;\n  top: 10px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz.voice-module_right__flf7V .voice-module_mContent__3n2Hy .voice-module_messBox__3vKtu.voice-module_meColor__1Pg3P {\n  position: relative;\n  background-color: rgba(33, 122, 249, 0.4);\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz.voice-module_right__flf7V .voice-module_mContent__3n2Hy .voice-module_messBox__3vKtu.voice-module_meColor__1Pg3P:after {\n  border: 5px solid transparent;\n  border-left-color: rgba(33, 122, 249, 0.4);\n  width: 0;\n  height: 0;\n  position: absolute;\n  content: \" \";\n  right: -10px;\n  left: auto;\n  top: 10px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz .voice-module_mAvatar__3FbWx {\n  width: 44px;\n  margin-right: 10px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz .voice-module_mContent__3n2Hy .voice-module_miniTitle__2cGiO {\n  font-size: 12px;\n  padding-bottom: 5px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz .voice-module_mContent__3n2Hy .voice-module_messBox__3vKtu {\n  display: inline-block;\n  text-align: left;\n  padding: 10px;\n  background: #ffffff;\n  border-radius: 3px;\n  position: relative;\n  word-break: break-all;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz .voice-module_mContent__3n2Hy .voice-module_messBox__3vKtu .voice-module_thumbImg__1GOIL {\n  max-width: 100px;\n  max-height: 230px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_chatContent__2uYYF .voice-module_chatBox__1qp6- .voice-module_messageItem__3V5Oz .voice-module_mContent__3n2Hy .voice-module_messBox__3vKtu:after {\n  border: 5px solid transparent;\n  border-right-color: #ffffff;\n  width: 0;\n  height: 0;\n  position: absolute;\n  content: \" \";\n  left: -10px;\n  top: 10px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_groupMember__27AS2 {\n  padding-top: 20px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_groupMember__27AS2 .voice-module_member__1upoz {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 15px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_groupMember__27AS2 .voice-module_member__1upoz .voice-module_iconGen__3bP8E {\n  cursor: pointer;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_groupMember__27AS2 .voice-module_member__1upoz .voice-module_iconGen__3bP8E img {\n  width: 22px;\n  height: 22px;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_groupMember__27AS2 .voice-module_member__1upoz .voice-module_mName__29XLB {\n  flex: 1;\n  overflow: hidden;\n  padding: 0 10px 0 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.voice-module_chatWrapper__2_kx2 .voice-module_groupMember__27AS2 .voice-module_member__1upoz .voice-module_mTag__3zhUf {\n  cursor: pointer;\n  margin: 0;\n}\n.voice-module_messBox__3vKtu span {\n  color: #f00;\n}\n.voice-module_newTabHeader__1pqGf {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 12px;\n}\n.voice-module_newTabHeader__1pqGf .voice-module_tabItem__2mlY7 {\n  flex: 1;\n  padding: 10px 0;\n  cursor: pointer;\n  text-align: center;\n  border-bottom: 3px solid #fff;\n}\n.voice-module_newTabHeader__1pqGf .voice-module_tabItem__2mlY7.voice-module_active__2JrBZ {\n  color: #217af9;\n  border-bottom: 3px solid #217af9;\n}\n.voice-module_right__flf7V .voice-module_chatCard__1-6ae::after {\n  border-left-color: #ffffff;\n  border-right-color: transparent;\n  right: -10px;\n  left: auto;\n  top: 10px;\n}\n.voice-module_chatCard__1-6ae {\n  width: 240px;\n  position: relative;\n  display: inline-block;\n  background-color: #ffffff;\n  padding: 12px 12px;\n  text-align: left;\n  border-radius: 3px;\n}\n.voice-module_chatCard__1-6ae:after {\n  border: 5px solid transparent;\n  border-right-color: #ffffff;\n  width: 0;\n  height: 0;\n  position: absolute;\n  content: \" \";\n  right: auto;\n  left: -10px;\n  top: 10px;\n}\n.voice-module_chatCard__1-6ae .voice-module_cardBody__2F7oC {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border-bottom: 1px solid rgba(26, 26, 26, 0.05);\n  padding: 0 0 10px 0;\n}\n.voice-module_chatCard__1-6ae .voice-module_cardBody__2F7oC .voice-module_avatar__1NXSZ {\n  width: 44px;\n  height: 44px;\n  overflow: hidden;\n  border-radius: 3px;\n  margin-right: 5px;\n}\n.voice-module_chatCard__1-6ae .voice-module_cardBody__2F7oC .voice-module_avatar__1NXSZ img {\n  width: 44px;\n  height: 44px;\n}\n.voice-module_chatCard__1-6ae .voice-module_cardBody__2F7oC .voice-module_text__3cmmr {\n  flex: 1;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.voice-module_chatCard__1-6ae .voice-module_cardFooter__1o_cJ {\n  padding: 10px 0 0 0;\n  font-size: 12px;\n}\n.voice-module_fileCard__3bMmx {\n  width: 300px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n}\n.voice-module_fileCard__3bMmx .voice-module_context__3T22N {\n  flex: 1;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  padding-right: 12px;\n}\n.voice-module_fileCard__3bMmx .voice-module_iconPic__cgKft {\n  width: 72px;\n  height: 72px;\n  border-radius: 3px;\n  overflow: hidden;\n}\n.voice-module_fileCard__3bMmx .voice-module_iconPic__cgKft > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.voice-module_messBoxPic__3_D-j {\n  max-width: 300px;\n  display: inline-block;\n  justify-content: flex-start;\n}\n.voice-module_messBoxPic__3_D-j img {\n  max-width: 300px !important;\n}\n.voice-module_NullMessBoxPic__2aL9l {\n  max-width: 300px;\n  display: inline-block;\n  justify-content: flex-start;\n}\n.voice-module_NullMessBoxPic__2aL9l img {\n  max-width: 70px !important;\n}\n.voice-module_right__flf7V .voice-module_commonBox__7XmNB::after {\n  border-left-color: #ffffff;\n  border-right-color: transparent;\n  right: -10px;\n  left: auto;\n  top: 10px;\n}\n.voice-module_commonBox__7XmNB {\n  display: inline-block;\n  position: relative;\n  background-color: #ffffff;\n  border-radius: 3px;\n  padding: 10px 12px;\n}\n.voice-module_commonBox__7XmNB:after {\n  border: 5px solid transparent;\n  border-right-color: #ffffff;\n  width: 0;\n  height: 0;\n  position: absolute;\n  content: \" \";\n  right: auto;\n  left: -10px;\n  top: 10px;\n}\n.voice-module_linkBox__UzTS7 {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  align-items: center;\n  text-align: left;\n  cursor: pointer;\n  width: 300px;\n}\n.voice-module_linkBox__UzTS7 .voice-module_linkText__lZi44 {\n  flex: 1;\n  font-size: 14px;\n  padding-right: 10px;\n}\n.voice-module_linkBox__UzTS7 .voice-module_rightImg__2eflI {\n  width: 44px;\n}\n.voice-module_linkBox__UzTS7 .voice-module_rightImg__2eflI img {\n  display: inline-block;\n  width: 100%;\n}\n.voice-module_right__flf7V .voice-module_voiceContent__kZ1i3 .voice-module_voiceTip__3NZrt {\n  text-align: right;\n}\n.voice-module_right__flf7V .voice-module_voiceContent__kZ1i3 .voice-module_explainText__2JH08 {\n  text-align: left;\n}\n.voice-module_right__flf7V .voice-module_redBagBox__3P-Sa {\n  margin-left: 0;\n  margin-right: -8px;\n}\n.voice-module_voiceContent__kZ1i3 {\n  display: inline-block;\n}\n.voice-module_voiceContent__kZ1i3 .voice-module_voiceTip__3NZrt {\n  padding: 3px 0;\n  text-align: left;\n  font-size: 14px;\n  cursor: pointer;\n}\n.voice-module_voiceContent__kZ1i3 .voice-module_explainText__2JH08 {\n  margin-top: 5px;\n  border-radius: 3px;\n  background-color: #fff;\n  padding: 10px 10px;\n}\n.voice-module_voiceContent__kZ1i3 .voice-module_explainText__2JH08 .voice-module_text__3cmmr {\n  margin-bottom: 5px;\n}\n.voice-module_voiceContent__kZ1i3 .voice-module_explainText__2JH08 .voice-module_status__2qv8i {\n  font-size: 12px;\n}\n.voice-module_voiceContent__kZ1i3 .voice-module_explainText__2JH08 .voice-module_status__2qv8i img {\n  margin-right: 4px;\n  width: 11px;\n  height: 11px;\n}\n.voice-module_voiceBox__3vhh2 {\n  display: flex;\n  width: 200px;\n  line-height: 1;\n  align-items: center;\n}\n.voice-module_voiceBox__3vhh2 .voice-module_iconVoice__1dkPt {\n  width: 12px;\n  height: 12px;\n  margin-right: 8px;\n}\n.voice-module_redBagBox__3P-Sa {\n  width: 257px;\n  height: 108px;\n  margin-left: -8px;\n  text-align: center;\n  padding-right: 10px;\n  background-repeat: no-repeat;\n  display: inline-block;\n}\n.voice-module_redBagBox__3P-Sa .voice-module_tipInfo__RGvLX {\n  padding-left: 70px;\n  height: 80px;\n  display: flex;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  color: #ffffff;\n}\n.voice-module_redBagBox__3P-Sa .voice-module_footer__2iHwT {\n  color: #fff;\n  text-align: left;\n  padding-left: 22px;\n  padding-top: 3px;\n}\n.voice-module_right__flf7V .voice-module_boxContain__LR1jv {\n  justify-content: flex-end;\n}\n.voice-module_boxContain__LR1jv {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n}\n.voice-module_boxContain__LR1jv .voice-module_position__2SmYu {\n  margin-left: 10px;\n}\n.voice-module_boxContain__LR1jv .voice-module_position__2SmYu img {\n  width: 15px;\n  height: 15px;\n  display: inline-block;\n}\n.voice-module_baiduBox__28iLa {\n  width: 300px;\n}\n.voice-module_baiduBox__28iLa .voice-module_desc__1CEz7 {\n  font-size: 14px;\n  padding: 12px 0;\n}\n.voice-module_baiduBox__28iLa .voice-module_map__11Com {\n  width: 300px;\n  height: 200px;\n}\n.voice-module_xiaoChengxu__3EbMc {\n  position: relative;\n  font-size: 14px;\n  width: 200px;\n  display: inline-block;\n  padding: 12px 12px;\n  border-radius: 3px;\n  background-color: #fff;\n}\n.voice-module_xiaoChengxu__3EbMc .voice-module_header__2cWTs {\n  color: #1a1a1a;\n  text-align: left;\n  font-size: 14px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.voice-module_xiaoChengxu__3EbMc .voice-module_imgThumb__2S45O {\n  max-width: 200px;\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(26, 26, 26, 0.05);\n}\n.voice-module_xiaoChengxu__3EbMc .voice-module_imgThumb__2S45O img {\n  max-width: 100% !important;\n}\n.voice-module_xiaoChengxu__3EbMc .voice-module_footer__2iHwT {\n  display: flex;\n  color: #1a1a1a;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px 0 0 0;\n  font-size: 14px;\n}\n.voice-module_xiaoChengxu__3EbMc .voice-module_footer__2iHwT .voice-module_icon__MJPxu {\n  margin-right: 8px;\n}\n.voice-module_xiaoChengxu__3EbMc .voice-module_footer__2iHwT .voice-module_icon__MJPxu img {\n  width: 20px;\n  height: 20px;\n  display: block;\n  overflow: hidden;\n}\n.voice-module_addressBook__3Ezuv {\n  position: relative;\n  height: 100vh;\n  flex-shrink: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid #cfcfcf;\n}\n.voice-module_addressBook__3Ezuv .voice-module_searchPart__3QZ_9 {\n  padding: 18px 24px;\n}\n.voice-module_addressBook__3Ezuv .voice-module_tabContent__2dkGu {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  height: 0;\n  overflow: hidden;\n}\n.voice-module_addressBook__3Ezuv .voice-module_searchWrapper__20k2r {\n  position: absolute;\n  top: 70px;\n  width: 100%;\n  bottom: 0;\n  overflow: auto;\n  z-index: 99;\n  background-color: #ffffff;\n}\n.voice-module_addressBook__3Ezuv .voice-module_searchWrapper__20k2r .voice-module_friendItem__16R0X {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  padding: 16px 16px;\n  align-items: center;\n}\n.voice-module_addressBook__3Ezuv .voice-module_searchWrapper__20k2r .voice-module_friendItem__16R0X .voice-module_friendImg__1VuRE {\n  margin-right: 10px;\n  width: 44px;\n}\n.voice-module_addressBook__3Ezuv .voice-module_searchWrapper__20k2r .voice-module_friendItem__16R0X .voice-module_descContent__2NpE6 {\n  font-size: 16px;\n  font-weight: 400;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  color: #1a1a1a;\n}\n.voice-module_addressBook__3Ezuv .voice-module_searchWrapper__20k2r .voice-module_friendItem__16R0X::after {\n  content: \" \";\n  position: absolute;\n  height: 1px;\n  background: #e4e4e4;\n  left: 16px;\n  bottom: -1px;\n  right: 0;\n}\n.voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q {\n  flex: 1;\n  overflow-y: auto;\n}\n.voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q .voice-module_friendItem__16R0X {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  padding: 16px 16px;\n}\n.voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q .voice-module_friendItem__16R0X .voice-module_friendImg__1VuRE {\n  margin-right: 10px;\n  width: 44px;\n}\n.voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q .voice-module_friendItem__16R0X .voice-module_descContent__2NpE6 {\n  overflow: hidden;\n  flex: 1;\n}\n.voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q .voice-module_friendItem__16R0X .voice-module_descContent__2NpE6 .voice-module_tit__2xVAc {\n  font-size: 16px;\n  font-weight: 400;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  color: #1a1a1a;\n}\n.voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q .voice-module_friendItem__16R0X .voice-module_descContent__2NpE6 .voice-module_desc__1CEz7 {\n  font-size: 12px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-weight: 400;\n  color: rgba(26, 26, 26, 0.7);\n}\n.voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q .voice-module_friendItem__16R0X::after {\n  content: \" \";\n  position: absolute;\n  height: 1px;\n  background: #e4e4e4;\n  left: 16px;\n  bottom: -1px;\n  right: 0;\n}\n.voice-module_addressBook__3Ezuv .voice-module_friendWrapper__1qp4Q .voice-module_friendItem__16R0X.voice-module_active__2JrBZ {\n  background-color: #d6d6d6;\n}\n.voice-module_timeLine__2zefe {\n  text-align: center;\n  font-size: 12px;\n  color: rgba(26, 26, 26, 0.7);\n}\n.ant-drawer-right.ant-drawer-open .ant-drawer-content-wrapper {\n  border: solid 1px #e8e8e8;\n  border-top: none;\n  box-shadow: none !important;\n}\n.ant-slider {\n  flex: 1;\n  margin: 0 !important;\n  padding: 0 !important;\n  display: flex;\n}\n.ant-slider .ant-slider-step {\n  width: 100%;\n  height: 12px;\n  background: #006aff;\n  border-radius: 6px;\n  opacity: 0.1;\n}\n.ant-slider .ant-slider-track {\n  left: 0%;\n  right: auto;\n  height: 12px;\n  width: 60%;\n  border-radius: 6px;\n  background: #006aff;\n}\n.ant-slider .ant-slider-handle {\n  left: 60%;\n  right: auto;\n  background: #006aff;\n  transform: translateX(-50%);\n  margin-top: -1px;\n}\n.ant-slider .ant-slider-rail {\n  display: none;\n}\n.ant-menu-root.ant-menu-vertical,\n.ant-menu-root.ant-menu-vertical-left,\n.ant-menu-root.ant-menu-vertical-right,\n.ant-menu-root.ant-menu-inline {\n  height: auto !important;\n}\n.voice-module_voiceBlock__N2J3z {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border-radius: 4px;\n  min-width: 250px;\n}\n.voice-module_sliderBlock__1Bruc {\n  display: block;\n}\n.voice-module_circle16__ToUvK {\n  width: 16px;\n  height: 16px;\n  border-radius: 8px;\n}\n.voice-module_secondText__3wa_6 {\n  font-size: 14px;\n  font-weight: 500;\n  color: #006aff;\n  line-height: 20px;\n  margin: 0 16px 0 6px;\n}\n.voice-module_normalText__1VMJA {\n  font-size: 14px;\n  font-weight: 400;\n  color: #1a1a1a;\n  line-height: 20px;\n  margin-left: 16px;\n}\n.voice-module_curTime__18AwE {\n  font-size: 14px;\n  font-weight: 400;\n  color: #006aff;\n  line-height: 20px;\n  margin-left: 8px;\n}\n.voice-module_disabledColor__1uZ8S {\n  color: #999999;\n}\n.voice-module_secondLong__2Jbii {\n  width: 480px;\n}\n.voice-module_rateBlock__2Tgdx {\n  position: absolute;\n  display: inline-block;\n  margin-top: -40px;\n}\n.voice-module_leftRate__2waFo {\n  margin-left: -75px;\n}\n.voice-module_rateItem__1lbbS {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 8px 12px;\n  width: 52px;\n  height: 30px;\n  background: rgba(26, 26, 26, 0.15);\n  border-radius: 15px;\n}\n.voice-module_rateItemSelected__3af9t {\n  background: rgba(0, 106, 255, 0.1);\n}\n.voice-module_rate__1wVI2 {\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n}\n.voice-module_rateSelected__dgmeB {\n  font-size: 14px;\n  font-weight: 500;\n  color: #006aff;\n}\n.voice-module_vodieBox__1PsKo {\n  width: 300px;\n  height: 300px;\n}\n.voice-module_sources__3rQK8 {\n  max-width: 333px;\n  padding: 4px;\n  border-radius: 4px;\n  font-size: 12px !important;\n  background-color: rgba(26, 26, 26, 0.15);\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n}\n.ant-spin-blur::after {\n  opacity: 1 !important;\n}\n";
var styles$3 = {"rightWrapper":"voice-module_rightWrapper__10_6g","searchForm":"voice-module_searchForm__1jpPB","checkBox":"voice-module_checkBox__3H7Rp","emptyContent":"voice-module_emptyContent__w2rkw","wechatInfo":"voice-module_wechatInfo__2w5PS","avatar":"voice-module_avatar__1NXSZ","searchContentWrapper":"voice-module_searchContentWrapper__1Ggt6","itemInfo":"voice-module_itemInfo__2z7nH","name":"voice-module_name__2Ih9F","content":"voice-module_content__2-BYa","chatWrapper":"voice-module_chatWrapper__2_kx2","sidebar":"voice-module_sidebar__3y4v1","nickname":"voice-module_nickname__2XxD_","chatMenu":"voice-module_chatMenu__2GeOH","menuItem":"voice-module_menuItem__3VsrR","active":"voice-module_active__2JrBZ","addressBook":"voice-module_addressBook__3Ezuv","searchPart":"voice-module_searchPart__3QZ_9","tabContent":"voice-module_tabContent__2dkGu","searchWrapper":"voice-module_searchWrapper__20k2r","friendItem":"voice-module_friendItem__16R0X","friendImg":"voice-module_friendImg__1VuRE","descContent":"voice-module_descContent__2NpE6","friendWrapper":"voice-module_friendWrapper__1qp4Q","tit":"voice-module_tit__2xVAc","desc":"voice-module_desc__1CEz7","chatContent":"voice-module_chatContent__2uYYF","headerChat":"voice-module_headerChat__3Itte","uname":"voice-module_uname__3uW5D","subHead":"voice-module_subHead__CdyJo","searchTool":"voice-module_searchTool___OPug","btnUsers":"voice-module_btnUsers__2mh42","chatBox":"voice-module_chatBox__1qp6-","ant-drawer-content-wrapper":"voice-module_ant-drawer-content-wrapper__yKrPi","linkMore":"voice-module_linkMore__2noT3","tips":"voice-module_tips__2w3GY","messageItem":"voice-module_messageItem__3V5Oz","tipmsg":"voice-module_tipmsg__10LC1","right":"voice-module_right__flf7V","mAvatar":"voice-module_mAvatar__3FbWx","corner":"voice-module_corner__30d4N","mContent":"voice-module_mContent__3n2Hy","messBox":"voice-module_messBox__3vKtu","meColor":"voice-module_meColor__1Pg3P","miniTitle":"voice-module_miniTitle__2cGiO","thumbImg":"voice-module_thumbImg__1GOIL","groupMember":"voice-module_groupMember__27AS2","member":"voice-module_member__1upoz","iconGen":"voice-module_iconGen__3bP8E","mName":"voice-module_mName__29XLB","mTag":"voice-module_mTag__3zhUf","newTabHeader":"voice-module_newTabHeader__1pqGf","tabItem":"voice-module_tabItem__2mlY7","chatCard":"voice-module_chatCard__1-6ae","cardBody":"voice-module_cardBody__2F7oC","text":"voice-module_text__3cmmr","cardFooter":"voice-module_cardFooter__1o_cJ","fileCard":"voice-module_fileCard__3bMmx","context":"voice-module_context__3T22N","iconPic":"voice-module_iconPic__cgKft","messBoxPic":"voice-module_messBoxPic__3_D-j","NullMessBoxPic":"voice-module_NullMessBoxPic__2aL9l","commonBox":"voice-module_commonBox__7XmNB","linkBox":"voice-module_linkBox__UzTS7","linkText":"voice-module_linkText__lZi44","rightImg":"voice-module_rightImg__2eflI","voiceContent":"voice-module_voiceContent__kZ1i3","voiceTip":"voice-module_voiceTip__3NZrt","explainText":"voice-module_explainText__2JH08","redBagBox":"voice-module_redBagBox__3P-Sa","status":"voice-module_status__2qv8i","voiceBox":"voice-module_voiceBox__3vhh2","iconVoice":"voice-module_iconVoice__1dkPt","tipInfo":"voice-module_tipInfo__RGvLX","footer":"voice-module_footer__2iHwT","boxContain":"voice-module_boxContain__LR1jv","position":"voice-module_position__2SmYu","baiduBox":"voice-module_baiduBox__28iLa","map":"voice-module_map__11Com","xiaoChengxu":"voice-module_xiaoChengxu__3EbMc","header":"voice-module_header__2cWTs","imgThumb":"voice-module_imgThumb__2S45O","icon":"voice-module_icon__MJPxu","timeLine":"voice-module_timeLine__2zefe","voiceBlock":"voice-module_voiceBlock__N2J3z","sliderBlock":"voice-module_sliderBlock__1Bruc","circle16":"voice-module_circle16__ToUvK","secondText":"voice-module_secondText__3wa_6","normalText":"voice-module_normalText__1VMJA","curTime":"voice-module_curTime__18AwE","disabledColor":"voice-module_disabledColor__1uZ8S","secondLong":"voice-module_secondLong__2Jbii","rateBlock":"voice-module_rateBlock__2Tgdx","leftRate":"voice-module_leftRate__2waFo","rateItem":"voice-module_rateItem__1lbbS","rateItemSelected":"voice-module_rateItemSelected__3af9t","rate":"voice-module_rate__1wVI2","rateSelected":"voice-module_rateSelected__dgmeB","vodieBox":"voice-module_vodieBox__1PsKo","sources":"voice-module_sources__3rQK8"};
styleInject(css_248z$3);

const rates = [1, 1.5, 2];
const propTypes$5 = {
  message: PropTypes.shape({
    type: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    voiceid: PropTypes.string,
    file: PropTypes.string,
    timestamp: PropTypes.number,
    mine: PropTypes.bool,
    msgSvrId: PropTypes.string
  }).isRequired,
  wechatId: PropTypes.string.isRequired,
  datasource: PropTypes.number,
  curTimestamp: PropTypes.number,
  headers: PropTypes.shape({
    token: PropTypes.string,
    userId: PropTypes.string
  }),
  turnText: bool,
  videoPlay: bool,
  zhStatus: PropTypes.number,
  setVoiceStatus: PropTypes.func
};
const defaultProps$5 = {
  datasource: 0,
  curTimestamp: 1,
  turnText: true,
  videoPlay: true,
  headers: null,
  zhStatus: 0,
  setVoiceStatus: () => null
};
class VoiceComponent extends Component {
  static getDerivedStateFromProps(nextProps) {
    return {
      inzhStatus: nextProps?.zhStatus || 0
    };
  }
  constructor(props) {
    super(props);
    this.renderVoiceWidth = num => {
      const second = Number(num);
      let size = null;
      if (second >= 0 <= 9) {
        size = '76px';
      } else if (second >= 10 <= 19) {
        size = '136px';
      } else if (second >= 20 <= 29) {
        size = '196px';
      } else if (second >= 30 <= 39) {
        size = '256px';
      } else if (second >= 40 <= 49) {
        size = '316px';
      } else if (second >= 50 <= 59) {
        size = '376px';
      } else if (second >= 60) {
        size = '436px';
      }
      return size;
    };
    this.voiceTotext = item => {
      const {
        setVoiceStatus
      } = this.props;
      setVoiceStatus({
        type: 'add',
        msgSvrId: item.msgSvrId
      });
      this.setState({
        getted: true,
        loading: true
      });
      const params = {
        url: `msg_${item.file}.amr`,
        isTrans: 2,
        type: 1
      };
      this.timer = setInterval(() => {
        voiceToCharacter(params).then(res => {
          if (res.success && (res.data === 2 || res.data === 3)) {
            this.setState({
              loading: true
            }, () => {});
          } else if (res.data === 4) {
            this.setState({
              data: {
                flag: -1,
                text: res.message
              },
              loading: false
            });
            window.clearInterval(this.timer);
            setVoiceStatus({
              type: 'reduce',
              msgSvrId: item.msgSvrId
            });
          } else if (typeof res.data === 'string') {
            this.setState({
              data: {
                flag: 1,
                text: res.data
              },
              loading: false
            }, () => {});
            setVoiceStatus({
              type: 'reduce',
              msgSvrId: item.msgSvrId
            });
            window.clearInterval(this.timer);
          } else {
            this.setState({
              data: {
                flag: -1,
                text: ''
              },
              loading: false
            });
            window.clearInterval(this.timer);
            setVoiceStatus({
              type: 'reduce',
              msgSvrId: item.msgSvrId
            });
          }
        }).catch(() => {
          this.setState({
            loading: false
          });
          setVoiceStatus({
            type: 'reduce',
            msgSvrId: item.msgSvrId
          });
          window.clearInterval(this.timer);
        });
      }, 2000);
    };
    this.playSound = async item => {
      const audio = this.voiceRef;
      try {
        const res = await voiceToPlay({
          voice: `msg_${item.file}`
        });
        if (res.success) {
          this.setState({
            audioSrc: res.data
          }, () => {
            audio.load();
            audio.addEventListener('canplaythrough', () => {
              if (audio.paused) this.handlePlay();
            }, false);
          });
        }
      } catch (e) {
        _message.error(e.message);
      }
    };
    // 播放中
    this.handleTimeUpdate = () => {
      const audio = this.voiceRef;
      this.setState({
        curPlayPosition: Math.floor(audio.currentTime)
      });
    };
    // 播放结束
    this.onEnded = () => {
      this.setState({
        isPlaying: false,
        curPlayPosition: 0
      });
    };
    // 滚动条拖动点击
    this.onSliderChange = value => {
      const audio = this.voiceRef;
      if (!audio.paused) audio.pause();
      this.setState({
        curPlayPosition: value
      });
    };
    // 滚动条拖动/点击 结束
    this.onAfterChange = e => {
      const audio = this.voiceRef;
      audio.currentTime = e;
      this.handlePlay();
      this.setState({
        isPlaying: true
      });
    };
    // 设置语速
    this.onRateChange = value => {
      const audio = this.voiceRef;
      // 速度切换， 暂停、设置新速度
      // if (!audio.paused) {
      //   audio.pause();
      //   audio.load();
      // }
      audio.playbackRate = value;
      this.setState({
        curRate: value,
        isPlaying: false
      });
    };
    this.handlePlay = () => {
      const audio = this.voiceRef;
      const {
        message
      } = this.props;
      const playPromise = audio.play();
      if (playPromise) {
        playPromise.then(() => {
          // 音频加载成功
          // 音频的播放需要耗时
          setTimeout(() => {
            // 后续操作
          }, audio.duration * 1000); // audio.duration 为音频的时长单位为秒
        }).catch(() => {
          // 音频加载失败
        });
      }
      Emitter$1.emit('audioPlay', message.timestamp);
    };
    this.handleReloadAudio = curTimestamp => {
      const audio = this.voiceRef;
      const {
        message
      } = this.props;
      if (message.timestamp !== curTimestamp) {
        audio.load();
        this.onEnded();
      }
    };
    // 播放或暂停
    this.playOrPaused = () => {
      const {
        isPlaying,
        canPlay
      } = this.state;

      // if (!canPlay) return alert.error('该录音文字不存在，可能原因如下：1、微信语音未接通 2、音频文件暂未上传3、音频文件过大上传失败');

      if (!canPlay) return null;
      const audio = this.voiceRef;
      if (audio.paused) {
        // 判断当前的状态是否为暂停，若是则点击播放，否则暂停
        audio.addEventListener('canplaythrough', this.handlePlay(), false);
      } else {
        audio.pause();
      }
      this.setState({
        isPlaying: !isPlaying
      });
      return null;
    };
    this.rateModelChange = () => {
      const {
        isShowRate
      } = this.state;
      this.setState({
        isShowRate: !isShowRate
      });
    };
    // 获取播放按钮位置的图标
    this.getShowIcon = (type = 3, canPlay) => {
      let showIcon = img$6;
      switch (type) {
        case 6:
          // 语音通话Icon
          if (canPlay) showIcon = img$4;else showIcon = img$1;
          break;
        case 7:
          // 视频通话Icon
          if (canPlay) showIcon = img$3;else showIcon = img;
          break;
        default:
          if (canPlay) showIcon = img$6;else showIcon = img$2;
          break;
      }
      return showIcon;
    };
    this.getCallType = (type = 3) => {
      let callType = '';
      switch (type) {
        case 6:
          callType = '语音通话 ';
          break;
        case 7:
          callType = '视频通话 ';
          break;
        case 15:
          callType = '群语音 ';
          break;
      }
      return callType;
    };
    // 倍速弹窗
    this.renderRateList = position => {
      const {
        curRate
      } = this.state;
      return /*#__PURE__*/React.createElement("div", {
        className: position === 'left' ? `${styles$3.rateBlock} ${styles$3.leftRate}` : styles$3.rateBlock
      }, rates.map(item => {
        let isSelected = false;
        if (curRate === item) isSelected = true;
        return /*#__PURE__*/React.createElement("div", {
          role: "button",
          tabIndex: "0",
          onKeyPress: () => null,
          key: item,
          onClick: this.onRateChange.bind(null, item),
          className: isSelected ? `${styles$3.rateItem} ${styles$3.rateItemSelected}` : styles$3.rateItem
        }, /*#__PURE__*/React.createElement("span", {
          className: isSelected ? styles$3.rateSelected : styles$3.rate
        }, item, "X"));
      }));
    };
    this.state = {
      loading: false,
      getted: false,
      // zhStatus: false, // 转换结果
      // text: '',
      data: {
        text: '',
        flag: 1
      },
      audioSrc: '',
      audioDuration: 0,
      curPlayPosition: 0,
      // 当前播放位置
      isPlaying: false,
      // 当前播放状态
      curRate: 1,
      // 当前倍速
      isShowRate: false,
      // 倍速弹窗
      canPlay: false,
      inzhStatus: 0
    };
    this.voiceRef = null;
    this.timer = null;
  }
  async componentDidMount() {
    const This = this;
    const {
      message,
      wechatId,
      datasource,
      headers,
      videoPlay
    } = this.props;
    const params = {};
    const search1 = new URLSearchParams(encodeURI(window.location.search));
    const user = search1 ? decodeURIComponent(search1.get('user')) : '';
    if (message.type === 3 || message.type === 33) {
      params.voice = datasource === 2 ? message.voiceid : `msg_${message.file}`;
      params.msgId = '1681210247958';
      params.datasource = datasource || 1;
    } else if (message.type === 6 || message.type === 7 || message.type === 15) {
      params.msgId = message.msgSvrId;
      params.callStamp = message.timestamp;
      params.wxId = wechatId;
    }
    /* type 3 短语音调用原接口， 其余调用 新增语音通话、视频通话、群语音 获取文件接口 */
    let service = videoToPlay;
    if (message.type === 3 || message.type === 33) {
      service = headers ? voice2ToPlay : voiceToPlay;
    } else {
      if (!videoPlay) {
        return;
      }
      service = videoToPlay;
    }
    const res = await service(params, {
      ...headers,
      user
    });
    if (res.code === '10000' || res.success && res.success) {
      const audio = this.voiceRef;
      let audioSrc = '';
      if (message.type === 3 || message.type === 33) {
        if (res.data === 'success') {
          audioSrc = res.message;
        } else {
          audioSrc = res.data;
        }
      } else {
        audioSrc = res.message;
      }
      this.setState({
        audioSrc,
        canPlay: true
      }, () => {
        audio.load();
        audio.addEventListener('timeupdate', this.handleTimeUpdate, false);
        audio.addEventListener('ended', this.onEnded, false);
        Emitter$1.addListener('audioPlay', this.handleReloadAudio);
        audio.oncanplay = () => {
          setTimeout(() => {
            This.setState({
              audioDuration: Math.floor(audio.duration)
            });
          }, 100);
        };
      });
    }
  }
  componentDidUpdate() {
    const {
      curTimestamp,
      message
    } = this.props;
    const audio = this.voiceRef;
    if (curTimestamp === message.timestamp && !audio.paused) {
      audio.pause();
      audio.load();
    }
  }
  componentWillUnmount() {
    const audio = this.voiceRef;
    audio.removeEventListener('timeupdate', this.handleTimeUpdate, false);
    audio.removeEventListener('ended', this.onEnded, false);
    Emitter$1.removeAllListeners('audioPlay');
  }
  render() {
    const {
      message,
      turnText,
      videoPlay
    } = this.props;
    const {
      loading,
      getted,
      data,
      curPlayPosition,
      isPlaying,
      curRate,
      isShowRate,
      canPlay,
      audioDuration,
      audioSrc,
      inzhStatus
    } = this.state;
    const showIcon = this.getShowIcon(message.type, canPlay);
    const callType = this.getCallType(message.type);
    return /*#__PURE__*/React.createElement("div", {
      className: message.mine ? styles$3.right : ''
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$3.voiceContent
    }, message.mine && isShowRate ? this.renderRateList('left') : null, /*#__PURE__*/React.createElement(_Tooltip, {
      placement: "rightBottom",
      title: !canPlay ? '该录音文字不存在，可能原因如下：1、微信语音未接通 2、音频文件暂未上传3、音频文件过大上传失败' : ''
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$3.commonBox,
      style: {
        cursor: 'pointer'
      }
    }, /*#__PURE__*/React.createElement("audio", {
      controls: true,
      type: "audio/mp3",
      playbackrate: curRate,
      ref: voice => {
        this.voiceRef = voice;
      },
      preload: "auto",
      hidden: true
    }, /*#__PURE__*/React.createElement("track", {
      default: true,
      kind: "captions",
      controls: "controls",
      type: "audio/mp3",
      src: audioSrc
    }), /*#__PURE__*/React.createElement("source", {
      controls: "controls",
      type: "audio/mp3",
      playbackrate: curRate,
      src: audioSrc
    }), "\u60A8\u7684\u6D4F\u89C8\u5668\u4E0D\u652F\u6301 audio \u6807\u7B7E\u3002"), /*#__PURE__*/React.createElement("div", {
      className: Number(audioDuration) >= 60 ? `${styles$3.secondLong} ${styles$3.voiceBlock}` : styles$3.voiceBlock
    }, /*#__PURE__*/React.createElement("span", {
      role: "button",
      tabIndex: "0",
      onClick: this.playOrPaused,
      onKeyPress: () => null
    }, /*#__PURE__*/React.createElement("img", {
      className: styles$3.circle16,
      alt: "",
      src: isPlaying ? img$5 : showIcon
    })), /*#__PURE__*/React.createElement("span", {
      className: !canPlay ? `${styles$3.secondText} ${styles$3.disabledColor}` : styles$3.secondText
    }, callType + (audioDuration ? `${parseInt(audioDuration / 60, 10)}'${audioDuration % 60}` : "0'")), (videoPlay || !callType) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Slider, {
      min: 0,
      max: audioDuration ? Number(audioDuration) : 1,
      disabled: !canPlay,
      onChange: this.onSliderChange,
      onAfterChange: this.onAfterChange,
      value: typeof curPlayPosition === 'number' ? curPlayPosition : 0
    }), /*#__PURE__*/React.createElement("span", {
      className: !canPlay ? `${styles$3.curTime} ${styles$3.disabledColor}` : styles$3.curTime
    }, formatMS(curPlayPosition)), /*#__PURE__*/React.createElement("span", {
      role: "button",
      tabIndex: "0",
      onKeyPress: () => null,
      className: styles$3.normalText,
      onClick: this.rateModelChange
    }, "\u500D\u901F"))))), !message.mine && isShowRate ? this.renderRateList() : null, turnText && message.type === 3 && getted === false && inzhStatus < 2 && /*#__PURE__*/React.createElement("div", {
      role: "button",
      tabIndex: "0",
      onKeyPress: () => null,
      onClick: this.voiceTotext.bind(null, message),
      className: styles$3.voiceTip
    }, "\u70B9\u51FB\u8F6C\u6362\u6210\u6587\u5B57\uFF08\u4EC5\u666E\u901A\u8BDD\uFF09"), /*#__PURE__*/React.createElement("div", {
      className: styles$3.explainText,
      style: {
        display: getted ? 'block' : 'none'
      }
    }, /*#__PURE__*/React.createElement(_Spin, {
      spinning: loading
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      className: styles$3.text
    }, data.text), data.flag === 1 && /*#__PURE__*/React.createElement("div", {
      className: styles$3.status
    }, /*#__PURE__*/React.createElement("img", {
      alt: "",
      src: img$8
    }), "\u8F6C\u6362\u5B8C\u6210"), data.flag !== 1 && /*#__PURE__*/React.createElement("div", {
      className: styles$3.status
    }, /*#__PURE__*/React.createElement("img", {
      alt: "",
      src: img$7
    }), "\u8F6C\u6362\u5931\u8D25"))))));
  }
}
VoiceComponent.propTypes = propTypes$5;
VoiceComponent.defaultProps = defaultProps$5;

var css_248z$2 = ".styles-module_rightWrapper__IoF6s {\n  flex: 1;\n  width: 100%;\n  overflow: auto;\n  background-color: #ffffff;\n}\n.styles-module_rightWrapper__IoF6s .styles-module_searchForm__1tbYk {\n  padding: 25px 25px;\n}\n.styles-module_checkBox__29L5J {\n  padding-top: 12px;\n  margin-right: 10px;\n}\n.styles-module_emptyContent__21jRv {\n  display: flex;\n  width: 100%;\n  flex: 1;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n.styles-module_wechatInfo__2mFO0 {\n  display: flex;\n  align-items: center;\n}\n.styles-module_wechatInfo__2mFO0 .styles-module_avatar__EpRU8 {\n  margin-right: 10px;\n}\n.styles-module_searchContentWrapper__1pRyp {\n  height: 400px;\n  overflow: auto;\n}\n.styles-module_searchContentWrapper__1pRyp .styles-module_itemInfo__yuXx6 {\n  cursor: pointer;\n  line-height: 22px;\n  border-bottom: 1px solid #e8e8e8;\n  margin-bottom: 5px;\n}\n.styles-module_searchContentWrapper__1pRyp .styles-module_itemInfo__yuXx6 .styles-module_name__18OhJ {\n  font-size: 14px;\n  padding: 3px 0;\n}\n.styles-module_searchContentWrapper__1pRyp .styles-module_itemInfo__yuXx6 .styles-module_content__izlqp {\n  max-width: 300px;\n  word-break: break-all;\n  font-size: 12px;\n}\n.styles-module_chatWrapper__3uuHg {\n  width: 100%;\n  height: 100%;\n  overflow: hidden;\n  min-width: 960px;\n  display: flex;\n  background-color: #f9f9f9;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_sidebar__I65ke {\n  width: 160px;\n  height: 100%;\n  flex-shrink: 0;\n  background-color: #3b3b3b;\n  color: #ffffff;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_sidebar__I65ke .styles-module_avatar__EpRU8 {\n  text-align: center;\n  padding-top: 50px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_sidebar__I65ke .styles-module_nickname__1TETq {\n  text-align: center;\n  font-size: 16px;\n  color: #ffffff;\n  padding: 16px 5px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_sidebar__I65ke .styles-module_chatMenu__2GrIz {\n  padding-top: 10px;\n  padding-left: 30px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_sidebar__I65ke .styles-module_chatMenu__2GrIz .styles-module_menuItem__1tHes {\n  display: block;\n  cursor: pointer;\n  font-size: 14px;\n  margin-bottom: 30px;\n  line-height: 20px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_sidebar__I65ke .styles-module_chatMenu__2GrIz .styles-module_menuItem__1tHes.styles-module_active__1BiYn {\n  color: #217af9;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD {\n  position: relative;\n  width: 360px !important;\n  height: 100%;\n  flex-shrink: 0;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  border-right: 1px solid #cfcfcf;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD .styles-module_searchPart__107ln {\n  padding: 18px 24px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD .styles-module_tabContent__197Q3 {\n  display: flex;\n  flex-direction: column;\n  flex: 1;\n  height: 0;\n  overflow: hidden;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD .styles-module_searchWrapper__3jFxA {\n  position: absolute;\n  top: 70px;\n  width: 100%;\n  bottom: 0;\n  overflow: auto;\n  z-index: 99;\n  background-color: #ffffff;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD .styles-module_searchWrapper__3jFxA .styles-module_friendItem__2vZ21 {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  padding: 16px 16px;\n  align-items: center;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD .styles-module_searchWrapper__3jFxA .styles-module_friendItem__2vZ21 .styles-module_friendImg__2s84D {\n  margin-right: 10px;\n  width: 44px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD .styles-module_searchWrapper__3jFxA .styles-module_friendItem__2vZ21 .styles-module_descContent__2oE67 {\n  font-size: 16px;\n  font-weight: 400;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  color: #1a1a1a;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD .styles-module_searchWrapper__3jFxA .styles-module_friendItem__2vZ21::after {\n  content: \" \";\n  position: absolute;\n  height: 1px;\n  background: #e4e4e4;\n  left: 16px;\n  bottom: -1px;\n  right: 0;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD .styles-module_friendWrapper__1knBf {\n  flex: 1;\n  overflow-y: auto;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD .styles-module_friendWrapper__1knBf .styles-module_friendItem__2vZ21 {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  padding: 16px 16px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD .styles-module_friendWrapper__1knBf .styles-module_friendItem__2vZ21 .styles-module_friendImg__2s84D {\n  margin-right: 10px;\n  width: 44px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD .styles-module_friendWrapper__1knBf .styles-module_friendItem__2vZ21 .styles-module_descContent__2oE67 {\n  overflow: hidden;\n  flex: 1;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD .styles-module_friendWrapper__1knBf .styles-module_friendItem__2vZ21 .styles-module_descContent__2oE67 .styles-module_tit__26yER {\n  font-size: 16px;\n  font-weight: 400;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  color: #1a1a1a;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD .styles-module_friendWrapper__1knBf .styles-module_friendItem__2vZ21 .styles-module_descContent__2oE67 .styles-module_desc__1_jKb {\n  font-size: 12px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  font-weight: 400;\n  color: rgba(26, 26, 26, 0.7);\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD .styles-module_friendWrapper__1knBf .styles-module_friendItem__2vZ21::after {\n  content: \" \";\n  position: absolute;\n  height: 1px;\n  background: #e4e4e4;\n  left: 16px;\n  bottom: -1px;\n  right: 0;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_addressBook__3BdUD .styles-module_friendWrapper__1knBf .styles-module_friendItem__2vZ21.styles-module_active__1BiYn {\n  background-color: #d6d6d6;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY {\n  width: 100%;\n  height: 100vh;\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: auto;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_headerChat__1Dwr8 {\n  padding: 20px 30px;\n  height: 120px;\n  overflow: hidden;\n  border-bottom: solid 1px #e8e8e8;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_headerChat__1Dwr8 .styles-module_uname__1xkoH {\n  font-size: 16px;\n  font-weight: 500;\n  margin-bottom: 10px;\n  color: #1a1a1a;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_headerChat__1Dwr8 .styles-module_subHead__13Xxk {\n  display: flex;\n  padding-top: 2px;\n  margin-bottom: 10px;\n  justify-content: space-between;\n  align-items: center;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_headerChat__1Dwr8 .styles-module_subHead__13Xxk .styles-module_searchTool__21Ma3 {\n  white-space: nowrap;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_headerChat__1Dwr8 .styles-module_subHead__13Xxk .styles-module_btnUsers__1eSAi {\n  cursor: pointer;\n  font-size: 18px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m {\n  flex: 1;\n  position: relative;\n  padding: 20px 20px;\n  overflow: hidden;\n  overflow-y: auto;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_ant-drawer-content-wrapper__1hdsF {\n  box-shadow: none !important;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_linkMore__32KR3 {\n  text-align: center;\n  cursor: pointer;\n  font-size: 12px;\n  padding: 8px 5px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_tips__3lQNZ {\n  text-align: center;\n  padding: 10px 10px;\n  font-size: 12px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q {\n  display: flex;\n  flex-direction: row;\n  max-width: 100%;\n  padding: 10px 0;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q .styles-module_tipmsg__1M5LP {\n  font-size: 12px;\n  text-align: center;\n  width: 100%;\n  color: #b2b2b2;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q.styles-module_right__2Auhk {\n  flex-direction: row-reverse;\n  text-align: right;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q.styles-module_right__2Auhk .styles-module_mAvatar__34pVg {\n  margin-right: 0;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q.styles-module_right__2Auhk .styles-module_checkBox__29L5J {\n  margin-left: 10px;\n  margin-right: 0;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q.styles-module_right__2Auhk .styles-module_corner__1WnSp {\n  color: #ffffff;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q.styles-module_right__2Auhk .styles-module_corner__1WnSp::after {\n  border: 5px solid transparent;\n  border-left-color: inherit;\n  width: 0;\n  height: 0;\n  position: absolute;\n  content: \" \";\n  right: -10px;\n  left: auto;\n  top: 10px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q.styles-module_right__2Auhk .styles-module_mContent__1neuT {\n  margin-right: 10px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q.styles-module_right__2Auhk .styles-module_mContent__1neuT .styles-module_messBox__1Vttp {\n  position: relative;\n  background-color: rgba(33, 122, 249, 0.4);\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q.styles-module_right__2Auhk .styles-module_mContent__1neuT .styles-module_messBox__1Vttp:after {\n  border: 5px solid transparent;\n  border-left-color: rgba(33, 122, 249, 0.4);\n  width: 0;\n  height: 0;\n  position: absolute;\n  content: \" \";\n  right: -10px;\n  left: auto;\n  top: 10px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q.styles-module_right__2Auhk .styles-module_mContent__1neuT .styles-module_messBox__1Vttp.styles-module_meColor__1IQF1 {\n  position: relative;\n  background-color: rgba(33, 122, 249, 0.4);\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q.styles-module_right__2Auhk .styles-module_mContent__1neuT .styles-module_messBox__1Vttp.styles-module_meColor__1IQF1:after {\n  border: 5px solid transparent;\n  border-left-color: rgba(33, 122, 249, 0.4);\n  width: 0;\n  height: 0;\n  position: absolute;\n  content: \" \";\n  right: -10px;\n  left: auto;\n  top: 10px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q .styles-module_mAvatar__34pVg {\n  width: 44px;\n  margin-right: 10px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q .styles-module_mContent__1neuT .styles-module_miniTitle__1iSx3 {\n  font-size: 12px;\n  padding-bottom: 5px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q .styles-module_mContent__1neuT .styles-module_messBox__1Vttp {\n  display: inline-block;\n  text-align: left;\n  padding: 10px;\n  background: #ffffff;\n  border-radius: 3px;\n  position: relative;\n  word-break: break-all;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q .styles-module_mContent__1neuT .styles-module_messBox__1Vttp .styles-module_thumbImg__3wxSI {\n  max-width: 100px;\n  max-height: 230px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_chatContent__Tq7bY .styles-module_chatBox__2lC2m .styles-module_messageItem__1bZ2Q .styles-module_mContent__1neuT .styles-module_messBox__1Vttp:after {\n  border: 5px solid transparent;\n  border-right-color: #ffffff;\n  width: 0;\n  height: 0;\n  position: absolute;\n  content: \" \";\n  left: -10px;\n  top: 10px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_groupMember__1CURp {\n  padding-top: 20px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_groupMember__1CURp .styles-module_member__3zU_Y {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin-bottom: 15px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_groupMember__1CURp .styles-module_member__3zU_Y .styles-module_iconGen__1FS52 {\n  cursor: pointer;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_groupMember__1CURp .styles-module_member__3zU_Y .styles-module_iconGen__1FS52 img {\n  width: 22px;\n  height: 22px;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_groupMember__1CURp .styles-module_member__3zU_Y .styles-module_mName__mQRV_ {\n  flex: 1;\n  overflow: hidden;\n  padding: 0 10px 0 0;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n.styles-module_chatWrapper__3uuHg .styles-module_groupMember__1CURp .styles-module_member__3zU_Y .styles-module_mTag__by9VG {\n  cursor: pointer;\n  margin: 0;\n}\n.styles-module_messBox__1Vttp span {\n  color: #f00;\n}\n.styles-module_newTabHeader__3p3Kv {\n  display: flex;\n  flex-direction: row;\n  margin-bottom: 12px;\n}\n.styles-module_newTabHeader__3p3Kv .styles-module_tabItem__3tMLe {\n  flex: 1;\n  padding: 10px 0;\n  cursor: pointer;\n  text-align: center;\n}\n.styles-module_newTabHeader__3p3Kv .styles-module_tabItem__3tMLe.styles-module_active__1BiYn {\n  color: #217af9;\n}\n.styles-module_right__2Auhk .styles-module_chatCard__8mtQR::after {\n  border-left-color: #ffffff;\n  border-right-color: transparent;\n  right: -10px;\n  left: auto;\n  top: 10px;\n}\n.styles-module_chatCard__8mtQR {\n  width: 240px;\n  position: relative;\n  display: inline-block;\n  background-color: #ffffff;\n  padding: 12px 12px;\n  text-align: left;\n  border-radius: 3px;\n}\n.styles-module_chatCard__8mtQR:after {\n  border: 5px solid transparent;\n  border-right-color: #ffffff;\n  width: 0;\n  height: 0;\n  position: absolute;\n  content: \" \";\n  right: auto;\n  left: -10px;\n  top: 10px;\n}\n.styles-module_chatCard__8mtQR .styles-module_cardBody__3baTK {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  border-bottom: 1px solid rgba(26, 26, 26, 0.05);\n  padding: 0 0 10px 0;\n}\n.styles-module_chatCard__8mtQR .styles-module_cardBody__3baTK .styles-module_avatar__EpRU8 {\n  width: 44px;\n  height: 44px;\n  overflow: hidden;\n  border-radius: 3px;\n  margin-right: 5px;\n}\n.styles-module_chatCard__8mtQR .styles-module_cardBody__3baTK .styles-module_avatar__EpRU8 img {\n  width: 44px;\n  height: 44px;\n}\n.styles-module_chatCard__8mtQR .styles-module_cardBody__3baTK .styles-module_text__1ppqJ {\n  flex: 1;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.styles-module_chatCard__8mtQR .styles-module_cardFooter__2DQao {\n  padding: 10px 0 0 0;\n  font-size: 12px;\n}\n.styles-module_fileCard__3Oc6v {\n  width: 300px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  cursor: pointer;\n}\n.styles-module_fileCard__3Oc6v .styles-module_context__-Zy1r {\n  flex: 1;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  padding-right: 12px;\n}\n.styles-module_fileCard__3Oc6v .styles-module_iconPic__1H9d7 {\n  width: 72px;\n  height: 72px;\n  border-radius: 3px;\n  overflow: hidden;\n}\n.styles-module_fileCard__3Oc6v .styles-module_iconPic__1H9d7 > img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n.styles-module_messBoxPic__MZ4qe {\n  max-width: 300px;\n  display: inline-block;\n  justify-content: flex-start;\n}\n.styles-module_messBoxPic__MZ4qe img {\n  max-width: 300px !important;\n}\n.styles-module_NullMessBoxPic__23Ydu {\n  max-width: 300px;\n  display: inline-block;\n  justify-content: flex-start;\n}\n.styles-module_NullMessBoxPic__23Ydu img {\n  max-width: 70px !important;\n}\n.styles-module_right__2Auhk .styles-module_commonBox__O5D6t::after {\n  border-left-color: #ffffff;\n  border-right-color: transparent;\n  right: -10px;\n  left: auto;\n  top: 10px;\n}\n.styles-module_commonBox__O5D6t {\n  display: inline-block;\n  position: relative;\n  background-color: #ffffff;\n  border-radius: 3px;\n  padding: 10px 12px;\n}\n.styles-module_commonBox__O5D6t:after {\n  border: 5px solid transparent;\n  border-right-color: #ffffff;\n  width: 0;\n  height: 0;\n  position: absolute;\n  content: \" \";\n  right: auto;\n  left: -10px;\n  top: 10px;\n}\n.styles-module_linkBox__pqJ19 {\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  align-items: center;\n  text-align: left;\n  cursor: pointer;\n  width: 300px;\n}\n.styles-module_linkBox__pqJ19 .styles-module_linkText__3PRaD {\n  flex: 1;\n  font-size: 14px;\n  padding-right: 10px;\n}\n.styles-module_linkBox__pqJ19 .styles-module_rightImg__1fY4Z {\n  width: 44px;\n}\n.styles-module_linkBox__pqJ19 .styles-module_rightImg__1fY4Z img {\n  display: inline-block;\n  width: 100%;\n}\n.styles-module_right__2Auhk .styles-module_voiceContent__1E2_2 .styles-module_voiceTip__2UmC- {\n  text-align: right;\n}\n.styles-module_right__2Auhk .styles-module_voiceContent__1E2_2 .styles-module_explainText__3-6fu {\n  text-align: left;\n}\n.styles-module_right__2Auhk .styles-module_redBagBox__3-DcT {\n  margin-left: 0;\n  margin-right: -8px;\n}\n.styles-module_voiceContent__1E2_2 {\n  display: inline-block;\n}\n.styles-module_voiceContent__1E2_2 .styles-module_voiceTip__2UmC- {\n  padding: 3px 0;\n  text-align: left;\n  font-size: 14px;\n  cursor: pointer;\n}\n.styles-module_voiceContent__1E2_2 .styles-module_explainText__3-6fu {\n  margin-top: 5px;\n  border-radius: 3px;\n  background-color: #fff;\n  padding: 10px 10px;\n}\n.styles-module_voiceContent__1E2_2 .styles-module_explainText__3-6fu .styles-module_text__1ppqJ {\n  margin-bottom: 5px;\n}\n.styles-module_voiceContent__1E2_2 .styles-module_explainText__3-6fu .styles-module_status__1G2rN {\n  font-size: 12px;\n}\n.styles-module_voiceContent__1E2_2 .styles-module_explainText__3-6fu .styles-module_status__1G2rN img {\n  margin-right: 4px;\n  width: 11px;\n  height: 11px;\n}\n.styles-module_voiceBox__4oB87 {\n  display: flex;\n  width: 200px;\n  line-height: 1;\n  align-items: center;\n}\n.styles-module_voiceBox__4oB87 .styles-module_iconVoice__1GjKo {\n  width: 12px;\n  height: 12px;\n  margin-right: 8px;\n}\n.styles-module_redBagBox__3-DcT {\n  width: 257px;\n  height: 108px;\n  margin-left: -8px;\n  text-align: center;\n  padding-right: 10px;\n  background-repeat: no-repeat;\n  display: inline-block;\n}\n.styles-module_redBagBox__3-DcT .styles-module_tipInfo__3bV2L {\n  padding-left: 70px;\n  height: 80px;\n  display: flex;\n  text-align: center;\n  align-items: center;\n  justify-content: center;\n  font-size: 14px;\n  color: #ffffff;\n}\n.styles-module_redBagBox__3-DcT .styles-module_footer__1-UGP {\n  color: #fff;\n  text-align: left;\n  padding-left: 22px;\n  padding-top: 3px;\n}\n.styles-module_right__2Auhk .styles-module_boxContain__8yP61 {\n  justify-content: flex-end;\n}\n.styles-module_boxContain__8yP61 {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n}\n.styles-module_boxContain__8yP61 .styles-module_position__hT7u0 {\n  margin-left: 10px;\n}\n.styles-module_boxContain__8yP61 .styles-module_position__hT7u0 img {\n  width: 15px;\n  height: 15px;\n  display: inline-block;\n}\n.styles-module_baiduBox__13-JW {\n  width: 300px;\n}\n.styles-module_baiduBox__13-JW .styles-module_desc__1_jKb {\n  font-size: 14px;\n  padding: 12px 0;\n}\n.styles-module_baiduBox__13-JW .styles-module_map__2ZNv4 {\n  width: 300px;\n  height: 200px;\n}\n.styles-module_xiaoChengxu__2fxwG {\n  position: relative;\n  font-size: 14px;\n  width: 200px;\n  display: inline-block;\n  padding: 12px 12px;\n  border-radius: 3px;\n  background-color: #fff;\n}\n.styles-module_xiaoChengxu__2fxwG .styles-module_header__sF4o6 {\n  color: #1a1a1a;\n  text-align: left;\n  font-size: 14px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n.styles-module_xiaoChengxu__2fxwG .styles-module_imgThumb__DSTip {\n  max-width: 200px;\n  padding: 10px 0;\n  border-bottom: 1px solid rgba(26, 26, 26, 0.05);\n}\n.styles-module_xiaoChengxu__2fxwG .styles-module_imgThumb__DSTip img {\n  max-width: 100% !important;\n}\n.styles-module_xiaoChengxu__2fxwG .styles-module_footer__1-UGP {\n  display: flex;\n  color: #1a1a1a;\n  flex-direction: row;\n  align-items: center;\n  padding: 8px 0 0 0;\n  font-size: 14px;\n}\n.styles-module_xiaoChengxu__2fxwG .styles-module_footer__1-UGP .styles-module_icon__2xfSt {\n  margin-right: 8px;\n}\n.styles-module_xiaoChengxu__2fxwG .styles-module_footer__1-UGP .styles-module_icon__2xfSt img {\n  width: 20px;\n  height: 20px;\n  display: block;\n  overflow: hidden;\n}\n.styles-module_timeLine__3puI_ {\n  text-align: center;\n  font-size: 12px;\n  color: rgba(26, 26, 26, 0.7);\n}\n.styles-module_voiceBlock__1VDkK {\n  display: flex;\n  align-items: center;\n  background-color: #fff;\n  border-radius: 4px;\n  min-width: 250px;\n}\n.styles-module_sliderBlock__3y18i {\n  display: block;\n}\n.styles-module_circle16__2fgeg {\n  width: 16px;\n  height: 16px;\n  border-radius: 8px;\n}\n.styles-module_secondText__11r3u {\n  font-size: 14px;\n  font-weight: 500;\n  color: #006aff;\n  line-height: 20px;\n  margin: 0 16px 0 6px;\n}\n.styles-module_normalText__2VTyU {\n  font-size: 14px;\n  font-weight: 400;\n  color: #1a1a1a;\n  line-height: 20px;\n  margin-left: 16px;\n}\n.styles-module_curTime__36FMe {\n  font-size: 14px;\n  font-weight: 400;\n  color: #006aff;\n  line-height: 20px;\n  margin-left: 8px;\n}\n.styles-module_disabledColor__1jSum {\n  color: #999999;\n}\n.styles-module_secondLong__1E8un {\n  width: 480px;\n}\n.styles-module_rateBlock__1J9BT {\n  position: absolute;\n  display: inline-block;\n  margin-top: -40px;\n}\n.styles-module_leftRate__2lWNM {\n  margin-left: -75px;\n}\n.styles-module_rateItem__1ADbY {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 8px 12px;\n  width: 52px;\n  height: 30px;\n  background: rgba(26, 26, 26, 0.15);\n  border-radius: 15px;\n}\n.styles-module_rateItemSelected__21o4V {\n  background: rgba(0, 106, 255, 0.1);\n}\n.styles-module_rate__2Jofm {\n  font-size: 14px;\n  font-weight: 500;\n  color: #fff;\n}\n.styles-module_rateSelected__TwrKb {\n  font-size: 14px;\n  font-weight: 500;\n  color: #006aff;\n}\n.styles-module_vodieBox__26s0H {\n  width: 300px;\n  height: 300px;\n}\n.styles-module_sources__zKVgs {\n  max-width: 333px;\n  padding: 4px;\n  border-radius: 4px;\n  font-size: 12px !important;\n  background-color: rgba(26, 26, 26, 0.15);\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 2;\n  overflow: hidden;\n}\n";
var styles$2 = {"rightWrapper":"styles-module_rightWrapper__IoF6s","searchForm":"styles-module_searchForm__1tbYk","checkBox":"styles-module_checkBox__29L5J","emptyContent":"styles-module_emptyContent__21jRv","wechatInfo":"styles-module_wechatInfo__2mFO0","avatar":"styles-module_avatar__EpRU8","searchContentWrapper":"styles-module_searchContentWrapper__1pRyp","itemInfo":"styles-module_itemInfo__yuXx6","name":"styles-module_name__18OhJ","content":"styles-module_content__izlqp","chatWrapper":"styles-module_chatWrapper__3uuHg","sidebar":"styles-module_sidebar__I65ke","nickname":"styles-module_nickname__1TETq","chatMenu":"styles-module_chatMenu__2GrIz","menuItem":"styles-module_menuItem__1tHes","active":"styles-module_active__1BiYn","addressBook":"styles-module_addressBook__3BdUD","searchPart":"styles-module_searchPart__107ln","tabContent":"styles-module_tabContent__197Q3","searchWrapper":"styles-module_searchWrapper__3jFxA","friendItem":"styles-module_friendItem__2vZ21","friendImg":"styles-module_friendImg__2s84D","descContent":"styles-module_descContent__2oE67","friendWrapper":"styles-module_friendWrapper__1knBf","tit":"styles-module_tit__26yER","desc":"styles-module_desc__1_jKb","chatContent":"styles-module_chatContent__Tq7bY","headerChat":"styles-module_headerChat__1Dwr8","uname":"styles-module_uname__1xkoH","subHead":"styles-module_subHead__13Xxk","searchTool":"styles-module_searchTool__21Ma3","btnUsers":"styles-module_btnUsers__1eSAi","chatBox":"styles-module_chatBox__2lC2m","ant-drawer-content-wrapper":"styles-module_ant-drawer-content-wrapper__1hdsF","linkMore":"styles-module_linkMore__32KR3","tips":"styles-module_tips__3lQNZ","messageItem":"styles-module_messageItem__1bZ2Q","tipmsg":"styles-module_tipmsg__1M5LP","right":"styles-module_right__2Auhk","mAvatar":"styles-module_mAvatar__34pVg","corner":"styles-module_corner__1WnSp","mContent":"styles-module_mContent__1neuT","messBox":"styles-module_messBox__1Vttp","meColor":"styles-module_meColor__1IQF1","miniTitle":"styles-module_miniTitle__1iSx3","thumbImg":"styles-module_thumbImg__3wxSI","groupMember":"styles-module_groupMember__1CURp","member":"styles-module_member__3zU_Y","iconGen":"styles-module_iconGen__1FS52","mName":"styles-module_mName__mQRV_","mTag":"styles-module_mTag__by9VG","newTabHeader":"styles-module_newTabHeader__3p3Kv","tabItem":"styles-module_tabItem__3tMLe","chatCard":"styles-module_chatCard__8mtQR","cardBody":"styles-module_cardBody__3baTK","text":"styles-module_text__1ppqJ","cardFooter":"styles-module_cardFooter__2DQao","fileCard":"styles-module_fileCard__3Oc6v","context":"styles-module_context__-Zy1r","iconPic":"styles-module_iconPic__1H9d7","messBoxPic":"styles-module_messBoxPic__MZ4qe","NullMessBoxPic":"styles-module_NullMessBoxPic__23Ydu","commonBox":"styles-module_commonBox__O5D6t","linkBox":"styles-module_linkBox__pqJ19","linkText":"styles-module_linkText__3PRaD","rightImg":"styles-module_rightImg__1fY4Z","voiceContent":"styles-module_voiceContent__1E2_2","voiceTip":"styles-module_voiceTip__2UmC-","explainText":"styles-module_explainText__3-6fu","redBagBox":"styles-module_redBagBox__3-DcT","status":"styles-module_status__1G2rN","voiceBox":"styles-module_voiceBox__4oB87","iconVoice":"styles-module_iconVoice__1GjKo","tipInfo":"styles-module_tipInfo__3bV2L","footer":"styles-module_footer__1-UGP","boxContain":"styles-module_boxContain__8yP61","position":"styles-module_position__hT7u0","baiduBox":"styles-module_baiduBox__13-JW","map":"styles-module_map__2ZNv4","xiaoChengxu":"styles-module_xiaoChengxu__2fxwG","header":"styles-module_header__sF4o6","imgThumb":"styles-module_imgThumb__DSTip","icon":"styles-module_icon__2xfSt","timeLine":"styles-module_timeLine__3puI_","voiceBlock":"styles-module_voiceBlock__1VDkK","sliderBlock":"styles-module_sliderBlock__3y18i","circle16":"styles-module_circle16__2fgeg","secondText":"styles-module_secondText__11r3u","normalText":"styles-module_normalText__2VTyU","curTime":"styles-module_curTime__36FMe","disabledColor":"styles-module_disabledColor__1jSum","secondLong":"styles-module_secondLong__1E8un","rateBlock":"styles-module_rateBlock__1J9BT","leftRate":"styles-module_leftRate__2lWNM","rateItem":"styles-module_rateItem__1ADbY","rateItemSelected":"styles-module_rateItemSelected__21o4V","rate":"styles-module_rate__2Jofm","rateSelected":"styles-module_rateSelected__TwrKb","vodieBox":"styles-module_vodieBox__26s0H","sources":"styles-module_sources__zKVgs"};
styleInject(css_248z$2);

const {
  Search
} = _Input;
const {
  RangePicker
} = _DatePicker;
const {
  Point
} = Base;
const {
  ANIMATION
} = Constants;
const WECHAT_LOGO = 'http://yunke-pcfile.oss-cn-beijing.aliyuncs.com/wechat_img/default_head.png';
const searchTypeList = [{
  name: '文本',
  value: '1'
}, {
  name: '图片',
  value: '2'
}, {
  name: '语音消息',
  value: '3'
}, {
  name: '语音通话',
  value: '6'
}, {
  name: '视频通话',
  value: '7'
}, {
  name: '文件',
  value: '9'
}, {
  name: '小程序名片',
  value: '18'
}, {
  name: '链接',
  value: '10'
}, {
  name: '红包',
  value: '5'
}, {
  name: '转账',
  value: '11'
}, {
  name: '视频消息',
  value: '4'
}];
const propTypes$4 = {
  detail: PropTypes.shape({
    customerName: PropTypes.string
  }),
  deploy: PropTypes.shape({
    global: PropTypes.shape({
      isDecodeURI: PropTypes.string
    })
  }),
  wechatId: PropTypes.string,
  friendId: PropTypes.string,
  msgid: PropTypes.string,
  start: PropTypes.number || PropTypes.string,
  sensitive: PropTypes.string
};
const defaultProps$4 = {
  detail: {},
  deploy: {},
  wechatId: '',
  friendId: '',
  msgid: '',
  sensitive: '',
  start: ''
};
const WechatMessage = props => {
  const {
    detail,
    deploy,
    wechatId,
    friendId,
    msgid,
    sensitive,
    start
  } = props;
  const loginMenus = JSON.parse(localStorage.getItem('permissions'));
  const delAuth = loginMenus?.find(item => item.id === '1005')?.children?.find(item => item.id === '100502')?.buttons?.findIndex(item => item.id === '10050201') > -1;
  const [chatContentList, setlist] = useState([]);
  const [chatContentHasLast, setchatContentHasLast] = useState(false);
  const [chatContentHasNext, setchatContentHasNext] = useState(false);
  const [loading, setloading] = useState(false);
  const [deleteStatus, setDelteStatus] = useState(false);
  const [zhStatus, setzhStatus] = useState(0);
  const chatListRef = useRef(null);
  const [chatscrollHeight, setchatscrollHeight] = useState(0);
  const [params, setParams] = useState({
    types: '',
    start: start ? moment(start).valueOf() : moment().startOf('month').valueOf(),
    end: start ? moment(start).endOf('day').valueOf() : moment().valueOf()
  });
  const [dates, setDates] = useState([moment().startOf('month'), moment()]);
  const [dateValue, setDateValue] = useState(null);
  const [showSearchList, setshowSearchList] = useState(false);
  const [searchContentList, setSeachist] = useState([]);
  const [isShow, setisShow] = useState(false);
  const [chatGroupMember, setchatGroupMember] = useState([]);
  const [tableData, settableData] = useState([]);
  const [modal, setModal] = useState(false);
  const [queryParams, setQueryParams] = useState({});
  const [open, setopen] = useState(false);
  const [src, setSrc] = useState('');
  const [voiceStatus, setVoiceStatus] = useState(undefined);
  const search1 = new URLSearchParams(encodeURI(window.location.search));
  const user = decodeURIComponent(search1.get('user'));
  const [userObj] = useState({
    user
  });
  const columns = [{
    title: '用户',
    dataIndex: 'saleName',
    key: 'saleName',
    render: (value, record) => /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, record.saleName), /*#__PURE__*/React.createElement("div", null, record.salePhone))
  }, {
    title: '微信信息',
    dataIndex: 'saleNickName',
    key: 'saleNickName',
    render: (value, record) => /*#__PURE__*/React.createElement("div", {
      className: styles$2.wechatInfo
    }, /*#__PURE__*/React.createElement("div", {
      className: styles$2.avatar
    }, /*#__PURE__*/React.createElement(_Avatar, {
      shape: "square",
      size: "large",
      icon: /*#__PURE__*/React.createElement(UserOutlined, null),
      src: forceHttps(record.saleHeadImg)
    })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, record.saleNickName), /*#__PURE__*/React.createElement("div", null, record.saleAlias)))
  }];
  const getWecahRecord = async () => {
    setloading(true);
    setlist([]);
    const response = await chatRecords({
      wechatId,
      friendId,
      ...params
    }, userObj);
    if (response) {
      setlist(response.messages);
      setloading(false);
      setchatContentHasLast(response.hasLast);
      setchatContentHasNext(response.hasNext);
    } else {
      _message.error('获取聊天记录失败');
    }
  };
  useEffect(() => {
    if (start) {
      setParams({
        ...params,
        start,
        end: ''
      });
    }
  }, [start]);
  useEffect(() => {
    setQueryParams({
      ...queryParams,
      msgid,
      sensitive
    });
  }, [msgid, sensitive]);
  useEffect(() => {
    getWecahRecord();
  }, [params.start, friendId, params.end, params.types, wechatId, friendId]);
  const linkHref = item => {
    const href = item.file;
    if (href.indexOf('http') > -1 || href.indexOf('https') > -1) {
      window.open(href);
    } else {
      window.open(`http://${href}`);
    }
  };
  const showBigPic = async (message, e) => {
    e.preventDefault();
    e.stopPropagation();
    const image = await getOriginalPic({
      md5: message?.md5,
      url: message?.file
    });
    setSrc(image);
    setopen(true);
  };
  const linkHrefFile = item => {
    const {
      global
    } = deploy;
    if (item.file) {
      const isPrew = item.file.includes('fileview.yunkecn.com');
      const a = isPrew ? item.file.split('url=')[1] : item.file;
      const url = decodeURIComponent(a);
      if (!global?.isDecodeURI) {
        request.download(url, {}, {
          responseType: 'arraybuffer',
          method: 'GET',
          name: item.text,
          fileType: `.${item.remark}`
        });
      } else {
        window.open(a);
      }
    }
  };
  const renderIcon = message => {
    if (!message?.remark) {
      return img$m;
    }
    if (message?.remark === 'txt') {
      return img$l;
    }
    if (message?.remark === 'ppt') {
      return img$k;
    }
    if (message?.remark === 'zip') {
      return img$g;
    }
    if (message?.remark === 'pdf') {
      return img$j;
    }
    if ('doc,docx,docm,dotx,dotm'.indexOf(message?.remark) > -1) {
      return img$i;
    }
    if ('xls,xlsx,xlsm,xltx,xltm,xlsb,xlam'.indexOf(message?.remark) > -1) {
      return img$h;
    }
    return img$m;
  };
  const checkMessage = (messge, index) => {
    const list = JSON.parse(JSON.stringify(chatContentList));
    list[index].checkStatus = !list[index].checkStatus;
    setlist(list);
  };
  const renderSourcesMsg = message => {
    switch (message?.type) {
      case 1:
        return /*#__PURE__*/React.createElement(_Popover, {
          placement: message?.mine ? 'left' : 'right',
          content: message?.text,
          trigger: "click",
          overlayInnerStyle: {
            maxWidth: 296
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.sources,
          role: "button"
        }, `${message?.name}：${message?.text}`));
      case 2:
        return /*#__PURE__*/React.createElement("div", {
          className: styles$2.sources
        }, /*#__PURE__*/React.createElement(_Row, null, /*#__PURE__*/React.createElement(_Col, null, message?.name, "\uFF1A"), /*#__PURE__*/React.createElement(_Col, null, /*#__PURE__*/React.createElement(_Tooltip, {
          placement: "rightBottom",
          title: message?.file ? null : '图片，视频等数据过大，上传速度较慢，请稍后查看,请在手机端点击下载图片，才能在后台查看高清图'
        }, /*#__PURE__*/React.createElement("div", {
          role: "button",
          onKeyPress: () => null,
          tabIndex: "0",
          onClick: () => showBigPic(message)
        }, /*#__PURE__*/React.createElement("img", {
          style: {
            width: 50,
            height: 50
          },
          src: forceHttps(message?.file) || img$c,
          alt: ""
        }))))));
      case 4:
        return /*#__PURE__*/React.createElement("div", {
          className: styles$2.sources
        }, /*#__PURE__*/React.createElement(_Row, null, /*#__PURE__*/React.createElement(_Col, null, message?.name, "\uFF1A"), /*#__PURE__*/React.createElement(_Col, null, /*#__PURE__*/React.createElement(_Tooltip, {
          placement: "bottom",
          title: message?.file ? null : '视频数据过大，上传速度较慢，请稍后查看'
        }, /*#__PURE__*/React.createElement("div", {
          key: `${message?.msgSvrId}`
        }, /*#__PURE__*/React.createElement("video", {
          kind: "captions",
          width: 150,
          controls: "controls",
          type: "video/mp4",
          preload: "auto",
          src: forceHttps(message?.file)
        }, /*#__PURE__*/React.createElement("track", {
          kind: "captions",
          width: 150,
          controls: "controls",
          type: "video/mp4",
          preload: "auto",
          src: forceHttps(message?.file)
        })))))));
      case 9:
        return /*#__PURE__*/React.createElement("div", {
          className: styles$2.sources
        }, /*#__PURE__*/React.createElement(_Row, null, /*#__PURE__*/React.createElement(_Col, null, message?.name, "\uFF1A"), /*#__PURE__*/React.createElement(_Col, null, /*#__PURE__*/React.createElement(_Tooltip, {
          placement: "rightBottom",
          title: message?.file ? null : '文件需要在手机端下载才能上传后台。文件数据过大，上传速度较慢，请稍后查看'
        }, /*#__PURE__*/React.createElement("div", {
          role: "button",
          tabIndex: "0",
          onKeyPress: () => null,
          onClick: () => linkHrefFile(message),
          style: {
            display: 'inline'
          }
        }, message?.text, /*#__PURE__*/React.createElement("img", {
          style: {
            width: 25,
            height: 25,
            display: 'inline'
          },
          alt: "",
          src: renderIcon(message)
        }))))));
      case 10:
        return /*#__PURE__*/React.createElement("div", {
          className: styles$2.sources
        }, /*#__PURE__*/React.createElement(_Row, null, /*#__PURE__*/React.createElement(_Col, null, message?.name, "\uFF1A"), /*#__PURE__*/React.createElement(_Col, null, /*#__PURE__*/React.createElement("div", {
          role: "button",
          tabIndex: "0",
          onKeyPress: () => null,
          onClick: () => linkHref(message)
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.linkBox,
          style: {
            width: 250
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.linkText
        }, message?.text.slice(0, 24), "..."), /*#__PURE__*/React.createElement("div", {
          className: styles$2.rightImg
        }, /*#__PURE__*/React.createElement("img", {
          alt: "",
          src: img$9
        })))))));
      case 14:
        return /*#__PURE__*/React.createElement(_Popover, {
          placement: message?.mine ? 'left' : 'right',
          content: /*#__PURE__*/React.createElement("div", {
            key: `${message?.msgSvrId}`,
            className: styles$2.commonBox
          }, /*#__PURE__*/React.createElement("div", {
            className: styles$2.baiduBox
          }, /*#__PURE__*/React.createElement("div", {
            className: styles$2.desc
          }, message?.text), /*#__PURE__*/React.createElement("div", {
            className: styles$2.map
          }, /*#__PURE__*/React.createElement(Map, {
            ak: "WAeVpuoSBH4NswS30GNbCRrlsmdGB5Gv",
            scrollWheelZoom: true,
            zoom: Number(12)
          }, /*#__PURE__*/React.createElement(Point, {
            name: "center",
            lng: message?.file.split(',')[1],
            lat: message?.file.split(',')[0]
          }), /*#__PURE__*/React.createElement(Marker, {
            animation: ANIMATION.BOUNCE
          }, /*#__PURE__*/React.createElement(Point, {
            lng: message?.file.split(',')[1],
            lat: message?.file.split(',')[0]
          })))))),
          trigger: "click"
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.sources,
          role: "button"
        }, message?.name, "\uFF1A", /*#__PURE__*/React.createElement(EnvironmentOutlined, null), message?.text));
      case 18:
        return /*#__PURE__*/React.createElement(_Popover, {
          placement: message?.mine ? 'left' : 'right',
          content: /*#__PURE__*/React.createElement("div", {
            key: `${message?.msgSvrId}`,
            className: `${styles$2.xiaoChengxu} ${styles$2.corner}`
          }, /*#__PURE__*/React.createElement("div", {
            className: styles$2.header
          }, message?.text), /*#__PURE__*/React.createElement("div", {
            className: styles$2.imgThumb
          }, /*#__PURE__*/React.createElement("img", {
            alt: "",
            src: img$n
          })), /*#__PURE__*/React.createElement("div", {
            className: styles$2.footer
          }, /*#__PURE__*/React.createElement("div", {
            className: styles$2.icon
          }, /*#__PURE__*/React.createElement("img", {
            alt: "",
            src: img$o
          })), /*#__PURE__*/React.createElement("div", null, message?.remark))),
          trigger: "click"
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.sources,
          role: "button"
        }, message?.name, "\uFF1A", /*#__PURE__*/React.createElement(LinkOutlined, null), message?.text));
      default:
        return message?.text;
    }
  };
  const renderMessageText = message => {
    const keyword = getRequest('keyword') || '';
    const text = queryParams?.sensitive || keyword;
    let mess = message.text;
    if (message?.msgSvrId === queryParams?.msgid) {
      // 标记关键词
      mess = mess.replace(text, `<span id="${message?.msgSvrId}">${text}</span>`);
    }
    return mess;
  };
  useEffect(() => {
    if (voiceStatus?.type === 'add') {
      setzhStatus(zhStatus + 1);
      setVoiceStatus(undefined);
    } else if (voiceStatus?.type === 'reduce') {
      setzhStatus(zhStatus - 1);
      setVoiceStatus(undefined);
    }
  }, [voiceStatus, zhStatus]);
  useEffect(() => {
    document.title = '聊天记录';
    if (!sensitive && (!params.start || !params.end)) {
      // 如果没有敏感词的话改变滚动条的高度
      setTimeout(() => {
        const {
          current
        } = chatListRef;
        if (chatscrollHeight === 0) {
          current.scrollTop = current.scrollHeight;
        } else {
          current.scrollTop = current.scrollHeight - chatscrollHeight;
        }
        setloading(false);
      }, 2000);
    } else {
      setloading(false);
    }
  }, [chatContentList]);
  const renderMessageType = (message, index) => {
    const sourcesMsg = message?.referMsgJson ? JSON.parse(message?.referMsgJson) : null;
    switch (message?.type) {
      case 1:
        // 文本
        return /*#__PURE__*/React.createElement("div", {
          key: `${message?.msgSvrId}`,
          className: styles$2.messBox
          // eslint-disable-next-line
          ,
          dangerouslySetInnerHTML: {
            __html: renderMessageText(message)
          }
        });
      case 2: // 图片
      case 8:
        // 动图
        return /*#__PURE__*/React.createElement(_Tooltip, {
          placement: "rightBottom",
          title: message?.type === 2 && (message?.file ? null : '图片，视频等数据过大，上传速度较慢，请稍后查看,请在手机端点击下载图片，才能在后台查看高清图')
        }, /*#__PURE__*/React.createElement("div", {
          key: `${message?.msgSvrId}`,
          role: "button",
          onKeyPress: () => null,
          tabIndex: "0",
          onClick: message?.type === 2 ? showBigPic.bind(null, message) : () => null,
          className: message?.file ? styles$2.messBoxPic : styles$2.NullMessBoxPic
        }, /*#__PURE__*/React.createElement("img", {
          className: styles$2.thumbImg,
          src: message?.file && message?.file?.startsWith('http://vweixinf.tc.qq.com') ? message?.file?.replace('http://vweixinf.tc.qq.com', '//shmmsns.yunkecn.com/vweixinf') : forceHttps(message?.file) || img$c,
          alt: ""
        })));
      case 3: // 语音
      case 6: // 语音通话样式
      case 7: // 视频通话样式
      case 15:
        // 群语音样式
        return /*#__PURE__*/React.createElement(VoiceComponent, {
          key: `${message?.msgSvrId}`,
          message: message,
          wechatId: wechatId,
          friendId: friendId,
          index: index,
          zhStatus: zhStatus,
          setVoiceStatus: setVoiceStatus
          // onChangedataout={onChangedataout}
        });
      case 4:
        // 视频
        return /*#__PURE__*/React.createElement(_Tooltip, {
          placement: "bottom",
          title: message?.file ? null : '图片，视频等数据过大，上传速度较慢，请稍后查看'
        }, /*#__PURE__*/React.createElement("div", {
          key: `${message?.msgSvrId}`,
          className: styles$2.chatVideo
        }, /*#__PURE__*/React.createElement("video", {
          kind: "captions",
          width: 250,
          controls: "controls",
          type: "video/mp4",
          preload: "auto",
          src: forceHttps(message?.file)
        }, /*#__PURE__*/React.createElement("track", {
          kind: "captions",
          width: 250,
          controls: "controls",
          type: "video/mp4",
          preload: "auto",
          src: forceHttps(message?.file)
        }))));
      case 5:
        // 红包
        return /*#__PURE__*/React.createElement("div", {
          key: `${message?.msgSvrId}`,
          className: styles$2.redBagBox,
          style: {
            backgroundImage: `url(${img$f})`
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.tipInfo
        }, /*#__PURE__*/React.createElement("div", null, message?.remark)), /*#__PURE__*/React.createElement("div", {
          className: styles$2.footer
        }, "\u5FAE\u4FE1\u7EA2\u5305"));
      case 9:
        // 文件类型
        return /*#__PURE__*/React.createElement(_Tooltip, {
          placement: "rightBottom",
          title: message?.file ? null : '文件需要在手机端下载才能上传后台。文件数据过大，上传速度较慢，请稍后查看'
        }, /*#__PURE__*/React.createElement("div", {
          key: `${message?.msgSvrId}`,
          className: styles$2.commonBox
        }, /*#__PURE__*/React.createElement("div", {
          role: "button",
          tabIndex: "0",
          onKeyPress: () => null,
          className: styles$2.fileCard,
          onClick: () => linkHrefFile(message)
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.context
        }, message?.text), /*#__PURE__*/React.createElement("div", {
          className: styles$2.iconPic
        }, /*#__PURE__*/React.createElement("img", {
          alt: "",
          src: renderIcon(message)
        })))));
      case 10:
        // 链接文件
        return /*#__PURE__*/React.createElement("div", {
          key: `${message?.msgSvrId}`,
          role: "button",
          tabIndex: "0",
          onKeyPress: () => null,
          onClick: () => linkHref(message),
          className: styles$2.commonBox
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.linkBox
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.linkText
        }, message?.text), /*#__PURE__*/React.createElement("div", {
          className: styles$2.rightImg
        }, /*#__PURE__*/React.createElement("img", {
          alt: "",
          src: img$9
        }))));
      case 11:
        // 转账
        return /*#__PURE__*/React.createElement("div", {
          className: styles$2.redBagBox,
          key: `${message?.msgSvrId}`,
          style: {
            backgroundImage: `url(${img$e})`
          }
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.tipInfo
        }, /*#__PURE__*/React.createElement("div", null, message?.text)), /*#__PURE__*/React.createElement("div", {
          className: styles$2.footer
        }, "\u5FAE\u4FE1\u8F6C\u8D26"));
      case 13:
        // 公众号
        return /*#__PURE__*/React.createElement("div", {
          key: `${message?.msgSvrId}`,
          className: styles$2.chatCard
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.cardBody
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.avatar
        }, /*#__PURE__*/React.createElement("img", {
          alt: "",
          src: message?.file
        })), /*#__PURE__*/React.createElement("div", {
          className: styles$2.text
        }, message?.text)), /*#__PURE__*/React.createElement("div", {
          className: styles$2.cardFooter
        }, message?.remark));
      case 14:
        // 地图
        return /*#__PURE__*/React.createElement("div", {
          key: `${message?.msgSvrId}`,
          className: styles$2.commonBox
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.baiduBox
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.desc
        }, message?.text), /*#__PURE__*/React.createElement("div", {
          className: styles$2.map
        }, /*#__PURE__*/React.createElement(Map, {
          ak: "WAeVpuoSBH4NswS30GNbCRrlsmdGB5Gv",
          scrollWheelZoom: true,
          zoom: Number(12)
        }, /*#__PURE__*/React.createElement(Point, {
          name: "center",
          lng: message?.file.split(',')[1],
          lat: message?.file.split(',')[0]
        }), /*#__PURE__*/React.createElement(Marker, {
          animation: ANIMATION.BOUNCE
        }, /*#__PURE__*/React.createElement(Point, {
          lng: message?.file.split(',')[1],
          lat: message?.file.split(',')[0]
        }))))));
      case 18:
        // 小程序
        return /*#__PURE__*/React.createElement("div", {
          key: `${message?.msgSvrId}`,
          className: `${styles$2.xiaoChengxu} ${styles$2.corner}`
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.header
        }, message?.text), /*#__PURE__*/React.createElement("div", {
          className: styles$2.imgThumb
        }, /*#__PURE__*/React.createElement("img", {
          alt: "",
          src: img$n
        })), /*#__PURE__*/React.createElement("div", {
          className: styles$2.footer
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.icon
        }, /*#__PURE__*/React.createElement("img", {
          alt: "",
          src: img$o
        })), /*#__PURE__*/React.createElement("div", null, message?.remark)));
      case 20:
        // 第三方视频消息
        return /*#__PURE__*/React.createElement("div", {
          key: `${message?.msgSvrId}`,
          className: `${styles$2.xiaoChengxu} ${styles$2.corner}`
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.header
        }, message?.text), /*#__PURE__*/React.createElement("div", {
          className: styles$2.imgThumb
        }, /*#__PURE__*/React.createElement("img", {
          style: {
            maxWidth: '300px !important'
          },
          alt: "",
          src: message?.file
        }), /*#__PURE__*/React.createElement("div", {
          style: {
            color: '#000',
            textAlign: 'left'
          }
        }, message?.text)), /*#__PURE__*/React.createElement("div", {
          className: styles$2.footer
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.icon
        }, /*#__PURE__*/React.createElement("img", {
          alt: "",
          src: message?.imgPath
        })), /*#__PURE__*/React.createElement("div", null, message?.remark)));
      case 21:
        // 引用消息
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
          key: `${message?.msgSvrId}`,
          className: styles$2.messBox
          // eslint-disable-next-line
          ,
          dangerouslySetInnerHTML: {
            __html: renderMessageText(message)
          }
        }), /*#__PURE__*/React.createElement("div", {
          style: {
            marginTop: 5,
            maxWidth: 333
          }
        }, renderSourcesMsg(sourcesMsg)));
      default:
        return /*#__PURE__*/React.createElement("div", {
          key: `${message?.msgSvrId}`
        }, "\u672A\u77E5\u5185\u5BB9\u7C7B\u578B");
    }
  };
  const renderMessageList = () => {
    const messageType = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 14, 15, 16, 17, 18, 19, 20, 21]; // 左右聊天条样式
    const messageData = chatContentList;
    return messageData.map((message, index) => {
      if (message?.type === -2) {
        return /*#__PURE__*/React.createElement("div", {
          key: `${message?.timestamp}-${message?.text}`,
          className: styles$2.timeLine
        }, message?.text);
      }
      if (message?.type === 15 && !message?.text.includes('语音通话已经结束')) {
        return /*#__PURE__*/React.createElement("div", {
          className: styles$2.messageItem,
          key: `${message?.msgSvrId}`
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.tipmsg
        }, message?.text));
      }
      if (message?.type === 19) {
        return /*#__PURE__*/React.createElement("div", {
          className: styles$2.messageItem,
          key: `${message?.msgSvrId}`
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.tipmsg
        }, "\u5F00\u59CB\u4F4D\u7F6E\u5171\u4EAB"));
      }
      if (messageType.includes(message?.type)) {
        return /*#__PURE__*/React.createElement("div", {
          className: message?.mine ? `${styles$2.messageItem} ${styles$2.right}` : styles$2.messageItem,
          key: `${message?.msgSvrId}`
        }, deleteStatus && /*#__PURE__*/React.createElement("div", {
          className: styles$2.checkBox
        }, /*#__PURE__*/React.createElement(_Checkbox, {
          checked: message?.checkStatus,
          onChange: () => checkMessage(message, index)
        })), /*#__PURE__*/React.createElement("div", {
          className: styles$2.mAvatar
        }, /*#__PURE__*/React.createElement(_Avatar, {
          src: forceHttps(message?.headUrl) || WECHAT_LOGO,
          shape: "square",
          size: 44
        })), /*#__PURE__*/React.createElement("div", {
          className: styles$2.mContent
        }, /*#__PURE__*/React.createElement("div", {
          className: styles$2.miniTitle
        }, message?.name, ' ', moment(message?.timestamp).format('YYYY-MM-DD HH:mm:ss')), /*#__PURE__*/React.createElement("div", {
          className: styles$2.boxContain
        }, message?.mine && message?.msgSvrId === queryParams?.msgid && /*#__PURE__*/React.createElement("div", {
          className: styles$2.position
        }, /*#__PURE__*/React.createElement("img", {
          src: img$d,
          alt: ""
        })), renderMessageType(message, index), !message?.mine && message?.msgSvrId === queryParams?.msgid && /*#__PURE__*/React.createElement("div", {
          className: styles$2.position
        }, /*#__PURE__*/React.createElement("img", {
          src: img$d,
          alt: ""
        })))));
      }
      return /*#__PURE__*/React.createElement("div", {
        className: styles$2.messageItem,
        key: `${message?.msgSvrId}`
      }, /*#__PURE__*/React.createElement("div", {
        className: styles$2.tipmsg
      }, "\u672A\u77E5\u7C7B\u578B-\u6682\u65E0\u5904\u7406"));
    });
  };
  const renderChangetime = value => {
    setParams({
      ...params,
      start: value && value[0] ? value[0].startOf('day').valueOf() : '',
      end: value && value[1] ? value[1].endOf('day').valueOf() : ''
    });
  };
  const getChatContentListPre = async () => {
    const data = {
      wechatId,
      friendId,
      start: '',
      end: Number(chatContentList[0]?.timestamp) - 1
    };
    setloading(true);
    const response = await chatRecords(data, userObj);
    if (response) {
      setlist(response?.messages.concat(chatContentList));
      setchatContentHasLast(response.hasLast);
      setchatContentHasNext(response.hasNext);
      setchatscrollHeight(0);
    }
  };
  const getChatContentListLast = async () => {
    const data = {
      wechatId,
      friendId,
      start: chatContentList[chatContentList.length - 1]?.timestamp + 1,
      end: ''
    };
    setloading(true);
    const response = await chatRecords(data, userObj);
    if (response) {
      setlist(chatContentList.concat(response?.messages));
      setchatContentHasLast(response.hasLast);
      setchatContentHasNext(response.hasNext);
    }
  };
  const moreMessage = e => {
    const {
      current
    } = chatListRef;
    setchatscrollHeight(current.scrollHeight);
    if (e === 1) {
      getChatContentListPre();
    } else if (e === 2) {
      getChatContentListLast();
    }
  };
  const searchKeywords = value => {
    const data = {
      wxId: wechatId,
      friendId,
      keyword: value
    };
    searchContent(data).then(res => {
      if (res.success) {
        setSeachist(res.data);
        setshowSearchList(true);
      }
    });
  };
  const searchReulstJump = item => {
    setParams({
      ...params,
      start: item.timestamp - 1,
      end: ''
    });
  };
  const renderSearchList = () => /*#__PURE__*/React.createElement("div", {
    className: styles$2.searchContentWrapper
  }, searchContentList.length > 0 && searchContentList.map(item => /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: "0",
    onKeyPress: () => null,
    onClick: () => searchReulstJump(item),
    className: styles$2.itemInfo
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2.name
  }, item.name, item.time), /*#__PURE__*/React.createElement("div", {
    className: styles$2.content
  }, item.text))), searchContentList.length === 0 && /*#__PURE__*/React.createElement("div", null, "\u6682\u65E0\u641C\u7D22\u7ED3\u679C"), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Button, {
    type: "primary",
    onClick: () => setshowSearchList(false)
  }, "\u5173\u95ED")));
  const deteleCustomer = async () => {
    const msgSvrIds = chatContentList.filter(item => item.checkStatus).map(item => item.msgSvrId).join(',');
    const data = {
      msgSvrIds,
      wechatId
    };
    const response = await delRecords(data);
    if (response.success) {
      getWecahRecord();
      setDelteStatus(false);
    } else {
      _message.error(response.message);
    }
  };
  const genjinUser = async item => {
    const data = {
      friendId: item.friendId
    };
    const response = await groupFriendSaleList(data);
    if (response.success) {
      settableData(response.data);
      setModal(true);
    }
  };
  const renderGenjin = item => {
    // eslint-disable-next-line
    const status =
    // eslint-disable-next-line no-nested-ternary
    wechatId !== item.friendId ? (item.wechatId !== undefined ? item.wechatId.indexOf(wechatId) >= 0 : false) === true ? item.num > 1 : item.num > 0 : false;
    if (status) {
      return /*#__PURE__*/React.createElement(_Tooltip, {
        placement: "rightBottom",
        title: "\u8BE5\u7FA4\u6210\u5458\u6709\u5176\u4ED6\u9500\u552E\u8DDF\u8FDB"
      }, /*#__PURE__*/React.createElement("div", {
        role: "button",
        tabIndex: "0",
        onKeyPress: () => null,
        onClick: () => genjinUser(item),
        className: styles$2.iconGen
      }, /*#__PURE__*/React.createElement("img", {
        alt: "\u8DDF\u8FDB\u7528\u6237",
        src: img$b
      })));
    }
    return true;
  };
  const getLists = async value => {
    const response = await groupTalkerList({
      wechatId,
      friendId,
      friendName: value || ''
    });
    if (response.success) {
      setchatGroupMember(response.data);
    }
  };
  useEffect(() => {
    if (isShow) {
      getLists();
    }
  }, [isShow]);
  const searchGroupMember = value => {
    getLists(value);
  };
  const handleChangeType = value => {
    setParams({
      ...params,
      types: value.join(',')
    });
  };
  const disabledDate = current => {
    if (!dates) {
      return false;
    }
    const a = Math.floor((dates[1] - moment(dates[1]).startOf('month')) / 1000 / 3600 / 24);
    const b = Math.floor((moment(dates[0]).endOf('month') - dates[0]) / 1000 / 3600 / 24);
    const tooLate = dates[0] && current.diff(dates[0], 'days') > b;
    const tooEarly = dates[1] && dates[1].diff(current, 'days') > a;
    return !!tooEarly || !!tooLate;
  };
  const onOpenChange = open => {
    if (open) {
      setDates([null, null]);
    } else {
      setDates(null);
    }
  };
  return /*#__PURE__*/React.createElement("div", {
    className: styles$2.chatWrapper
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2.chatContent
  }, !friendId && /*#__PURE__*/React.createElement(_Empty, null), friendId && /*#__PURE__*/React.createElement("div", {
    className: styles$2.headerChat
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2.uname
  }, detail?.customerName || '微信聊天'), /*#__PURE__*/React.createElement("div", {
    className: styles$2.subHead
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2.searchTool
  }, /*#__PURE__*/React.createElement(RangePicker, {
    allowClear: false,
    value: dates || dateValue,
    locale: zhCN,
    onCalendarChange: val => setDates(val),
    disabledDate: disabledDate,
    onOpenChange: onOpenChange,
    onChange: value => {
      setDateValue(value);
      renderChangetime(value);
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-block'
    },
    id: "searchDom"
  }, /*#__PURE__*/React.createElement(_Popover, {
    placement: "bottom",
    open: showSearchList,
    title: "\u641C\u7D22\u7ED3\u679C",
    getPopupContainer: () => document.getElementById('searchDom'),
    content: renderSearchList()
  }, /*#__PURE__*/React.createElement(Search, {
    placeholder: "\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u641C\u7D22",
    onSearch: value => {
      searchKeywords(value);
    },
    style: {
      width: '200px',
      marginLeft: '10px',
      marginTop: '-6px'
    }
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'inline-block'
    },
    id: "selectDom"
  }, /*#__PURE__*/React.createElement(_Select, {
    mode: "multiple",
    style: {
      width: '300px',
      marginLeft: '10px'
    },
    placeholder: "\u8BF7\u9009\u62E9\u7C7B\u578B",
    getPopupContainer: () => document.getElementById('selectDom'),
    onChange: handleChangeType
  }, searchTypeList.map(item => /*#__PURE__*/React.createElement(_Select.Option, {
    value: item.value
  }, item.name)))), delAuth && !deleteStatus && /*#__PURE__*/React.createElement(_Button, {
    onClick: () => {
      setDelteStatus(true);
    },
    type: "danger",
    style: {
      marginLeft: '10px',
      fontSize: 12
    }
  }, "\u5220\u9664\u804A\u5929\u8BB0\u5F55"), deleteStatus && /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement(_Button, {
    onClick: () => deteleCustomer(),
    type: "danger",
    style: {
      marginLeft: '10px'
    }
  }, "\u786E\u5B9A\u5220\u9664"), /*#__PURE__*/React.createElement(_Button, {
    onClick: () => {
      setDelteStatus(false);
    },
    style: {
      marginLeft: '10px'
    }
  }, "\u53D6\u6D88"))), friendId.indexOf('@chatroom') > -1 && /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: "0",
    onKeyPress: () => null,
    onClick: () => setisShow(!isShow),
    className: styles$2.btnUsers
  }, /*#__PURE__*/React.createElement(UserOutlined, null)))), friendId && /*#__PURE__*/React.createElement("div", {
    className: styles$2.chatBox,
    ref: chatListRef
  }, /*#__PURE__*/React.createElement(_Spin, {
    spinning: loading
  }, chatContentHasLast && /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: "0",
    onKeyPress: () => null,
    onClick: () => moreMessage(1),
    className: styles$2.linkMore
  }, "\u67E5\u770B\u66F4\u591A\u6D88\u606F"), chatContentList.length > 0 && renderMessageList(), chatContentList.length < 0 && /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: "0",
    onKeyPress: () => null,
    onClick: () => null,
    className: styles$2.linkMore
  }, "\u6682\u65E0\u4FE1\u606F"), chatContentHasNext && /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: "0",
    onKeyPress: () => null,
    onClick: () => moreMessage(2),
    className: styles$2.linkMore
  }, "\u67E5\u770B\u66F4\u591A\u6D88\u606F")), /*#__PURE__*/React.createElement(_Drawer, {
    placement: "right",
    closable: false,
    onClose: () => setisShow(false),
    open: isShow,
    mask: false,
    getContainer: false,
    width: 300,
    drawerStyle: {
      boxShadow: 'none'
    },
    style: {
      position: 'fixed',
      top: '120px'
    }
  }, /*#__PURE__*/React.createElement(Search, {
    onSearch: value => {
      searchGroupMember(value);
    },
    placeholder: "\u8BF7\u8F93\u5165\u5173\u952E\u8BCD\u641C\u7D22"
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$2.groupMember
  }, chatGroupMember.map(item => /*#__PURE__*/React.createElement("div", {
    className: styles$2.member,
    key: item.friendName
  }, /*#__PURE__*/React.createElement(_Avatar, {
    src: forceHttps(item.friendHeadImageUrl),
    style: {
      marginRight: '5px'
    },
    shape: "square",
    size: 32
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$2.mName
  }, item.friendName), item.wechatId !== undefined && item.friendId !== wechatId && item.wechatId.indexOf(wechatId) >= 0 && /*#__PURE__*/React.createElement(_Tooltip, {
    placement: "rightBottom",
    title: "\u8BE5\u7FA4\u6210\u5458\u662F\u6B64\u5FAE\u4FE1\u53F7\u7684\u597D\u53CB"
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$2.iconGen
  }, /*#__PURE__*/React.createElement("img", {
    alt: "\u597D\u53CB\u5173\u7CFB",
    src: img$a
  }))), renderGenjin(item))))))), open && /*#__PURE__*/React.createElement(PhotoSlider, {
    toolbarRender: ({
      rotate,
      onRotate,
      onScale,
      scale
    }) => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
      className: "PhotoView-PhotoSlider__toolbarIcon",
      width: "44",
      height: "44",
      viewBox: "0 0 768 768",
      fill: "white",
      onClick: () => onScale(scale + 0.2)
    }, /*#__PURE__*/React.createElement("path", {
      d: "M384 640.5q105 0 180.75-75.75t75.75-180.75-75.75-180.75-180.75-75.75-180.75 75.75-75.75 180.75 75.75 180.75 180.75 75.75zM384 64.5q132 0 225.75 93.75t93.75 225.75-93.75 225.75-225.75 93.75-225.75-93.75-93.75-225.75 93.75-225.75 225.75-93.75zM415.5 223.5v129h129v63h-129v129h-63v-129h-129v-63h129v-129h63z"
    })), /*#__PURE__*/React.createElement("svg", {
      className: "PhotoView-PhotoSlider__toolbarIcon",
      width: "44",
      height: "44",
      viewBox: "0 0 768 768",
      fill: "white",
      onClick: () => onScale(scale - 0.2)
    }, /*#__PURE__*/React.createElement("path", {
      d: "M384 640.5q105 0 180.75-75.75t75.75-180.75-75.75-180.75-180.75-75.75-180.75 75.75-75.75 180.75 75.75 180.75 180.75 75.75zM384 64.5q132 0 225.75 93.75t93.75 225.75-93.75 225.75-225.75 93.75-225.75-93.75-93.75-225.75 93.75-225.75 225.75-93.75zM223.5 352.5h321v63h-321v-63z"
    })), /*#__PURE__*/React.createElement("svg", {
      className: "PhotoView-PhotoSlider__toolbarIcon",
      onClick: () => onRotate(rotate + 90),
      width: "44",
      height: "44",
      fill: "white",
      viewBox: "0 0 768 768"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M565.5 202.5l75-75v225h-225l103.5-103.5c-34.5-34.5-82.5-57-135-57-106.5 0-192 85.5-192 192s85.5 192 192 192c84 0 156-52.5 181.5-127.5h66c-28.5 111-127.5 192-247.5 192-141 0-255-115.5-255-256.5s114-256.5 255-256.5c70.5 0 135 28.5 181.5 75z"
    }))),
    images: [{
      src,
      key: '1'
    }],
    open: true,
    onClose: () => setopen(false),
    index: 0
  }), /*#__PURE__*/React.createElement(_Modal, {
    title: "\u8DDF\u8FDB\u7528\u6237",
    centered: true,
    width: 600,
    footer: false,
    open: modal,
    onOk: () => setModal(false),
    onCancel: () => setModal(false)
  }, /*#__PURE__*/React.createElement(_Table, {
    columns: columns,
    dataSource: tableData
  })));
};
WechatMessage.propTypes = propTypes$4;
WechatMessage.defaultProps = defaultProps$4;

const useWebsocket = ({
  url,
  verify
}) => {
  const ws = useRef(null);
  const [wsData, setMessage] = useState({});
  const [readyState, setReadyState] = useState({
    key: 0,
    value: '正在连接中'
  });
  const creatWebSocket = () => {
    const stateArr = [{
      key: 0,
      value: '正在连接中'
    }, {
      key: 1,
      value: '已经连接并且可以通讯'
    }, {
      key: 2,
      value: '连接正在关闭'
    }, {
      key: 3,
      value: '连接已关闭或者没有连接成功'
    }];
    try {
      ws.current = new WebSocket(url);
      ws.current.onopen = () => {
        setReadyState(stateArr[ws.current?.readyState ?? 0]);
      };
      ws.current.onclose = () => {
        setReadyState(stateArr[ws.current?.readyState ?? 0]);
      };
      ws.current.onerror = () => {
        setReadyState(stateArr[ws.current?.readyState ?? 0]);
      };
      ws.current.onmessage = e => {
        const {
          data
        } = e;
        if (data.startsWith('{')) {
          const obj = JSON.parse(data);
          if (obj.pushType === 'DIALOG_TYPE' || obj.pushType === 'MSG_TYPE') {
            setMessage(obj);
          } else if (obj.pushType === 'ELINK_PAY_STATUS') {
            const orderStatus = obj.data.orderstatus;
            setMessage({
              orderStatus
            });
          } else {
            // const { payload } = obj;
            // const orderStatus = payload?.extra?.orderStatus || 0;
            setMessage(obj);
          }
        }
      };
    } catch (error) {
      console.log(error);
    }
  };
  const webSocketInit = () => {
    if (!ws.current || ws.current.readyState === 3) {
      creatWebSocket();
    }
  };

  //  关闭 WebSocket
  const closeWebSocket = () => {
    ws.current?.close();
  };

  // 发送数据
  const sendMessage = str => {
    ws.current?.send(str);
  };

  // 重连
  const reconnect = () => {
    try {
      closeWebSocket();
      ws.current = null;
      creatWebSocket();
    } catch (e) {
      console.log(e);
    }
  };
  useEffect(() => {
    if (verify) {
      webSocketInit();
    }
    return () => {
      ws.current?.close();
    };
  }, [ws, verify]);
  return {
    wsData,
    readyState,
    closeWebSocket,
    reconnect,
    sendMessage
  };
};

var css_248z$1 = ".style-module_pageView__1Hvnt {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: row;\n  background-color: #f1f2f5;\n  overflow: hidden !important;\n}\n.style-module_rightContentPart__2YJGy {\n  width: 100%;\n  padding: 20px 20px;\n  overflow: auto;\n}\n.style-module_rightContentPart__2YJGy ::-webkit-scrollbar {\n  width: 0;\n  height: 0;\n}\n.style-module_headerBox__WSDHo {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.style-module_headportrait__gdw7T {\n  display: flex;\n  align-items: center;\n  justify-content: space-around;\n  padding-right: 30%;\n  border-right: 1px solid #eeeeee;\n}\n.style-module_name__BO2M1 {\n  width: 300px;\n  font-size: 24px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.85);\n}\n.style-module_account__1iEiE {\n  margin-left: 40px;\n  width: 800px;\n}\n.style-module_account__1iEiE .style-module_yue__1840r {\n  font-weight: 500;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.85);\n}\n.style-module_account__1iEiE .style-module_yuan__1NJRV {\n  font-weight: 500;\n  font-size: 24px;\n  color: rgba(0, 0, 0, 0.85);\n}\n.style-module_account__1iEiE p {\n  padding: 0;\n  margin: 0;\n}\n.style-module_ImageBOx__1h3RK {\n  margin-left: 26px;\n}\n.style-module_ImageBOx__1h3RK .style-module_name__BO2M1 {\n  font-size: 24px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.85);\n}\n.style-module_ImageBOx__1h3RK .style-module_phone__1iC6F {\n  margin-top: 6px;\n  font-size: 14px;\n  color: rgba(0, 0, 0, 0.45);\n  font-weight: 400;\n}\n.style-module_ImageBOx__1h3RK .style-module_authentication__3gdhc {\n  font-size: 14px;\n  font-weight: 400;\n  color: #00bf40;\n  margin-top: 10px;\n}\n.style-module_ImageBOx__1h3RK p {\n  margin: 0;\n  padding: 0;\n}\n.style-module_headerBody__2VXUe {\n  width: 100%;\n  height: 166px;\n  background: #ffffff;\n  border-radius: 4px;\n  border: 1px solid #f0f0f2;\n  margin-bottom: 20px;\n  padding: 20px;\n}\n.style-module_pageContent__TBAja {\n  width: 100%;\n  height: 738px;\n  padding: 20px 20px;\n  overflow-x: hidden;\n  background: #ffffff;\n  border-radius: 4px;\n  border: 1px solid #f0f0f2;\n}\n.style-module_pageContent__TBAja .style-module_title__2Dg11 {\n  font-size: 16px;\n  line-height: 24px;\n  padding: 15px 0;\n  margin-top: -20px;\n  margin-bottom: 10px;\n  font-weight: 500;\n  border-bottom: 1px solid rgba(0, 0, 0, 0.06);\n}\n.style-module_boxflex__22_0Z {\n  display: flex;\n}\n.style-module_box__3pOmx {\n  width: 440px;\n  height: 258px;\n  background: #ffffff;\n  border-radius: 4px;\n  border: 1px solid #e6e6e6;\n  margin-top: 10px;\n  padding: 20px;\n}\n.style-module_imgBox__32BxB {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n.style-module_imgBox__32BxB img {\n  width: 58px !important;\n}\n.style-module_texts__3l8z6 {\n  font-size: 16px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.85);\n  display: inline-block;\n  vertical-align: middle;\n}\n.style-module_textP__1_Un- {\n  font-size: 14px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.45);\n}\n.style-module_textP__1_Un- p {\n  margin: 0;\n  padding: 0;\n}\n.style-module_boxFlex__11FLF {\n  display: flex;\n  justify-self: start;\n  align-items: center;\n}\n.style-module_boxFlex__11FLF .style-module_headerImg__nx4vQ {\n  width: 70px;\n  height: 70px;\n}\n.style-module_boxFlex__11FLF .style-module_comnameTitle___eOz1 {\n  font-size: 16px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.85);\n  line-height: 21px;\n  display: inline-block;\n  margin-left: 30px;\n}\n.style-module_boxfooter__xUZuK {\n  position: fixed;\n  bottom: 0;\n  padding-bottom: 10px;\n  right: 3%;\n}\n.style-module_boxfooter__xUZuK button {\n  width: 270px;\n  height: 36px;\n  margin: 0 auto;\n  text-align: center;\n  background: #006aff;\n  border-radius: 3px;\n}\n.style-module_inputNumber__xq5fn {\n  width: 165px;\n  background: #ffffff;\n  border-radius: 3px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n}\n.style-module_rechargeBox__3fRya {\n  margin-top: 20px;\n  font-size: 13px;\n  font-weight: 500;\n}\n.style-module_rechargeBox__3fRya .style-module_textSpan__Aca8e {\n  margin-left: 10px;\n  display: inline-block;\n}\n.style-module_rechargeBox__3fRya b {\n  font-size: 19px;\n  font-weight: bold;\n  color: #ff4d4f;\n}\n.style-module_iconStyle__1Gj1I {\n  display: inline-block;\n  width: 14px;\n  height: 14px;\n  margin-right: 8px;\n}\n.style-module_bule__vSiCl {\n  margin-top: 20px;\n  width: 100%;\n  height: 130px;\n  background: #f2faff;\n  border-radius: 4px;\n  padding: 15px;\n}\n.style-module_bule__vSiCl .style-module_tips__11xcx {\n  font-size: 12px;\n  font-weight: bold;\n  display: inline-block;\n}\n.style-module_bule__vSiCl p {\n  line-height: 17px;\n  margin-top: 3px;\n  color: rgba(0, 0, 0, 0.45);\n  font-size: 14px;\n  font-weight: 400;\n}\n.style-module_code__2sYWT {\n  text-align: center;\n}\n.style-module_code__2sYWT .style-module_codeWrap__3q5oY {\n  padding: 40px 0 28px;\n  border-radius: 10px;\n}\n.style-module_code__2sYWT .style-module_codeWrap__3q5oY .style-module_codeavatar__eslXV {\n  display: block;\n  width: 100px;\n  height: 100px;\n  margin: 0 auto;\n  text-align: center;\n  border-radius: 50%;\n}\n.style-module_code__2sYWT .style-module_codeWrap__3q5oY .style-module_codeCompanyname__2lwMb {\n  margin-top: 16px;\n  font-size: 18px;\n  color: #333;\n}\n.style-module_code__2sYWT .style-module_codeWrap__3q5oY .style-module_codeMoney__dED5k {\n  margin-top: 10px;\n  font-size: 23px;\n  font-weight: bold;\n  line-height: 1;\n  color: #333;\n}\n.style-module_code__2sYWT .style-module_codeWrap__3q5oY .style-module_codeQrcode__2QPBa {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  width: 150px;\n  height: 150px;\n  margin: 28px auto 0;\n  border: 2px solid #f8f8f8;\n}\n.style-module_code__2sYWT .style-module_codeWrap__3q5oY .style-module_codetips__Q2gja {\n  margin-top: 20px;\n  font-size: 17px;\n  font-weight: 600;\n  color: #006aff;\n}\n.style-module_code__2sYWT .style-module_codeWrap__3q5oY .style-module_codebottomtext__1VuUB {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 12px;\n  font-size: 14px;\n  color: #333;\n  margin-left: 19px;\n}\n.style-module_code__2sYWT .style-module_codeWrap__3q5oY .style-module_codebottomtext__1VuUB .style-module_text__1aV6x {\n  margin-left: 19px;\n}\n.style-module_code__2sYWT .style-module_codeWrap__3q5oY .style-module_ContraryPay__ZQGh1 {\n  height: 30px;\n  margin-top: 50px;\n  font-size: 14px;\n  color: #333;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.style-module_code__2sYWT .style-module_codeWrap__3q5oY .style-module_ContraryPayName__1Ylpq {\n  color: #006aff;\n  margin-left: 15px;\n}\n.style-module_code__2sYWT .style-module_codeWrap__3q5oY .style-module_ContraryPayText__2kB2p {\n  color: #000;\n  margin-left: 170px;\n}\n.style-module_code__2sYWT .style-module_codeWrap__3q5oY .style-module_ContraryPayTitle__3tR_q {\n  height: 30px;\n  margin-top: 5px;\n  font-size: 14px;\n  color: #999;\n  line-height: 30px;\n}\n";
var styles$1 = {"pageView":"style-module_pageView__1Hvnt","rightContentPart":"style-module_rightContentPart__2YJGy","headerBox":"style-module_headerBox__WSDHo","headportrait":"style-module_headportrait__gdw7T","name":"style-module_name__BO2M1","account":"style-module_account__1iEiE","yue":"style-module_yue__1840r","yuan":"style-module_yuan__1NJRV","ImageBOx":"style-module_ImageBOx__1h3RK","phone":"style-module_phone__1iC6F","authentication":"style-module_authentication__3gdhc","headerBody":"style-module_headerBody__2VXUe","pageContent":"style-module_pageContent__TBAja","title":"style-module_title__2Dg11","boxflex":"style-module_boxflex__22_0Z","box":"style-module_box__3pOmx","imgBox":"style-module_imgBox__32BxB","texts":"style-module_texts__3l8z6","textP":"style-module_textP__1_Un-","boxFlex":"style-module_boxFlex__11FLF","headerImg":"style-module_headerImg__nx4vQ","comnameTitle":"style-module_comnameTitle___eOz1","boxfooter":"style-module_boxfooter__xUZuK","inputNumber":"style-module_inputNumber__xq5fn","rechargeBox":"style-module_rechargeBox__3fRya","textSpan":"style-module_textSpan__Aca8e","iconStyle":"style-module_iconStyle__1Gj1I","bule":"style-module_bule__vSiCl","tips":"style-module_tips__11xcx","code":"style-module_code__2sYWT","codeWrap":"style-module_codeWrap__3q5oY","codeavatar":"style-module_codeavatar__eslXV","codeCompanyname":"style-module_codeCompanyname__2lwMb","codeMoney":"style-module_codeMoney__dED5k","codeQrcode":"style-module_codeQrcode__2QPBa","codetips":"style-module_codetips__Q2gja","codebottomtext":"style-module_codebottomtext__1VuUB","text":"style-module_text__1aV6x","ContraryPay":"style-module_ContraryPay__ZQGh1","ContraryPayName":"style-module_ContraryPayName__1Ylpq","ContraryPayText":"style-module_ContraryPayText__2kB2p","ContraryPayTitle":"style-module_ContraryPayTitle__3tR_q"};
styleInject(css_248z$1);

const propTypes$3 = {
  companyName: PropTypes.string,
  money: PropTypes.number
};
const defaultProps$3 = {
  companyName: '',
  money: 0
};
const Result = ({
  companyName,
  money
}) => /*#__PURE__*/React.createElement("div", {
  className: styles$1.code
}, /*#__PURE__*/React.createElement("div", {
  className: styles$1.codeWrap
}, /*#__PURE__*/React.createElement("img", {
  className: styles$1.codeavatar,
  alt: "",
  src: "https://yunke-pcfile.oss-cn-beijing.aliyuncs.com/images/success.png"
}), /*#__PURE__*/React.createElement("div", {
  style: {
    color: '#006AFF'
  },
  className: styles$1.codeCompanyname
}, "\u5145\u503C\u6210\u529F"), /*#__PURE__*/React.createElement("div", {
  className: styles$1.codeCompanyname
}, companyName), /*#__PURE__*/React.createElement("div", {
  style: {
    color: '#006AFF'
  },
  className: styles$1.codeMoney
}, "\xA5", money / 100)));
Result.propTypes = propTypes$3;
Result.defaultProps = defaultProps$3;

const propTypes$2 = {
  companyInfo: PropTypes.shape({
    imgUrl: PropTypes.string,
    name: PropTypes.string,
    code: PropTypes.string
  }),
  setChangeDetail: PropTypes.func
};
const defaultProps$2 = {
  companyInfo: {},
  setChangeDetail: () => {}
};
const TopUp = ({
  companyInfo,
  setChangeDetail
}) => {
  const [amount, setamount] = useState(0);
  const [loading, setloaing] = useState(false);
  const limitDecimalsF = value => {
    if (value) {
      const reg = /^(-)*(\d+)\.(\d\d).*$/;
      return `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',').replace(reg, '$1$2.$3');
    }
    return '';
  };
  const limitDecimalsP = value => {
    const reg = /^(-)*(\d+)\.(\d\d).*$/;
    return value.replace(/￥\s?|(,*)/g, '').replace(reg, '$1$2.$3');
  };
  const handleChangeClick = async () => {
    setloaing(true);
    const data = {
      amount: amount * 100,
      type: 3,
      name: '线上充值',
      remark: '线上充值'
    };
    const response = await addRechargeCode(data);
    setloaing(false);
    if (response.code === 10000) {
      setChangeDetail({
        id: response?.data?.id,
        money: amount * 100,
        orderType: 3
      });
    } else {
      _message.error(response.message);
    }
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: styles$1.boxFlex
  }, /*#__PURE__*/React.createElement("img", {
    className: styles$1.headerImg,
    alt: "",
    src: companyInfo.imgUrl
  }), /*#__PURE__*/React.createElement("span", {
    className: styles$1.comnameTitle
  }, companyInfo.name)), /*#__PURE__*/React.createElement("div", {
    className: styles$1.rechargeBox
  }, "\u4F59\u989D\u5145\u503C\uFF1A", /*#__PURE__*/React.createElement(_InputNumber, {
    formatter: limitDecimalsF,
    parser: limitDecimalsP,
    onChange: e => setamount(e),
    style: {
      width: '170px'
    },
    placeholder: "\u8BF7\u8F93\u5165\u8981\u5145\u503C\u7684\u6570\u989D"
  }), /*#__PURE__*/React.createElement("span", {
    className: styles$1.textSpan
  }, "\u5143")), /*#__PURE__*/React.createElement("div", {
    className: styles$1.rechargeBox
  }, "\u5E94\u4ED8\u91D1\u989D\uFF1A", /*#__PURE__*/React.createElement("b", null, "\xA5", limitDecimalsF(amount))), /*#__PURE__*/React.createElement("div", {
    className: styles$1.bule
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      paddingTop: '16px'
    }
  }, /*#__PURE__*/React.createElement(InfoCircleOutlined, {
    theme: "filled",
    style: {
      color: '#006aff'
    },
    className: styles$1.iconStyle
  }), /*#__PURE__*/React.createElement("span", {
    className: styles$1.Tips
  }, "\u63D0\u793A")), /*#__PURE__*/React.createElement("p", null, " \u60A8\u597D\uFF0C\u6682\u65F6\u4E0D\u652F\u6301\u7535\u5B50\u53D1\u7968\uFF0C\u82E5\u60F3\u5F00\u53D1\u7968\u8BF7\u76F4\u63A5\u8054\u7CFB\u60A8\u7684\u9500\u552E\u7ECF\u7406~"))), /*#__PURE__*/React.createElement("div", {
    className: styles$1.boxfooter
  }, /*#__PURE__*/React.createElement(_Button, {
    loading: loading,
    onClick: () => handleChangeClick(),
    type: "primary"
  }, "\u4E0B\u4E00\u6B65")));
};

// class TopUp extends Component {
//   constructor() {
//     super();
//     this.state = {
//       amount: 0,
//       loading: false,
//     };
//   }

//   handleChangeClick = async () => {
//     this.setState(
//       {
//         loading: true,
//       },
//     );
//     const { amount } = this.state;
//     const { setUserPayInfo } = this.props;
//     const data = {
//       amount: amount * 100, type: 3, name: '线上充值', remark: '线上充值',
//     };
//     const response = await addRechargeCode(data);
//     this.setState(
//       {
//         loading: false,
//       },
//     );
//     if (response.code === 10000) {
//       setUserPayInfo({
//         id: response?.data?.id,
//         money: amount * 100,
//       });
//     } else {
//       message.error(response.message);
//     }
//   };

//   render() {
//     const { amount, loading } = this.state;
//     const { companyInfo } = this.props;
//     return (
//       <>
//         <div>
//           <div className={styles.boxFlex}>
//             <img className={styles.headerImg} alt="" src={companyInfo.imgUrl} />
//             <span className={styles.comnameTitle}>{companyInfo.name}</span>
//           </div>
//           <div className={styles.rechargeBox}>
//             余额充值：
//             <InputNumber
//               formatter={limitDecimalsF}
//               parser={limitDecimalsP}
//               onChange={(e) => this.setState({ amount: e })}
//               style={{ width: '170px' }}
//               placeholder="请输入要充值的数额"
//             />
//             <span className={styles.textSpan}>元</span>
//           </div>
//           <div className={styles.rechargeBox}>
//             应付金额：
//             <b>
//               ¥
//               {limitDecimalsF(amount)}
//             </b>
//           </div>
//           <div className={styles.bule}>
//             <p style={{ paddingTop: '16px' }}>
//               <InfoCircleOutlined
//                 theme="filled"
//                 style={{ color: '#006aff' }}
//                 className={styles.iconStyle}
//               />
//               <span className={styles.Tips}>提示</span>
//             </p>
//             <p> 您好，暂时不支持电子发票，若想开发票请直接联系您的销售经理~</p>
//           </div>
//         </div>
//         <div className={styles.boxfooter}>
//           <Button
//             loading={loading}
//             onClick={() => this.handleChangeClick()}
//             type="primary"
//           >
//             下一步
//           </Button>
//         </div>
//       </>
//     );
//   }
// }
TopUp.propTypes = propTypes$2;
TopUp.defaultProps = defaultProps$2;

const propTypes$1 = {
  userPayInfo: PropTypes.shape({
    id: PropTypes.string,
    money: PropTypes.number,
    orderType: PropTypes.number,
    open: PropTypes.bool
  }),
  onClose: PropTypes.func
};
const defaultProps$1 = {
  userPayInfo: {
    id: '',
    money: 0,
    orderType: 4
  },
  onClose: () => null
};
const UserPay = ({
  userPayInfo,
  onClose
}) => {
  const {
    wsData,
    readyState,
    closeWebSocket,
    reconnect,
    sendMessage
  } = useWebsocket({
    url: window.location.hostname === 'test.yunkecn.com' ? 'wss://test.yunkecn.com:443/netty/ws?appVersion=cms' : `wss://netty.yunkecn.com:443/netty/ws?compnayCode=${localStorage.getItem('company')}&userId=${localStorage.getItem('userid')}&appVersion=cms`,
    verify: true // 此参数控制是否有权限，请求该方法
  });
  const [orderStatus, setorderStatus] = useState('');
  const [detail, setDetail] = useState({});
  const companyInfo = JSON.parse(localStorage.getItem('companyInfo'));
  const {
    id,
    money,
    orderType
  } = userPayInfo;
  const userId = JSON.parse(localStorage.getItem('userData'))?.userId;
  const [contraryPayisModalopen, setcontraryPayisModalopen] = useState(false);
  useEffect(() => {
    if (readyState.key === 1) {
      const messagae = {
        WXZ_NETTY: 'USER_ONLINE_STATUS',
        appId: 'yunkepc',
        companyCode: localStorage.getItem('company'),
        userId: localStorage.getItem('userid')
      };
      sendMessage(JSON.stringify(messagae));
    }
    const {
      orderStatus: orderStatus1
    } = wsData;
    if (orderStatus1) {
      setorderStatus(orderStatus1);
    }
    // 如果是已关闭且是当前页面自动重连
    if (readyState.key === 3) {
      reconnect();
    }
  }, [wsData, readyState]);
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Drawer, {
    title: "\u5145\u503C",
    width: "450",
    open: true,
    onClose: () => {
      closeWebSocket();
      onClose();
      setDetail({
        ...detail,
        open: false
      });
    }
  }, !id && !detail.id && !orderStatus && /*#__PURE__*/React.createElement(TopUp, {
    setChangeDetail: value => setDetail(value),
    companyInfo: companyInfo
  }), (id || detail.id) && !orderStatus && /*#__PURE__*/React.createElement("div", {
    className: styles$1.code
  }, /*#__PURE__*/React.createElement("div", {
    className: styles$1.codeWrap
  }, /*#__PURE__*/React.createElement("img", {
    className: styles$1.codeavatar,
    alt: "",
    src: companyInfo.imgUrl || 'https://yunke-pcfile.oss-cn-beijing.aliyuncs.com/POrV/2021-07-06/6219c80023.png'
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$1.codeCompanyname
  }, companyInfo.name), /*#__PURE__*/React.createElement("div", {
    className: styles$1.codeMoney
  }, "\xA5", (money || detail?.money) / 100), /*#__PURE__*/React.createElement("div", {
    className: styles$1.codeQrcode
  }, /*#__PURE__*/React.createElement(QRCode, {
    value: `https://www.yunkecn.com/cashier-h5/#/pages/receiving-code/amount/index?id=${id || detail.id}&shareUserId=9F11AC906E7843A58CE2F02EB1C24754&userId=${userId}&orderType=${orderType || detail?.orderType}&companyCode=${companyInfo.code}`,
    size: 145,
    scale: 4,
    typenumber: 2
  })), /*#__PURE__*/React.createElement("div", {
    className: styles$1.codetips
  }, "\u626B\u7801\u4ED8\u6B3E"), /*#__PURE__*/React.createElement("div", {
    className: styles$1.codebottomtext
  }, /*#__PURE__*/React.createElement(WechatOutlined, {
    style: {
      color: '#49C13C'
    },
    size: "20"
  }, "\uE607"), /*#__PURE__*/React.createElement("div", {
    className: styles$1.text
  }, "\u5FAE\u4FE1\u652F\u4ED8\xA0\xA0\xA0\xA0\xA0\xA0\xA0\xA0"), /*#__PURE__*/React.createElement(AlipayCircleOutlined, {
    style: {
      color: '#03A9F3'
    },
    size: "20"
  }, "\uE602"), /*#__PURE__*/React.createElement("div", {
    className: styles$1.text
  }, "\u652F\u4ED8\u5B9D\u652F\u4ED8")), /*#__PURE__*/React.createElement("div", {
    className: styles$1.ContraryPay
  }, /*#__PURE__*/React.createElement("img", {
    src: "http://yunke-pcfile.oss-cn-beijing.aliyuncs.com/POrV/2022-07-14/aebe47e53a.png",
    style: {
      width: 15,
      height: 15
    },
    alt: ""
  }), /*#__PURE__*/React.createElement("div", {
    className: styles$1.ContraryPayName
  }, "\u5BF9\u516C\u652F\u4ED8"), /*#__PURE__*/React.createElement(_Button, {
    type: "link",
    className: styles$1.ContraryPayText,
    onClick: () => {
      setcontraryPayisModalopen(true);
    }
  }, "\u6211\u8981\u5BF9\u516C\u652F\u4ED8", '>')), /*#__PURE__*/React.createElement("p", {
    className: styles$1.ContraryPayTitle
  }, "\u83B7\u53D6\u5BF9\u516C\u652F\u4ED8\u8BE6\u7EC6\u4FE1\u606F\uFF0C\u652F\u4ED8\u5B8C\u6210\u540E\u6211\u4EEC\u4F1A\u5C3D\u5FEB\u786E\u8BA4\u5230\u8D26\u6237\u3002"))), orderStatus === 1 && /*#__PURE__*/React.createElement(Result, {
    companyName: companyInfo?.companyName,
    money: detail?.money || money
  })), /*#__PURE__*/React.createElement(_Modal, {
    title: "\u5BF9\u516C\u652F\u4ED8",
    open: contraryPayisModalopen,
    onOk: () => {
      setcontraryPayisModalopen(false);
    },
    width: 800,
    onCancel: () => {
      setcontraryPayisModalopen(false);
    },
    okText: "\u5DF2\u5B8C\u6210\u5BF9\u516C\u8F6C\u8D26"
  }, /*#__PURE__*/React.createElement("div", {
    className: "site-card-wrapper"
  }, /*#__PURE__*/React.createElement(_Row, {
    gutter: 16
  }, /*#__PURE__*/React.createElement(_Col, {
    span: 12
  }, /*#__PURE__*/React.createElement(_Card, {
    title: "\u5BF9\u516C\u8F6C\u8D26\u6D41\u7A0B",
    bordered: false
  }, /*#__PURE__*/React.createElement("p", null, "\u7B2C\u4E00\u6B65:\u5BF9\u516C\u6C47\u6B3E"), /*#__PURE__*/React.createElement("p", null, "\u516C\u53F8\u540D\u79F0:", /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: 10
    }
  }, "\u4E0A\u6D77\u98A2\u4E30\u79D1\u6280\u6709\u9650\u516C\u53F8")), /*#__PURE__*/React.createElement("p", null, "\u5F00\u6237\u884C:", /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: 10
    }
  }, "\u5DE5\u5546\u94F6\u884C\u957F\u4E09\u89D2\u4E00\u4F53\u5316\u793A\u8303\u533A\u652F\u884C")), /*#__PURE__*/React.createElement("p", null, "\u8D26\u53F7:", /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: 10
    }
  }, "1001742209300224440")), /*#__PURE__*/React.createElement("p", null, "\u6C47\u6B3E\u91D1\u989D:", /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: 10
    }
  }, "\xA5", money / 100)), /*#__PURE__*/React.createElement("p", null, "\u6C47\u6B3E\u5907\u6CE8:", /*#__PURE__*/React.createElement("span", {
    style: {
      marginLeft: 10
    }
  }, "\u4F01\u4E1A\u8D26\u6237\u5145\u503C")))), /*#__PURE__*/React.createElement(_Col, {
    span: 12
  }, /*#__PURE__*/React.createElement(_Card, {
    title: "\u5BF9\u516C\u8F6C\u8D26\u6D41\u7A0B",
    bordered: false
  }, /*#__PURE__*/React.createElement("p", null, "\u7B2C\u4E8C\u6B65\uFF1A\u5347\u7EA7\u8D26\u53F7"), /*#__PURE__*/React.createElement("p", null, "\u8F6C\u8D26\u5B8C\u6210\u540E\u8BF7\u70B9\u51FB", /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#1890ff'
    }
  }, "\u5DF2\u5B8C\u6210\u5BF9\u516C\u8F6C\u8D26"), ",\u6211\u4EEC\u6536\u5230\u6C47\u6B3E24\u5C0F\u65F6\u5185\u5C06\u4F1A\u4E3A\u60A8\u7684\u8D26\u6237\u8FDB\u884C\u5145\u503C\u3002\uFF08\u5468\u672B\u3001\u6CD5\u5B9A\u5047\u65E5\u53EF\u80FD\u5EF6\u8FDF\uFF09"), /*#__PURE__*/React.createElement("p", null, "\u7EBF\u4E0B\u6C47\u6B3E\u5B8C\u6210\u540E\uFF0C\u8BF7\u5C06\u6C47\u6B3E\u622A\u56FE\u548C\u4F01\u4E1A\u4E32\u7801\u53D1\u9001\u5230", /*#__PURE__*/React.createElement("span", {
    style: {
      color: '#1890ff'
    }
  }, "caiwu@yunkecn.com"), ",\u6211\u53F8\u4E8E\u6536\u5230\u6C47\u6B3E\u4E00\u4E2A\u5DE5\u4F5C\u65E5\u5185\u4E3A\u60A8\u5145\u503C\uFF0C\u60C5\u51B5\u52A0\u6025\u53EF\u8054\u7CFB\u60A8\u7684\u5546\u52A1\u7ECF\u7406")))))));
};
UserPay.propTypes = propTypes$1;
UserPay.defaultProps = defaultProps$1;

var css_248z = ".style-module_page-header__15sCF {\n  padding: 0;\n}\n.style-module_item2__1jPP_ {\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  margin-bottom: 18px;\n  line-height: 32px;\n}\n.style-module_item2__1jPP_ .style-module_left__3uJYJ {\n  flex: none;\n  font-size: 14px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.45);\n  margin-right: 20px;\n  width: 87px;\n  line-height: 32px;\n}\n.style-module_item2__1jPP_ .style-module_right__3iw-B {\n  font-size: 14px;\n  font-weight: 400;\n  color: rgba(0, 0, 0, 0.85);\n  flex: 0 0 250px;\n}\n.style-module_item2__1jPP_ .style-module_right__3iw-B > * {\n  width: 100%;\n}\n.style-module_textbox__3wK5T {\n  margin-top: 10px;\n  padding: 4px 10px 4px 10px;\n  color: #2580FF;\n  font-size: 12px;\n  background-color: #ECF4FF;\n  border-radius: 2px;\n}\n.style-module_text__3c9ll {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  display: -webkit-box;\n  -webkit-line-clamp: 2;\n  line-clamp: 2;\n  -webkit-box-orient: vertical;\n}\n.style-module_buttonLink__PapGr {\n  background-color: transparent;\n  border: 0;\n}\n.style-module_green__3f2Rd {\n  width: 8px;\n  height: 8px;\n  background-color: #00bf40;\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n.style-module_red__10IJB {\n  width: 8px;\n  height: 8px;\n  background-color: #ff4d4f;\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n.style-module_grey__RcqzD {\n  width: 8px;\n  height: 8px;\n  background-color: #f0f0f2;\n  display: inline-block;\n  border-radius: 50%;\n  margin-right: 10px;\n}\n.style-module_title__3SFyZ {\n  font-size: 14px;\n  font-weight: 500;\n  color: rgba(0, 0, 0, 0.85);\n}\n.style-module_bigBox__1AG7b {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  flex-flow: wrap;\n}\n.style-module_box__1jYz6 {\n  padding-left: 20px;\n  padding-right: 20px;\n  height: 32px;\n  background: rgba(0, 0, 0, 0.06);\n  border-radius: 4px;\n  text-align: center;\n  line-height: 32px;\n  margin-right: 10px;\n  color: rgba(0, 0, 0, 0.65);\n}\n.style-module_heightBox__2fnSp {\n  width: 340px;\n  height: 720px;\n  background: #ffffff;\n  border-radius: 4px;\n  border: 1px solid rgba(0, 0, 0, 0.15);\n}\n.style-module_WEContetD__1CLDd {\n  flex: auto;\n  padding: 0 20px 16px;\n  overflow: auto;\n}\n.style-module_WEContetD__1CLDd .style-module_callLineL__ZbtKj {\n  margin-top: 16px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n}\n.style-module_WEContetD__1CLDd .style-module_callLineL__ZbtKj .style-module_duiLioneL__1CVoZ {\n  padding: 9px 10px;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 400;\n  color: #000000;\n  line-height: 18px;\n  position: relative;\n  background: #fff;\n  margin-left: 9px;\n  max-width: 300px;\n}\n.style-module_WEContetD__1CLDd .style-module_callLineL__ZbtKj .style-module_duiLioneL__1CVoZ span {\n  color: red;\n}\n.style-module_WEContetD__1CLDd .style-module_callLineL__ZbtKj .style-module_duiLioneL__1CVoZ:after {\n  position: absolute;\n  content: \" \";\n  height: 0;\n  width: 0;\n  top: 15px;\n  left: -6px;\n  margin-top: -5px;\n  border-top: 5px solid #f1f2f5;\n  border-right: 6px solid #fff;\n  border-bottom: 5px solid #f1f2f5;\n  border-left: 0 solid #f1f2f5;\n}\n.style-module_WEContetD__1CLDd .style-module_callLineR__1QpHv {\n  margin-top: 16px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: flex-start;\n  flex-direction: row-reverse;\n}\n.style-module_WEContetD__1CLDd .style-module_callLineR__1QpHv .style-module_duiLioneL__1CVoZ {\n  padding: 9px 10px;\n  border-radius: 4px;\n  font-size: 13px;\n  font-weight: 400;\n  color: #000000;\n  line-height: 18px;\n  position: relative;\n  background: #fff;\n  margin-left: 9px;\n  max-width: 300px;\n}\n.style-module_WEContetD__1CLDd .style-module_touxiang__28NBV {\n  width: 36px;\n  height: 36px;\n}\n.style-module_WEContetD__1CLDd .style-module_touxiang__28NBV img {\n  width: 36px;\n  height: 36px;\n}\n::-webkit-input-placeholder {\n  font-size: 14px;\n}\n.ant-pagination,\n.ant-pagination ol,\n.ant-pagination ul {\n  text-align: center !important;\n}\n.ant-pro-card-body {\n  padding-bottom: 0px !important;\n}\n";
var styles = {"page-header":"style-module_page-header__15sCF","item2":"style-module_item2__1jPP_","left":"style-module_left__3uJYJ","right":"style-module_right__3iw-B","textbox":"style-module_textbox__3wK5T","text":"style-module_text__3c9ll","buttonLink":"style-module_buttonLink__PapGr","green":"style-module_green__3f2Rd","red":"style-module_red__10IJB","grey":"style-module_grey__RcqzD","title":"style-module_title__3SFyZ","bigBox":"style-module_bigBox__1AG7b","box":"style-module_box__1jYz6","heightBox":"style-module_heightBox__2fnSp","WEContetD":"style-module_WEContetD__1CLDd","callLineL":"style-module_callLineL__ZbtKj","duiLioneL":"style-module_duiLioneL__1CVoZ","callLineR":"style-module_callLineR__1QpHv","touxiang":"style-module_touxiang__28NBV"};
styleInject(css_248z);

const propTypes = {
  realName: PropTypes.string,
  onClose: PropTypes.func,
  userId: PropTypes.string,
  phone: PropTypes.string
};
const defaultProps = {
  realName: '',
  onClose: () => {},
  userId: '',
  phone: ''
};
const userSex = {
  0: '女',
  1: '男'
};
/**
 * 查询员工信息组件
 */
const UserInformation = ({
  realName,
  onClose,
  userId,
  phone
}) => {
  const [detail, setDetail] = useState({});
  const [loading, setLoading] = useState(true);
  const [phoneDetail, setPhoneDetail] = useState({});
  const [appdetail, setAppdetail] = useState({});
  const getAppslist = async () => {
    const response = await getAllLastAppByPlatform({});
    if (response.code === '10000') {
      const appCurreVersion = response.data?.find(item => item.platform === '7')?.version;
      const ykMyDb = response.data?.find(item => item.platform === '14')?.version;
      const enterprisep = response.data?.find(item => item.platform === '11')?.version;
      const versioncontrol = response.data?.find(item => item.platform === '16')?.version;
      setAppdetail({
        appCurreVersion,
        ykMyDb,
        enterprisep,
        versioncontrol
      });
    } else {
      _message.error(response.message);
    }
  };
  useEffect(() => {
    getAppslist();
  }, []);
  const loadData = async () => {
    const response = await getfindByUser({
      userId,
      phone: phone || realName
    });
    if (response.success) {
      setLoading(false);
      setDetail(response.data);
    } else {
      _message.error(response.message || '获取员工信息失败');
    }
  };
  const compare = (version1, version2) => {
    if (version1 && version2) {
      const arr1 = version1.split('.');
      const arr2 = version2.split('.');
      const length = Math.max(arr1.length, arr2.length);
      for (let i = 0; i < length; i += 1) {
        const n1 = Number(arr1[i] || 0);
        const n2 = Number(arr2[i] || 0);
        if (n1 > n2) return 1;
        if (n1 < n2) return -1;
      }
      return 0;
    }
    return 0;
  };
  const getDetail = async () => {
    const response = await getDevice({
      page: 1,
      pageSize: 1,
      userId: detail.id
    });
    if (response.success) {
      setPhoneDetail(response?.data?.bindImeiList[0]);
    } else {
      _message.error(response.message);
    }
  };
  const msFormat = val => {
    const isNumber = Number.isNaN(Number(val));
    if (!isNumber) {
      const e = Math.floor(val / 1000);
      const a = Math.floor(e / 3600);
      const x = Math.floor(a / 24);
      const y = Math.floor(a % 24);
      const b = e % 3600;
      const c = Math.floor(b / 60);
      const d = b % 60;
      const day = `${x}天`;
      const hour = y < 10 ? `0${y}小时` : `${y}小时`;
      const min = c < 10 ? `0${c}分钟` : `${c}分钟`;
      const sec = d < 10 ? `0${d}秒` : `${d}秒`;
      return (x ? day : '') + (y ? hour : '') + (c ? min : '') + (d ? sec : '');
    }
    return val;
  };
  useEffect(() => {
    if (detail.id) {
      getDetail();
    }
  }, [detail]);
  useEffect(() => {
    loadData();
  }, []);
  return /*#__PURE__*/React.createElement(_Drawer, {
    title: "\u5458\u5DE5\u4FE1\u606F",
    open: true,
    extra: [/*#__PURE__*/React.createElement(CloseOutlined, {
      className: styles.hover,
      onClick: () => {
        onClose();
      }
    })],
    onClose: () => onClose(),
    closable: false
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overflow: 'auto'
    }
  }, /*#__PURE__*/React.createElement(_Spin, {
    spinning: loading
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 16,
      fontWeight: 500,
      marginBottom: 10
    }
  }, "\u5458\u5DE5\u4FE1\u606F"), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u59D3\u540D"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, detail.name)), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u6027\u522B"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, userSex[detail?.userSex])), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u624B\u673A\u53F7"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, detail.phone)), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u90AE\u7BB1"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, detail.email)), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u804C\u4F4D"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, detail.major)), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u89D2\u8272"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, detail.roleName)), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u6240\u5C5E\u90E8\u95E8"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, detail.department)), phoneDetail?.imei && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 16,
      fontWeight: 500,
      marginBottom: 10
    }
  }, "\u624B\u673A\u4FE1\u606F"), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "IMEI"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, phoneDetail?.imei)), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u662F\u5426\u6FC0\u6D3B"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: '10px',
      height: '10px',
      display: 'inline-block',
      borderRadius: '5px',
      background: phoneDetail?.userId ? '#00BF40' : 'red',
      marginRight: 10
    }
  }), phoneDetail?.userId ? '已激活' : '未激活')), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u662F\u5426\u89E3\u9501"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: '10px',
      height: '10px',
      display: 'inline-block',
      borderRadius: '5px',
      background: phoneDetail?.locked === 0 ? '#00BF40' : 'red',
      marginRight: 10
    }
  }), phoneDetail?.locked === 0 ? '已解锁' : '锁定')), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u662F\u5426\u5728\u7EBF"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: '10px',
      height: '10px',
      display: 'inline-block',
      borderRadius: '5px',
      background: phoneDetail?.activeType === 1 ? '#00BF40' : 'red',
      marginRight: 10
    }
  }), phoneDetail?.activeType === 1 ? '在线' : '离线')), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u4E0A\u6B21\u5728\u7EBF\u65F6\u95F4"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, phoneDetail?.lastOnlineTime)), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u79BB\u7EBF\u65F6\u957F"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, phoneDetail.activeType !== 1 ? (() => {
    const now = moment().format('x');
    const last = moment(phoneDetail?.lastOnlineTime).format('x');
    const res = now - last;
    const resTime = Number.isNaN(res) || res < 0 ? 0 : res;
    return msFormat(resTime);
  })() : '')), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u5F53\u65E5\u5728\u7EBF\u65F6\u957F"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, msFormat(phoneDetail?.onlineTime))), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u5DE5\u4F5C\u53F0"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("span", null, phoneDetail?.appCurreVersion, compare(phoneDetail?.appCurreVersion, appdetail?.appCurreVersion) === -1 && /*#__PURE__*/React.createElement(_Tooltip, {
    title: `工作台版本过低，请尽快升级最新版本${appdetail?.appCurreVersion}`
  }, /*#__PURE__*/React.createElement(CloudUploadOutlined, {
    style: {
      marginLeft: 7,
      color: 'red'
    }
  }))))), phoneDetail?.weixiaozhu && /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u5FAE\u5C0F\u52A9"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("span", null, phoneDetail?.weixiaozhu))), phoneDetail?.yunxiaozhu && /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u4E91\u5C0F\u52A9"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("span", null, phoneDetail?.yunxiaozhu))), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u5FAE\u4FE1\u670D\u52A1"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("span", null, phoneDetail?.ykMyDb, compare(phoneDetail?.ykMyDb, appdetail.ykMyDb) === -1 && /*#__PURE__*/React.createElement(_Tooltip, {
    title: `微信服务版本过低，请尽快升级最新版本${appdetail.ykMyDb}`
  }, /*#__PURE__*/React.createElement(CloudUploadOutlined, {
    style: {
      marginLeft: 7,
      color: 'red'
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u4F01\u4E1A\u670D\u52A1"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("span", null, phoneDetail?.enterprisep, compare(phoneDetail?.enterprisep, appdetail.enterprisep) === -1 && /*#__PURE__*/React.createElement(_Tooltip, {
    title: `企业服务版本过低，请尽快升级最新版本${appdetail.enterprisep}`
  }, /*#__PURE__*/React.createElement(CloudUploadOutlined, {
    style: {
      marginLeft: 7,
      color: 'red'
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u5E94\u7528\u7BA1\u7406"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, /*#__PURE__*/React.createElement("span", null, phoneDetail?.versioncontrol, compare(phoneDetail?.versioncontrol, appdetail.versioncontrol) === -1 && /*#__PURE__*/React.createElement(_Tooltip, {
    title: `应用管理版本过低，请尽快升级最新版本${appdetail.versioncontrol}`
  }, /*#__PURE__*/React.createElement(CloudUploadOutlined, {
    style: {
      marginLeft: 7,
      color: 'red'
    }
  }))))), /*#__PURE__*/React.createElement("div", {
    className: styles.item2
  }, /*#__PURE__*/React.createElement("div", {
    className: styles.left
  }, "\u7CFB\u7EDF"), /*#__PURE__*/React.createElement("div", {
    className: styles.right
  }, phoneDetail?.cellphoneCurreVersion ? phoneDetail.cellphoneCurreVersion?.replace('YK.', '')?.replace('YUNKE.', '') : ''))))));
};
UserInformation.propTypes = propTypes;
UserInformation.defaultProps = defaultProps;

/**
 * 弹窗提醒
 * @returns
 */
const BecomeDueModal = () => {
  const [visible, setVisible] = useState(false);
  const [dateTime, setDateTime] = useState(JSON.parse(sessionStorage.getItem('dataTime')));
  const loadData = () => {
    const noNeedWatermarkPages = ['/cms/auth/login', '/cms/auth/reg', '/cms/auth/forgotpass', '/cms/auth/accountcheck', '/cms/auth/changephone', '/cms/auth/announce'];
    if (noNeedWatermarkPages.includes(window.location.pathname)) return;
    if (Cookies.get('user') && Cookies.get('userToken') || sessionStorage.getItem('user')) {
      // 如果cookies中有company信息，说明已经登录
      setTimeout(async () => {
        const repsonse = await getCompanyInfo();
        if (repsonse?.serviceExpireDate) {
          if (new Date(repsonse?.serviceExpireDate).getTime() < new Date().getTime()) {
            setVisible(true);
            if (!dateTime?.startTime && !dateTime?.endTime) {
              const startTime = new Date().getTime();
              const endTime = new Date().getTime() + 1800000;
              sessionStorage.setItem('dateTime', JSON.stringify({
                startTime,
                endTime
              }));
            }
          }
        } else {
          window.clearTimeout();
        }
      }, dateTime?.endTime - dateTime?.startTime);
    } else {
      // 如果没有company信息，说明没有登录，跳转到登录页面
      logout('/cms/auth/login', window.location.pathname === '/cms/chatworkbench/index' ? 1 : 0);
    }
  };
  useEffect(() => {
    loadData();
    return () => window.clearTimeout();
  }, [dateTime]);
  const handleChangeClose = () => {
    setVisible(false);
    const startTime = new Date().getTime();
    const endTime = new Date().getTime() + 1800000;
    sessionStorage.setItem('dateTime', JSON.stringify({
      startTime,
      endTime
    }));
    setDateTime(JSON.parse(sessionStorage.getItem('dateTime')));
  };
  return /*#__PURE__*/React.createElement(_Modal, {
    title: "\u91CD\u8981\u63D0\u9192",
    visible: visible,
    onCancel: () => {
      handleChangeClose();
    },
    footer: [/*#__PURE__*/React.createElement(_Button, {
      onClick: () => {
        handleChangeClose();
      },
      type: "primary"
    }, "\u6211\u77E5\u9053\u4E86")]
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement(ExclamationCircleFilled, {
    style: {
      color: 'red',
      marginRight: 10
    }
  }), "\u670D\u52A1\u5230\u671F\u63D0\u9192"), /*#__PURE__*/React.createElement("h3", null, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 10,
      height: 10,
      border: '1px solid blue',
      borderRadius: '50%',
      display: 'inline-block',
      marginRight: 10
    }
  }), "\u60A8\u6240\u5728\u516C\u53F8\u7684\u670D\u52A1\u5DF2\u7ECF\u5230\u671F"), /*#__PURE__*/React.createElement("p", null, "\u60A8\u6240\u5728\u516C\u53F8\u7684\u670D\u52A1\u5DF2\u7ECF\u5230\u671F\uFF0C\u4E3A\u4E86\u907F\u514D\u4E1A\u52A1\u635F\u5931\uFF0C\u8BF7\u5C3D\u5FEB\u8054\u7CFB\u7BA1\u7406\u4EBA\u5458\u8FDB\u884C\u5EF6\u957F\u670D\u52A1\u5904\u7406\u3002"));
};

export { BecomeDueModal, CollapseTree, ModalComponent as CommonModal, CommonTableComponent, EmojiReplace, ImageClipping, insideTree as InsideCollapseTree, index as LayoutComponent, LazyOrganizationTree, LazySelectTree$1 as LazySelectTree, preview as PhonePreview, RightContent, LazySelectTree as SelectTree, HeaderNav as Tagnumber, useWebsocket as UseWebsocket, UserInformation, UserPay, VirtualTable, WechatMessage };
